var J4 = Object.defineProperty;
var Q4 = (r, a, n) => a in r ? J4(r, a, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[a] = n;
var Ue = (r, a, n) => Q4(r, typeof a != "symbol" ? a + "" : a, n);
var Pe = /* @__PURE__ */ ((r) => (r.BOOKING_NAME = "booking-name", r.VIEWER_DATE = "viewer-date", r.VIEWER_FULL = "viewer-full", r.VIEWER_NAME = "viewer-name", r.VIEWER_STAGING = "viewer-staging", r))(Pe || {}), mn = /* @__PURE__ */ ((r) => (r.CONTAIN = "contain", r.COVER = "cover", r))(mn || {}), tt = /* @__PURE__ */ ((r) => (r.RED = "Red", r.BLUE = "Blue", r.GREEN = "Green", r.YELLOW = "Yellow", r.ORANGE = "Orange", r.PINK = "Pink", r.WHITE = "White", r.BLACK = "Black", r.PURPLE = "Purple", r.RED_FLUO = "Fluored", r.BLUE_FLUO = "Fluoblue", r.GREEN_FLUO = "Fluogreen", r.YELLOW_FLUO = "Fluoyellow", r.PINK_FLUO = "Fluopink", r.WHITE_FLUO = "Fluowhite", r.PURPLE_FLUO = "Fluopurple", r.BLACK_WHITE = "Black-White", r.BLACK_BLUE = "Black-Blue", r.BLACK_YELLOW = "Black-Yellow", r.BLACK_GREY = "Black-Grey", r.BLACK_RED = "Black-Red", r.BLACK_GREEN = "Black-Green", r.BLACK_PURPLE = "Black-Purple", r.GREY = "Grey", r.CYAN = "Cyan", r.BROWN = "Brown", r.LIME = "Lime", r))(tt || {});
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.WHITE, tt.BLACK, tt.PURPLE, tt.RED_FLUO, tt.BLUE_FLUO, tt.GREEN_FLUO, tt.YELLOW_FLUO, tt.PINK_FLUO, tt.WHITE_FLUO, tt.PURPLE_FLUO, tt.BLACK_WHITE, tt.BLACK_BLUE, tt.BLACK_YELLOW, tt.BLACK_GREY, tt.BLACK_RED, tt.BLACK_GREEN, // Color.BLACK_PINK,
tt.BLACK_PURPLE;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.WHITE, tt.BLACK, tt.PURPLE;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK;
// Color.WHITE,
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.GREY, tt.CYAN, tt.BROWN, tt.LIME;
tt.RED, tt.BLUE, tt.GREEN, tt.YELLOW, tt.ORANGE, tt.PINK, tt.GREY, tt.CYAN, tt.BROWN, tt.LIME, tt.WHITE, tt.BLACK, tt.PURPLE, tt.WHITE_FLUO, tt.RED_FLUO, tt.BLUE_FLUO, tt.GREEN_FLUO, tt.YELLOW_FLUO, tt.PURPLE_FLUO, tt.BLACK_WHITE, tt.BLACK_RED, tt.BLACK_BLUE, tt.BLACK_GREEN, tt.BLACK_YELLOW, tt.BLACK_PURPLE, tt.BLACK_GREY;
var ge = /* @__PURE__ */ ((r) => (r.FOOTBOARD = "footboard", r.LINE = "line", r.LABEL = "label", r.CUSTOM = "custom", r.BENCH = "bench", r.CAR = "car", r.CHIRINGUITO = "chiringuito", r.RECEPTION = "reception", r.DESK = "desk", r.BEACH_VOLLEY = "beach-volley", r.BASKET_FIELD = "basket-field", r.COURT = "court", r.SOCCER_FIELD = "soccer-field", r.LIFEBELT = "lifebelt", r.GYM_BARBELL = "gym-barbell", r.GYM_EXERCISE = "gym-exercise", r.GYM_TREADMILL = "gym-treadmill", r.PALM = "palm", r.PLAYGROUND = "playground", r.POOL = "pool", r.POOL_ROUNDED = "pool-rounded", r.SHOWER = "shower", r.ROWBOAT = "rowboat", r.TENT = "tent", r.TENT_BIG = "tent-big", r.TREE = "tree", r.TREE1 = "tree1", r))(ge || {}), Er = /* @__PURE__ */ ((r) => (r.UMBRELLA = "umbrella", r.GAZEBO = "gazebo", r.PARKING = "parking", r.BED = "bed", r.BEDS = "beds", r.CABIN = "cabins", r.BOAT = "boat", r.PLAYFIELD = "playfield", r))(Er || {});
function Rr(r, a) {
  throw new Error(
    `Unhandled discriminated union member: ${JSON.stringify(r)}`
  );
}
var xi = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, pa = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
pa.exports;
(function(r, a) {
  (function() {
    var n, o = "4.17.21", u = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", h = "Expected a function", l = "Invalid `variable` option passed into `_.template`", g = "__lodash_hash_undefined__", p = 500, b = "__lodash_placeholder__", m = 1, C = 2, v = 4, _ = 1, w = 2, x = 1, P = 2, c = 4, f = 8, S = 16, E = 32, T = 64, D = 128, I = 256, M = 512, O = 30, N = "...", H = 800, y = 16, F = 1, R = 2, G = 3, U = 1 / 0, K = 9007199254740991, $ = 17976931348623157e292, X = NaN, Q = 4294967295, st = Q - 1, Z = Q >>> 1, at = [
      ["ary", D],
      ["bind", x],
      ["bindKey", P],
      ["curry", f],
      ["curryRight", S],
      ["flip", M],
      ["partial", E],
      ["partialRight", T],
      ["rearg", I]
    ], ht = "[object Arguments]", ct = "[object Array]", z = "[object AsyncFunction]", j = "[object Boolean]", et = "[object Date]", ut = "[object DOMException]", ft = "[object Error]", gt = "[object Function]", Mt = "[object GeneratorFunction]", xt = "[object Map]", mt = "[object Number]", ee = "[object Null]", Pt = "[object Object]", zt = "[object Promise]", gr = "[object Proxy]", re = "[object RegExp]", Zt = "[object Set]", Jt = "[object String]", Ut = "[object Symbol]", He = "[object Undefined]", ie = "[object WeakMap]", ze = "[object WeakSet]", Wt = "[object ArrayBuffer]", ne = "[object DataView]", Fe = "[object Float32Array]", pe = "[object Float64Array]", $e = "[object Int8Array]", Ta = "[object Int16Array]", Ve = "[object Int32Array]", Oe = "[object Uint8Array]", Ze = "[object Uint8ClampedArray]", hi = "[object Uint16Array]", Pa = "[object Uint32Array]", m1 = /\b__p \+= '';/g, b1 = /\b(__p \+=) '' \+/g, S1 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, nl = /&(?:amp|lt|gt|quot|#39);/g, al = /[&<>"']/g, w1 = RegExp(nl.source), C1 = RegExp(al.source), x1 = /<%-([\s\S]+?)%>/g, E1 = /<%([\s\S]+?)%>/g, sl = /<%=([\s\S]+?)%>/g, R1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, A1 = /^\w*$/, T1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Fa = /[\\^$.*+?()[\]{}|]/g, P1 = RegExp(Fa.source), Oa = /^\s+/, F1 = /\s/, O1 = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, k1 = /\{\n\/\* \[wrapped with (.+)\] \*/, I1 = /,? & /, M1 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, L1 = /[()=,{}\[\]\/\s]/, N1 = /\\(\\)?/g, G1 = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ol = /\w*$/, D1 = /^[-+]0x[0-9a-f]+$/i, B1 = /^0b[01]+$/i, U1 = /^\[object .+?Constructor\]$/, q1 = /^0o[0-7]+$/i, H1 = /^(?:0|[1-9]\d*)$/, z1 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Cn = /($^)/, V1 = /['\n\r\u2028\u2029\\]/g, xn = "\\ud800-\\udfff", W1 = "\\u0300-\\u036f", j1 = "\\ufe20-\\ufe2f", K1 = "\\u20d0-\\u20ff", hl = W1 + j1 + K1, ll = "\\u2700-\\u27bf", ul = "a-z\\xdf-\\xf6\\xf8-\\xff", Y1 = "\\xac\\xb1\\xd7\\xf7", X1 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $1 = "\\u2000-\\u206f", Z1 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", cl = "A-Z\\xc0-\\xd6\\xd8-\\xde", dl = "\\ufe0e\\ufe0f", fl = Y1 + X1 + $1 + Z1, ka = "['’]", J1 = "[" + xn + "]", gl = "[" + fl + "]", En = "[" + hl + "]", pl = "\\d+", Q1 = "[" + ll + "]", _l = "[" + ul + "]", vl = "[^" + xn + fl + pl + ll + ul + cl + "]", Ia = "\\ud83c[\\udffb-\\udfff]", tg = "(?:" + En + "|" + Ia + ")", yl = "[^" + xn + "]", Ma = "(?:\\ud83c[\\udde6-\\uddff]){2}", La = "[\\ud800-\\udbff][\\udc00-\\udfff]", Br = "[" + cl + "]", ml = "\\u200d", bl = "(?:" + _l + "|" + vl + ")", eg = "(?:" + Br + "|" + vl + ")", Sl = "(?:" + ka + "(?:d|ll|m|re|s|t|ve))?", wl = "(?:" + ka + "(?:D|LL|M|RE|S|T|VE))?", Cl = tg + "?", xl = "[" + dl + "]?", rg = "(?:" + ml + "(?:" + [yl, Ma, La].join("|") + ")" + xl + Cl + ")*", ig = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ng = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", El = xl + Cl + rg, ag = "(?:" + [Q1, Ma, La].join("|") + ")" + El, sg = "(?:" + [yl + En + "?", En, Ma, La, J1].join("|") + ")", og = RegExp(ka, "g"), hg = RegExp(En, "g"), Na = RegExp(Ia + "(?=" + Ia + ")|" + sg + El, "g"), lg = RegExp([
      Br + "?" + _l + "+" + Sl + "(?=" + [gl, Br, "$"].join("|") + ")",
      eg + "+" + wl + "(?=" + [gl, Br + bl, "$"].join("|") + ")",
      Br + "?" + bl + "+" + Sl,
      Br + "+" + wl,
      ng,
      ig,
      pl,
      ag
    ].join("|"), "g"), ug = RegExp("[" + ml + xn + hl + dl + "]"), cg = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, dg = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], fg = -1, qt = {};
    qt[Fe] = qt[pe] = qt[$e] = qt[Ta] = qt[Ve] = qt[Oe] = qt[Ze] = qt[hi] = qt[Pa] = !0, qt[ht] = qt[ct] = qt[Wt] = qt[j] = qt[ne] = qt[et] = qt[ft] = qt[gt] = qt[xt] = qt[mt] = qt[Pt] = qt[re] = qt[Zt] = qt[Jt] = qt[ie] = !1;
    var Bt = {};
    Bt[ht] = Bt[ct] = Bt[Wt] = Bt[ne] = Bt[j] = Bt[et] = Bt[Fe] = Bt[pe] = Bt[$e] = Bt[Ta] = Bt[Ve] = Bt[xt] = Bt[mt] = Bt[Pt] = Bt[re] = Bt[Zt] = Bt[Jt] = Bt[Ut] = Bt[Oe] = Bt[Ze] = Bt[hi] = Bt[Pa] = !0, Bt[ft] = Bt[gt] = Bt[ie] = !1;
    var gg = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, pg = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, _g = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, vg = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, yg = parseFloat, mg = parseInt, Rl = typeof xi == "object" && xi && xi.Object === Object && xi, bg = typeof self == "object" && self && self.Object === Object && self, oe = Rl || bg || Function("return this")(), Ga = a && !a.nodeType && a, Ar = Ga && !0 && r && !r.nodeType && r, Al = Ar && Ar.exports === Ga, Da = Al && Rl.process, ke = function() {
      try {
        var V = Ar && Ar.require && Ar.require("util").types;
        return V || Da && Da.binding && Da.binding("util");
      } catch {
      }
    }(), Tl = ke && ke.isArrayBuffer, Pl = ke && ke.isDate, Fl = ke && ke.isMap, Ol = ke && ke.isRegExp, kl = ke && ke.isSet, Il = ke && ke.isTypedArray;
    function Ce(V, J, Y) {
      switch (Y.length) {
        case 0:
          return V.call(J);
        case 1:
          return V.call(J, Y[0]);
        case 2:
          return V.call(J, Y[0], Y[1]);
        case 3:
          return V.call(J, Y[0], Y[1], Y[2]);
      }
      return V.apply(J, Y);
    }
    function Sg(V, J, Y, lt) {
      for (var bt = -1, Lt = V == null ? 0 : V.length; ++bt < Lt; ) {
        var Qt = V[bt];
        J(lt, Qt, Y(Qt), V);
      }
      return lt;
    }
    function Ie(V, J) {
      for (var Y = -1, lt = V == null ? 0 : V.length; ++Y < lt && J(V[Y], Y, V) !== !1; )
        ;
      return V;
    }
    function wg(V, J) {
      for (var Y = V == null ? 0 : V.length; Y-- && J(V[Y], Y, V) !== !1; )
        ;
      return V;
    }
    function Ml(V, J) {
      for (var Y = -1, lt = V == null ? 0 : V.length; ++Y < lt; )
        if (!J(V[Y], Y, V))
          return !1;
      return !0;
    }
    function pr(V, J) {
      for (var Y = -1, lt = V == null ? 0 : V.length, bt = 0, Lt = []; ++Y < lt; ) {
        var Qt = V[Y];
        J(Qt, Y, V) && (Lt[bt++] = Qt);
      }
      return Lt;
    }
    function Rn(V, J) {
      var Y = V == null ? 0 : V.length;
      return !!Y && Ur(V, J, 0) > -1;
    }
    function Ba(V, J, Y) {
      for (var lt = -1, bt = V == null ? 0 : V.length; ++lt < bt; )
        if (Y(J, V[lt]))
          return !0;
      return !1;
    }
    function Ht(V, J) {
      for (var Y = -1, lt = V == null ? 0 : V.length, bt = Array(lt); ++Y < lt; )
        bt[Y] = J(V[Y], Y, V);
      return bt;
    }
    function _r(V, J) {
      for (var Y = -1, lt = J.length, bt = V.length; ++Y < lt; )
        V[bt + Y] = J[Y];
      return V;
    }
    function Ua(V, J, Y, lt) {
      var bt = -1, Lt = V == null ? 0 : V.length;
      for (lt && Lt && (Y = V[++bt]); ++bt < Lt; )
        Y = J(Y, V[bt], bt, V);
      return Y;
    }
    function Cg(V, J, Y, lt) {
      var bt = V == null ? 0 : V.length;
      for (lt && bt && (Y = V[--bt]); bt--; )
        Y = J(Y, V[bt], bt, V);
      return Y;
    }
    function qa(V, J) {
      for (var Y = -1, lt = V == null ? 0 : V.length; ++Y < lt; )
        if (J(V[Y], Y, V))
          return !0;
      return !1;
    }
    var xg = Ha("length");
    function Eg(V) {
      return V.split("");
    }
    function Rg(V) {
      return V.match(M1) || [];
    }
    function Ll(V, J, Y) {
      var lt;
      return Y(V, function(bt, Lt, Qt) {
        if (J(bt, Lt, Qt))
          return lt = Lt, !1;
      }), lt;
    }
    function An(V, J, Y, lt) {
      for (var bt = V.length, Lt = Y + (lt ? 1 : -1); lt ? Lt-- : ++Lt < bt; )
        if (J(V[Lt], Lt, V))
          return Lt;
      return -1;
    }
    function Ur(V, J, Y) {
      return J === J ? Dg(V, J, Y) : An(V, Nl, Y);
    }
    function Ag(V, J, Y, lt) {
      for (var bt = Y - 1, Lt = V.length; ++bt < Lt; )
        if (lt(V[bt], J))
          return bt;
      return -1;
    }
    function Nl(V) {
      return V !== V;
    }
    function Gl(V, J) {
      var Y = V == null ? 0 : V.length;
      return Y ? Va(V, J) / Y : X;
    }
    function Ha(V) {
      return function(J) {
        return J == null ? n : J[V];
      };
    }
    function za(V) {
      return function(J) {
        return V == null ? n : V[J];
      };
    }
    function Dl(V, J, Y, lt, bt) {
      return bt(V, function(Lt, Qt, Dt) {
        Y = lt ? (lt = !1, Lt) : J(Y, Lt, Qt, Dt);
      }), Y;
    }
    function Tg(V, J) {
      var Y = V.length;
      for (V.sort(J); Y--; )
        V[Y] = V[Y].value;
      return V;
    }
    function Va(V, J) {
      for (var Y, lt = -1, bt = V.length; ++lt < bt; ) {
        var Lt = J(V[lt]);
        Lt !== n && (Y = Y === n ? Lt : Y + Lt);
      }
      return Y;
    }
    function Wa(V, J) {
      for (var Y = -1, lt = Array(V); ++Y < V; )
        lt[Y] = J(Y);
      return lt;
    }
    function Pg(V, J) {
      return Ht(J, function(Y) {
        return [Y, V[Y]];
      });
    }
    function Bl(V) {
      return V && V.slice(0, zl(V) + 1).replace(Oa, "");
    }
    function xe(V) {
      return function(J) {
        return V(J);
      };
    }
    function ja(V, J) {
      return Ht(J, function(Y) {
        return V[Y];
      });
    }
    function li(V, J) {
      return V.has(J);
    }
    function Ul(V, J) {
      for (var Y = -1, lt = V.length; ++Y < lt && Ur(J, V[Y], 0) > -1; )
        ;
      return Y;
    }
    function ql(V, J) {
      for (var Y = V.length; Y-- && Ur(J, V[Y], 0) > -1; )
        ;
      return Y;
    }
    function Fg(V, J) {
      for (var Y = V.length, lt = 0; Y--; )
        V[Y] === J && ++lt;
      return lt;
    }
    var Og = za(gg), kg = za(pg);
    function Ig(V) {
      return "\\" + vg[V];
    }
    function Mg(V, J) {
      return V == null ? n : V[J];
    }
    function qr(V) {
      return ug.test(V);
    }
    function Lg(V) {
      return cg.test(V);
    }
    function Ng(V) {
      for (var J, Y = []; !(J = V.next()).done; )
        Y.push(J.value);
      return Y;
    }
    function Ka(V) {
      var J = -1, Y = Array(V.size);
      return V.forEach(function(lt, bt) {
        Y[++J] = [bt, lt];
      }), Y;
    }
    function Hl(V, J) {
      return function(Y) {
        return V(J(Y));
      };
    }
    function vr(V, J) {
      for (var Y = -1, lt = V.length, bt = 0, Lt = []; ++Y < lt; ) {
        var Qt = V[Y];
        (Qt === J || Qt === b) && (V[Y] = b, Lt[bt++] = Y);
      }
      return Lt;
    }
    function Tn(V) {
      var J = -1, Y = Array(V.size);
      return V.forEach(function(lt) {
        Y[++J] = lt;
      }), Y;
    }
    function Gg(V) {
      var J = -1, Y = Array(V.size);
      return V.forEach(function(lt) {
        Y[++J] = [lt, lt];
      }), Y;
    }
    function Dg(V, J, Y) {
      for (var lt = Y - 1, bt = V.length; ++lt < bt; )
        if (V[lt] === J)
          return lt;
      return -1;
    }
    function Bg(V, J, Y) {
      for (var lt = Y + 1; lt--; )
        if (V[lt] === J)
          return lt;
      return lt;
    }
    function Hr(V) {
      return qr(V) ? qg(V) : xg(V);
    }
    function We(V) {
      return qr(V) ? Hg(V) : Eg(V);
    }
    function zl(V) {
      for (var J = V.length; J-- && F1.test(V.charAt(J)); )
        ;
      return J;
    }
    var Ug = za(_g);
    function qg(V) {
      for (var J = Na.lastIndex = 0; Na.test(V); )
        ++J;
      return J;
    }
    function Hg(V) {
      return V.match(Na) || [];
    }
    function zg(V) {
      return V.match(lg) || [];
    }
    var Vg = function V(J) {
      J = J == null ? oe : zr.defaults(oe.Object(), J, zr.pick(oe, dg));
      var Y = J.Array, lt = J.Date, bt = J.Error, Lt = J.Function, Qt = J.Math, Dt = J.Object, Ya = J.RegExp, Wg = J.String, Me = J.TypeError, Pn = Y.prototype, jg = Lt.prototype, Vr = Dt.prototype, Fn = J["__core-js_shared__"], On = jg.toString, Gt = Vr.hasOwnProperty, Kg = 0, Vl = function() {
        var t = /[^.]+$/.exec(Fn && Fn.keys && Fn.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }(), kn = Vr.toString, Yg = On.call(Dt), Xg = oe._, $g = Ya(
        "^" + On.call(Gt).replace(Fa, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), In = Al ? J.Buffer : n, yr = J.Symbol, Mn = J.Uint8Array, Wl = In ? In.allocUnsafe : n, Ln = Hl(Dt.getPrototypeOf, Dt), jl = Dt.create, Kl = Vr.propertyIsEnumerable, Nn = Pn.splice, Yl = yr ? yr.isConcatSpreadable : n, ui = yr ? yr.iterator : n, Tr = yr ? yr.toStringTag : n, Gn = function() {
        try {
          var t = Ir(Dt, "defineProperty");
          return t({}, "", {}), t;
        } catch {
        }
      }(), Zg = J.clearTimeout !== oe.clearTimeout && J.clearTimeout, Jg = lt && lt.now !== oe.Date.now && lt.now, Qg = J.setTimeout !== oe.setTimeout && J.setTimeout, Dn = Qt.ceil, Bn = Qt.floor, Xa = Dt.getOwnPropertySymbols, t2 = In ? In.isBuffer : n, Xl = J.isFinite, e2 = Pn.join, r2 = Hl(Dt.keys, Dt), te = Qt.max, le = Qt.min, i2 = lt.now, n2 = J.parseInt, $l = Qt.random, a2 = Pn.reverse, $a = Ir(J, "DataView"), ci = Ir(J, "Map"), Za = Ir(J, "Promise"), Wr = Ir(J, "Set"), di = Ir(J, "WeakMap"), fi = Ir(Dt, "create"), Un = di && new di(), jr = {}, s2 = Mr($a), o2 = Mr(ci), h2 = Mr(Za), l2 = Mr(Wr), u2 = Mr(di), qn = yr ? yr.prototype : n, gi = qn ? qn.valueOf : n, Zl = qn ? qn.toString : n;
      function k(t) {
        if (jt(t) && !St(t) && !(t instanceof kt)) {
          if (t instanceof Le)
            return t;
          if (Gt.call(t, "__wrapped__"))
            return Ju(t);
        }
        return new Le(t);
      }
      var Kr = /* @__PURE__ */ function() {
        function t() {
        }
        return function(e) {
          if (!Vt(e))
            return {};
          if (jl)
            return jl(e);
          t.prototype = e;
          var i = new t();
          return t.prototype = n, i;
        };
      }();
      function Hn() {
      }
      function Le(t, e) {
        this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = n;
      }
      k.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: x1,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: E1,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: sl,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: k
        }
      }, k.prototype = Hn.prototype, k.prototype.constructor = k, Le.prototype = Kr(Hn.prototype), Le.prototype.constructor = Le;
      function kt(t) {
        this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Q, this.__views__ = [];
      }
      function c2() {
        var t = new kt(this.__wrapped__);
        return t.__actions__ = _e(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = _e(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = _e(this.__views__), t;
      }
      function d2() {
        if (this.__filtered__) {
          var t = new kt(this);
          t.__dir__ = -1, t.__filtered__ = !0;
        } else
          t = this.clone(), t.__dir__ *= -1;
        return t;
      }
      function f2() {
        var t = this.__wrapped__.value(), e = this.__dir__, i = St(t), d = e < 0, A = i ? t.length : 0, L = Ep(0, A, this.__views__), B = L.start, q = L.end, W = q - B, rt = d ? q : B - 1, it = this.__iteratees__, nt = it.length, ot = 0, dt = le(W, this.__takeCount__);
        if (!i || !d && A == W && dt == W)
          return Su(t, this.__actions__);
        var _t = [];
        t:
          for (; W-- && ot < dt; ) {
            rt += e;
            for (var Ct = -1, vt = t[rt]; ++Ct < nt; ) {
              var Ft = it[Ct], It = Ft.iteratee, Ae = Ft.type, fe = It(vt);
              if (Ae == R)
                vt = fe;
              else if (!fe) {
                if (Ae == F)
                  continue t;
                break t;
              }
            }
            _t[ot++] = vt;
          }
        return _t;
      }
      kt.prototype = Kr(Hn.prototype), kt.prototype.constructor = kt;
      function Pr(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++e < i; ) {
          var d = t[e];
          this.set(d[0], d[1]);
        }
      }
      function g2() {
        this.__data__ = fi ? fi(null) : {}, this.size = 0;
      }
      function p2(t) {
        var e = this.has(t) && delete this.__data__[t];
        return this.size -= e ? 1 : 0, e;
      }
      function _2(t) {
        var e = this.__data__;
        if (fi) {
          var i = e[t];
          return i === g ? n : i;
        }
        return Gt.call(e, t) ? e[t] : n;
      }
      function v2(t) {
        var e = this.__data__;
        return fi ? e[t] !== n : Gt.call(e, t);
      }
      function y2(t, e) {
        var i = this.__data__;
        return this.size += this.has(t) ? 0 : 1, i[t] = fi && e === n ? g : e, this;
      }
      Pr.prototype.clear = g2, Pr.prototype.delete = p2, Pr.prototype.get = _2, Pr.prototype.has = v2, Pr.prototype.set = y2;
      function rr(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++e < i; ) {
          var d = t[e];
          this.set(d[0], d[1]);
        }
      }
      function m2() {
        this.__data__ = [], this.size = 0;
      }
      function b2(t) {
        var e = this.__data__, i = zn(e, t);
        if (i < 0)
          return !1;
        var d = e.length - 1;
        return i == d ? e.pop() : Nn.call(e, i, 1), --this.size, !0;
      }
      function S2(t) {
        var e = this.__data__, i = zn(e, t);
        return i < 0 ? n : e[i][1];
      }
      function w2(t) {
        return zn(this.__data__, t) > -1;
      }
      function C2(t, e) {
        var i = this.__data__, d = zn(i, t);
        return d < 0 ? (++this.size, i.push([t, e])) : i[d][1] = e, this;
      }
      rr.prototype.clear = m2, rr.prototype.delete = b2, rr.prototype.get = S2, rr.prototype.has = w2, rr.prototype.set = C2;
      function ir(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++e < i; ) {
          var d = t[e];
          this.set(d[0], d[1]);
        }
      }
      function x2() {
        this.size = 0, this.__data__ = {
          hash: new Pr(),
          map: new (ci || rr)(),
          string: new Pr()
        };
      }
      function E2(t) {
        var e = ea(this, t).delete(t);
        return this.size -= e ? 1 : 0, e;
      }
      function R2(t) {
        return ea(this, t).get(t);
      }
      function A2(t) {
        return ea(this, t).has(t);
      }
      function T2(t, e) {
        var i = ea(this, t), d = i.size;
        return i.set(t, e), this.size += i.size == d ? 0 : 1, this;
      }
      ir.prototype.clear = x2, ir.prototype.delete = E2, ir.prototype.get = R2, ir.prototype.has = A2, ir.prototype.set = T2;
      function Fr(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.__data__ = new ir(); ++e < i; )
          this.add(t[e]);
      }
      function P2(t) {
        return this.__data__.set(t, g), this;
      }
      function F2(t) {
        return this.__data__.has(t);
      }
      Fr.prototype.add = Fr.prototype.push = P2, Fr.prototype.has = F2;
      function je(t) {
        var e = this.__data__ = new rr(t);
        this.size = e.size;
      }
      function O2() {
        this.__data__ = new rr(), this.size = 0;
      }
      function k2(t) {
        var e = this.__data__, i = e.delete(t);
        return this.size = e.size, i;
      }
      function I2(t) {
        return this.__data__.get(t);
      }
      function M2(t) {
        return this.__data__.has(t);
      }
      function L2(t, e) {
        var i = this.__data__;
        if (i instanceof rr) {
          var d = i.__data__;
          if (!ci || d.length < u - 1)
            return d.push([t, e]), this.size = ++i.size, this;
          i = this.__data__ = new ir(d);
        }
        return i.set(t, e), this.size = i.size, this;
      }
      je.prototype.clear = O2, je.prototype.delete = k2, je.prototype.get = I2, je.prototype.has = M2, je.prototype.set = L2;
      function Jl(t, e) {
        var i = St(t), d = !i && Lr(t), A = !i && !d && Cr(t), L = !i && !d && !A && Zr(t), B = i || d || A || L, q = B ? Wa(t.length, Wg) : [], W = q.length;
        for (var rt in t)
          (e || Gt.call(t, rt)) && !(B && // Safari 9 has enumerable `arguments.length` in strict mode.
          (rt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          A && (rt == "offset" || rt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          L && (rt == "buffer" || rt == "byteLength" || rt == "byteOffset") || // Skip index properties.
          or(rt, W))) && q.push(rt);
        return q;
      }
      function Ql(t) {
        var e = t.length;
        return e ? t[hs(0, e - 1)] : n;
      }
      function N2(t, e) {
        return ra(_e(t), Or(e, 0, t.length));
      }
      function G2(t) {
        return ra(_e(t));
      }
      function Ja(t, e, i) {
        (i !== n && !Ke(t[e], i) || i === n && !(e in t)) && nr(t, e, i);
      }
      function pi(t, e, i) {
        var d = t[e];
        (!(Gt.call(t, e) && Ke(d, i)) || i === n && !(e in t)) && nr(t, e, i);
      }
      function zn(t, e) {
        for (var i = t.length; i--; )
          if (Ke(t[i][0], e))
            return i;
        return -1;
      }
      function D2(t, e, i, d) {
        return mr(t, function(A, L, B) {
          e(d, A, i(A), B);
        }), d;
      }
      function tu(t, e) {
        return t && Qe(e, ae(e), t);
      }
      function B2(t, e) {
        return t && Qe(e, ye(e), t);
      }
      function nr(t, e, i) {
        e == "__proto__" && Gn ? Gn(t, e, {
          configurable: !0,
          enumerable: !0,
          value: i,
          writable: !0
        }) : t[e] = i;
      }
      function Qa(t, e) {
        for (var i = -1, d = e.length, A = Y(d), L = t == null; ++i < d; )
          A[i] = L ? n : Is(t, e[i]);
        return A;
      }
      function Or(t, e, i) {
        return t === t && (i !== n && (t = t <= i ? t : i), e !== n && (t = t >= e ? t : e)), t;
      }
      function Ne(t, e, i, d, A, L) {
        var B, q = e & m, W = e & C, rt = e & v;
        if (i && (B = A ? i(t, d, A, L) : i(t)), B !== n)
          return B;
        if (!Vt(t))
          return t;
        var it = St(t);
        if (it) {
          if (B = Ap(t), !q)
            return _e(t, B);
        } else {
          var nt = ue(t), ot = nt == gt || nt == Mt;
          if (Cr(t))
            return xu(t, q);
          if (nt == Pt || nt == ht || ot && !A) {
            if (B = W || ot ? {} : zu(t), !q)
              return W ? _p(t, B2(B, t)) : pp(t, tu(B, t));
          } else {
            if (!Bt[nt])
              return A ? t : {};
            B = Tp(t, nt, q);
          }
        }
        L || (L = new je());
        var dt = L.get(t);
        if (dt)
          return dt;
        L.set(t, B), yc(t) ? t.forEach(function(vt) {
          B.add(Ne(vt, e, i, vt, t, L));
        }) : _c(t) && t.forEach(function(vt, Ft) {
          B.set(Ft, Ne(vt, e, i, Ft, t, L));
        });
        var _t = rt ? W ? ms : ys : W ? ye : ae, Ct = it ? n : _t(t);
        return Ie(Ct || t, function(vt, Ft) {
          Ct && (Ft = vt, vt = t[Ft]), pi(B, Ft, Ne(vt, e, i, Ft, t, L));
        }), B;
      }
      function U2(t) {
        var e = ae(t);
        return function(i) {
          return eu(i, t, e);
        };
      }
      function eu(t, e, i) {
        var d = i.length;
        if (t == null)
          return !d;
        for (t = Dt(t); d--; ) {
          var A = i[d], L = e[A], B = t[A];
          if (B === n && !(A in t) || !L(B))
            return !1;
        }
        return !0;
      }
      function ru(t, e, i) {
        if (typeof t != "function")
          throw new Me(h);
        return wi(function() {
          t.apply(n, i);
        }, e);
      }
      function _i(t, e, i, d) {
        var A = -1, L = Rn, B = !0, q = t.length, W = [], rt = e.length;
        if (!q)
          return W;
        i && (e = Ht(e, xe(i))), d ? (L = Ba, B = !1) : e.length >= u && (L = li, B = !1, e = new Fr(e));
        t:
          for (; ++A < q; ) {
            var it = t[A], nt = i == null ? it : i(it);
            if (it = d || it !== 0 ? it : 0, B && nt === nt) {
              for (var ot = rt; ot--; )
                if (e[ot] === nt)
                  continue t;
              W.push(it);
            } else
              L(e, nt, d) || W.push(it);
          }
        return W;
      }
      var mr = Pu(Je), iu = Pu(es, !0);
      function q2(t, e) {
        var i = !0;
        return mr(t, function(d, A, L) {
          return i = !!e(d, A, L), i;
        }), i;
      }
      function Vn(t, e, i) {
        for (var d = -1, A = t.length; ++d < A; ) {
          var L = t[d], B = e(L);
          if (B != null && (q === n ? B === B && !Re(B) : i(B, q)))
            var q = B, W = L;
        }
        return W;
      }
      function H2(t, e, i, d) {
        var A = t.length;
        for (i = wt(i), i < 0 && (i = -i > A ? 0 : A + i), d = d === n || d > A ? A : wt(d), d < 0 && (d += A), d = i > d ? 0 : bc(d); i < d; )
          t[i++] = e;
        return t;
      }
      function nu(t, e) {
        var i = [];
        return mr(t, function(d, A, L) {
          e(d, A, L) && i.push(d);
        }), i;
      }
      function he(t, e, i, d, A) {
        var L = -1, B = t.length;
        for (i || (i = Fp), A || (A = []); ++L < B; ) {
          var q = t[L];
          e > 0 && i(q) ? e > 1 ? he(q, e - 1, i, d, A) : _r(A, q) : d || (A[A.length] = q);
        }
        return A;
      }
      var ts = Fu(), au = Fu(!0);
      function Je(t, e) {
        return t && ts(t, e, ae);
      }
      function es(t, e) {
        return t && au(t, e, ae);
      }
      function Wn(t, e) {
        return pr(e, function(i) {
          return hr(t[i]);
        });
      }
      function kr(t, e) {
        e = Sr(e, t);
        for (var i = 0, d = e.length; t != null && i < d; )
          t = t[tr(e[i++])];
        return i && i == d ? t : n;
      }
      function su(t, e, i) {
        var d = e(t);
        return St(t) ? d : _r(d, i(t));
      }
      function ce(t) {
        return t == null ? t === n ? He : ee : Tr && Tr in Dt(t) ? xp(t) : Gp(t);
      }
      function rs(t, e) {
        return t > e;
      }
      function z2(t, e) {
        return t != null && Gt.call(t, e);
      }
      function V2(t, e) {
        return t != null && e in Dt(t);
      }
      function W2(t, e, i) {
        return t >= le(e, i) && t < te(e, i);
      }
      function is(t, e, i) {
        for (var d = i ? Ba : Rn, A = t[0].length, L = t.length, B = L, q = Y(L), W = 1 / 0, rt = []; B--; ) {
          var it = t[B];
          B && e && (it = Ht(it, xe(e))), W = le(it.length, W), q[B] = !i && (e || A >= 120 && it.length >= 120) ? new Fr(B && it) : n;
        }
        it = t[0];
        var nt = -1, ot = q[0];
        t:
          for (; ++nt < A && rt.length < W; ) {
            var dt = it[nt], _t = e ? e(dt) : dt;
            if (dt = i || dt !== 0 ? dt : 0, !(ot ? li(ot, _t) : d(rt, _t, i))) {
              for (B = L; --B; ) {
                var Ct = q[B];
                if (!(Ct ? li(Ct, _t) : d(t[B], _t, i)))
                  continue t;
              }
              ot && ot.push(_t), rt.push(dt);
            }
          }
        return rt;
      }
      function j2(t, e, i, d) {
        return Je(t, function(A, L, B) {
          e(d, i(A), L, B);
        }), d;
      }
      function vi(t, e, i) {
        e = Sr(e, t), t = Ku(t, e);
        var d = t == null ? t : t[tr(De(e))];
        return d == null ? n : Ce(d, t, i);
      }
      function ou(t) {
        return jt(t) && ce(t) == ht;
      }
      function K2(t) {
        return jt(t) && ce(t) == Wt;
      }
      function Y2(t) {
        return jt(t) && ce(t) == et;
      }
      function yi(t, e, i, d, A) {
        return t === e ? !0 : t == null || e == null || !jt(t) && !jt(e) ? t !== t && e !== e : X2(t, e, i, d, yi, A);
      }
      function X2(t, e, i, d, A, L) {
        var B = St(t), q = St(e), W = B ? ct : ue(t), rt = q ? ct : ue(e);
        W = W == ht ? Pt : W, rt = rt == ht ? Pt : rt;
        var it = W == Pt, nt = rt == Pt, ot = W == rt;
        if (ot && Cr(t)) {
          if (!Cr(e))
            return !1;
          B = !0, it = !1;
        }
        if (ot && !it)
          return L || (L = new je()), B || Zr(t) ? Uu(t, e, i, d, A, L) : wp(t, e, W, i, d, A, L);
        if (!(i & _)) {
          var dt = it && Gt.call(t, "__wrapped__"), _t = nt && Gt.call(e, "__wrapped__");
          if (dt || _t) {
            var Ct = dt ? t.value() : t, vt = _t ? e.value() : e;
            return L || (L = new je()), A(Ct, vt, i, d, L);
          }
        }
        return ot ? (L || (L = new je()), Cp(t, e, i, d, A, L)) : !1;
      }
      function $2(t) {
        return jt(t) && ue(t) == xt;
      }
      function ns(t, e, i, d) {
        var A = i.length, L = A, B = !d;
        if (t == null)
          return !L;
        for (t = Dt(t); A--; ) {
          var q = i[A];
          if (B && q[2] ? q[1] !== t[q[0]] : !(q[0] in t))
            return !1;
        }
        for (; ++A < L; ) {
          q = i[A];
          var W = q[0], rt = t[W], it = q[1];
          if (B && q[2]) {
            if (rt === n && !(W in t))
              return !1;
          } else {
            var nt = new je();
            if (d)
              var ot = d(rt, it, W, t, e, nt);
            if (!(ot === n ? yi(it, rt, _ | w, d, nt) : ot))
              return !1;
          }
        }
        return !0;
      }
      function hu(t) {
        if (!Vt(t) || kp(t))
          return !1;
        var e = hr(t) ? $g : U1;
        return e.test(Mr(t));
      }
      function Z2(t) {
        return jt(t) && ce(t) == re;
      }
      function J2(t) {
        return jt(t) && ue(t) == Zt;
      }
      function Q2(t) {
        return jt(t) && ha(t.length) && !!qt[ce(t)];
      }
      function lu(t) {
        return typeof t == "function" ? t : t == null ? me : typeof t == "object" ? St(t) ? du(t[0], t[1]) : cu(t) : Oc(t);
      }
      function as(t) {
        if (!Si(t))
          return r2(t);
        var e = [];
        for (var i in Dt(t))
          Gt.call(t, i) && i != "constructor" && e.push(i);
        return e;
      }
      function tp(t) {
        if (!Vt(t))
          return Np(t);
        var e = Si(t), i = [];
        for (var d in t)
          d == "constructor" && (e || !Gt.call(t, d)) || i.push(d);
        return i;
      }
      function ss(t, e) {
        return t < e;
      }
      function uu(t, e) {
        var i = -1, d = ve(t) ? Y(t.length) : [];
        return mr(t, function(A, L, B) {
          d[++i] = e(A, L, B);
        }), d;
      }
      function cu(t) {
        var e = Ss(t);
        return e.length == 1 && e[0][2] ? Wu(e[0][0], e[0][1]) : function(i) {
          return i === t || ns(i, t, e);
        };
      }
      function du(t, e) {
        return Cs(t) && Vu(e) ? Wu(tr(t), e) : function(i) {
          var d = Is(i, t);
          return d === n && d === e ? Ms(i, t) : yi(e, d, _ | w);
        };
      }
      function jn(t, e, i, d, A) {
        t !== e && ts(e, function(L, B) {
          if (A || (A = new je()), Vt(L))
            ep(t, e, B, i, jn, d, A);
          else {
            var q = d ? d(Es(t, B), L, B + "", t, e, A) : n;
            q === n && (q = L), Ja(t, B, q);
          }
        }, ye);
      }
      function ep(t, e, i, d, A, L, B) {
        var q = Es(t, i), W = Es(e, i), rt = B.get(W);
        if (rt) {
          Ja(t, i, rt);
          return;
        }
        var it = L ? L(q, W, i + "", t, e, B) : n, nt = it === n;
        if (nt) {
          var ot = St(W), dt = !ot && Cr(W), _t = !ot && !dt && Zr(W);
          it = W, ot || dt || _t ? St(q) ? it = q : Yt(q) ? it = _e(q) : dt ? (nt = !1, it = xu(W, !0)) : _t ? (nt = !1, it = Eu(W, !0)) : it = [] : Ci(W) || Lr(W) ? (it = q, Lr(q) ? it = Sc(q) : (!Vt(q) || hr(q)) && (it = zu(W))) : nt = !1;
        }
        nt && (B.set(W, it), A(it, W, d, L, B), B.delete(W)), Ja(t, i, it);
      }
      function fu(t, e) {
        var i = t.length;
        if (i)
          return e += e < 0 ? i : 0, or(e, i) ? t[e] : n;
      }
      function gu(t, e, i) {
        e.length ? e = Ht(e, function(L) {
          return St(L) ? function(B) {
            return kr(B, L.length === 1 ? L[0] : L);
          } : L;
        }) : e = [me];
        var d = -1;
        e = Ht(e, xe(pt()));
        var A = uu(t, function(L, B, q) {
          var W = Ht(e, function(rt) {
            return rt(L);
          });
          return { criteria: W, index: ++d, value: L };
        });
        return Tg(A, function(L, B) {
          return gp(L, B, i);
        });
      }
      function rp(t, e) {
        return pu(t, e, function(i, d) {
          return Ms(t, d);
        });
      }
      function pu(t, e, i) {
        for (var d = -1, A = e.length, L = {}; ++d < A; ) {
          var B = e[d], q = kr(t, B);
          i(q, B) && mi(L, Sr(B, t), q);
        }
        return L;
      }
      function ip(t) {
        return function(e) {
          return kr(e, t);
        };
      }
      function os(t, e, i, d) {
        var A = d ? Ag : Ur, L = -1, B = e.length, q = t;
        for (t === e && (e = _e(e)), i && (q = Ht(t, xe(i))); ++L < B; )
          for (var W = 0, rt = e[L], it = i ? i(rt) : rt; (W = A(q, it, W, d)) > -1; )
            q !== t && Nn.call(q, W, 1), Nn.call(t, W, 1);
        return t;
      }
      function _u(t, e) {
        for (var i = t ? e.length : 0, d = i - 1; i--; ) {
          var A = e[i];
          if (i == d || A !== L) {
            var L = A;
            or(A) ? Nn.call(t, A, 1) : cs(t, A);
          }
        }
        return t;
      }
      function hs(t, e) {
        return t + Bn($l() * (e - t + 1));
      }
      function np(t, e, i, d) {
        for (var A = -1, L = te(Dn((e - t) / (i || 1)), 0), B = Y(L); L--; )
          B[d ? L : ++A] = t, t += i;
        return B;
      }
      function ls(t, e) {
        var i = "";
        if (!t || e < 1 || e > K)
          return i;
        do
          e % 2 && (i += t), e = Bn(e / 2), e && (t += t);
        while (e);
        return i;
      }
      function Et(t, e) {
        return Rs(ju(t, e, me), t + "");
      }
      function ap(t) {
        return Ql(Jr(t));
      }
      function sp(t, e) {
        var i = Jr(t);
        return ra(i, Or(e, 0, i.length));
      }
      function mi(t, e, i, d) {
        if (!Vt(t))
          return t;
        e = Sr(e, t);
        for (var A = -1, L = e.length, B = L - 1, q = t; q != null && ++A < L; ) {
          var W = tr(e[A]), rt = i;
          if (W === "__proto__" || W === "constructor" || W === "prototype")
            return t;
          if (A != B) {
            var it = q[W];
            rt = d ? d(it, W, q) : n, rt === n && (rt = Vt(it) ? it : or(e[A + 1]) ? [] : {});
          }
          pi(q, W, rt), q = q[W];
        }
        return t;
      }
      var vu = Un ? function(t, e) {
        return Un.set(t, e), t;
      } : me, op = Gn ? function(t, e) {
        return Gn(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Ns(e),
          writable: !0
        });
      } : me;
      function hp(t) {
        return ra(Jr(t));
      }
      function Ge(t, e, i) {
        var d = -1, A = t.length;
        e < 0 && (e = -e > A ? 0 : A + e), i = i > A ? A : i, i < 0 && (i += A), A = e > i ? 0 : i - e >>> 0, e >>>= 0;
        for (var L = Y(A); ++d < A; )
          L[d] = t[d + e];
        return L;
      }
      function lp(t, e) {
        var i;
        return mr(t, function(d, A, L) {
          return i = e(d, A, L), !i;
        }), !!i;
      }
      function Kn(t, e, i) {
        var d = 0, A = t == null ? d : t.length;
        if (typeof e == "number" && e === e && A <= Z) {
          for (; d < A; ) {
            var L = d + A >>> 1, B = t[L];
            B !== null && !Re(B) && (i ? B <= e : B < e) ? d = L + 1 : A = L;
          }
          return A;
        }
        return us(t, e, me, i);
      }
      function us(t, e, i, d) {
        var A = 0, L = t == null ? 0 : t.length;
        if (L === 0)
          return 0;
        e = i(e);
        for (var B = e !== e, q = e === null, W = Re(e), rt = e === n; A < L; ) {
          var it = Bn((A + L) / 2), nt = i(t[it]), ot = nt !== n, dt = nt === null, _t = nt === nt, Ct = Re(nt);
          if (B)
            var vt = d || _t;
          else
            rt ? vt = _t && (d || ot) : q ? vt = _t && ot && (d || !dt) : W ? vt = _t && ot && !dt && (d || !Ct) : dt || Ct ? vt = !1 : vt = d ? nt <= e : nt < e;
          vt ? A = it + 1 : L = it;
        }
        return le(L, st);
      }
      function yu(t, e) {
        for (var i = -1, d = t.length, A = 0, L = []; ++i < d; ) {
          var B = t[i], q = e ? e(B) : B;
          if (!i || !Ke(q, W)) {
            var W = q;
            L[A++] = B === 0 ? 0 : B;
          }
        }
        return L;
      }
      function mu(t) {
        return typeof t == "number" ? t : Re(t) ? X : +t;
      }
      function Ee(t) {
        if (typeof t == "string")
          return t;
        if (St(t))
          return Ht(t, Ee) + "";
        if (Re(t))
          return Zl ? Zl.call(t) : "";
        var e = t + "";
        return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
      }
      function br(t, e, i) {
        var d = -1, A = Rn, L = t.length, B = !0, q = [], W = q;
        if (i)
          B = !1, A = Ba;
        else if (L >= u) {
          var rt = e ? null : bp(t);
          if (rt)
            return Tn(rt);
          B = !1, A = li, W = new Fr();
        } else
          W = e ? [] : q;
        t:
          for (; ++d < L; ) {
            var it = t[d], nt = e ? e(it) : it;
            if (it = i || it !== 0 ? it : 0, B && nt === nt) {
              for (var ot = W.length; ot--; )
                if (W[ot] === nt)
                  continue t;
              e && W.push(nt), q.push(it);
            } else
              A(W, nt, i) || (W !== q && W.push(nt), q.push(it));
          }
        return q;
      }
      function cs(t, e) {
        return e = Sr(e, t), t = Ku(t, e), t == null || delete t[tr(De(e))];
      }
      function bu(t, e, i, d) {
        return mi(t, e, i(kr(t, e)), d);
      }
      function Yn(t, e, i, d) {
        for (var A = t.length, L = d ? A : -1; (d ? L-- : ++L < A) && e(t[L], L, t); )
          ;
        return i ? Ge(t, d ? 0 : L, d ? L + 1 : A) : Ge(t, d ? L + 1 : 0, d ? A : L);
      }
      function Su(t, e) {
        var i = t;
        return i instanceof kt && (i = i.value()), Ua(e, function(d, A) {
          return A.func.apply(A.thisArg, _r([d], A.args));
        }, i);
      }
      function ds(t, e, i) {
        var d = t.length;
        if (d < 2)
          return d ? br(t[0]) : [];
        for (var A = -1, L = Y(d); ++A < d; )
          for (var B = t[A], q = -1; ++q < d; )
            q != A && (L[A] = _i(L[A] || B, t[q], e, i));
        return br(he(L, 1), e, i);
      }
      function wu(t, e, i) {
        for (var d = -1, A = t.length, L = e.length, B = {}; ++d < A; ) {
          var q = d < L ? e[d] : n;
          i(B, t[d], q);
        }
        return B;
      }
      function fs(t) {
        return Yt(t) ? t : [];
      }
      function gs(t) {
        return typeof t == "function" ? t : me;
      }
      function Sr(t, e) {
        return St(t) ? t : Cs(t, e) ? [t] : Zu(Nt(t));
      }
      var up = Et;
      function wr(t, e, i) {
        var d = t.length;
        return i = i === n ? d : i, !e && i >= d ? t : Ge(t, e, i);
      }
      var Cu = Zg || function(t) {
        return oe.clearTimeout(t);
      };
      function xu(t, e) {
        if (e)
          return t.slice();
        var i = t.length, d = Wl ? Wl(i) : new t.constructor(i);
        return t.copy(d), d;
      }
      function ps(t) {
        var e = new t.constructor(t.byteLength);
        return new Mn(e).set(new Mn(t)), e;
      }
      function cp(t, e) {
        var i = e ? ps(t.buffer) : t.buffer;
        return new t.constructor(i, t.byteOffset, t.byteLength);
      }
      function dp(t) {
        var e = new t.constructor(t.source, ol.exec(t));
        return e.lastIndex = t.lastIndex, e;
      }
      function fp(t) {
        return gi ? Dt(gi.call(t)) : {};
      }
      function Eu(t, e) {
        var i = e ? ps(t.buffer) : t.buffer;
        return new t.constructor(i, t.byteOffset, t.length);
      }
      function Ru(t, e) {
        if (t !== e) {
          var i = t !== n, d = t === null, A = t === t, L = Re(t), B = e !== n, q = e === null, W = e === e, rt = Re(e);
          if (!q && !rt && !L && t > e || L && B && W && !q && !rt || d && B && W || !i && W || !A)
            return 1;
          if (!d && !L && !rt && t < e || rt && i && A && !d && !L || q && i && A || !B && A || !W)
            return -1;
        }
        return 0;
      }
      function gp(t, e, i) {
        for (var d = -1, A = t.criteria, L = e.criteria, B = A.length, q = i.length; ++d < B; ) {
          var W = Ru(A[d], L[d]);
          if (W) {
            if (d >= q)
              return W;
            var rt = i[d];
            return W * (rt == "desc" ? -1 : 1);
          }
        }
        return t.index - e.index;
      }
      function Au(t, e, i, d) {
        for (var A = -1, L = t.length, B = i.length, q = -1, W = e.length, rt = te(L - B, 0), it = Y(W + rt), nt = !d; ++q < W; )
          it[q] = e[q];
        for (; ++A < B; )
          (nt || A < L) && (it[i[A]] = t[A]);
        for (; rt--; )
          it[q++] = t[A++];
        return it;
      }
      function Tu(t, e, i, d) {
        for (var A = -1, L = t.length, B = -1, q = i.length, W = -1, rt = e.length, it = te(L - q, 0), nt = Y(it + rt), ot = !d; ++A < it; )
          nt[A] = t[A];
        for (var dt = A; ++W < rt; )
          nt[dt + W] = e[W];
        for (; ++B < q; )
          (ot || A < L) && (nt[dt + i[B]] = t[A++]);
        return nt;
      }
      function _e(t, e) {
        var i = -1, d = t.length;
        for (e || (e = Y(d)); ++i < d; )
          e[i] = t[i];
        return e;
      }
      function Qe(t, e, i, d) {
        var A = !i;
        i || (i = {});
        for (var L = -1, B = e.length; ++L < B; ) {
          var q = e[L], W = d ? d(i[q], t[q], q, i, t) : n;
          W === n && (W = t[q]), A ? nr(i, q, W) : pi(i, q, W);
        }
        return i;
      }
      function pp(t, e) {
        return Qe(t, ws(t), e);
      }
      function _p(t, e) {
        return Qe(t, qu(t), e);
      }
      function Xn(t, e) {
        return function(i, d) {
          var A = St(i) ? Sg : D2, L = e ? e() : {};
          return A(i, t, pt(d, 2), L);
        };
      }
      function Yr(t) {
        return Et(function(e, i) {
          var d = -1, A = i.length, L = A > 1 ? i[A - 1] : n, B = A > 2 ? i[2] : n;
          for (L = t.length > 3 && typeof L == "function" ? (A--, L) : n, B && de(i[0], i[1], B) && (L = A < 3 ? n : L, A = 1), e = Dt(e); ++d < A; ) {
            var q = i[d];
            q && t(e, q, d, L);
          }
          return e;
        });
      }
      function Pu(t, e) {
        return function(i, d) {
          if (i == null)
            return i;
          if (!ve(i))
            return t(i, d);
          for (var A = i.length, L = e ? A : -1, B = Dt(i); (e ? L-- : ++L < A) && d(B[L], L, B) !== !1; )
            ;
          return i;
        };
      }
      function Fu(t) {
        return function(e, i, d) {
          for (var A = -1, L = Dt(e), B = d(e), q = B.length; q--; ) {
            var W = B[t ? q : ++A];
            if (i(L[W], W, L) === !1)
              break;
          }
          return e;
        };
      }
      function vp(t, e, i) {
        var d = e & x, A = bi(t);
        function L() {
          var B = this && this !== oe && this instanceof L ? A : t;
          return B.apply(d ? i : this, arguments);
        }
        return L;
      }
      function Ou(t) {
        return function(e) {
          e = Nt(e);
          var i = qr(e) ? We(e) : n, d = i ? i[0] : e.charAt(0), A = i ? wr(i, 1).join("") : e.slice(1);
          return d[t]() + A;
        };
      }
      function Xr(t) {
        return function(e) {
          return Ua(Pc(Tc(e).replace(og, "")), t, "");
        };
      }
      function bi(t) {
        return function() {
          var e = arguments;
          switch (e.length) {
            case 0:
              return new t();
            case 1:
              return new t(e[0]);
            case 2:
              return new t(e[0], e[1]);
            case 3:
              return new t(e[0], e[1], e[2]);
            case 4:
              return new t(e[0], e[1], e[2], e[3]);
            case 5:
              return new t(e[0], e[1], e[2], e[3], e[4]);
            case 6:
              return new t(e[0], e[1], e[2], e[3], e[4], e[5]);
            case 7:
              return new t(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
          }
          var i = Kr(t.prototype), d = t.apply(i, e);
          return Vt(d) ? d : i;
        };
      }
      function yp(t, e, i) {
        var d = bi(t);
        function A() {
          for (var L = arguments.length, B = Y(L), q = L, W = $r(A); q--; )
            B[q] = arguments[q];
          var rt = L < 3 && B[0] !== W && B[L - 1] !== W ? [] : vr(B, W);
          if (L -= rt.length, L < i)
            return Nu(
              t,
              e,
              $n,
              A.placeholder,
              n,
              B,
              rt,
              n,
              n,
              i - L
            );
          var it = this && this !== oe && this instanceof A ? d : t;
          return Ce(it, this, B);
        }
        return A;
      }
      function ku(t) {
        return function(e, i, d) {
          var A = Dt(e);
          if (!ve(e)) {
            var L = pt(i, 3);
            e = ae(e), i = function(q) {
              return L(A[q], q, A);
            };
          }
          var B = t(e, i, d);
          return B > -1 ? A[L ? e[B] : B] : n;
        };
      }
      function Iu(t) {
        return sr(function(e) {
          var i = e.length, d = i, A = Le.prototype.thru;
          for (t && e.reverse(); d--; ) {
            var L = e[d];
            if (typeof L != "function")
              throw new Me(h);
            if (A && !B && ta(L) == "wrapper")
              var B = new Le([], !0);
          }
          for (d = B ? d : i; ++d < i; ) {
            L = e[d];
            var q = ta(L), W = q == "wrapper" ? bs(L) : n;
            W && xs(W[0]) && W[1] == (D | f | E | I) && !W[4].length && W[9] == 1 ? B = B[ta(W[0])].apply(B, W[3]) : B = L.length == 1 && xs(L) ? B[q]() : B.thru(L);
          }
          return function() {
            var rt = arguments, it = rt[0];
            if (B && rt.length == 1 && St(it))
              return B.plant(it).value();
            for (var nt = 0, ot = i ? e[nt].apply(this, rt) : it; ++nt < i; )
              ot = e[nt].call(this, ot);
            return ot;
          };
        });
      }
      function $n(t, e, i, d, A, L, B, q, W, rt) {
        var it = e & D, nt = e & x, ot = e & P, dt = e & (f | S), _t = e & M, Ct = ot ? n : bi(t);
        function vt() {
          for (var Ft = arguments.length, It = Y(Ft), Ae = Ft; Ae--; )
            It[Ae] = arguments[Ae];
          if (dt)
            var fe = $r(vt), Te = Fg(It, fe);
          if (d && (It = Au(It, d, A, dt)), L && (It = Tu(It, L, B, dt)), Ft -= Te, dt && Ft < rt) {
            var Xt = vr(It, fe);
            return Nu(
              t,
              e,
              $n,
              vt.placeholder,
              i,
              It,
              Xt,
              q,
              W,
              rt - Ft
            );
          }
          var Ye = nt ? i : this, ur = ot ? Ye[t] : t;
          return Ft = It.length, q ? It = Dp(It, q) : _t && Ft > 1 && It.reverse(), it && W < Ft && (It.length = W), this && this !== oe && this instanceof vt && (ur = Ct || bi(ur)), ur.apply(Ye, It);
        }
        return vt;
      }
      function Mu(t, e) {
        return function(i, d) {
          return j2(i, t, e(d), {});
        };
      }
      function Zn(t, e) {
        return function(i, d) {
          var A;
          if (i === n && d === n)
            return e;
          if (i !== n && (A = i), d !== n) {
            if (A === n)
              return d;
            typeof i == "string" || typeof d == "string" ? (i = Ee(i), d = Ee(d)) : (i = mu(i), d = mu(d)), A = t(i, d);
          }
          return A;
        };
      }
      function _s(t) {
        return sr(function(e) {
          return e = Ht(e, xe(pt())), Et(function(i) {
            var d = this;
            return t(e, function(A) {
              return Ce(A, d, i);
            });
          });
        });
      }
      function Jn(t, e) {
        e = e === n ? " " : Ee(e);
        var i = e.length;
        if (i < 2)
          return i ? ls(e, t) : e;
        var d = ls(e, Dn(t / Hr(e)));
        return qr(e) ? wr(We(d), 0, t).join("") : d.slice(0, t);
      }
      function mp(t, e, i, d) {
        var A = e & x, L = bi(t);
        function B() {
          for (var q = -1, W = arguments.length, rt = -1, it = d.length, nt = Y(it + W), ot = this && this !== oe && this instanceof B ? L : t; ++rt < it; )
            nt[rt] = d[rt];
          for (; W--; )
            nt[rt++] = arguments[++q];
          return Ce(ot, A ? i : this, nt);
        }
        return B;
      }
      function Lu(t) {
        return function(e, i, d) {
          return d && typeof d != "number" && de(e, i, d) && (i = d = n), e = lr(e), i === n ? (i = e, e = 0) : i = lr(i), d = d === n ? e < i ? 1 : -1 : lr(d), np(e, i, d, t);
        };
      }
      function Qn(t) {
        return function(e, i) {
          return typeof e == "string" && typeof i == "string" || (e = Be(e), i = Be(i)), t(e, i);
        };
      }
      function Nu(t, e, i, d, A, L, B, q, W, rt) {
        var it = e & f, nt = it ? B : n, ot = it ? n : B, dt = it ? L : n, _t = it ? n : L;
        e |= it ? E : T, e &= ~(it ? T : E), e & c || (e &= -4);
        var Ct = [
          t,
          e,
          A,
          dt,
          nt,
          _t,
          ot,
          q,
          W,
          rt
        ], vt = i.apply(n, Ct);
        return xs(t) && Yu(vt, Ct), vt.placeholder = d, Xu(vt, t, e);
      }
      function vs(t) {
        var e = Qt[t];
        return function(i, d) {
          if (i = Be(i), d = d == null ? 0 : le(wt(d), 292), d && Xl(i)) {
            var A = (Nt(i) + "e").split("e"), L = e(A[0] + "e" + (+A[1] + d));
            return A = (Nt(L) + "e").split("e"), +(A[0] + "e" + (+A[1] - d));
          }
          return e(i);
        };
      }
      var bp = Wr && 1 / Tn(new Wr([, -0]))[1] == U ? function(t) {
        return new Wr(t);
      } : Bs;
      function Gu(t) {
        return function(e) {
          var i = ue(e);
          return i == xt ? Ka(e) : i == Zt ? Gg(e) : Pg(e, t(e));
        };
      }
      function ar(t, e, i, d, A, L, B, q) {
        var W = e & P;
        if (!W && typeof t != "function")
          throw new Me(h);
        var rt = d ? d.length : 0;
        if (rt || (e &= -97, d = A = n), B = B === n ? B : te(wt(B), 0), q = q === n ? q : wt(q), rt -= A ? A.length : 0, e & T) {
          var it = d, nt = A;
          d = A = n;
        }
        var ot = W ? n : bs(t), dt = [
          t,
          e,
          i,
          d,
          A,
          it,
          nt,
          L,
          B,
          q
        ];
        if (ot && Lp(dt, ot), t = dt[0], e = dt[1], i = dt[2], d = dt[3], A = dt[4], q = dt[9] = dt[9] === n ? W ? 0 : t.length : te(dt[9] - rt, 0), !q && e & (f | S) && (e &= -25), !e || e == x)
          var _t = vp(t, e, i);
        else
          e == f || e == S ? _t = yp(t, e, q) : (e == E || e == (x | E)) && !A.length ? _t = mp(t, e, i, d) : _t = $n.apply(n, dt);
        var Ct = ot ? vu : Yu;
        return Xu(Ct(_t, dt), t, e);
      }
      function Du(t, e, i, d) {
        return t === n || Ke(t, Vr[i]) && !Gt.call(d, i) ? e : t;
      }
      function Bu(t, e, i, d, A, L) {
        return Vt(t) && Vt(e) && (L.set(e, t), jn(t, e, n, Bu, L), L.delete(e)), t;
      }
      function Sp(t) {
        return Ci(t) ? n : t;
      }
      function Uu(t, e, i, d, A, L) {
        var B = i & _, q = t.length, W = e.length;
        if (q != W && !(B && W > q))
          return !1;
        var rt = L.get(t), it = L.get(e);
        if (rt && it)
          return rt == e && it == t;
        var nt = -1, ot = !0, dt = i & w ? new Fr() : n;
        for (L.set(t, e), L.set(e, t); ++nt < q; ) {
          var _t = t[nt], Ct = e[nt];
          if (d)
            var vt = B ? d(Ct, _t, nt, e, t, L) : d(_t, Ct, nt, t, e, L);
          if (vt !== n) {
            if (vt)
              continue;
            ot = !1;
            break;
          }
          if (dt) {
            if (!qa(e, function(Ft, It) {
              if (!li(dt, It) && (_t === Ft || A(_t, Ft, i, d, L)))
                return dt.push(It);
            })) {
              ot = !1;
              break;
            }
          } else if (!(_t === Ct || A(_t, Ct, i, d, L))) {
            ot = !1;
            break;
          }
        }
        return L.delete(t), L.delete(e), ot;
      }
      function wp(t, e, i, d, A, L, B) {
        switch (i) {
          case ne:
            if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
              return !1;
            t = t.buffer, e = e.buffer;
          case Wt:
            return !(t.byteLength != e.byteLength || !L(new Mn(t), new Mn(e)));
          case j:
          case et:
          case mt:
            return Ke(+t, +e);
          case ft:
            return t.name == e.name && t.message == e.message;
          case re:
          case Jt:
            return t == e + "";
          case xt:
            var q = Ka;
          case Zt:
            var W = d & _;
            if (q || (q = Tn), t.size != e.size && !W)
              return !1;
            var rt = B.get(t);
            if (rt)
              return rt == e;
            d |= w, B.set(t, e);
            var it = Uu(q(t), q(e), d, A, L, B);
            return B.delete(t), it;
          case Ut:
            if (gi)
              return gi.call(t) == gi.call(e);
        }
        return !1;
      }
      function Cp(t, e, i, d, A, L) {
        var B = i & _, q = ys(t), W = q.length, rt = ys(e), it = rt.length;
        if (W != it && !B)
          return !1;
        for (var nt = W; nt--; ) {
          var ot = q[nt];
          if (!(B ? ot in e : Gt.call(e, ot)))
            return !1;
        }
        var dt = L.get(t), _t = L.get(e);
        if (dt && _t)
          return dt == e && _t == t;
        var Ct = !0;
        L.set(t, e), L.set(e, t);
        for (var vt = B; ++nt < W; ) {
          ot = q[nt];
          var Ft = t[ot], It = e[ot];
          if (d)
            var Ae = B ? d(It, Ft, ot, e, t, L) : d(Ft, It, ot, t, e, L);
          if (!(Ae === n ? Ft === It || A(Ft, It, i, d, L) : Ae)) {
            Ct = !1;
            break;
          }
          vt || (vt = ot == "constructor");
        }
        if (Ct && !vt) {
          var fe = t.constructor, Te = e.constructor;
          fe != Te && "constructor" in t && "constructor" in e && !(typeof fe == "function" && fe instanceof fe && typeof Te == "function" && Te instanceof Te) && (Ct = !1);
        }
        return L.delete(t), L.delete(e), Ct;
      }
      function sr(t) {
        return Rs(ju(t, n, ec), t + "");
      }
      function ys(t) {
        return su(t, ae, ws);
      }
      function ms(t) {
        return su(t, ye, qu);
      }
      var bs = Un ? function(t) {
        return Un.get(t);
      } : Bs;
      function ta(t) {
        for (var e = t.name + "", i = jr[e], d = Gt.call(jr, e) ? i.length : 0; d--; ) {
          var A = i[d], L = A.func;
          if (L == null || L == t)
            return A.name;
        }
        return e;
      }
      function $r(t) {
        var e = Gt.call(k, "placeholder") ? k : t;
        return e.placeholder;
      }
      function pt() {
        var t = k.iteratee || Gs;
        return t = t === Gs ? lu : t, arguments.length ? t(arguments[0], arguments[1]) : t;
      }
      function ea(t, e) {
        var i = t.__data__;
        return Op(e) ? i[typeof e == "string" ? "string" : "hash"] : i.map;
      }
      function Ss(t) {
        for (var e = ae(t), i = e.length; i--; ) {
          var d = e[i], A = t[d];
          e[i] = [d, A, Vu(A)];
        }
        return e;
      }
      function Ir(t, e) {
        var i = Mg(t, e);
        return hu(i) ? i : n;
      }
      function xp(t) {
        var e = Gt.call(t, Tr), i = t[Tr];
        try {
          t[Tr] = n;
          var d = !0;
        } catch {
        }
        var A = kn.call(t);
        return d && (e ? t[Tr] = i : delete t[Tr]), A;
      }
      var ws = Xa ? function(t) {
        return t == null ? [] : (t = Dt(t), pr(Xa(t), function(e) {
          return Kl.call(t, e);
        }));
      } : Us, qu = Xa ? function(t) {
        for (var e = []; t; )
          _r(e, ws(t)), t = Ln(t);
        return e;
      } : Us, ue = ce;
      ($a && ue(new $a(new ArrayBuffer(1))) != ne || ci && ue(new ci()) != xt || Za && ue(Za.resolve()) != zt || Wr && ue(new Wr()) != Zt || di && ue(new di()) != ie) && (ue = function(t) {
        var e = ce(t), i = e == Pt ? t.constructor : n, d = i ? Mr(i) : "";
        if (d)
          switch (d) {
            case s2:
              return ne;
            case o2:
              return xt;
            case h2:
              return zt;
            case l2:
              return Zt;
            case u2:
              return ie;
          }
        return e;
      });
      function Ep(t, e, i) {
        for (var d = -1, A = i.length; ++d < A; ) {
          var L = i[d], B = L.size;
          switch (L.type) {
            case "drop":
              t += B;
              break;
            case "dropRight":
              e -= B;
              break;
            case "take":
              e = le(e, t + B);
              break;
            case "takeRight":
              t = te(t, e - B);
              break;
          }
        }
        return { start: t, end: e };
      }
      function Rp(t) {
        var e = t.match(k1);
        return e ? e[1].split(I1) : [];
      }
      function Hu(t, e, i) {
        e = Sr(e, t);
        for (var d = -1, A = e.length, L = !1; ++d < A; ) {
          var B = tr(e[d]);
          if (!(L = t != null && i(t, B)))
            break;
          t = t[B];
        }
        return L || ++d != A ? L : (A = t == null ? 0 : t.length, !!A && ha(A) && or(B, A) && (St(t) || Lr(t)));
      }
      function Ap(t) {
        var e = t.length, i = new t.constructor(e);
        return e && typeof t[0] == "string" && Gt.call(t, "index") && (i.index = t.index, i.input = t.input), i;
      }
      function zu(t) {
        return typeof t.constructor == "function" && !Si(t) ? Kr(Ln(t)) : {};
      }
      function Tp(t, e, i) {
        var d = t.constructor;
        switch (e) {
          case Wt:
            return ps(t);
          case j:
          case et:
            return new d(+t);
          case ne:
            return cp(t, i);
          case Fe:
          case pe:
          case $e:
          case Ta:
          case Ve:
          case Oe:
          case Ze:
          case hi:
          case Pa:
            return Eu(t, i);
          case xt:
            return new d();
          case mt:
          case Jt:
            return new d(t);
          case re:
            return dp(t);
          case Zt:
            return new d();
          case Ut:
            return fp(t);
        }
      }
      function Pp(t, e) {
        var i = e.length;
        if (!i)
          return t;
        var d = i - 1;
        return e[d] = (i > 1 ? "& " : "") + e[d], e = e.join(i > 2 ? ", " : " "), t.replace(O1, `{
/* [wrapped with ` + e + `] */
`);
      }
      function Fp(t) {
        return St(t) || Lr(t) || !!(Yl && t && t[Yl]);
      }
      function or(t, e) {
        var i = typeof t;
        return e = e == null ? K : e, !!e && (i == "number" || i != "symbol" && H1.test(t)) && t > -1 && t % 1 == 0 && t < e;
      }
      function de(t, e, i) {
        if (!Vt(i))
          return !1;
        var d = typeof e;
        return (d == "number" ? ve(i) && or(e, i.length) : d == "string" && e in i) ? Ke(i[e], t) : !1;
      }
      function Cs(t, e) {
        if (St(t))
          return !1;
        var i = typeof t;
        return i == "number" || i == "symbol" || i == "boolean" || t == null || Re(t) ? !0 : A1.test(t) || !R1.test(t) || e != null && t in Dt(e);
      }
      function Op(t) {
        var e = typeof t;
        return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
      }
      function xs(t) {
        var e = ta(t), i = k[e];
        if (typeof i != "function" || !(e in kt.prototype))
          return !1;
        if (t === i)
          return !0;
        var d = bs(i);
        return !!d && t === d[0];
      }
      function kp(t) {
        return !!Vl && Vl in t;
      }
      var Ip = Fn ? hr : qs;
      function Si(t) {
        var e = t && t.constructor, i = typeof e == "function" && e.prototype || Vr;
        return t === i;
      }
      function Vu(t) {
        return t === t && !Vt(t);
      }
      function Wu(t, e) {
        return function(i) {
          return i == null ? !1 : i[t] === e && (e !== n || t in Dt(i));
        };
      }
      function Mp(t) {
        var e = sa(t, function(d) {
          return i.size === p && i.clear(), d;
        }), i = e.cache;
        return e;
      }
      function Lp(t, e) {
        var i = t[1], d = e[1], A = i | d, L = A < (x | P | D), B = d == D && i == f || d == D && i == I && t[7].length <= e[8] || d == (D | I) && e[7].length <= e[8] && i == f;
        if (!(L || B))
          return t;
        d & x && (t[2] = e[2], A |= i & x ? 0 : c);
        var q = e[3];
        if (q) {
          var W = t[3];
          t[3] = W ? Au(W, q, e[4]) : q, t[4] = W ? vr(t[3], b) : e[4];
        }
        return q = e[5], q && (W = t[5], t[5] = W ? Tu(W, q, e[6]) : q, t[6] = W ? vr(t[5], b) : e[6]), q = e[7], q && (t[7] = q), d & D && (t[8] = t[8] == null ? e[8] : le(t[8], e[8])), t[9] == null && (t[9] = e[9]), t[0] = e[0], t[1] = A, t;
      }
      function Np(t) {
        var e = [];
        if (t != null)
          for (var i in Dt(t))
            e.push(i);
        return e;
      }
      function Gp(t) {
        return kn.call(t);
      }
      function ju(t, e, i) {
        return e = te(e === n ? t.length - 1 : e, 0), function() {
          for (var d = arguments, A = -1, L = te(d.length - e, 0), B = Y(L); ++A < L; )
            B[A] = d[e + A];
          A = -1;
          for (var q = Y(e + 1); ++A < e; )
            q[A] = d[A];
          return q[e] = i(B), Ce(t, this, q);
        };
      }
      function Ku(t, e) {
        return e.length < 2 ? t : kr(t, Ge(e, 0, -1));
      }
      function Dp(t, e) {
        for (var i = t.length, d = le(e.length, i), A = _e(t); d--; ) {
          var L = e[d];
          t[d] = or(L, i) ? A[L] : n;
        }
        return t;
      }
      function Es(t, e) {
        if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
          return t[e];
      }
      var Yu = $u(vu), wi = Qg || function(t, e) {
        return oe.setTimeout(t, e);
      }, Rs = $u(op);
      function Xu(t, e, i) {
        var d = e + "";
        return Rs(t, Pp(d, Bp(Rp(d), i)));
      }
      function $u(t) {
        var e = 0, i = 0;
        return function() {
          var d = i2(), A = y - (d - i);
          if (i = d, A > 0) {
            if (++e >= H)
              return arguments[0];
          } else
            e = 0;
          return t.apply(n, arguments);
        };
      }
      function ra(t, e) {
        var i = -1, d = t.length, A = d - 1;
        for (e = e === n ? d : e; ++i < e; ) {
          var L = hs(i, A), B = t[L];
          t[L] = t[i], t[i] = B;
        }
        return t.length = e, t;
      }
      var Zu = Mp(function(t) {
        var e = [];
        return t.charCodeAt(0) === 46 && e.push(""), t.replace(T1, function(i, d, A, L) {
          e.push(A ? L.replace(N1, "$1") : d || i);
        }), e;
      });
      function tr(t) {
        if (typeof t == "string" || Re(t))
          return t;
        var e = t + "";
        return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
      }
      function Mr(t) {
        if (t != null) {
          try {
            return On.call(t);
          } catch {
          }
          try {
            return t + "";
          } catch {
          }
        }
        return "";
      }
      function Bp(t, e) {
        return Ie(at, function(i) {
          var d = "_." + i[0];
          e & i[1] && !Rn(t, d) && t.push(d);
        }), t.sort();
      }
      function Ju(t) {
        if (t instanceof kt)
          return t.clone();
        var e = new Le(t.__wrapped__, t.__chain__);
        return e.__actions__ = _e(t.__actions__), e.__index__ = t.__index__, e.__values__ = t.__values__, e;
      }
      function Up(t, e, i) {
        (i ? de(t, e, i) : e === n) ? e = 1 : e = te(wt(e), 0);
        var d = t == null ? 0 : t.length;
        if (!d || e < 1)
          return [];
        for (var A = 0, L = 0, B = Y(Dn(d / e)); A < d; )
          B[L++] = Ge(t, A, A += e);
        return B;
      }
      function qp(t) {
        for (var e = -1, i = t == null ? 0 : t.length, d = 0, A = []; ++e < i; ) {
          var L = t[e];
          L && (A[d++] = L);
        }
        return A;
      }
      function Hp() {
        var t = arguments.length;
        if (!t)
          return [];
        for (var e = Y(t - 1), i = arguments[0], d = t; d--; )
          e[d - 1] = arguments[d];
        return _r(St(i) ? _e(i) : [i], he(e, 1));
      }
      var zp = Et(function(t, e) {
        return Yt(t) ? _i(t, he(e, 1, Yt, !0)) : [];
      }), Vp = Et(function(t, e) {
        var i = De(e);
        return Yt(i) && (i = n), Yt(t) ? _i(t, he(e, 1, Yt, !0), pt(i, 2)) : [];
      }), Wp = Et(function(t, e) {
        var i = De(e);
        return Yt(i) && (i = n), Yt(t) ? _i(t, he(e, 1, Yt, !0), n, i) : [];
      });
      function jp(t, e, i) {
        var d = t == null ? 0 : t.length;
        return d ? (e = i || e === n ? 1 : wt(e), Ge(t, e < 0 ? 0 : e, d)) : [];
      }
      function Kp(t, e, i) {
        var d = t == null ? 0 : t.length;
        return d ? (e = i || e === n ? 1 : wt(e), e = d - e, Ge(t, 0, e < 0 ? 0 : e)) : [];
      }
      function Yp(t, e) {
        return t && t.length ? Yn(t, pt(e, 3), !0, !0) : [];
      }
      function Xp(t, e) {
        return t && t.length ? Yn(t, pt(e, 3), !0) : [];
      }
      function $p(t, e, i, d) {
        var A = t == null ? 0 : t.length;
        return A ? (i && typeof i != "number" && de(t, e, i) && (i = 0, d = A), H2(t, e, i, d)) : [];
      }
      function Qu(t, e, i) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var A = i == null ? 0 : wt(i);
        return A < 0 && (A = te(d + A, 0)), An(t, pt(e, 3), A);
      }
      function tc(t, e, i) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var A = d - 1;
        return i !== n && (A = wt(i), A = i < 0 ? te(d + A, 0) : le(A, d - 1)), An(t, pt(e, 3), A, !0);
      }
      function ec(t) {
        var e = t == null ? 0 : t.length;
        return e ? he(t, 1) : [];
      }
      function Zp(t) {
        var e = t == null ? 0 : t.length;
        return e ? he(t, U) : [];
      }
      function Jp(t, e) {
        var i = t == null ? 0 : t.length;
        return i ? (e = e === n ? 1 : wt(e), he(t, e)) : [];
      }
      function Qp(t) {
        for (var e = -1, i = t == null ? 0 : t.length, d = {}; ++e < i; ) {
          var A = t[e];
          d[A[0]] = A[1];
        }
        return d;
      }
      function rc(t) {
        return t && t.length ? t[0] : n;
      }
      function t_(t, e, i) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var A = i == null ? 0 : wt(i);
        return A < 0 && (A = te(d + A, 0)), Ur(t, e, A);
      }
      function e_(t) {
        var e = t == null ? 0 : t.length;
        return e ? Ge(t, 0, -1) : [];
      }
      var r_ = Et(function(t) {
        var e = Ht(t, fs);
        return e.length && e[0] === t[0] ? is(e) : [];
      }), i_ = Et(function(t) {
        var e = De(t), i = Ht(t, fs);
        return e === De(i) ? e = n : i.pop(), i.length && i[0] === t[0] ? is(i, pt(e, 2)) : [];
      }), n_ = Et(function(t) {
        var e = De(t), i = Ht(t, fs);
        return e = typeof e == "function" ? e : n, e && i.pop(), i.length && i[0] === t[0] ? is(i, n, e) : [];
      });
      function a_(t, e) {
        return t == null ? "" : e2.call(t, e);
      }
      function De(t) {
        var e = t == null ? 0 : t.length;
        return e ? t[e - 1] : n;
      }
      function s_(t, e, i) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var A = d;
        return i !== n && (A = wt(i), A = A < 0 ? te(d + A, 0) : le(A, d - 1)), e === e ? Bg(t, e, A) : An(t, Nl, A, !0);
      }
      function o_(t, e) {
        return t && t.length ? fu(t, wt(e)) : n;
      }
      var h_ = Et(ic);
      function ic(t, e) {
        return t && t.length && e && e.length ? os(t, e) : t;
      }
      function l_(t, e, i) {
        return t && t.length && e && e.length ? os(t, e, pt(i, 2)) : t;
      }
      function u_(t, e, i) {
        return t && t.length && e && e.length ? os(t, e, n, i) : t;
      }
      var c_ = sr(function(t, e) {
        var i = t == null ? 0 : t.length, d = Qa(t, e);
        return _u(t, Ht(e, function(A) {
          return or(A, i) ? +A : A;
        }).sort(Ru)), d;
      });
      function d_(t, e) {
        var i = [];
        if (!(t && t.length))
          return i;
        var d = -1, A = [], L = t.length;
        for (e = pt(e, 3); ++d < L; ) {
          var B = t[d];
          e(B, d, t) && (i.push(B), A.push(d));
        }
        return _u(t, A), i;
      }
      function As(t) {
        return t == null ? t : a2.call(t);
      }
      function f_(t, e, i) {
        var d = t == null ? 0 : t.length;
        return d ? (i && typeof i != "number" && de(t, e, i) ? (e = 0, i = d) : (e = e == null ? 0 : wt(e), i = i === n ? d : wt(i)), Ge(t, e, i)) : [];
      }
      function g_(t, e) {
        return Kn(t, e);
      }
      function p_(t, e, i) {
        return us(t, e, pt(i, 2));
      }
      function __(t, e) {
        var i = t == null ? 0 : t.length;
        if (i) {
          var d = Kn(t, e);
          if (d < i && Ke(t[d], e))
            return d;
        }
        return -1;
      }
      function v_(t, e) {
        return Kn(t, e, !0);
      }
      function y_(t, e, i) {
        return us(t, e, pt(i, 2), !0);
      }
      function m_(t, e) {
        var i = t == null ? 0 : t.length;
        if (i) {
          var d = Kn(t, e, !0) - 1;
          if (Ke(t[d], e))
            return d;
        }
        return -1;
      }
      function b_(t) {
        return t && t.length ? yu(t) : [];
      }
      function S_(t, e) {
        return t && t.length ? yu(t, pt(e, 2)) : [];
      }
      function w_(t) {
        var e = t == null ? 0 : t.length;
        return e ? Ge(t, 1, e) : [];
      }
      function C_(t, e, i) {
        return t && t.length ? (e = i || e === n ? 1 : wt(e), Ge(t, 0, e < 0 ? 0 : e)) : [];
      }
      function x_(t, e, i) {
        var d = t == null ? 0 : t.length;
        return d ? (e = i || e === n ? 1 : wt(e), e = d - e, Ge(t, e < 0 ? 0 : e, d)) : [];
      }
      function E_(t, e) {
        return t && t.length ? Yn(t, pt(e, 3), !1, !0) : [];
      }
      function R_(t, e) {
        return t && t.length ? Yn(t, pt(e, 3)) : [];
      }
      var A_ = Et(function(t) {
        return br(he(t, 1, Yt, !0));
      }), T_ = Et(function(t) {
        var e = De(t);
        return Yt(e) && (e = n), br(he(t, 1, Yt, !0), pt(e, 2));
      }), P_ = Et(function(t) {
        var e = De(t);
        return e = typeof e == "function" ? e : n, br(he(t, 1, Yt, !0), n, e);
      });
      function F_(t) {
        return t && t.length ? br(t) : [];
      }
      function O_(t, e) {
        return t && t.length ? br(t, pt(e, 2)) : [];
      }
      function k_(t, e) {
        return e = typeof e == "function" ? e : n, t && t.length ? br(t, n, e) : [];
      }
      function Ts(t) {
        if (!(t && t.length))
          return [];
        var e = 0;
        return t = pr(t, function(i) {
          if (Yt(i))
            return e = te(i.length, e), !0;
        }), Wa(e, function(i) {
          return Ht(t, Ha(i));
        });
      }
      function nc(t, e) {
        if (!(t && t.length))
          return [];
        var i = Ts(t);
        return e == null ? i : Ht(i, function(d) {
          return Ce(e, n, d);
        });
      }
      var I_ = Et(function(t, e) {
        return Yt(t) ? _i(t, e) : [];
      }), M_ = Et(function(t) {
        return ds(pr(t, Yt));
      }), L_ = Et(function(t) {
        var e = De(t);
        return Yt(e) && (e = n), ds(pr(t, Yt), pt(e, 2));
      }), N_ = Et(function(t) {
        var e = De(t);
        return e = typeof e == "function" ? e : n, ds(pr(t, Yt), n, e);
      }), G_ = Et(Ts);
      function D_(t, e) {
        return wu(t || [], e || [], pi);
      }
      function B_(t, e) {
        return wu(t || [], e || [], mi);
      }
      var U_ = Et(function(t) {
        var e = t.length, i = e > 1 ? t[e - 1] : n;
        return i = typeof i == "function" ? (t.pop(), i) : n, nc(t, i);
      });
      function ac(t) {
        var e = k(t);
        return e.__chain__ = !0, e;
      }
      function q_(t, e) {
        return e(t), t;
      }
      function ia(t, e) {
        return e(t);
      }
      var H_ = sr(function(t) {
        var e = t.length, i = e ? t[0] : 0, d = this.__wrapped__, A = function(L) {
          return Qa(L, t);
        };
        return e > 1 || this.__actions__.length || !(d instanceof kt) || !or(i) ? this.thru(A) : (d = d.slice(i, +i + (e ? 1 : 0)), d.__actions__.push({
          func: ia,
          args: [A],
          thisArg: n
        }), new Le(d, this.__chain__).thru(function(L) {
          return e && !L.length && L.push(n), L;
        }));
      });
      function z_() {
        return ac(this);
      }
      function V_() {
        return new Le(this.value(), this.__chain__);
      }
      function W_() {
        this.__values__ === n && (this.__values__ = mc(this.value()));
        var t = this.__index__ >= this.__values__.length, e = t ? n : this.__values__[this.__index__++];
        return { done: t, value: e };
      }
      function j_() {
        return this;
      }
      function K_(t) {
        for (var e, i = this; i instanceof Hn; ) {
          var d = Ju(i);
          d.__index__ = 0, d.__values__ = n, e ? A.__wrapped__ = d : e = d;
          var A = d;
          i = i.__wrapped__;
        }
        return A.__wrapped__ = t, e;
      }
      function Y_() {
        var t = this.__wrapped__;
        if (t instanceof kt) {
          var e = t;
          return this.__actions__.length && (e = new kt(this)), e = e.reverse(), e.__actions__.push({
            func: ia,
            args: [As],
            thisArg: n
          }), new Le(e, this.__chain__);
        }
        return this.thru(As);
      }
      function X_() {
        return Su(this.__wrapped__, this.__actions__);
      }
      var $_ = Xn(function(t, e, i) {
        Gt.call(t, i) ? ++t[i] : nr(t, i, 1);
      });
      function Z_(t, e, i) {
        var d = St(t) ? Ml : q2;
        return i && de(t, e, i) && (e = n), d(t, pt(e, 3));
      }
      function J_(t, e) {
        var i = St(t) ? pr : nu;
        return i(t, pt(e, 3));
      }
      var Q_ = ku(Qu), t5 = ku(tc);
      function e5(t, e) {
        return he(na(t, e), 1);
      }
      function r5(t, e) {
        return he(na(t, e), U);
      }
      function i5(t, e, i) {
        return i = i === n ? 1 : wt(i), he(na(t, e), i);
      }
      function sc(t, e) {
        var i = St(t) ? Ie : mr;
        return i(t, pt(e, 3));
      }
      function oc(t, e) {
        var i = St(t) ? wg : iu;
        return i(t, pt(e, 3));
      }
      var n5 = Xn(function(t, e, i) {
        Gt.call(t, i) ? t[i].push(e) : nr(t, i, [e]);
      });
      function a5(t, e, i, d) {
        t = ve(t) ? t : Jr(t), i = i && !d ? wt(i) : 0;
        var A = t.length;
        return i < 0 && (i = te(A + i, 0)), la(t) ? i <= A && t.indexOf(e, i) > -1 : !!A && Ur(t, e, i) > -1;
      }
      var s5 = Et(function(t, e, i) {
        var d = -1, A = typeof e == "function", L = ve(t) ? Y(t.length) : [];
        return mr(t, function(B) {
          L[++d] = A ? Ce(e, B, i) : vi(B, e, i);
        }), L;
      }), o5 = Xn(function(t, e, i) {
        nr(t, i, e);
      });
      function na(t, e) {
        var i = St(t) ? Ht : uu;
        return i(t, pt(e, 3));
      }
      function h5(t, e, i, d) {
        return t == null ? [] : (St(e) || (e = e == null ? [] : [e]), i = d ? n : i, St(i) || (i = i == null ? [] : [i]), gu(t, e, i));
      }
      var l5 = Xn(function(t, e, i) {
        t[i ? 0 : 1].push(e);
      }, function() {
        return [[], []];
      });
      function u5(t, e, i) {
        var d = St(t) ? Ua : Dl, A = arguments.length < 3;
        return d(t, pt(e, 4), i, A, mr);
      }
      function c5(t, e, i) {
        var d = St(t) ? Cg : Dl, A = arguments.length < 3;
        return d(t, pt(e, 4), i, A, iu);
      }
      function d5(t, e) {
        var i = St(t) ? pr : nu;
        return i(t, oa(pt(e, 3)));
      }
      function f5(t) {
        var e = St(t) ? Ql : ap;
        return e(t);
      }
      function g5(t, e, i) {
        (i ? de(t, e, i) : e === n) ? e = 1 : e = wt(e);
        var d = St(t) ? N2 : sp;
        return d(t, e);
      }
      function p5(t) {
        var e = St(t) ? G2 : hp;
        return e(t);
      }
      function _5(t) {
        if (t == null)
          return 0;
        if (ve(t))
          return la(t) ? Hr(t) : t.length;
        var e = ue(t);
        return e == xt || e == Zt ? t.size : as(t).length;
      }
      function v5(t, e, i) {
        var d = St(t) ? qa : lp;
        return i && de(t, e, i) && (e = n), d(t, pt(e, 3));
      }
      var y5 = Et(function(t, e) {
        if (t == null)
          return [];
        var i = e.length;
        return i > 1 && de(t, e[0], e[1]) ? e = [] : i > 2 && de(e[0], e[1], e[2]) && (e = [e[0]]), gu(t, he(e, 1), []);
      }), aa = Jg || function() {
        return oe.Date.now();
      };
      function m5(t, e) {
        if (typeof e != "function")
          throw new Me(h);
        return t = wt(t), function() {
          if (--t < 1)
            return e.apply(this, arguments);
        };
      }
      function hc(t, e, i) {
        return e = i ? n : e, e = t && e == null ? t.length : e, ar(t, D, n, n, n, n, e);
      }
      function lc(t, e) {
        var i;
        if (typeof e != "function")
          throw new Me(h);
        return t = wt(t), function() {
          return --t > 0 && (i = e.apply(this, arguments)), t <= 1 && (e = n), i;
        };
      }
      var Ps = Et(function(t, e, i) {
        var d = x;
        if (i.length) {
          var A = vr(i, $r(Ps));
          d |= E;
        }
        return ar(t, d, e, i, A);
      }), uc = Et(function(t, e, i) {
        var d = x | P;
        if (i.length) {
          var A = vr(i, $r(uc));
          d |= E;
        }
        return ar(e, d, t, i, A);
      });
      function cc(t, e, i) {
        e = i ? n : e;
        var d = ar(t, f, n, n, n, n, n, e);
        return d.placeholder = cc.placeholder, d;
      }
      function dc(t, e, i) {
        e = i ? n : e;
        var d = ar(t, S, n, n, n, n, n, e);
        return d.placeholder = dc.placeholder, d;
      }
      function fc(t, e, i) {
        var d, A, L, B, q, W, rt = 0, it = !1, nt = !1, ot = !0;
        if (typeof t != "function")
          throw new Me(h);
        e = Be(e) || 0, Vt(i) && (it = !!i.leading, nt = "maxWait" in i, L = nt ? te(Be(i.maxWait) || 0, e) : L, ot = "trailing" in i ? !!i.trailing : ot);
        function dt(Xt) {
          var Ye = d, ur = A;
          return d = A = n, rt = Xt, B = t.apply(ur, Ye), B;
        }
        function _t(Xt) {
          return rt = Xt, q = wi(Ft, e), it ? dt(Xt) : B;
        }
        function Ct(Xt) {
          var Ye = Xt - W, ur = Xt - rt, kc = e - Ye;
          return nt ? le(kc, L - ur) : kc;
        }
        function vt(Xt) {
          var Ye = Xt - W, ur = Xt - rt;
          return W === n || Ye >= e || Ye < 0 || nt && ur >= L;
        }
        function Ft() {
          var Xt = aa();
          if (vt(Xt))
            return It(Xt);
          q = wi(Ft, Ct(Xt));
        }
        function It(Xt) {
          return q = n, ot && d ? dt(Xt) : (d = A = n, B);
        }
        function Ae() {
          q !== n && Cu(q), rt = 0, d = W = A = q = n;
        }
        function fe() {
          return q === n ? B : It(aa());
        }
        function Te() {
          var Xt = aa(), Ye = vt(Xt);
          if (d = arguments, A = this, W = Xt, Ye) {
            if (q === n)
              return _t(W);
            if (nt)
              return Cu(q), q = wi(Ft, e), dt(W);
          }
          return q === n && (q = wi(Ft, e)), B;
        }
        return Te.cancel = Ae, Te.flush = fe, Te;
      }
      var b5 = Et(function(t, e) {
        return ru(t, 1, e);
      }), S5 = Et(function(t, e, i) {
        return ru(t, Be(e) || 0, i);
      });
      function w5(t) {
        return ar(t, M);
      }
      function sa(t, e) {
        if (typeof t != "function" || e != null && typeof e != "function")
          throw new Me(h);
        var i = function() {
          var d = arguments, A = e ? e.apply(this, d) : d[0], L = i.cache;
          if (L.has(A))
            return L.get(A);
          var B = t.apply(this, d);
          return i.cache = L.set(A, B) || L, B;
        };
        return i.cache = new (sa.Cache || ir)(), i;
      }
      sa.Cache = ir;
      function oa(t) {
        if (typeof t != "function")
          throw new Me(h);
        return function() {
          var e = arguments;
          switch (e.length) {
            case 0:
              return !t.call(this);
            case 1:
              return !t.call(this, e[0]);
            case 2:
              return !t.call(this, e[0], e[1]);
            case 3:
              return !t.call(this, e[0], e[1], e[2]);
          }
          return !t.apply(this, e);
        };
      }
      function C5(t) {
        return lc(2, t);
      }
      var x5 = up(function(t, e) {
        e = e.length == 1 && St(e[0]) ? Ht(e[0], xe(pt())) : Ht(he(e, 1), xe(pt()));
        var i = e.length;
        return Et(function(d) {
          for (var A = -1, L = le(d.length, i); ++A < L; )
            d[A] = e[A].call(this, d[A]);
          return Ce(t, this, d);
        });
      }), Fs = Et(function(t, e) {
        var i = vr(e, $r(Fs));
        return ar(t, E, n, e, i);
      }), gc = Et(function(t, e) {
        var i = vr(e, $r(gc));
        return ar(t, T, n, e, i);
      }), E5 = sr(function(t, e) {
        return ar(t, I, n, n, n, e);
      });
      function R5(t, e) {
        if (typeof t != "function")
          throw new Me(h);
        return e = e === n ? e : wt(e), Et(t, e);
      }
      function A5(t, e) {
        if (typeof t != "function")
          throw new Me(h);
        return e = e == null ? 0 : te(wt(e), 0), Et(function(i) {
          var d = i[e], A = wr(i, 0, e);
          return d && _r(A, d), Ce(t, this, A);
        });
      }
      function T5(t, e, i) {
        var d = !0, A = !0;
        if (typeof t != "function")
          throw new Me(h);
        return Vt(i) && (d = "leading" in i ? !!i.leading : d, A = "trailing" in i ? !!i.trailing : A), fc(t, e, {
          leading: d,
          maxWait: e,
          trailing: A
        });
      }
      function P5(t) {
        return hc(t, 1);
      }
      function F5(t, e) {
        return Fs(gs(e), t);
      }
      function O5() {
        if (!arguments.length)
          return [];
        var t = arguments[0];
        return St(t) ? t : [t];
      }
      function k5(t) {
        return Ne(t, v);
      }
      function I5(t, e) {
        return e = typeof e == "function" ? e : n, Ne(t, v, e);
      }
      function M5(t) {
        return Ne(t, m | v);
      }
      function L5(t, e) {
        return e = typeof e == "function" ? e : n, Ne(t, m | v, e);
      }
      function N5(t, e) {
        return e == null || eu(t, e, ae(e));
      }
      function Ke(t, e) {
        return t === e || t !== t && e !== e;
      }
      var G5 = Qn(rs), D5 = Qn(function(t, e) {
        return t >= e;
      }), Lr = ou(/* @__PURE__ */ function() {
        return arguments;
      }()) ? ou : function(t) {
        return jt(t) && Gt.call(t, "callee") && !Kl.call(t, "callee");
      }, St = Y.isArray, B5 = Tl ? xe(Tl) : K2;
      function ve(t) {
        return t != null && ha(t.length) && !hr(t);
      }
      function Yt(t) {
        return jt(t) && ve(t);
      }
      function U5(t) {
        return t === !0 || t === !1 || jt(t) && ce(t) == j;
      }
      var Cr = t2 || qs, q5 = Pl ? xe(Pl) : Y2;
      function H5(t) {
        return jt(t) && t.nodeType === 1 && !Ci(t);
      }
      function z5(t) {
        if (t == null)
          return !0;
        if (ve(t) && (St(t) || typeof t == "string" || typeof t.splice == "function" || Cr(t) || Zr(t) || Lr(t)))
          return !t.length;
        var e = ue(t);
        if (e == xt || e == Zt)
          return !t.size;
        if (Si(t))
          return !as(t).length;
        for (var i in t)
          if (Gt.call(t, i))
            return !1;
        return !0;
      }
      function V5(t, e) {
        return yi(t, e);
      }
      function W5(t, e, i) {
        i = typeof i == "function" ? i : n;
        var d = i ? i(t, e) : n;
        return d === n ? yi(t, e, n, i) : !!d;
      }
      function Os(t) {
        if (!jt(t))
          return !1;
        var e = ce(t);
        return e == ft || e == ut || typeof t.message == "string" && typeof t.name == "string" && !Ci(t);
      }
      function j5(t) {
        return typeof t == "number" && Xl(t);
      }
      function hr(t) {
        if (!Vt(t))
          return !1;
        var e = ce(t);
        return e == gt || e == Mt || e == z || e == gr;
      }
      function pc(t) {
        return typeof t == "number" && t == wt(t);
      }
      function ha(t) {
        return typeof t == "number" && t > -1 && t % 1 == 0 && t <= K;
      }
      function Vt(t) {
        var e = typeof t;
        return t != null && (e == "object" || e == "function");
      }
      function jt(t) {
        return t != null && typeof t == "object";
      }
      var _c = Fl ? xe(Fl) : $2;
      function K5(t, e) {
        return t === e || ns(t, e, Ss(e));
      }
      function Y5(t, e, i) {
        return i = typeof i == "function" ? i : n, ns(t, e, Ss(e), i);
      }
      function X5(t) {
        return vc(t) && t != +t;
      }
      function $5(t) {
        if (Ip(t))
          throw new bt(s);
        return hu(t);
      }
      function Z5(t) {
        return t === null;
      }
      function J5(t) {
        return t == null;
      }
      function vc(t) {
        return typeof t == "number" || jt(t) && ce(t) == mt;
      }
      function Ci(t) {
        if (!jt(t) || ce(t) != Pt)
          return !1;
        var e = Ln(t);
        if (e === null)
          return !0;
        var i = Gt.call(e, "constructor") && e.constructor;
        return typeof i == "function" && i instanceof i && On.call(i) == Yg;
      }
      var ks = Ol ? xe(Ol) : Z2;
      function Q5(t) {
        return pc(t) && t >= -9007199254740991 && t <= K;
      }
      var yc = kl ? xe(kl) : J2;
      function la(t) {
        return typeof t == "string" || !St(t) && jt(t) && ce(t) == Jt;
      }
      function Re(t) {
        return typeof t == "symbol" || jt(t) && ce(t) == Ut;
      }
      var Zr = Il ? xe(Il) : Q2;
      function t3(t) {
        return t === n;
      }
      function e3(t) {
        return jt(t) && ue(t) == ie;
      }
      function r3(t) {
        return jt(t) && ce(t) == ze;
      }
      var i3 = Qn(ss), n3 = Qn(function(t, e) {
        return t <= e;
      });
      function mc(t) {
        if (!t)
          return [];
        if (ve(t))
          return la(t) ? We(t) : _e(t);
        if (ui && t[ui])
          return Ng(t[ui]());
        var e = ue(t), i = e == xt ? Ka : e == Zt ? Tn : Jr;
        return i(t);
      }
      function lr(t) {
        if (!t)
          return t === 0 ? t : 0;
        if (t = Be(t), t === U || t === -1 / 0) {
          var e = t < 0 ? -1 : 1;
          return e * $;
        }
        return t === t ? t : 0;
      }
      function wt(t) {
        var e = lr(t), i = e % 1;
        return e === e ? i ? e - i : e : 0;
      }
      function bc(t) {
        return t ? Or(wt(t), 0, Q) : 0;
      }
      function Be(t) {
        if (typeof t == "number")
          return t;
        if (Re(t))
          return X;
        if (Vt(t)) {
          var e = typeof t.valueOf == "function" ? t.valueOf() : t;
          t = Vt(e) ? e + "" : e;
        }
        if (typeof t != "string")
          return t === 0 ? t : +t;
        t = Bl(t);
        var i = B1.test(t);
        return i || q1.test(t) ? mg(t.slice(2), i ? 2 : 8) : D1.test(t) ? X : +t;
      }
      function Sc(t) {
        return Qe(t, ye(t));
      }
      function a3(t) {
        return t ? Or(wt(t), -9007199254740991, K) : t === 0 ? t : 0;
      }
      function Nt(t) {
        return t == null ? "" : Ee(t);
      }
      var s3 = Yr(function(t, e) {
        if (Si(e) || ve(e)) {
          Qe(e, ae(e), t);
          return;
        }
        for (var i in e)
          Gt.call(e, i) && pi(t, i, e[i]);
      }), wc = Yr(function(t, e) {
        Qe(e, ye(e), t);
      }), ua = Yr(function(t, e, i, d) {
        Qe(e, ye(e), t, d);
      }), o3 = Yr(function(t, e, i, d) {
        Qe(e, ae(e), t, d);
      }), h3 = sr(Qa);
      function l3(t, e) {
        var i = Kr(t);
        return e == null ? i : tu(i, e);
      }
      var u3 = Et(function(t, e) {
        t = Dt(t);
        var i = -1, d = e.length, A = d > 2 ? e[2] : n;
        for (A && de(e[0], e[1], A) && (d = 1); ++i < d; )
          for (var L = e[i], B = ye(L), q = -1, W = B.length; ++q < W; ) {
            var rt = B[q], it = t[rt];
            (it === n || Ke(it, Vr[rt]) && !Gt.call(t, rt)) && (t[rt] = L[rt]);
          }
        return t;
      }), c3 = Et(function(t) {
        return t.push(n, Bu), Ce(Cc, n, t);
      });
      function d3(t, e) {
        return Ll(t, pt(e, 3), Je);
      }
      function f3(t, e) {
        return Ll(t, pt(e, 3), es);
      }
      function g3(t, e) {
        return t == null ? t : ts(t, pt(e, 3), ye);
      }
      function p3(t, e) {
        return t == null ? t : au(t, pt(e, 3), ye);
      }
      function _3(t, e) {
        return t && Je(t, pt(e, 3));
      }
      function v3(t, e) {
        return t && es(t, pt(e, 3));
      }
      function y3(t) {
        return t == null ? [] : Wn(t, ae(t));
      }
      function m3(t) {
        return t == null ? [] : Wn(t, ye(t));
      }
      function Is(t, e, i) {
        var d = t == null ? n : kr(t, e);
        return d === n ? i : d;
      }
      function b3(t, e) {
        return t != null && Hu(t, e, z2);
      }
      function Ms(t, e) {
        return t != null && Hu(t, e, V2);
      }
      var S3 = Mu(function(t, e, i) {
        e != null && typeof e.toString != "function" && (e = kn.call(e)), t[e] = i;
      }, Ns(me)), w3 = Mu(function(t, e, i) {
        e != null && typeof e.toString != "function" && (e = kn.call(e)), Gt.call(t, e) ? t[e].push(i) : t[e] = [i];
      }, pt), C3 = Et(vi);
      function ae(t) {
        return ve(t) ? Jl(t) : as(t);
      }
      function ye(t) {
        return ve(t) ? Jl(t, !0) : tp(t);
      }
      function x3(t, e) {
        var i = {};
        return e = pt(e, 3), Je(t, function(d, A, L) {
          nr(i, e(d, A, L), d);
        }), i;
      }
      function E3(t, e) {
        var i = {};
        return e = pt(e, 3), Je(t, function(d, A, L) {
          nr(i, A, e(d, A, L));
        }), i;
      }
      var R3 = Yr(function(t, e, i) {
        jn(t, e, i);
      }), Cc = Yr(function(t, e, i, d) {
        jn(t, e, i, d);
      }), A3 = sr(function(t, e) {
        var i = {};
        if (t == null)
          return i;
        var d = !1;
        e = Ht(e, function(L) {
          return L = Sr(L, t), d || (d = L.length > 1), L;
        }), Qe(t, ms(t), i), d && (i = Ne(i, m | C | v, Sp));
        for (var A = e.length; A--; )
          cs(i, e[A]);
        return i;
      });
      function T3(t, e) {
        return xc(t, oa(pt(e)));
      }
      var P3 = sr(function(t, e) {
        return t == null ? {} : rp(t, e);
      });
      function xc(t, e) {
        if (t == null)
          return {};
        var i = Ht(ms(t), function(d) {
          return [d];
        });
        return e = pt(e), pu(t, i, function(d, A) {
          return e(d, A[0]);
        });
      }
      function F3(t, e, i) {
        e = Sr(e, t);
        var d = -1, A = e.length;
        for (A || (A = 1, t = n); ++d < A; ) {
          var L = t == null ? n : t[tr(e[d])];
          L === n && (d = A, L = i), t = hr(L) ? L.call(t) : L;
        }
        return t;
      }
      function O3(t, e, i) {
        return t == null ? t : mi(t, e, i);
      }
      function k3(t, e, i, d) {
        return d = typeof d == "function" ? d : n, t == null ? t : mi(t, e, i, d);
      }
      var Ec = Gu(ae), Rc = Gu(ye);
      function I3(t, e, i) {
        var d = St(t), A = d || Cr(t) || Zr(t);
        if (e = pt(e, 4), i == null) {
          var L = t && t.constructor;
          A ? i = d ? new L() : [] : Vt(t) ? i = hr(L) ? Kr(Ln(t)) : {} : i = {};
        }
        return (A ? Ie : Je)(t, function(B, q, W) {
          return e(i, B, q, W);
        }), i;
      }
      function M3(t, e) {
        return t == null ? !0 : cs(t, e);
      }
      function L3(t, e, i) {
        return t == null ? t : bu(t, e, gs(i));
      }
      function N3(t, e, i, d) {
        return d = typeof d == "function" ? d : n, t == null ? t : bu(t, e, gs(i), d);
      }
      function Jr(t) {
        return t == null ? [] : ja(t, ae(t));
      }
      function G3(t) {
        return t == null ? [] : ja(t, ye(t));
      }
      function D3(t, e, i) {
        return i === n && (i = e, e = n), i !== n && (i = Be(i), i = i === i ? i : 0), e !== n && (e = Be(e), e = e === e ? e : 0), Or(Be(t), e, i);
      }
      function B3(t, e, i) {
        return e = lr(e), i === n ? (i = e, e = 0) : i = lr(i), t = Be(t), W2(t, e, i);
      }
      function U3(t, e, i) {
        if (i && typeof i != "boolean" && de(t, e, i) && (e = i = n), i === n && (typeof e == "boolean" ? (i = e, e = n) : typeof t == "boolean" && (i = t, t = n)), t === n && e === n ? (t = 0, e = 1) : (t = lr(t), e === n ? (e = t, t = 0) : e = lr(e)), t > e) {
          var d = t;
          t = e, e = d;
        }
        if (i || t % 1 || e % 1) {
          var A = $l();
          return le(t + A * (e - t + yg("1e-" + ((A + "").length - 1))), e);
        }
        return hs(t, e);
      }
      var q3 = Xr(function(t, e, i) {
        return e = e.toLowerCase(), t + (i ? Ac(e) : e);
      });
      function Ac(t) {
        return Ls(Nt(t).toLowerCase());
      }
      function Tc(t) {
        return t = Nt(t), t && t.replace(z1, Og).replace(hg, "");
      }
      function H3(t, e, i) {
        t = Nt(t), e = Ee(e);
        var d = t.length;
        i = i === n ? d : Or(wt(i), 0, d);
        var A = i;
        return i -= e.length, i >= 0 && t.slice(i, A) == e;
      }
      function z3(t) {
        return t = Nt(t), t && C1.test(t) ? t.replace(al, kg) : t;
      }
      function V3(t) {
        return t = Nt(t), t && P1.test(t) ? t.replace(Fa, "\\$&") : t;
      }
      var W3 = Xr(function(t, e, i) {
        return t + (i ? "-" : "") + e.toLowerCase();
      }), j3 = Xr(function(t, e, i) {
        return t + (i ? " " : "") + e.toLowerCase();
      }), K3 = Ou("toLowerCase");
      function Y3(t, e, i) {
        t = Nt(t), e = wt(e);
        var d = e ? Hr(t) : 0;
        if (!e || d >= e)
          return t;
        var A = (e - d) / 2;
        return Jn(Bn(A), i) + t + Jn(Dn(A), i);
      }
      function X3(t, e, i) {
        t = Nt(t), e = wt(e);
        var d = e ? Hr(t) : 0;
        return e && d < e ? t + Jn(e - d, i) : t;
      }
      function $3(t, e, i) {
        t = Nt(t), e = wt(e);
        var d = e ? Hr(t) : 0;
        return e && d < e ? Jn(e - d, i) + t : t;
      }
      function Z3(t, e, i) {
        return i || e == null ? e = 0 : e && (e = +e), n2(Nt(t).replace(Oa, ""), e || 0);
      }
      function J3(t, e, i) {
        return (i ? de(t, e, i) : e === n) ? e = 1 : e = wt(e), ls(Nt(t), e);
      }
      function Q3() {
        var t = arguments, e = Nt(t[0]);
        return t.length < 3 ? e : e.replace(t[1], t[2]);
      }
      var t4 = Xr(function(t, e, i) {
        return t + (i ? "_" : "") + e.toLowerCase();
      });
      function e4(t, e, i) {
        return i && typeof i != "number" && de(t, e, i) && (e = i = n), i = i === n ? Q : i >>> 0, i ? (t = Nt(t), t && (typeof e == "string" || e != null && !ks(e)) && (e = Ee(e), !e && qr(t)) ? wr(We(t), 0, i) : t.split(e, i)) : [];
      }
      var r4 = Xr(function(t, e, i) {
        return t + (i ? " " : "") + Ls(e);
      });
      function i4(t, e, i) {
        return t = Nt(t), i = i == null ? 0 : Or(wt(i), 0, t.length), e = Ee(e), t.slice(i, i + e.length) == e;
      }
      function n4(t, e, i) {
        var d = k.templateSettings;
        i && de(t, e, i) && (e = n), t = Nt(t), e = ua({}, e, d, Du);
        var A = ua({}, e.imports, d.imports, Du), L = ae(A), B = ja(A, L), q, W, rt = 0, it = e.interpolate || Cn, nt = "__p += '", ot = Ya(
          (e.escape || Cn).source + "|" + it.source + "|" + (it === sl ? G1 : Cn).source + "|" + (e.evaluate || Cn).source + "|$",
          "g"
        ), dt = "//# sourceURL=" + (Gt.call(e, "sourceURL") ? (e.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++fg + "]") + `
`;
        t.replace(ot, function(vt, Ft, It, Ae, fe, Te) {
          return It || (It = Ae), nt += t.slice(rt, Te).replace(V1, Ig), Ft && (q = !0, nt += `' +
__e(` + Ft + `) +
'`), fe && (W = !0, nt += `';
` + fe + `;
__p += '`), It && (nt += `' +
((__t = (` + It + `)) == null ? '' : __t) +
'`), rt = Te + vt.length, vt;
        }), nt += `';
`;
        var _t = Gt.call(e, "variable") && e.variable;
        if (!_t)
          nt = `with (obj) {
` + nt + `
}
`;
        else if (L1.test(_t))
          throw new bt(l);
        nt = (W ? nt.replace(m1, "") : nt).replace(b1, "$1").replace(S1, "$1;"), nt = "function(" + (_t || "obj") + `) {
` + (_t ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (q ? ", __e = _.escape" : "") + (W ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + nt + `return __p
}`;
        var Ct = Fc(function() {
          return Lt(L, dt + "return " + nt).apply(n, B);
        });
        if (Ct.source = nt, Os(Ct))
          throw Ct;
        return Ct;
      }
      function a4(t) {
        return Nt(t).toLowerCase();
      }
      function s4(t) {
        return Nt(t).toUpperCase();
      }
      function o4(t, e, i) {
        if (t = Nt(t), t && (i || e === n))
          return Bl(t);
        if (!t || !(e = Ee(e)))
          return t;
        var d = We(t), A = We(e), L = Ul(d, A), B = ql(d, A) + 1;
        return wr(d, L, B).join("");
      }
      function h4(t, e, i) {
        if (t = Nt(t), t && (i || e === n))
          return t.slice(0, zl(t) + 1);
        if (!t || !(e = Ee(e)))
          return t;
        var d = We(t), A = ql(d, We(e)) + 1;
        return wr(d, 0, A).join("");
      }
      function l4(t, e, i) {
        if (t = Nt(t), t && (i || e === n))
          return t.replace(Oa, "");
        if (!t || !(e = Ee(e)))
          return t;
        var d = We(t), A = Ul(d, We(e));
        return wr(d, A).join("");
      }
      function u4(t, e) {
        var i = O, d = N;
        if (Vt(e)) {
          var A = "separator" in e ? e.separator : A;
          i = "length" in e ? wt(e.length) : i, d = "omission" in e ? Ee(e.omission) : d;
        }
        t = Nt(t);
        var L = t.length;
        if (qr(t)) {
          var B = We(t);
          L = B.length;
        }
        if (i >= L)
          return t;
        var q = i - Hr(d);
        if (q < 1)
          return d;
        var W = B ? wr(B, 0, q).join("") : t.slice(0, q);
        if (A === n)
          return W + d;
        if (B && (q += W.length - q), ks(A)) {
          if (t.slice(q).search(A)) {
            var rt, it = W;
            for (A.global || (A = Ya(A.source, Nt(ol.exec(A)) + "g")), A.lastIndex = 0; rt = A.exec(it); )
              var nt = rt.index;
            W = W.slice(0, nt === n ? q : nt);
          }
        } else if (t.indexOf(Ee(A), q) != q) {
          var ot = W.lastIndexOf(A);
          ot > -1 && (W = W.slice(0, ot));
        }
        return W + d;
      }
      function c4(t) {
        return t = Nt(t), t && w1.test(t) ? t.replace(nl, Ug) : t;
      }
      var d4 = Xr(function(t, e, i) {
        return t + (i ? " " : "") + e.toUpperCase();
      }), Ls = Ou("toUpperCase");
      function Pc(t, e, i) {
        return t = Nt(t), e = i ? n : e, e === n ? Lg(t) ? zg(t) : Rg(t) : t.match(e) || [];
      }
      var Fc = Et(function(t, e) {
        try {
          return Ce(t, n, e);
        } catch (i) {
          return Os(i) ? i : new bt(i);
        }
      }), f4 = sr(function(t, e) {
        return Ie(e, function(i) {
          i = tr(i), nr(t, i, Ps(t[i], t));
        }), t;
      });
      function g4(t) {
        var e = t == null ? 0 : t.length, i = pt();
        return t = e ? Ht(t, function(d) {
          if (typeof d[1] != "function")
            throw new Me(h);
          return [i(d[0]), d[1]];
        }) : [], Et(function(d) {
          for (var A = -1; ++A < e; ) {
            var L = t[A];
            if (Ce(L[0], this, d))
              return Ce(L[1], this, d);
          }
        });
      }
      function p4(t) {
        return U2(Ne(t, m));
      }
      function Ns(t) {
        return function() {
          return t;
        };
      }
      function _4(t, e) {
        return t == null || t !== t ? e : t;
      }
      var v4 = Iu(), y4 = Iu(!0);
      function me(t) {
        return t;
      }
      function Gs(t) {
        return lu(typeof t == "function" ? t : Ne(t, m));
      }
      function m4(t) {
        return cu(Ne(t, m));
      }
      function b4(t, e) {
        return du(t, Ne(e, m));
      }
      var S4 = Et(function(t, e) {
        return function(i) {
          return vi(i, t, e);
        };
      }), w4 = Et(function(t, e) {
        return function(i) {
          return vi(t, i, e);
        };
      });
      function Ds(t, e, i) {
        var d = ae(e), A = Wn(e, d);
        i == null && !(Vt(e) && (A.length || !d.length)) && (i = e, e = t, t = this, A = Wn(e, ae(e)));
        var L = !(Vt(i) && "chain" in i) || !!i.chain, B = hr(t);
        return Ie(A, function(q) {
          var W = e[q];
          t[q] = W, B && (t.prototype[q] = function() {
            var rt = this.__chain__;
            if (L || rt) {
              var it = t(this.__wrapped__), nt = it.__actions__ = _e(this.__actions__);
              return nt.push({ func: W, args: arguments, thisArg: t }), it.__chain__ = rt, it;
            }
            return W.apply(t, _r([this.value()], arguments));
          });
        }), t;
      }
      function C4() {
        return oe._ === this && (oe._ = Xg), this;
      }
      function Bs() {
      }
      function x4(t) {
        return t = wt(t), Et(function(e) {
          return fu(e, t);
        });
      }
      var E4 = _s(Ht), R4 = _s(Ml), A4 = _s(qa);
      function Oc(t) {
        return Cs(t) ? Ha(tr(t)) : ip(t);
      }
      function T4(t) {
        return function(e) {
          return t == null ? n : kr(t, e);
        };
      }
      var P4 = Lu(), F4 = Lu(!0);
      function Us() {
        return [];
      }
      function qs() {
        return !1;
      }
      function O4() {
        return {};
      }
      function k4() {
        return "";
      }
      function I4() {
        return !0;
      }
      function M4(t, e) {
        if (t = wt(t), t < 1 || t > K)
          return [];
        var i = Q, d = le(t, Q);
        e = pt(e), t -= Q;
        for (var A = Wa(d, e); ++i < t; )
          e(i);
        return A;
      }
      function L4(t) {
        return St(t) ? Ht(t, tr) : Re(t) ? [t] : _e(Zu(Nt(t)));
      }
      function N4(t) {
        var e = ++Kg;
        return Nt(t) + e;
      }
      var G4 = Zn(function(t, e) {
        return t + e;
      }, 0), D4 = vs("ceil"), B4 = Zn(function(t, e) {
        return t / e;
      }, 1), U4 = vs("floor");
      function q4(t) {
        return t && t.length ? Vn(t, me, rs) : n;
      }
      function H4(t, e) {
        return t && t.length ? Vn(t, pt(e, 2), rs) : n;
      }
      function z4(t) {
        return Gl(t, me);
      }
      function V4(t, e) {
        return Gl(t, pt(e, 2));
      }
      function W4(t) {
        return t && t.length ? Vn(t, me, ss) : n;
      }
      function j4(t, e) {
        return t && t.length ? Vn(t, pt(e, 2), ss) : n;
      }
      var K4 = Zn(function(t, e) {
        return t * e;
      }, 1), Y4 = vs("round"), X4 = Zn(function(t, e) {
        return t - e;
      }, 0);
      function $4(t) {
        return t && t.length ? Va(t, me) : 0;
      }
      function Z4(t, e) {
        return t && t.length ? Va(t, pt(e, 2)) : 0;
      }
      return k.after = m5, k.ary = hc, k.assign = s3, k.assignIn = wc, k.assignInWith = ua, k.assignWith = o3, k.at = h3, k.before = lc, k.bind = Ps, k.bindAll = f4, k.bindKey = uc, k.castArray = O5, k.chain = ac, k.chunk = Up, k.compact = qp, k.concat = Hp, k.cond = g4, k.conforms = p4, k.constant = Ns, k.countBy = $_, k.create = l3, k.curry = cc, k.curryRight = dc, k.debounce = fc, k.defaults = u3, k.defaultsDeep = c3, k.defer = b5, k.delay = S5, k.difference = zp, k.differenceBy = Vp, k.differenceWith = Wp, k.drop = jp, k.dropRight = Kp, k.dropRightWhile = Yp, k.dropWhile = Xp, k.fill = $p, k.filter = J_, k.flatMap = e5, k.flatMapDeep = r5, k.flatMapDepth = i5, k.flatten = ec, k.flattenDeep = Zp, k.flattenDepth = Jp, k.flip = w5, k.flow = v4, k.flowRight = y4, k.fromPairs = Qp, k.functions = y3, k.functionsIn = m3, k.groupBy = n5, k.initial = e_, k.intersection = r_, k.intersectionBy = i_, k.intersectionWith = n_, k.invert = S3, k.invertBy = w3, k.invokeMap = s5, k.iteratee = Gs, k.keyBy = o5, k.keys = ae, k.keysIn = ye, k.map = na, k.mapKeys = x3, k.mapValues = E3, k.matches = m4, k.matchesProperty = b4, k.memoize = sa, k.merge = R3, k.mergeWith = Cc, k.method = S4, k.methodOf = w4, k.mixin = Ds, k.negate = oa, k.nthArg = x4, k.omit = A3, k.omitBy = T3, k.once = C5, k.orderBy = h5, k.over = E4, k.overArgs = x5, k.overEvery = R4, k.overSome = A4, k.partial = Fs, k.partialRight = gc, k.partition = l5, k.pick = P3, k.pickBy = xc, k.property = Oc, k.propertyOf = T4, k.pull = h_, k.pullAll = ic, k.pullAllBy = l_, k.pullAllWith = u_, k.pullAt = c_, k.range = P4, k.rangeRight = F4, k.rearg = E5, k.reject = d5, k.remove = d_, k.rest = R5, k.reverse = As, k.sampleSize = g5, k.set = O3, k.setWith = k3, k.shuffle = p5, k.slice = f_, k.sortBy = y5, k.sortedUniq = b_, k.sortedUniqBy = S_, k.split = e4, k.spread = A5, k.tail = w_, k.take = C_, k.takeRight = x_, k.takeRightWhile = E_, k.takeWhile = R_, k.tap = q_, k.throttle = T5, k.thru = ia, k.toArray = mc, k.toPairs = Ec, k.toPairsIn = Rc, k.toPath = L4, k.toPlainObject = Sc, k.transform = I3, k.unary = P5, k.union = A_, k.unionBy = T_, k.unionWith = P_, k.uniq = F_, k.uniqBy = O_, k.uniqWith = k_, k.unset = M3, k.unzip = Ts, k.unzipWith = nc, k.update = L3, k.updateWith = N3, k.values = Jr, k.valuesIn = G3, k.without = I_, k.words = Pc, k.wrap = F5, k.xor = M_, k.xorBy = L_, k.xorWith = N_, k.zip = G_, k.zipObject = D_, k.zipObjectDeep = B_, k.zipWith = U_, k.entries = Ec, k.entriesIn = Rc, k.extend = wc, k.extendWith = ua, Ds(k, k), k.add = G4, k.attempt = Fc, k.camelCase = q3, k.capitalize = Ac, k.ceil = D4, k.clamp = D3, k.clone = k5, k.cloneDeep = M5, k.cloneDeepWith = L5, k.cloneWith = I5, k.conformsTo = N5, k.deburr = Tc, k.defaultTo = _4, k.divide = B4, k.endsWith = H3, k.eq = Ke, k.escape = z3, k.escapeRegExp = V3, k.every = Z_, k.find = Q_, k.findIndex = Qu, k.findKey = d3, k.findLast = t5, k.findLastIndex = tc, k.findLastKey = f3, k.floor = U4, k.forEach = sc, k.forEachRight = oc, k.forIn = g3, k.forInRight = p3, k.forOwn = _3, k.forOwnRight = v3, k.get = Is, k.gt = G5, k.gte = D5, k.has = b3, k.hasIn = Ms, k.head = rc, k.identity = me, k.includes = a5, k.indexOf = t_, k.inRange = B3, k.invoke = C3, k.isArguments = Lr, k.isArray = St, k.isArrayBuffer = B5, k.isArrayLike = ve, k.isArrayLikeObject = Yt, k.isBoolean = U5, k.isBuffer = Cr, k.isDate = q5, k.isElement = H5, k.isEmpty = z5, k.isEqual = V5, k.isEqualWith = W5, k.isError = Os, k.isFinite = j5, k.isFunction = hr, k.isInteger = pc, k.isLength = ha, k.isMap = _c, k.isMatch = K5, k.isMatchWith = Y5, k.isNaN = X5, k.isNative = $5, k.isNil = J5, k.isNull = Z5, k.isNumber = vc, k.isObject = Vt, k.isObjectLike = jt, k.isPlainObject = Ci, k.isRegExp = ks, k.isSafeInteger = Q5, k.isSet = yc, k.isString = la, k.isSymbol = Re, k.isTypedArray = Zr, k.isUndefined = t3, k.isWeakMap = e3, k.isWeakSet = r3, k.join = a_, k.kebabCase = W3, k.last = De, k.lastIndexOf = s_, k.lowerCase = j3, k.lowerFirst = K3, k.lt = i3, k.lte = n3, k.max = q4, k.maxBy = H4, k.mean = z4, k.meanBy = V4, k.min = W4, k.minBy = j4, k.stubArray = Us, k.stubFalse = qs, k.stubObject = O4, k.stubString = k4, k.stubTrue = I4, k.multiply = K4, k.nth = o_, k.noConflict = C4, k.noop = Bs, k.now = aa, k.pad = Y3, k.padEnd = X3, k.padStart = $3, k.parseInt = Z3, k.random = U3, k.reduce = u5, k.reduceRight = c5, k.repeat = J3, k.replace = Q3, k.result = F3, k.round = Y4, k.runInContext = V, k.sample = f5, k.size = _5, k.snakeCase = t4, k.some = v5, k.sortedIndex = g_, k.sortedIndexBy = p_, k.sortedIndexOf = __, k.sortedLastIndex = v_, k.sortedLastIndexBy = y_, k.sortedLastIndexOf = m_, k.startCase = r4, k.startsWith = i4, k.subtract = X4, k.sum = $4, k.sumBy = Z4, k.template = n4, k.times = M4, k.toFinite = lr, k.toInteger = wt, k.toLength = bc, k.toLower = a4, k.toNumber = Be, k.toSafeInteger = a3, k.toString = Nt, k.toUpper = s4, k.trim = o4, k.trimEnd = h4, k.trimStart = l4, k.truncate = u4, k.unescape = c4, k.uniqueId = N4, k.upperCase = d4, k.upperFirst = Ls, k.each = sc, k.eachRight = oc, k.first = rc, Ds(k, function() {
        var t = {};
        return Je(k, function(e, i) {
          Gt.call(k.prototype, i) || (t[i] = e);
        }), t;
      }(), { chain: !1 }), k.VERSION = o, Ie(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(t) {
        k[t].placeholder = k;
      }), Ie(["drop", "take"], function(t, e) {
        kt.prototype[t] = function(i) {
          i = i === n ? 1 : te(wt(i), 0);
          var d = this.__filtered__ && !e ? new kt(this) : this.clone();
          return d.__filtered__ ? d.__takeCount__ = le(i, d.__takeCount__) : d.__views__.push({
            size: le(i, Q),
            type: t + (d.__dir__ < 0 ? "Right" : "")
          }), d;
        }, kt.prototype[t + "Right"] = function(i) {
          return this.reverse()[t](i).reverse();
        };
      }), Ie(["filter", "map", "takeWhile"], function(t, e) {
        var i = e + 1, d = i == F || i == G;
        kt.prototype[t] = function(A) {
          var L = this.clone();
          return L.__iteratees__.push({
            iteratee: pt(A, 3),
            type: i
          }), L.__filtered__ = L.__filtered__ || d, L;
        };
      }), Ie(["head", "last"], function(t, e) {
        var i = "take" + (e ? "Right" : "");
        kt.prototype[t] = function() {
          return this[i](1).value()[0];
        };
      }), Ie(["initial", "tail"], function(t, e) {
        var i = "drop" + (e ? "" : "Right");
        kt.prototype[t] = function() {
          return this.__filtered__ ? new kt(this) : this[i](1);
        };
      }), kt.prototype.compact = function() {
        return this.filter(me);
      }, kt.prototype.find = function(t) {
        return this.filter(t).head();
      }, kt.prototype.findLast = function(t) {
        return this.reverse().find(t);
      }, kt.prototype.invokeMap = Et(function(t, e) {
        return typeof t == "function" ? new kt(this) : this.map(function(i) {
          return vi(i, t, e);
        });
      }), kt.prototype.reject = function(t) {
        return this.filter(oa(pt(t)));
      }, kt.prototype.slice = function(t, e) {
        t = wt(t);
        var i = this;
        return i.__filtered__ && (t > 0 || e < 0) ? new kt(i) : (t < 0 ? i = i.takeRight(-t) : t && (i = i.drop(t)), e !== n && (e = wt(e), i = e < 0 ? i.dropRight(-e) : i.take(e - t)), i);
      }, kt.prototype.takeRightWhile = function(t) {
        return this.reverse().takeWhile(t).reverse();
      }, kt.prototype.toArray = function() {
        return this.take(Q);
      }, Je(kt.prototype, function(t, e) {
        var i = /^(?:filter|find|map|reject)|While$/.test(e), d = /^(?:head|last)$/.test(e), A = k[d ? "take" + (e == "last" ? "Right" : "") : e], L = d || /^find/.test(e);
        A && (k.prototype[e] = function() {
          var B = this.__wrapped__, q = d ? [1] : arguments, W = B instanceof kt, rt = q[0], it = W || St(B), nt = function(Ft) {
            var It = A.apply(k, _r([Ft], q));
            return d && ot ? It[0] : It;
          };
          it && i && typeof rt == "function" && rt.length != 1 && (W = it = !1);
          var ot = this.__chain__, dt = !!this.__actions__.length, _t = L && !ot, Ct = W && !dt;
          if (!L && it) {
            B = Ct ? B : new kt(this);
            var vt = t.apply(B, q);
            return vt.__actions__.push({ func: ia, args: [nt], thisArg: n }), new Le(vt, ot);
          }
          return _t && Ct ? t.apply(this, q) : (vt = this.thru(nt), _t ? d ? vt.value()[0] : vt.value() : vt);
        });
      }), Ie(["pop", "push", "shift", "sort", "splice", "unshift"], function(t) {
        var e = Pn[t], i = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", d = /^(?:pop|shift)$/.test(t);
        k.prototype[t] = function() {
          var A = arguments;
          if (d && !this.__chain__) {
            var L = this.value();
            return e.apply(St(L) ? L : [], A);
          }
          return this[i](function(B) {
            return e.apply(St(B) ? B : [], A);
          });
        };
      }), Je(kt.prototype, function(t, e) {
        var i = k[e];
        if (i) {
          var d = i.name + "";
          Gt.call(jr, d) || (jr[d] = []), jr[d].push({ name: e, func: i });
        }
      }), jr[$n(n, P).name] = [{
        name: "wrapper",
        func: n
      }], kt.prototype.clone = c2, kt.prototype.reverse = d2, kt.prototype.value = f2, k.prototype.at = H_, k.prototype.chain = z_, k.prototype.commit = V_, k.prototype.next = W_, k.prototype.plant = K_, k.prototype.reverse = Y_, k.prototype.toJSON = k.prototype.valueOf = k.prototype.value = X_, k.prototype.first = k.prototype.head, ui && (k.prototype[ui] = j_), k;
    }, zr = Vg();
    Ar ? ((Ar.exports = zr)._ = zr, Ga._ = zr) : oe._ = zr;
  }).call(xi);
})(pa, pa.exports);
pa.exports;
Object.values(ge);
const t6 = Object.values(Er), e6 = (r) => t6.includes(r);
var fr = /* @__PURE__ */ ((r) => (r.SPOT = "spot", r.DECORATION = "decoration", r))(fr || {});
function r6(r) {
  return !r || typeof r != "object" ? !1 : "type" in r && "subType" in r ? r.type === "spot" && e6(r.subType) : !1;
}
var ri = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function ai(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var ga = { exports: {} }, Ei = {}, Hs = {}, zs = {}, Ic;
function At() {
  return Ic || (Ic = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r._registerNode = r.Konva = r.glob = void 0;
    const a = Math.PI / 180;
    function n() {
      return typeof window != "undefined" && ({}.toString.call(window) === "[object Window]" || {}.toString.call(window) === "[object global]");
    }
    r.glob = typeof ri != "undefined" ? ri : typeof window != "undefined" ? window : typeof WorkerGlobalScope != "undefined" ? self : {}, r.Konva = {
      _global: r.glob,
      version: "9.3.16",
      isBrowser: n(),
      isUnminified: /param/.test(function(u) {
      }.toString()),
      dblClickWindow: 400,
      getAngle(u) {
        return r.Konva.angleDeg ? u * a : u;
      },
      enableTrace: !1,
      pointerEventsEnabled: !0,
      autoDrawEnabled: !0,
      hitOnDragEnabled: !1,
      capturePointerEventsEnabled: !1,
      _mouseListenClick: !1,
      _touchListenClick: !1,
      _pointerListenClick: !1,
      _mouseInDblClickWindow: !1,
      _touchInDblClickWindow: !1,
      _pointerInDblClickWindow: !1,
      _mouseDblClickPointerId: null,
      _touchDblClickPointerId: null,
      _pointerDblClickPointerId: null,
      _fixTextRendering: !1,
      pixelRatio: typeof window != "undefined" && window.devicePixelRatio || 1,
      dragDistance: 3,
      angleDeg: !0,
      showWarnings: !0,
      dragButtons: [0, 1],
      isDragging() {
        return r.Konva.DD.isDragging;
      },
      isTransforming() {
        var u;
        return (u = r.Konva.Transformer) === null || u === void 0 ? void 0 : u.isTransforming();
      },
      isDragReady() {
        return !!r.Konva.DD.node;
      },
      releaseCanvasOnDestroy: !0,
      document: r.glob.document,
      _injectGlobal(u) {
        r.glob.Konva = u;
      }
    };
    const o = (u) => {
      r.Konva[u.prototype.getClassName()] = u;
    };
    r._registerNode = o, r.Konva._injectGlobal(r.Konva);
  }(zs)), zs;
}
var Vs = {}, Mc;
function Kt() {
  return Mc || (Mc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Util = r.Transform = void 0;
    const a = At();
    class n {
      constructor(S = [1, 0, 0, 1, 0, 0]) {
        this.dirty = !1, this.m = S && S.slice() || [1, 0, 0, 1, 0, 0];
      }
      reset() {
        this.m[0] = 1, this.m[1] = 0, this.m[2] = 0, this.m[3] = 1, this.m[4] = 0, this.m[5] = 0;
      }
      copy() {
        return new n(this.m);
      }
      copyInto(S) {
        S.m[0] = this.m[0], S.m[1] = this.m[1], S.m[2] = this.m[2], S.m[3] = this.m[3], S.m[4] = this.m[4], S.m[5] = this.m[5];
      }
      point(S) {
        const E = this.m;
        return {
          x: E[0] * S.x + E[2] * S.y + E[4],
          y: E[1] * S.x + E[3] * S.y + E[5]
        };
      }
      translate(S, E) {
        return this.m[4] += this.m[0] * S + this.m[2] * E, this.m[5] += this.m[1] * S + this.m[3] * E, this;
      }
      scale(S, E) {
        return this.m[0] *= S, this.m[1] *= S, this.m[2] *= E, this.m[3] *= E, this;
      }
      rotate(S) {
        const E = Math.cos(S), T = Math.sin(S), D = this.m[0] * E + this.m[2] * T, I = this.m[1] * E + this.m[3] * T, M = this.m[0] * -T + this.m[2] * E, O = this.m[1] * -T + this.m[3] * E;
        return this.m[0] = D, this.m[1] = I, this.m[2] = M, this.m[3] = O, this;
      }
      getTranslation() {
        return {
          x: this.m[4],
          y: this.m[5]
        };
      }
      skew(S, E) {
        const T = this.m[0] + this.m[2] * E, D = this.m[1] + this.m[3] * E, I = this.m[2] + this.m[0] * S, M = this.m[3] + this.m[1] * S;
        return this.m[0] = T, this.m[1] = D, this.m[2] = I, this.m[3] = M, this;
      }
      multiply(S) {
        const E = this.m[0] * S.m[0] + this.m[2] * S.m[1], T = this.m[1] * S.m[0] + this.m[3] * S.m[1], D = this.m[0] * S.m[2] + this.m[2] * S.m[3], I = this.m[1] * S.m[2] + this.m[3] * S.m[3], M = this.m[0] * S.m[4] + this.m[2] * S.m[5] + this.m[4], O = this.m[1] * S.m[4] + this.m[3] * S.m[5] + this.m[5];
        return this.m[0] = E, this.m[1] = T, this.m[2] = D, this.m[3] = I, this.m[4] = M, this.m[5] = O, this;
      }
      invert() {
        const S = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]), E = this.m[3] * S, T = -this.m[1] * S, D = -this.m[2] * S, I = this.m[0] * S, M = S * (this.m[2] * this.m[5] - this.m[3] * this.m[4]), O = S * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        return this.m[0] = E, this.m[1] = T, this.m[2] = D, this.m[3] = I, this.m[4] = M, this.m[5] = O, this;
      }
      getMatrix() {
        return this.m;
      }
      decompose() {
        const S = this.m[0], E = this.m[1], T = this.m[2], D = this.m[3], I = this.m[4], M = this.m[5], O = S * D - E * T, N = {
          x: I,
          y: M,
          rotation: 0,
          scaleX: 0,
          scaleY: 0,
          skewX: 0,
          skewY: 0
        };
        if (S != 0 || E != 0) {
          const H = Math.sqrt(S * S + E * E);
          N.rotation = E > 0 ? Math.acos(S / H) : -Math.acos(S / H), N.scaleX = H, N.scaleY = O / H, N.skewX = (S * T + E * D) / O, N.skewY = 0;
        } else if (T != 0 || D != 0) {
          const H = Math.sqrt(T * T + D * D);
          N.rotation = Math.PI / 2 - (D > 0 ? Math.acos(-T / H) : -Math.acos(T / H)), N.scaleX = O / H, N.scaleY = H, N.skewX = 0, N.skewY = (S * T + E * D) / O;
        }
        return N.rotation = r.Util._getRotation(N.rotation), N;
      }
    }
    r.Transform = n;
    let o = "[object Array]", u = "[object Number]", s = "[object String]", h = "[object Boolean]", l = Math.PI / 180, g = 180 / Math.PI, p = "#", b = "", m = "0", C = "Konva warning: ", v = "Konva error: ", _ = "rgb(", w = {
      aliceblue: [240, 248, 255],
      antiquewhite: [250, 235, 215],
      aqua: [0, 255, 255],
      aquamarine: [127, 255, 212],
      azure: [240, 255, 255],
      beige: [245, 245, 220],
      bisque: [255, 228, 196],
      black: [0, 0, 0],
      blanchedalmond: [255, 235, 205],
      blue: [0, 0, 255],
      blueviolet: [138, 43, 226],
      brown: [165, 42, 42],
      burlywood: [222, 184, 135],
      cadetblue: [95, 158, 160],
      chartreuse: [127, 255, 0],
      chocolate: [210, 105, 30],
      coral: [255, 127, 80],
      cornflowerblue: [100, 149, 237],
      cornsilk: [255, 248, 220],
      crimson: [220, 20, 60],
      cyan: [0, 255, 255],
      darkblue: [0, 0, 139],
      darkcyan: [0, 139, 139],
      darkgoldenrod: [184, 132, 11],
      darkgray: [169, 169, 169],
      darkgreen: [0, 100, 0],
      darkgrey: [169, 169, 169],
      darkkhaki: [189, 183, 107],
      darkmagenta: [139, 0, 139],
      darkolivegreen: [85, 107, 47],
      darkorange: [255, 140, 0],
      darkorchid: [153, 50, 204],
      darkred: [139, 0, 0],
      darksalmon: [233, 150, 122],
      darkseagreen: [143, 188, 143],
      darkslateblue: [72, 61, 139],
      darkslategray: [47, 79, 79],
      darkslategrey: [47, 79, 79],
      darkturquoise: [0, 206, 209],
      darkviolet: [148, 0, 211],
      deeppink: [255, 20, 147],
      deepskyblue: [0, 191, 255],
      dimgray: [105, 105, 105],
      dimgrey: [105, 105, 105],
      dodgerblue: [30, 144, 255],
      firebrick: [178, 34, 34],
      floralwhite: [255, 255, 240],
      forestgreen: [34, 139, 34],
      fuchsia: [255, 0, 255],
      gainsboro: [220, 220, 220],
      ghostwhite: [248, 248, 255],
      gold: [255, 215, 0],
      goldenrod: [218, 165, 32],
      gray: [128, 128, 128],
      green: [0, 128, 0],
      greenyellow: [173, 255, 47],
      grey: [128, 128, 128],
      honeydew: [240, 255, 240],
      hotpink: [255, 105, 180],
      indianred: [205, 92, 92],
      indigo: [75, 0, 130],
      ivory: [255, 255, 240],
      khaki: [240, 230, 140],
      lavender: [230, 230, 250],
      lavenderblush: [255, 240, 245],
      lawngreen: [124, 252, 0],
      lemonchiffon: [255, 250, 205],
      lightblue: [173, 216, 230],
      lightcoral: [240, 128, 128],
      lightcyan: [224, 255, 255],
      lightgoldenrodyellow: [250, 250, 210],
      lightgray: [211, 211, 211],
      lightgreen: [144, 238, 144],
      lightgrey: [211, 211, 211],
      lightpink: [255, 182, 193],
      lightsalmon: [255, 160, 122],
      lightseagreen: [32, 178, 170],
      lightskyblue: [135, 206, 250],
      lightslategray: [119, 136, 153],
      lightslategrey: [119, 136, 153],
      lightsteelblue: [176, 196, 222],
      lightyellow: [255, 255, 224],
      lime: [0, 255, 0],
      limegreen: [50, 205, 50],
      linen: [250, 240, 230],
      magenta: [255, 0, 255],
      maroon: [128, 0, 0],
      mediumaquamarine: [102, 205, 170],
      mediumblue: [0, 0, 205],
      mediumorchid: [186, 85, 211],
      mediumpurple: [147, 112, 219],
      mediumseagreen: [60, 179, 113],
      mediumslateblue: [123, 104, 238],
      mediumspringgreen: [0, 250, 154],
      mediumturquoise: [72, 209, 204],
      mediumvioletred: [199, 21, 133],
      midnightblue: [25, 25, 112],
      mintcream: [245, 255, 250],
      mistyrose: [255, 228, 225],
      moccasin: [255, 228, 181],
      navajowhite: [255, 222, 173],
      navy: [0, 0, 128],
      oldlace: [253, 245, 230],
      olive: [128, 128, 0],
      olivedrab: [107, 142, 35],
      orange: [255, 165, 0],
      orangered: [255, 69, 0],
      orchid: [218, 112, 214],
      palegoldenrod: [238, 232, 170],
      palegreen: [152, 251, 152],
      paleturquoise: [175, 238, 238],
      palevioletred: [219, 112, 147],
      papayawhip: [255, 239, 213],
      peachpuff: [255, 218, 185],
      peru: [205, 133, 63],
      pink: [255, 192, 203],
      plum: [221, 160, 203],
      powderblue: [176, 224, 230],
      purple: [128, 0, 128],
      rebeccapurple: [102, 51, 153],
      red: [255, 0, 0],
      rosybrown: [188, 143, 143],
      royalblue: [65, 105, 225],
      saddlebrown: [139, 69, 19],
      salmon: [250, 128, 114],
      sandybrown: [244, 164, 96],
      seagreen: [46, 139, 87],
      seashell: [255, 245, 238],
      sienna: [160, 82, 45],
      silver: [192, 192, 192],
      skyblue: [135, 206, 235],
      slateblue: [106, 90, 205],
      slategray: [119, 128, 144],
      slategrey: [119, 128, 144],
      snow: [255, 255, 250],
      springgreen: [0, 255, 127],
      steelblue: [70, 130, 180],
      tan: [210, 180, 140],
      teal: [0, 128, 128],
      thistle: [216, 191, 216],
      transparent: [255, 255, 255, 0],
      tomato: [255, 99, 71],
      turquoise: [64, 224, 208],
      violet: [238, 130, 238],
      wheat: [245, 222, 179],
      white: [255, 255, 255],
      whitesmoke: [245, 245, 245],
      yellow: [255, 255, 0],
      yellowgreen: [154, 205, 5]
    }, x = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, P = [];
    const c = typeof requestAnimationFrame != "undefined" && requestAnimationFrame || function(f) {
      setTimeout(f, 60);
    };
    r.Util = {
      _isElement(f) {
        return !!(f && f.nodeType == 1);
      },
      _isFunction(f) {
        return !!(f && f.constructor && f.call && f.apply);
      },
      _isPlainObject(f) {
        return !!f && f.constructor === Object;
      },
      _isArray(f) {
        return Object.prototype.toString.call(f) === o;
      },
      _isNumber(f) {
        return Object.prototype.toString.call(f) === u && !isNaN(f) && isFinite(f);
      },
      _isString(f) {
        return Object.prototype.toString.call(f) === s;
      },
      _isBoolean(f) {
        return Object.prototype.toString.call(f) === h;
      },
      isObject(f) {
        return f instanceof Object;
      },
      isValidSelector(f) {
        if (typeof f != "string")
          return !1;
        const S = f[0];
        return S === "#" || S === "." || S === S.toUpperCase();
      },
      _sign(f) {
        return f === 0 || f > 0 ? 1 : -1;
      },
      requestAnimFrame(f) {
        P.push(f), P.length === 1 && c(function() {
          const S = P;
          P = [], S.forEach(function(E) {
            E();
          });
        });
      },
      createCanvasElement() {
        const f = document.createElement("canvas");
        try {
          f.style = f.style || {};
        } catch {
        }
        return f;
      },
      createImageElement() {
        return document.createElement("img");
      },
      _isInDocument(f) {
        for (; f = f.parentNode; )
          if (f == document)
            return !0;
        return !1;
      },
      _urlToImage(f, S) {
        const E = r.Util.createImageElement();
        E.onload = function() {
          S(E);
        }, E.src = f;
      },
      _rgbToHex(f, S, E) {
        return ((1 << 24) + (f << 16) + (S << 8) + E).toString(16).slice(1);
      },
      _hexToRgb(f) {
        f = f.replace(p, b);
        const S = parseInt(f, 16);
        return {
          r: S >> 16 & 255,
          g: S >> 8 & 255,
          b: S & 255
        };
      },
      getRandomColor() {
        let f = (Math.random() * 16777215 << 0).toString(16);
        for (; f.length < 6; )
          f = m + f;
        return p + f;
      },
      getRGB(f) {
        let S;
        return f in w ? (S = w[f], {
          r: S[0],
          g: S[1],
          b: S[2]
        }) : f[0] === p ? this._hexToRgb(f.substring(1)) : f.substr(0, 4) === _ ? (S = x.exec(f.replace(/ /g, "")), {
          r: parseInt(S[1], 10),
          g: parseInt(S[2], 10),
          b: parseInt(S[3], 10)
        }) : {
          r: 0,
          g: 0,
          b: 0
        };
      },
      colorToRGBA(f) {
        return f = f || "black", r.Util._namedColorToRBA(f) || r.Util._hex3ColorToRGBA(f) || r.Util._hex4ColorToRGBA(f) || r.Util._hex6ColorToRGBA(f) || r.Util._hex8ColorToRGBA(f) || r.Util._rgbColorToRGBA(f) || r.Util._rgbaColorToRGBA(f) || r.Util._hslColorToRGBA(f);
      },
      _namedColorToRBA(f) {
        const S = w[f.toLowerCase()];
        return S ? {
          r: S[0],
          g: S[1],
          b: S[2],
          a: 1
        } : null;
      },
      _rgbColorToRGBA(f) {
        if (f.indexOf("rgb(") === 0) {
          f = f.match(/rgb\(([^)]+)\)/)[1];
          const S = f.split(/ *, */).map(Number);
          return {
            r: S[0],
            g: S[1],
            b: S[2],
            a: 1
          };
        }
      },
      _rgbaColorToRGBA(f) {
        if (f.indexOf("rgba(") === 0) {
          f = f.match(/rgba\(([^)]+)\)/)[1];
          const S = f.split(/ *, */).map((E, T) => E.slice(-1) === "%" ? T === 3 ? parseInt(E) / 100 : parseInt(E) / 100 * 255 : Number(E));
          return {
            r: S[0],
            g: S[1],
            b: S[2],
            a: S[3]
          };
        }
      },
      _hex8ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 9)
          return {
            r: parseInt(f.slice(1, 3), 16),
            g: parseInt(f.slice(3, 5), 16),
            b: parseInt(f.slice(5, 7), 16),
            a: parseInt(f.slice(7, 9), 16) / 255
          };
      },
      _hex6ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 7)
          return {
            r: parseInt(f.slice(1, 3), 16),
            g: parseInt(f.slice(3, 5), 16),
            b: parseInt(f.slice(5, 7), 16),
            a: 1
          };
      },
      _hex4ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 5)
          return {
            r: parseInt(f[1] + f[1], 16),
            g: parseInt(f[2] + f[2], 16),
            b: parseInt(f[3] + f[3], 16),
            a: parseInt(f[4] + f[4], 16) / 255
          };
      },
      _hex3ColorToRGBA(f) {
        if (f[0] === "#" && f.length === 4)
          return {
            r: parseInt(f[1] + f[1], 16),
            g: parseInt(f[2] + f[2], 16),
            b: parseInt(f[3] + f[3], 16),
            a: 1
          };
      },
      _hslColorToRGBA(f) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(f)) {
          const [S, ...E] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(f), T = Number(E[0]) / 360, D = Number(E[1]) / 100, I = Number(E[2]) / 100;
          let M, O, N;
          if (D === 0)
            return N = I * 255, {
              r: Math.round(N),
              g: Math.round(N),
              b: Math.round(N),
              a: 1
            };
          I < 0.5 ? M = I * (1 + D) : M = I + D - I * D;
          const H = 2 * I - M, y = [0, 0, 0];
          for (let F = 0; F < 3; F++)
            O = T + 1 / 3 * -(F - 1), O < 0 && O++, O > 1 && O--, 6 * O < 1 ? N = H + (M - H) * 6 * O : 2 * O < 1 ? N = M : 3 * O < 2 ? N = H + (M - H) * (2 / 3 - O) * 6 : N = H, y[F] = N * 255;
          return {
            r: Math.round(y[0]),
            g: Math.round(y[1]),
            b: Math.round(y[2]),
            a: 1
          };
        }
      },
      haveIntersection(f, S) {
        return !(S.x > f.x + f.width || S.x + S.width < f.x || S.y > f.y + f.height || S.y + S.height < f.y);
      },
      cloneObject(f) {
        const S = {};
        for (const E in f)
          this._isPlainObject(f[E]) ? S[E] = this.cloneObject(f[E]) : this._isArray(f[E]) ? S[E] = this.cloneArray(f[E]) : S[E] = f[E];
        return S;
      },
      cloneArray(f) {
        return f.slice(0);
      },
      degToRad(f) {
        return f * l;
      },
      radToDeg(f) {
        return f * g;
      },
      _degToRad(f) {
        return r.Util.warn("Util._degToRad is removed. Please use public Util.degToRad instead."), r.Util.degToRad(f);
      },
      _radToDeg(f) {
        return r.Util.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead."), r.Util.radToDeg(f);
      },
      _getRotation(f) {
        return a.Konva.angleDeg ? r.Util.radToDeg(f) : f;
      },
      _capitalize(f) {
        return f.charAt(0).toUpperCase() + f.slice(1);
      },
      throw(f) {
        throw new Error(v + f);
      },
      error(f) {
        console.error(v + f);
      },
      warn(f) {
        a.Konva.showWarnings && console.warn(C + f);
      },
      each(f, S) {
        for (const E in f)
          S(E, f[E]);
      },
      _inRange(f, S, E) {
        return S <= f && f < E;
      },
      _getProjectionToSegment(f, S, E, T, D, I) {
        let M, O, N;
        const H = (f - E) * (f - E) + (S - T) * (S - T);
        if (H == 0)
          M = f, O = S, N = (D - E) * (D - E) + (I - T) * (I - T);
        else {
          const y = ((D - f) * (E - f) + (I - S) * (T - S)) / H;
          y < 0 ? (M = f, O = S, N = (f - D) * (f - D) + (S - I) * (S - I)) : y > 1 ? (M = E, O = T, N = (E - D) * (E - D) + (T - I) * (T - I)) : (M = f + y * (E - f), O = S + y * (T - S), N = (M - D) * (M - D) + (O - I) * (O - I));
        }
        return [M, O, N];
      },
      _getProjectionToLine(f, S, E) {
        const T = r.Util.cloneObject(f);
        let D = Number.MAX_VALUE;
        return S.forEach(function(I, M) {
          if (!E && M === S.length - 1)
            return;
          const O = S[(M + 1) % S.length], N = r.Util._getProjectionToSegment(I.x, I.y, O.x, O.y, f.x, f.y), H = N[0], y = N[1], F = N[2];
          F < D && (T.x = H, T.y = y, D = F);
        }), T;
      },
      _prepareArrayForTween(f, S, E) {
        let T, D = [], I = [];
        if (f.length > S.length) {
          const O = S;
          S = f, f = O;
        }
        for (T = 0; T < f.length; T += 2)
          D.push({
            x: f[T],
            y: f[T + 1]
          });
        for (T = 0; T < S.length; T += 2)
          I.push({
            x: S[T],
            y: S[T + 1]
          });
        const M = [];
        return I.forEach(function(O) {
          const N = r.Util._getProjectionToLine(O, D, E);
          M.push(N.x), M.push(N.y);
        }), M;
      },
      _prepareToStringify(f) {
        let S;
        f.visitedByCircularReferenceRemoval = !0;
        for (const E in f)
          if (f.hasOwnProperty(E) && f[E] && typeof f[E] == "object") {
            if (S = Object.getOwnPropertyDescriptor(f, E), f[E].visitedByCircularReferenceRemoval || r.Util._isElement(f[E]))
              if (S.configurable)
                delete f[E];
              else
                return null;
            else if (r.Util._prepareToStringify(f[E]) === null)
              if (S.configurable)
                delete f[E];
              else
                return null;
          }
        return delete f.visitedByCircularReferenceRemoval, f;
      },
      _assign(f, S) {
        for (const E in S)
          f[E] = S[E];
        return f;
      },
      _getFirstPointerId(f) {
        return f.touches ? f.changedTouches[0].identifier : f.pointerId || 999;
      },
      releaseCanvas(...f) {
        a.Konva.releaseCanvasOnDestroy && f.forEach((S) => {
          S.width = 0, S.height = 0;
        });
      },
      drawRoundedRectPath(f, S, E, T) {
        let D = 0, I = 0, M = 0, O = 0;
        typeof T == "number" ? D = I = M = O = Math.min(T, S / 2, E / 2) : (D = Math.min(T[0] || 0, S / 2, E / 2), I = Math.min(T[1] || 0, S / 2, E / 2), O = Math.min(T[2] || 0, S / 2, E / 2), M = Math.min(T[3] || 0, S / 2, E / 2)), f.moveTo(D, 0), f.lineTo(S - I, 0), f.arc(S - I, I, I, Math.PI * 3 / 2, 0, !1), f.lineTo(S, E - O), f.arc(S - O, E - O, O, 0, Math.PI / 2, !1), f.lineTo(M, E), f.arc(M, E - M, M, Math.PI / 2, Math.PI, !1), f.lineTo(0, D), f.arc(D, D, D, Math.PI, Math.PI * 3 / 2, !1);
      }
    };
  }(Vs)), Vs;
}
var Ri = {}, Ws = {}, be = {}, Lc;
function Ot() {
  if (Lc) return be;
  Lc = 1, Object.defineProperty(be, "__esModule", { value: !0 }), be.RGBComponent = o, be.alphaComponent = u, be.getNumberValidator = s, be.getNumberOrArrayOfNumbersValidator = h, be.getNumberOrAutoValidator = l, be.getStringValidator = g, be.getStringOrGradientValidator = p, be.getFunctionValidator = b, be.getNumberArrayValidator = m, be.getBooleanValidator = C, be.getComponentValidator = v;
  const r = At(), a = Kt();
  function n(_) {
    return a.Util._isString(_) ? '"' + _ + '"' : Object.prototype.toString.call(_) === "[object Number]" || a.Util._isBoolean(_) ? _ : Object.prototype.toString.call(_);
  }
  function o(_) {
    return _ > 255 ? 255 : _ < 0 ? 0 : Math.round(_);
  }
  function u(_) {
    return _ > 1 ? 1 : _ < 1e-4 ? 1e-4 : _;
  }
  function s() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        return a.Util._isNumber(_) || a.Util.warn(n(_) + ' is a not valid value for "' + w + '" attribute. The value should be a number.'), _;
      };
  }
  function h(_) {
    if (r.Konva.isUnminified)
      return function(w, x) {
        const P = a.Util._isNumber(w), c = a.Util._isArray(w) && w.length == _;
        return !P && !c && a.Util.warn(n(w) + ' is a not valid value for "' + x + '" attribute. The value should be a number or Array<number>(' + _ + ")"), w;
      };
  }
  function l() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        return a.Util._isNumber(_) || _ === "auto" || a.Util.warn(n(_) + ' is a not valid value for "' + w + '" attribute. The value should be a number or "auto".'), _;
      };
  }
  function g() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        return a.Util._isString(_) || a.Util.warn(n(_) + ' is a not valid value for "' + w + '" attribute. The value should be a string.'), _;
      };
  }
  function p() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        const x = a.Util._isString(_), P = Object.prototype.toString.call(_) === "[object CanvasGradient]" || _ && _.addColorStop;
        return x || P || a.Util.warn(n(_) + ' is a not valid value for "' + w + '" attribute. The value should be a string or a native gradient.'), _;
      };
  }
  function b() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        return a.Util._isFunction(_) || a.Util.warn(n(_) + ' is a not valid value for "' + w + '" attribute. The value should be a function.'), _;
      };
  }
  function m() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        const x = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        return x && _ instanceof x || (a.Util._isArray(_) ? _.forEach(function(P) {
          a.Util._isNumber(P) || a.Util.warn('"' + w + '" attribute has non numeric element ' + P + ". Make sure that all elements are numbers.");
        }) : a.Util.warn(n(_) + ' is a not valid value for "' + w + '" attribute. The value should be a array of numbers.')), _;
      };
  }
  function C() {
    if (r.Konva.isUnminified)
      return function(_, w) {
        return _ === !0 || _ === !1 || a.Util.warn(n(_) + ' is a not valid value for "' + w + '" attribute. The value should be a boolean.'), _;
      };
  }
  function v(_) {
    if (r.Konva.isUnminified)
      return function(w, x) {
        return w == null || a.Util.isObject(w) || a.Util.warn(n(w) + ' is a not valid value for "' + x + '" attribute. The value should be an object with properties ' + _), w;
      };
  }
  return be;
}
var Nc;
function Tt() {
  return Nc || (Nc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Factory = void 0;
    const a = Kt(), n = Ot(), o = "get", u = "set";
    r.Factory = {
      addGetterSetter(s, h, l, g, p) {
        r.Factory.addGetter(s, h, l), r.Factory.addSetter(s, h, g, p), r.Factory.addOverloadedGetterSetter(s, h);
      },
      addGetter(s, h, l) {
        const g = o + a.Util._capitalize(h);
        s.prototype[g] = s.prototype[g] || function() {
          const p = this.attrs[h];
          return p === void 0 ? l : p;
        };
      },
      addSetter(s, h, l, g) {
        const p = u + a.Util._capitalize(h);
        s.prototype[p] || r.Factory.overWriteSetter(s, h, l, g);
      },
      overWriteSetter(s, h, l, g) {
        const p = u + a.Util._capitalize(h);
        s.prototype[p] = function(b) {
          return l && b !== void 0 && b !== null && (b = l.call(this, b, h)), this._setAttr(h, b), g && g.call(this), this;
        };
      },
      addComponentsGetterSetter(s, h, l, g, p) {
        let b = l.length, m = a.Util._capitalize, C = o + m(h), v = u + m(h), _, w;
        s.prototype[C] = function() {
          const P = {};
          for (_ = 0; _ < b; _++)
            w = l[_], P[w] = this.getAttr(h + m(w));
          return P;
        };
        const x = (0, n.getComponentValidator)(l);
        s.prototype[v] = function(P) {
          let c = this.attrs[h], f;
          g && (P = g.call(this, P)), x && x.call(this, P, h);
          for (f in P)
            P.hasOwnProperty(f) && this._setAttr(h + m(f), P[f]);
          return P || l.forEach((S) => {
            this._setAttr(h + m(S), void 0);
          }), this._fireChangeEvent(h, c, P), p && p.call(this), this;
        }, r.Factory.addOverloadedGetterSetter(s, h);
      },
      addOverloadedGetterSetter(s, h) {
        const l = a.Util._capitalize(h), g = u + l, p = o + l;
        s.prototype[h] = function() {
          return arguments.length ? (this[g](arguments[0]), this) : this[p]();
        };
      },
      addDeprecatedGetterSetter(s, h, l, g) {
        a.Util.error("Adding deprecated " + h);
        const p = o + a.Util._capitalize(h), b = h + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
        s.prototype[p] = function() {
          a.Util.error(b);
          const m = this.attrs[h];
          return m === void 0 ? l : m;
        }, r.Factory.addSetter(s, h, g, function() {
          a.Util.error(b);
        }), r.Factory.addOverloadedGetterSetter(s, h);
      },
      backCompat(s, h) {
        a.Util.each(h, function(l, g) {
          const p = s.prototype[g], b = o + a.Util._capitalize(l), m = u + a.Util._capitalize(l);
          function C() {
            p.apply(this, arguments), a.Util.error('"' + l + '" method is deprecated and will be removed soon. Use ""' + g + '" instead.');
          }
          s.prototype[l] = C, s.prototype[b] = C, s.prototype[m] = C;
        });
      },
      afterSetFilter() {
        this._filterUpToDate = !1;
      }
    };
  }(Ws)), Ws;
}
var cr = {}, dr = {}, Gc;
function X0() {
  if (Gc) return dr;
  Gc = 1, Object.defineProperty(dr, "__esModule", { value: !0 }), dr.HitContext = dr.SceneContext = dr.Context = void 0;
  const r = Kt(), a = At();
  function n(P) {
    let c = [], f = P.length, S = r.Util, E, T;
    for (E = 0; E < f; E++)
      T = P[E], S._isNumber(T) ? T = Math.round(T * 1e3) / 1e3 : S._isString(T) || (T = T + ""), c.push(T);
    return c;
  }
  const o = ",", u = "(", s = ")", h = "([", l = "])", g = ";", p = "()", b = "=", m = [
    "arc",
    "arcTo",
    "beginPath",
    "bezierCurveTo",
    "clearRect",
    "clip",
    "closePath",
    "createLinearGradient",
    "createPattern",
    "createRadialGradient",
    "drawImage",
    "ellipse",
    "fill",
    "fillText",
    "getImageData",
    "createImageData",
    "lineTo",
    "moveTo",
    "putImageData",
    "quadraticCurveTo",
    "rect",
    "roundRect",
    "restore",
    "rotate",
    "save",
    "scale",
    "setLineDash",
    "setTransform",
    "stroke",
    "strokeText",
    "transform",
    "translate"
  ], C = [
    "fillStyle",
    "strokeStyle",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "letterSpacing",
    "lineCap",
    "lineDashOffset",
    "lineJoin",
    "lineWidth",
    "miterLimit",
    "direction",
    "font",
    "textAlign",
    "textBaseline",
    "globalAlpha",
    "globalCompositeOperation",
    "imageSmoothingEnabled"
  ], v = 100;
  let _ = class {
    constructor(c) {
      this.canvas = c, a.Konva.enableTrace && (this.traceArr = [], this._enableTrace());
    }
    fillShape(c) {
      c.fillEnabled() && this._fill(c);
    }
    _fill(c) {
    }
    strokeShape(c) {
      c.hasStroke() && this._stroke(c);
    }
    _stroke(c) {
    }
    fillStrokeShape(c) {
      c.attrs.fillAfterStrokeEnabled ? (this.strokeShape(c), this.fillShape(c)) : (this.fillShape(c), this.strokeShape(c));
    }
    getTrace(c, f) {
      let S = this.traceArr, E = S.length, T = "", D, I, M, O;
      for (D = 0; D < E; D++)
        I = S[D], M = I.method, M ? (O = I.args, T += M, c ? T += p : r.Util._isArray(O[0]) ? T += h + O.join(o) + l : (f && (O = O.map((N) => typeof N == "number" ? Math.floor(N) : N)), T += u + O.join(o) + s)) : (T += I.property, c || (T += b + I.val)), T += g;
      return T;
    }
    clearTrace() {
      this.traceArr = [];
    }
    _trace(c) {
      let f = this.traceArr, S;
      f.push(c), S = f.length, S >= v && f.shift();
    }
    reset() {
      const c = this.getCanvas().getPixelRatio();
      this.setTransform(1 * c, 0, 0, 1 * c, 0, 0);
    }
    getCanvas() {
      return this.canvas;
    }
    clear(c) {
      const f = this.getCanvas();
      c ? this.clearRect(c.x || 0, c.y || 0, c.width || 0, c.height || 0) : this.clearRect(0, 0, f.getWidth() / f.pixelRatio, f.getHeight() / f.pixelRatio);
    }
    _applyLineCap(c) {
      const f = c.attrs.lineCap;
      f && this.setAttr("lineCap", f);
    }
    _applyOpacity(c) {
      const f = c.getAbsoluteOpacity();
      f !== 1 && this.setAttr("globalAlpha", f);
    }
    _applyLineJoin(c) {
      const f = c.attrs.lineJoin;
      f && this.setAttr("lineJoin", f);
    }
    setAttr(c, f) {
      this._context[c] = f;
    }
    arc(c, f, S, E, T, D) {
      this._context.arc(c, f, S, E, T, D);
    }
    arcTo(c, f, S, E, T) {
      this._context.arcTo(c, f, S, E, T);
    }
    beginPath() {
      this._context.beginPath();
    }
    bezierCurveTo(c, f, S, E, T, D) {
      this._context.bezierCurveTo(c, f, S, E, T, D);
    }
    clearRect(c, f, S, E) {
      this._context.clearRect(c, f, S, E);
    }
    clip(...c) {
      this._context.clip.apply(this._context, c);
    }
    closePath() {
      this._context.closePath();
    }
    createImageData(c, f) {
      const S = arguments;
      if (S.length === 2)
        return this._context.createImageData(c, f);
      if (S.length === 1)
        return this._context.createImageData(c);
    }
    createLinearGradient(c, f, S, E) {
      return this._context.createLinearGradient(c, f, S, E);
    }
    createPattern(c, f) {
      return this._context.createPattern(c, f);
    }
    createRadialGradient(c, f, S, E, T, D) {
      return this._context.createRadialGradient(c, f, S, E, T, D);
    }
    drawImage(c, f, S, E, T, D, I, M, O) {
      const N = arguments, H = this._context;
      N.length === 3 ? H.drawImage(c, f, S) : N.length === 5 ? H.drawImage(c, f, S, E, T) : N.length === 9 && H.drawImage(c, f, S, E, T, D, I, M, O);
    }
    ellipse(c, f, S, E, T, D, I, M) {
      this._context.ellipse(c, f, S, E, T, D, I, M);
    }
    isPointInPath(c, f, S, E) {
      return S ? this._context.isPointInPath(S, c, f, E) : this._context.isPointInPath(c, f, E);
    }
    fill(...c) {
      this._context.fill.apply(this._context, c);
    }
    fillRect(c, f, S, E) {
      this._context.fillRect(c, f, S, E);
    }
    strokeRect(c, f, S, E) {
      this._context.strokeRect(c, f, S, E);
    }
    fillText(c, f, S, E) {
      E ? this._context.fillText(c, f, S, E) : this._context.fillText(c, f, S);
    }
    measureText(c) {
      return this._context.measureText(c);
    }
    getImageData(c, f, S, E) {
      return this._context.getImageData(c, f, S, E);
    }
    lineTo(c, f) {
      this._context.lineTo(c, f);
    }
    moveTo(c, f) {
      this._context.moveTo(c, f);
    }
    rect(c, f, S, E) {
      this._context.rect(c, f, S, E);
    }
    roundRect(c, f, S, E, T) {
      this._context.roundRect(c, f, S, E, T);
    }
    putImageData(c, f, S) {
      this._context.putImageData(c, f, S);
    }
    quadraticCurveTo(c, f, S, E) {
      this._context.quadraticCurveTo(c, f, S, E);
    }
    restore() {
      this._context.restore();
    }
    rotate(c) {
      this._context.rotate(c);
    }
    save() {
      this._context.save();
    }
    scale(c, f) {
      this._context.scale(c, f);
    }
    setLineDash(c) {
      this._context.setLineDash ? this._context.setLineDash(c) : "mozDash" in this._context ? this._context.mozDash = c : "webkitLineDash" in this._context && (this._context.webkitLineDash = c);
    }
    getLineDash() {
      return this._context.getLineDash();
    }
    setTransform(c, f, S, E, T, D) {
      this._context.setTransform(c, f, S, E, T, D);
    }
    stroke(c) {
      c ? this._context.stroke(c) : this._context.stroke();
    }
    strokeText(c, f, S, E) {
      this._context.strokeText(c, f, S, E);
    }
    transform(c, f, S, E, T, D) {
      this._context.transform(c, f, S, E, T, D);
    }
    translate(c, f) {
      this._context.translate(c, f);
    }
    _enableTrace() {
      let c = this, f = m.length, S = this.setAttr, E, T;
      const D = function(I) {
        let M = c[I], O;
        c[I] = function() {
          return T = n(Array.prototype.slice.call(arguments, 0)), O = M.apply(c, arguments), c._trace({
            method: I,
            args: T
          }), O;
        };
      };
      for (E = 0; E < f; E++)
        D(m[E]);
      c.setAttr = function() {
        S.apply(c, arguments);
        const I = arguments[0];
        let M = arguments[1];
        (I === "shadowOffsetX" || I === "shadowOffsetY" || I === "shadowBlur") && (M = M / this.canvas.getPixelRatio()), c._trace({
          property: I,
          val: M
        });
      };
    }
    _applyGlobalCompositeOperation(c) {
      const f = c.attrs.globalCompositeOperation;
      !f || f === "source-over" || this.setAttr("globalCompositeOperation", f);
    }
  };
  dr.Context = _, C.forEach(function(P) {
    Object.defineProperty(_.prototype, P, {
      get() {
        return this._context[P];
      },
      set(c) {
        this._context[P] = c;
      }
    });
  });
  class w extends _ {
    constructor(c, { willReadFrequently: f = !1 } = {}) {
      super(c), this._context = c._canvas.getContext("2d", {
        willReadFrequently: f
      });
    }
    _fillColor(c) {
      const f = c.fill();
      this.setAttr("fillStyle", f), c._fillFunc(this);
    }
    _fillPattern(c) {
      this.setAttr("fillStyle", c._getFillPattern()), c._fillFunc(this);
    }
    _fillLinearGradient(c) {
      const f = c._getLinearGradient();
      f && (this.setAttr("fillStyle", f), c._fillFunc(this));
    }
    _fillRadialGradient(c) {
      const f = c._getRadialGradient();
      f && (this.setAttr("fillStyle", f), c._fillFunc(this));
    }
    _fill(c) {
      const f = c.fill(), S = c.getFillPriority();
      if (f && S === "color") {
        this._fillColor(c);
        return;
      }
      const E = c.getFillPatternImage();
      if (E && S === "pattern") {
        this._fillPattern(c);
        return;
      }
      const T = c.getFillLinearGradientColorStops();
      if (T && S === "linear-gradient") {
        this._fillLinearGradient(c);
        return;
      }
      const D = c.getFillRadialGradientColorStops();
      if (D && S === "radial-gradient") {
        this._fillRadialGradient(c);
        return;
      }
      f ? this._fillColor(c) : E ? this._fillPattern(c) : T ? this._fillLinearGradient(c) : D && this._fillRadialGradient(c);
    }
    _strokeLinearGradient(c) {
      const f = c.getStrokeLinearGradientStartPoint(), S = c.getStrokeLinearGradientEndPoint(), E = c.getStrokeLinearGradientColorStops(), T = this.createLinearGradient(f.x, f.y, S.x, S.y);
      if (E) {
        for (let D = 0; D < E.length; D += 2)
          T.addColorStop(E[D], E[D + 1]);
        this.setAttr("strokeStyle", T);
      }
    }
    _stroke(c) {
      const f = c.dash(), S = c.getStrokeScaleEnabled();
      if (c.hasStroke()) {
        if (!S) {
          this.save();
          const T = this.getCanvas().getPixelRatio();
          this.setTransform(T, 0, 0, T, 0, 0);
        }
        this._applyLineCap(c), f && c.dashEnabled() && (this.setLineDash(f), this.setAttr("lineDashOffset", c.dashOffset())), this.setAttr("lineWidth", c.strokeWidth()), c.getShadowForStrokeEnabled() || this.setAttr("shadowColor", "rgba(0,0,0,0)"), c.getStrokeLinearGradientColorStops() ? this._strokeLinearGradient(c) : this.setAttr("strokeStyle", c.stroke()), c._strokeFunc(this), S || this.restore();
      }
    }
    _applyShadow(c) {
      var f, S, E;
      const T = (f = c.getShadowRGBA()) !== null && f !== void 0 ? f : "black", D = (S = c.getShadowBlur()) !== null && S !== void 0 ? S : 5, I = (E = c.getShadowOffset()) !== null && E !== void 0 ? E : {
        x: 0,
        y: 0
      }, M = c.getAbsoluteScale(), O = this.canvas.getPixelRatio(), N = M.x * O, H = M.y * O;
      this.setAttr("shadowColor", T), this.setAttr("shadowBlur", D * Math.min(Math.abs(N), Math.abs(H))), this.setAttr("shadowOffsetX", I.x * N), this.setAttr("shadowOffsetY", I.y * H);
    }
  }
  dr.SceneContext = w;
  class x extends _ {
    constructor(c) {
      super(c), this._context = c._canvas.getContext("2d", {
        willReadFrequently: !0
      });
    }
    _fill(c) {
      this.save(), this.setAttr("fillStyle", c.colorKey), c._fillFuncHit(this), this.restore();
    }
    strokeShape(c) {
      c.hasHitStroke() && this._stroke(c);
    }
    _stroke(c) {
      if (c.hasHitStroke()) {
        const f = c.getStrokeScaleEnabled();
        if (!f) {
          this.save();
          const T = this.getCanvas().getPixelRatio();
          this.setTransform(T, 0, 0, T, 0, 0);
        }
        this._applyLineCap(c);
        const S = c.hitStrokeWidth(), E = S === "auto" ? c.strokeWidth() : S;
        this.setAttr("lineWidth", E), this.setAttr("strokeStyle", c.colorKey), c._strokeFuncHit(this), f || this.restore();
      }
    }
  }
  return dr.HitContext = x, dr;
}
var Dc;
function ba() {
  if (Dc) return cr;
  Dc = 1, Object.defineProperty(cr, "__esModule", { value: !0 }), cr.HitCanvas = cr.SceneCanvas = cr.Canvas = void 0;
  const r = Kt(), a = X0(), n = At(), o = Tt(), u = Ot();
  let s;
  function h() {
    if (s)
      return s;
    const b = r.Util.createCanvasElement(), m = b.getContext("2d");
    return s = function() {
      const C = n.Konva._global.devicePixelRatio || 1, v = m.webkitBackingStorePixelRatio || m.mozBackingStorePixelRatio || m.msBackingStorePixelRatio || m.oBackingStorePixelRatio || m.backingStorePixelRatio || 1;
      return C / v;
    }(), r.Util.releaseCanvas(b), s;
  }
  let l = class {
    constructor(m) {
      this.pixelRatio = 1, this.width = 0, this.height = 0, this.isCache = !1;
      const v = (m || {}).pixelRatio || n.Konva.pixelRatio || h();
      this.pixelRatio = v, this._canvas = r.Util.createCanvasElement(), this._canvas.style.padding = "0", this._canvas.style.margin = "0", this._canvas.style.border = "0", this._canvas.style.background = "transparent", this._canvas.style.position = "absolute", this._canvas.style.top = "0", this._canvas.style.left = "0";
    }
    getContext() {
      return this.context;
    }
    getPixelRatio() {
      return this.pixelRatio;
    }
    setPixelRatio(m) {
      const C = this.pixelRatio;
      this.pixelRatio = m, this.setSize(this.getWidth() / C, this.getHeight() / C);
    }
    setWidth(m) {
      this.width = this._canvas.width = m * this.pixelRatio, this._canvas.style.width = m + "px";
      const C = this.pixelRatio;
      this.getContext()._context.scale(C, C);
    }
    setHeight(m) {
      this.height = this._canvas.height = m * this.pixelRatio, this._canvas.style.height = m + "px";
      const C = this.pixelRatio;
      this.getContext()._context.scale(C, C);
    }
    getWidth() {
      return this.width;
    }
    getHeight() {
      return this.height;
    }
    setSize(m, C) {
      this.setWidth(m || 0), this.setHeight(C || 0);
    }
    toDataURL(m, C) {
      try {
        return this._canvas.toDataURL(m, C);
      } catch {
        try {
          return this._canvas.toDataURL();
        } catch (_) {
          return r.Util.error("Unable to get data URL. " + _.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html."), "";
        }
      }
    }
  };
  cr.Canvas = l, o.Factory.addGetterSetter(l, "pixelRatio", void 0, (0, u.getNumberValidator)());
  class g extends l {
    constructor(m = { width: 0, height: 0, willReadFrequently: !1 }) {
      super(m), this.context = new a.SceneContext(this, {
        willReadFrequently: m.willReadFrequently
      }), this.setSize(m.width, m.height);
    }
  }
  cr.SceneCanvas = g;
  class p extends l {
    constructor(m = { width: 0, height: 0 }) {
      super(m), this.hitCanvas = !0, this.context = new a.HitContext(this), this.setSize(m.width, m.height);
    }
  }
  return cr.HitCanvas = p, cr;
}
var js = {}, Bc;
function $h() {
  return Bc || (Bc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.DD = void 0;
    const a = At(), n = Kt();
    r.DD = {
      get isDragging() {
        let o = !1;
        return r.DD._dragElements.forEach((u) => {
          u.dragStatus === "dragging" && (o = !0);
        }), o;
      },
      justDragged: !1,
      get node() {
        let o;
        return r.DD._dragElements.forEach((u) => {
          o = u.node;
        }), o;
      },
      _dragElements: /* @__PURE__ */ new Map(),
      _drag(o) {
        const u = [];
        r.DD._dragElements.forEach((s, h) => {
          const { node: l } = s, g = l.getStage();
          g.setPointersPositions(o), s.pointerId === void 0 && (s.pointerId = n.Util._getFirstPointerId(o));
          const p = g._changedPointerPositions.find((b) => b.id === s.pointerId);
          if (p) {
            if (s.dragStatus !== "dragging") {
              const b = l.dragDistance();
              if (Math.max(Math.abs(p.x - s.startPointerPos.x), Math.abs(p.y - s.startPointerPos.y)) < b || (l.startDrag({ evt: o }), !l.isDragging()))
                return;
            }
            l._setDragPosition(o, s), u.push(l);
          }
        }), u.forEach((s) => {
          s.fire("dragmove", {
            type: "dragmove",
            target: s,
            evt: o
          }, !0);
        });
      },
      _endDragBefore(o) {
        const u = [];
        r.DD._dragElements.forEach((s) => {
          const { node: h } = s, l = h.getStage();
          if (o && l.setPointersPositions(o), !l._changedPointerPositions.find((b) => b.id === s.pointerId))
            return;
          (s.dragStatus === "dragging" || s.dragStatus === "stopped") && (r.DD.justDragged = !0, a.Konva._mouseListenClick = !1, a.Konva._touchListenClick = !1, a.Konva._pointerListenClick = !1, s.dragStatus = "stopped");
          const p = s.node.getLayer() || s.node instanceof a.Konva.Stage && s.node;
          p && u.indexOf(p) === -1 && u.push(p);
        }), u.forEach((s) => {
          s.draw();
        });
      },
      _endDragAfter(o) {
        r.DD._dragElements.forEach((u, s) => {
          u.dragStatus === "stopped" && u.node.fire("dragend", {
            type: "dragend",
            target: u.node,
            evt: o
          }, !0), u.dragStatus !== "dragging" && r.DD._dragElements.delete(s);
        });
      }
    }, a.Konva.isBrowser && (window.addEventListener("mouseup", r.DD._endDragBefore, !0), window.addEventListener("touchend", r.DD._endDragBefore, !0), window.addEventListener("touchcancel", r.DD._endDragBefore, !0), window.addEventListener("mousemove", r.DD._drag), window.addEventListener("touchmove", r.DD._drag), window.addEventListener("mouseup", r.DD._endDragAfter, !1), window.addEventListener("touchend", r.DD._endDragAfter, !1), window.addEventListener("touchcancel", r.DD._endDragAfter, !1));
  }(js)), js;
}
var Uc;
function $t() {
  if (Uc) return Ri;
  Uc = 1, Object.defineProperty(Ri, "__esModule", { value: !0 }), Ri.Node = void 0;
  const r = Kt(), a = Tt(), n = ba(), o = At(), u = $h(), s = Ot(), h = "absoluteOpacity", l = "allEventListeners", g = "absoluteTransform", p = "absoluteScale", b = "canvas", m = "Change", C = "children", v = "konva", _ = "listening", w = "mouseenter", x = "mouseleave", P = "set", c = "Shape", f = " ", S = "stage", E = "transform", T = "Stage", D = "visible", I = [
    "xChange.konva",
    "yChange.konva",
    "scaleXChange.konva",
    "scaleYChange.konva",
    "skewXChange.konva",
    "skewYChange.konva",
    "rotationChange.konva",
    "offsetXChange.konva",
    "offsetYChange.konva",
    "transformsEnabledChange.konva"
  ].join(f);
  let M = 1, O = class Yh {
    constructor(y) {
      this._id = M++, this.eventListeners = {}, this.attrs = {}, this.index = 0, this._allEventListeners = null, this.parent = null, this._cache = /* @__PURE__ */ new Map(), this._attachedDepsListeners = /* @__PURE__ */ new Map(), this._lastPos = null, this._batchingTransformChange = !1, this._needClearTransformCache = !1, this._filterUpToDate = !1, this._isUnderCache = !1, this._dragEventId = null, this._shouldFireChangeEvents = !1, this.setAttrs(y), this._shouldFireChangeEvents = !0;
    }
    hasChildren() {
      return !1;
    }
    _clearCache(y) {
      (y === E || y === g) && this._cache.get(y) ? this._cache.get(y).dirty = !0 : y ? this._cache.delete(y) : this._cache.clear();
    }
    _getCache(y, F) {
      let R = this._cache.get(y);
      return (R === void 0 || (y === E || y === g) && R.dirty === !0) && (R = F.call(this), this._cache.set(y, R)), R;
    }
    _calculate(y, F, R) {
      if (!this._attachedDepsListeners.get(y)) {
        const G = F.map((U) => U + "Change.konva").join(f);
        this.on(G, () => {
          this._clearCache(y);
        }), this._attachedDepsListeners.set(y, !0);
      }
      return this._getCache(y, R);
    }
    _getCanvasCache() {
      return this._cache.get(b);
    }
    _clearSelfAndDescendantCache(y) {
      this._clearCache(y), y === g && this.fire("absoluteTransformChange");
    }
    clearCache() {
      if (this._cache.has(b)) {
        const { scene: y, filter: F, hit: R } = this._cache.get(b);
        r.Util.releaseCanvas(y, F, R), this._cache.delete(b);
      }
      return this._clearSelfAndDescendantCache(), this._requestDraw(), this;
    }
    cache(y) {
      const F = y || {};
      let R = {};
      (F.x === void 0 || F.y === void 0 || F.width === void 0 || F.height === void 0) && (R = this.getClientRect({
        skipTransform: !0,
        relativeTo: this.getParent() || void 0
      }));
      let G = Math.ceil(F.width || R.width), U = Math.ceil(F.height || R.height), K = F.pixelRatio, $ = F.x === void 0 ? Math.floor(R.x) : F.x, X = F.y === void 0 ? Math.floor(R.y) : F.y, Q = F.offset || 0, st = F.drawBorder || !1, Z = F.hitCanvasPixelRatio || 1;
      if (!G || !U) {
        r.Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
        return;
      }
      const at = Math.abs(Math.round(R.x) - $) > 0.5 ? 1 : 0, ht = Math.abs(Math.round(R.y) - X) > 0.5 ? 1 : 0;
      G += Q * 2 + at, U += Q * 2 + ht, $ -= Q, X -= Q;
      const ct = new n.SceneCanvas({
        pixelRatio: K,
        width: G,
        height: U
      }), z = new n.SceneCanvas({
        pixelRatio: K,
        width: 0,
        height: 0,
        willReadFrequently: !0
      }), j = new n.HitCanvas({
        pixelRatio: Z,
        width: G,
        height: U
      }), et = ct.getContext(), ut = j.getContext();
      return j.isCache = !0, ct.isCache = !0, this._cache.delete(b), this._filterUpToDate = !1, F.imageSmoothingEnabled === !1 && (ct.getContext()._context.imageSmoothingEnabled = !1, z.getContext()._context.imageSmoothingEnabled = !1), et.save(), ut.save(), et.translate(-$, -X), ut.translate(-$, -X), this._isUnderCache = !0, this._clearSelfAndDescendantCache(h), this._clearSelfAndDescendantCache(p), this.drawScene(ct, this), this.drawHit(j, this), this._isUnderCache = !1, et.restore(), ut.restore(), st && (et.save(), et.beginPath(), et.rect(0, 0, G, U), et.closePath(), et.setAttr("strokeStyle", "red"), et.setAttr("lineWidth", 5), et.stroke(), et.restore()), this._cache.set(b, {
        scene: ct,
        filter: z,
        hit: j,
        x: $,
        y: X
      }), this._requestDraw(), this;
    }
    isCached() {
      return this._cache.has(b);
    }
    getClientRect(y) {
      throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(y, F) {
      const R = [
        { x: y.x, y: y.y },
        { x: y.x + y.width, y: y.y },
        { x: y.x + y.width, y: y.y + y.height },
        { x: y.x, y: y.y + y.height }
      ];
      let G = 1 / 0, U = 1 / 0, K = -1 / 0, $ = -1 / 0;
      const X = this.getAbsoluteTransform(F);
      return R.forEach(function(Q) {
        const st = X.point(Q);
        G === void 0 && (G = K = st.x, U = $ = st.y), G = Math.min(G, st.x), U = Math.min(U, st.y), K = Math.max(K, st.x), $ = Math.max($, st.y);
      }), {
        x: G,
        y: U,
        width: K - G,
        height: $ - U
      };
    }
    _drawCachedSceneCanvas(y) {
      y.save(), y._applyOpacity(this), y._applyGlobalCompositeOperation(this);
      const F = this._getCanvasCache();
      y.translate(F.x, F.y);
      const R = this._getCachedSceneCanvas(), G = R.pixelRatio;
      y.drawImage(R._canvas, 0, 0, R.width / G, R.height / G), y.restore();
    }
    _drawCachedHitCanvas(y) {
      const F = this._getCanvasCache(), R = F.hit;
      y.save(), y.translate(F.x, F.y), y.drawImage(R._canvas, 0, 0, R.width / R.pixelRatio, R.height / R.pixelRatio), y.restore();
    }
    _getCachedSceneCanvas() {
      let y = this.filters(), F = this._getCanvasCache(), R = F.scene, G = F.filter, U = G.getContext(), K, $, X, Q;
      if (y) {
        if (!this._filterUpToDate) {
          const st = R.pixelRatio;
          G.setSize(R.width / R.pixelRatio, R.height / R.pixelRatio);
          try {
            for (K = y.length, U.clear(), U.drawImage(R._canvas, 0, 0, R.getWidth() / st, R.getHeight() / st), $ = U.getImageData(0, 0, G.getWidth(), G.getHeight()), X = 0; X < K; X++) {
              if (Q = y[X], typeof Q != "function") {
                r.Util.error("Filter should be type of function, but got " + typeof Q + " instead. Please check correct filters");
                continue;
              }
              Q.call(this, $), U.putImageData($, 0, 0);
            }
          } catch (Z) {
            r.Util.error("Unable to apply filter. " + Z.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
          }
          this._filterUpToDate = !0;
        }
        return G;
      }
      return R;
    }
    on(y, F) {
      if (this._cache && this._cache.delete(l), arguments.length === 3)
        return this._delegate.apply(this, arguments);
      let R = y.split(f), G = R.length, U, K, $, X, Q;
      for (U = 0; U < G; U++)
        K = R[U], $ = K.split("."), X = $[0], Q = $[1] || "", this.eventListeners[X] || (this.eventListeners[X] = []), this.eventListeners[X].push({
          name: Q,
          handler: F
        });
      return this;
    }
    off(y, F) {
      let R = (y || "").split(f), G = R.length, U, K, $, X, Q, st;
      if (this._cache && this._cache.delete(l), !y)
        for (K in this.eventListeners)
          this._off(K);
      for (U = 0; U < G; U++)
        if ($ = R[U], X = $.split("."), Q = X[0], st = X[1], Q)
          this.eventListeners[Q] && this._off(Q, st, F);
        else
          for (K in this.eventListeners)
            this._off(K, st, F);
      return this;
    }
    dispatchEvent(y) {
      const F = {
        target: this,
        type: y.type,
        evt: y
      };
      return this.fire(y.type, F), this;
    }
    addEventListener(y, F) {
      return this.on(y, function(R) {
        F.call(this, R.evt);
      }), this;
    }
    removeEventListener(y) {
      return this.off(y), this;
    }
    _delegate(y, F, R) {
      const G = this;
      this.on(y, function(U) {
        const K = U.target.findAncestors(F, !0, G);
        for (let $ = 0; $ < K.length; $++)
          U = r.Util.cloneObject(U), U.currentTarget = K[$], R.call(K[$], U);
      });
    }
    remove() {
      return this.isDragging() && this.stopDrag(), u.DD._dragElements.delete(this._id), this._remove(), this;
    }
    _clearCaches() {
      this._clearSelfAndDescendantCache(g), this._clearSelfAndDescendantCache(h), this._clearSelfAndDescendantCache(p), this._clearSelfAndDescendantCache(S), this._clearSelfAndDescendantCache(D), this._clearSelfAndDescendantCache(_);
    }
    _remove() {
      this._clearCaches();
      const y = this.getParent();
      y && y.children && (y.children.splice(this.index, 1), y._setChildrenIndices(), this.parent = null);
    }
    destroy() {
      return this.remove(), this.clearCache(), this;
    }
    getAttr(y) {
      const F = "get" + r.Util._capitalize(y);
      return r.Util._isFunction(this[F]) ? this[F]() : this.attrs[y];
    }
    getAncestors() {
      let y = this.getParent(), F = [];
      for (; y; )
        F.push(y), y = y.getParent();
      return F;
    }
    getAttrs() {
      return this.attrs || {};
    }
    setAttrs(y) {
      return this._batchTransformChanges(() => {
        let F, R;
        if (!y)
          return this;
        for (F in y)
          F !== C && (R = P + r.Util._capitalize(F), r.Util._isFunction(this[R]) ? this[R](y[F]) : this._setAttr(F, y[F]));
      }), this;
    }
    isListening() {
      return this._getCache(_, this._isListening);
    }
    _isListening(y) {
      if (!this.listening())
        return !1;
      const R = this.getParent();
      return R && R !== y && this !== y ? R._isListening(y) : !0;
    }
    isVisible() {
      return this._getCache(D, this._isVisible);
    }
    _isVisible(y) {
      if (!this.visible())
        return !1;
      const R = this.getParent();
      return R && R !== y && this !== y ? R._isVisible(y) : !0;
    }
    shouldDrawHit(y, F = !1) {
      if (y)
        return this._isVisible(y) && this._isListening(y);
      const R = this.getLayer();
      let G = !1;
      u.DD._dragElements.forEach((K) => {
        K.dragStatus === "dragging" && (K.node.nodeType === "Stage" || K.node.getLayer() === R) && (G = !0);
      });
      const U = !F && !o.Konva.hitOnDragEnabled && (G || o.Konva.isTransforming());
      return this.isListening() && this.isVisible() && !U;
    }
    show() {
      return this.visible(!0), this;
    }
    hide() {
      return this.visible(!1), this;
    }
    getZIndex() {
      return this.index || 0;
    }
    getAbsoluteZIndex() {
      let y = this.getDepth(), F = this, R = 0, G, U, K, $;
      function X(st) {
        for (G = [], U = st.length, K = 0; K < U; K++)
          $ = st[K], R++, $.nodeType !== c && (G = G.concat($.getChildren().slice())), $._id === F._id && (K = U);
        G.length > 0 && G[0].getDepth() <= y && X(G);
      }
      const Q = this.getStage();
      return F.nodeType !== T && Q && X(Q.getChildren()), R;
    }
    getDepth() {
      let y = 0, F = this.parent;
      for (; F; )
        y++, F = F.parent;
      return y;
    }
    _batchTransformChanges(y) {
      this._batchingTransformChange = !0, y(), this._batchingTransformChange = !1, this._needClearTransformCache && (this._clearCache(E), this._clearSelfAndDescendantCache(g)), this._needClearTransformCache = !1;
    }
    setPosition(y) {
      return this._batchTransformChanges(() => {
        this.x(y.x), this.y(y.y);
      }), this;
    }
    getPosition() {
      return {
        x: this.x(),
        y: this.y()
      };
    }
    getRelativePointerPosition() {
      const y = this.getStage();
      if (!y)
        return null;
      const F = y.getPointerPosition();
      if (!F)
        return null;
      const R = this.getAbsoluteTransform().copy();
      return R.invert(), R.point(F);
    }
    getAbsolutePosition(y) {
      let F = !1, R = this.parent;
      for (; R; ) {
        if (R.isCached()) {
          F = !0;
          break;
        }
        R = R.parent;
      }
      F && !y && (y = !0);
      const G = this.getAbsoluteTransform(y).getMatrix(), U = new r.Transform(), K = this.offset();
      return U.m = G.slice(), U.translate(K.x, K.y), U.getTranslation();
    }
    setAbsolutePosition(y) {
      const { x: F, y: R, ...G } = this._clearTransform();
      this.attrs.x = F, this.attrs.y = R, this._clearCache(E);
      const U = this._getAbsoluteTransform().copy();
      return U.invert(), U.translate(y.x, y.y), y = {
        x: this.attrs.x + U.getTranslation().x,
        y: this.attrs.y + U.getTranslation().y
      }, this._setTransform(G), this.setPosition({ x: y.x, y: y.y }), this._clearCache(E), this._clearSelfAndDescendantCache(g), this;
    }
    _setTransform(y) {
      let F;
      for (F in y)
        this.attrs[F] = y[F];
    }
    _clearTransform() {
      const y = {
        x: this.x(),
        y: this.y(),
        rotation: this.rotation(),
        scaleX: this.scaleX(),
        scaleY: this.scaleY(),
        offsetX: this.offsetX(),
        offsetY: this.offsetY(),
        skewX: this.skewX(),
        skewY: this.skewY()
      };
      return this.attrs.x = 0, this.attrs.y = 0, this.attrs.rotation = 0, this.attrs.scaleX = 1, this.attrs.scaleY = 1, this.attrs.offsetX = 0, this.attrs.offsetY = 0, this.attrs.skewX = 0, this.attrs.skewY = 0, y;
    }
    move(y) {
      let F = y.x, R = y.y, G = this.x(), U = this.y();
      return F !== void 0 && (G += F), R !== void 0 && (U += R), this.setPosition({ x: G, y: U }), this;
    }
    _eachAncestorReverse(y, F) {
      let R = [], G = this.getParent(), U, K;
      if (!(F && F._id === this._id)) {
        for (R.unshift(this); G && (!F || G._id !== F._id); )
          R.unshift(G), G = G.parent;
        for (U = R.length, K = 0; K < U; K++)
          y(R[K]);
      }
    }
    rotate(y) {
      return this.rotation(this.rotation() + y), this;
    }
    moveToTop() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveToTop function is ignored."), !1;
      const y = this.index, F = this.parent.getChildren().length;
      return y < F - 1 ? (this.parent.children.splice(y, 1), this.parent.children.push(this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveUp() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveUp function is ignored."), !1;
      const y = this.index, F = this.parent.getChildren().length;
      return y < F - 1 ? (this.parent.children.splice(y, 1), this.parent.children.splice(y + 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveDown() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveDown function is ignored."), !1;
      const y = this.index;
      return y > 0 ? (this.parent.children.splice(y, 1), this.parent.children.splice(y - 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveToBottom() {
      if (!this.parent)
        return r.Util.warn("Node has no parent. moveToBottom function is ignored."), !1;
      const y = this.index;
      return y > 0 ? (this.parent.children.splice(y, 1), this.parent.children.unshift(this), this.parent._setChildrenIndices(), !0) : !1;
    }
    setZIndex(y) {
      if (!this.parent)
        return r.Util.warn("Node has no parent. zIndex parameter is ignored."), this;
      (y < 0 || y >= this.parent.children.length) && r.Util.warn("Unexpected value " + y + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
      const F = this.index;
      return this.parent.children.splice(F, 1), this.parent.children.splice(y, 0, this), this.parent._setChildrenIndices(), this;
    }
    getAbsoluteOpacity() {
      return this._getCache(h, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
      let y = this.opacity();
      const F = this.getParent();
      return F && !F._isUnderCache && (y *= F.getAbsoluteOpacity()), y;
    }
    moveTo(y) {
      return this.getParent() !== y && (this._remove(), y.add(this)), this;
    }
    toObject() {
      let y = this.getAttrs(), F, R, G, U, K;
      const $ = {
        attrs: {},
        className: this.getClassName()
      };
      for (F in y)
        R = y[F], K = r.Util.isObject(R) && !r.Util._isPlainObject(R) && !r.Util._isArray(R), !K && (G = typeof this[F] == "function" && this[F], delete y[F], U = G ? G.call(this) : null, y[F] = R, U !== R && ($.attrs[F] = R));
      return r.Util._prepareToStringify($);
    }
    toJSON() {
      return JSON.stringify(this.toObject());
    }
    getParent() {
      return this.parent;
    }
    findAncestors(y, F, R) {
      const G = [];
      F && this._isMatch(y) && G.push(this);
      let U = this.parent;
      for (; U; ) {
        if (U === R)
          return G;
        U._isMatch(y) && G.push(U), U = U.parent;
      }
      return G;
    }
    isAncestorOf(y) {
      return !1;
    }
    findAncestor(y, F, R) {
      return this.findAncestors(y, F, R)[0];
    }
    _isMatch(y) {
      if (!y)
        return !1;
      if (typeof y == "function")
        return y(this);
      let F = y.replace(/ /g, "").split(","), R = F.length, G, U;
      for (G = 0; G < R; G++)
        if (U = F[G], r.Util.isValidSelector(U) || (r.Util.warn('Selector "' + U + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'), r.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'), r.Util.warn("Konva is awesome, right?")), U.charAt(0) === "#") {
          if (this.id() === U.slice(1))
            return !0;
        } else if (U.charAt(0) === ".") {
          if (this.hasName(U.slice(1)))
            return !0;
        } else if (this.className === U || this.nodeType === U)
          return !0;
      return !1;
    }
    getLayer() {
      const y = this.getParent();
      return y ? y.getLayer() : null;
    }
    getStage() {
      return this._getCache(S, this._getStage);
    }
    _getStage() {
      const y = this.getParent();
      return y ? y.getStage() : null;
    }
    fire(y, F = {}, R) {
      return F.target = F.target || this, R ? this._fireAndBubble(y, F) : this._fire(y, F), this;
    }
    getAbsoluteTransform(y) {
      return y ? this._getAbsoluteTransform(y) : this._getCache(g, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(y) {
      let F;
      if (y)
        return F = new r.Transform(), this._eachAncestorReverse(function(R) {
          const G = R.transformsEnabled();
          G === "all" ? F.multiply(R.getTransform()) : G === "position" && F.translate(R.x() - R.offsetX(), R.y() - R.offsetY());
        }, y), F;
      {
        F = this._cache.get(g) || new r.Transform(), this.parent ? this.parent.getAbsoluteTransform().copyInto(F) : F.reset();
        const R = this.transformsEnabled();
        if (R === "all")
          F.multiply(this.getTransform());
        else if (R === "position") {
          const G = this.attrs.x || 0, U = this.attrs.y || 0, K = this.attrs.offsetX || 0, $ = this.attrs.offsetY || 0;
          F.translate(G - K, U - $);
        }
        return F.dirty = !1, F;
      }
    }
    getAbsoluteScale(y) {
      let F = this;
      for (; F; )
        F._isUnderCache && (y = F), F = F.getParent();
      const G = this.getAbsoluteTransform(y).decompose();
      return {
        x: G.scaleX,
        y: G.scaleY
      };
    }
    getAbsoluteRotation() {
      return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
      return this._getCache(E, this._getTransform);
    }
    _getTransform() {
      var y, F;
      const R = this._cache.get(E) || new r.Transform();
      R.reset();
      const G = this.x(), U = this.y(), K = o.Konva.getAngle(this.rotation()), $ = (y = this.attrs.scaleX) !== null && y !== void 0 ? y : 1, X = (F = this.attrs.scaleY) !== null && F !== void 0 ? F : 1, Q = this.attrs.skewX || 0, st = this.attrs.skewY || 0, Z = this.attrs.offsetX || 0, at = this.attrs.offsetY || 0;
      return (G !== 0 || U !== 0) && R.translate(G, U), K !== 0 && R.rotate(K), (Q !== 0 || st !== 0) && R.skew(Q, st), ($ !== 1 || X !== 1) && R.scale($, X), (Z !== 0 || at !== 0) && R.translate(-1 * Z, -1 * at), R.dirty = !1, R;
    }
    clone(y) {
      let F = r.Util.cloneObject(this.attrs), R, G, U, K, $;
      for (R in y)
        F[R] = y[R];
      const X = new this.constructor(F);
      for (R in this.eventListeners)
        for (G = this.eventListeners[R], U = G.length, K = 0; K < U; K++)
          $ = G[K], $.name.indexOf(v) < 0 && (X.eventListeners[R] || (X.eventListeners[R] = []), X.eventListeners[R].push($));
      return X;
    }
    _toKonvaCanvas(y) {
      y = y || {};
      const F = this.getClientRect(), R = this.getStage(), G = y.x !== void 0 ? y.x : Math.floor(F.x), U = y.y !== void 0 ? y.y : Math.floor(F.y), K = y.pixelRatio || 1, $ = new n.SceneCanvas({
        width: y.width || Math.ceil(F.width) || (R ? R.width() : 0),
        height: y.height || Math.ceil(F.height) || (R ? R.height() : 0),
        pixelRatio: K
      }), X = $.getContext(), Q = new n.SceneCanvas({
        width: $.width / $.pixelRatio + Math.abs(G),
        height: $.height / $.pixelRatio + Math.abs(U),
        pixelRatio: $.pixelRatio
      });
      return y.imageSmoothingEnabled === !1 && (X._context.imageSmoothingEnabled = !1), X.save(), (G || U) && X.translate(-1 * G, -1 * U), this.drawScene($, void 0, Q), X.restore(), $;
    }
    toCanvas(y) {
      return this._toKonvaCanvas(y)._canvas;
    }
    toDataURL(y) {
      y = y || {};
      const F = y.mimeType || null, R = y.quality || null, G = this._toKonvaCanvas(y).toDataURL(F, R);
      return y.callback && y.callback(G), G;
    }
    toImage(y) {
      return new Promise((F, R) => {
        try {
          const G = y == null ? void 0 : y.callback;
          G && delete y.callback, r.Util._urlToImage(this.toDataURL(y), function(U) {
            F(U), G == null || G(U);
          });
        } catch (G) {
          R(G);
        }
      });
    }
    toBlob(y) {
      return new Promise((F, R) => {
        try {
          const G = y == null ? void 0 : y.callback;
          G && delete y.callback, this.toCanvas(y).toBlob((U) => {
            F(U), G == null || G(U);
          }, y == null ? void 0 : y.mimeType, y == null ? void 0 : y.quality);
        } catch (G) {
          R(G);
        }
      });
    }
    setSize(y) {
      return this.width(y.width), this.height(y.height), this;
    }
    getSize() {
      return {
        width: this.width(),
        height: this.height()
      };
    }
    getClassName() {
      return this.className || this.nodeType;
    }
    getType() {
      return this.nodeType;
    }
    getDragDistance() {
      return this.attrs.dragDistance !== void 0 ? this.attrs.dragDistance : this.parent ? this.parent.getDragDistance() : o.Konva.dragDistance;
    }
    _off(y, F, R) {
      let G = this.eventListeners[y], U, K, $;
      for (U = 0; U < G.length; U++)
        if (K = G[U].name, $ = G[U].handler, (K !== "konva" || F === "konva") && (!F || K === F) && (!R || R === $)) {
          if (G.splice(U, 1), G.length === 0) {
            delete this.eventListeners[y];
            break;
          }
          U--;
        }
    }
    _fireChangeEvent(y, F, R) {
      this._fire(y + m, {
        oldVal: F,
        newVal: R
      });
    }
    addName(y) {
      if (!this.hasName(y)) {
        const F = this.name(), R = F ? F + " " + y : y;
        this.name(R);
      }
      return this;
    }
    hasName(y) {
      if (!y)
        return !1;
      const F = this.name();
      return F ? (F || "").split(/\s/g).indexOf(y) !== -1 : !1;
    }
    removeName(y) {
      const F = (this.name() || "").split(/\s/g), R = F.indexOf(y);
      return R !== -1 && (F.splice(R, 1), this.name(F.join(" "))), this;
    }
    setAttr(y, F) {
      const R = this[P + r.Util._capitalize(y)];
      return r.Util._isFunction(R) ? R.call(this, F) : this._setAttr(y, F), this;
    }
    _requestDraw() {
      if (o.Konva.autoDrawEnabled) {
        const y = this.getLayer() || this.getStage();
        y == null || y.batchDraw();
      }
    }
    _setAttr(y, F) {
      const R = this.attrs[y];
      R === F && !r.Util.isObject(F) || (F == null ? delete this.attrs[y] : this.attrs[y] = F, this._shouldFireChangeEvents && this._fireChangeEvent(y, R, F), this._requestDraw());
    }
    _setComponentAttr(y, F, R) {
      let G;
      R !== void 0 && (G = this.attrs[y], G || (this.attrs[y] = this.getAttr(y)), this.attrs[y][F] = R, this._fireChangeEvent(y, G, R));
    }
    _fireAndBubble(y, F, R) {
      if (F && this.nodeType === c && (F.target = this), !((y === w || y === x) && (R && (this === R || this.isAncestorOf && this.isAncestorOf(R)) || this.nodeType === "Stage" && !R))) {
        this._fire(y, F);
        const U = (y === w || y === x) && R && R.isAncestorOf && R.isAncestorOf(this) && !R.isAncestorOf(this.parent);
        (F && !F.cancelBubble || !F) && this.parent && this.parent.isListening() && !U && (R && R.parent ? this._fireAndBubble.call(this.parent, y, F, R) : this._fireAndBubble.call(this.parent, y, F));
      }
    }
    _getProtoListeners(y) {
      var F, R, G;
      const U = (F = this._cache.get(l)) !== null && F !== void 0 ? F : {};
      let K = U == null ? void 0 : U[y];
      if (K === void 0) {
        K = [];
        let $ = Object.getPrototypeOf(this);
        for (; $; ) {
          const X = (G = (R = $.eventListeners) === null || R === void 0 ? void 0 : R[y]) !== null && G !== void 0 ? G : [];
          K.push(...X), $ = Object.getPrototypeOf($);
        }
        U[y] = K, this._cache.set(l, U);
      }
      return K;
    }
    _fire(y, F) {
      F = F || {}, F.currentTarget = this, F.type = y;
      const R = this._getProtoListeners(y);
      if (R)
        for (var G = 0; G < R.length; G++)
          R[G].handler.call(this, F);
      const U = this.eventListeners[y];
      if (U)
        for (var G = 0; G < U.length; G++)
          U[G].handler.call(this, F);
    }
    draw() {
      return this.drawScene(), this.drawHit(), this;
    }
    _createDragElement(y) {
      const F = y ? y.pointerId : void 0, R = this.getStage(), G = this.getAbsolutePosition();
      if (!R)
        return;
      const U = R._getPointerById(F) || R._changedPointerPositions[0] || G;
      u.DD._dragElements.set(this._id, {
        node: this,
        startPointerPos: U,
        offset: {
          x: U.x - G.x,
          y: U.y - G.y
        },
        dragStatus: "ready",
        pointerId: F
      });
    }
    startDrag(y, F = !0) {
      u.DD._dragElements.has(this._id) || this._createDragElement(y);
      const R = u.DD._dragElements.get(this._id);
      R.dragStatus = "dragging", this.fire("dragstart", {
        type: "dragstart",
        target: this,
        evt: y && y.evt
      }, F);
    }
    _setDragPosition(y, F) {
      const R = this.getStage()._getPointerById(F.pointerId);
      if (!R)
        return;
      let G = {
        x: R.x - F.offset.x,
        y: R.y - F.offset.y
      };
      const U = this.dragBoundFunc();
      if (U !== void 0) {
        const K = U.call(this, G, y);
        K ? G = K : r.Util.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
      }
      (!this._lastPos || this._lastPos.x !== G.x || this._lastPos.y !== G.y) && (this.setAbsolutePosition(G), this._requestDraw()), this._lastPos = G;
    }
    stopDrag(y) {
      const F = u.DD._dragElements.get(this._id);
      F && (F.dragStatus = "stopped"), u.DD._endDragBefore(y), u.DD._endDragAfter(y);
    }
    setDraggable(y) {
      this._setAttr("draggable", y), this._dragChange();
    }
    isDragging() {
      const y = u.DD._dragElements.get(this._id);
      return y ? y.dragStatus === "dragging" : !1;
    }
    _listenDrag() {
      this._dragCleanup(), this.on("mousedown.konva touchstart.konva", function(y) {
        if (!(!(y.evt.button !== void 0) || o.Konva.dragButtons.indexOf(y.evt.button) >= 0) || this.isDragging())
          return;
        let G = !1;
        u.DD._dragElements.forEach((U) => {
          this.isAncestorOf(U.node) && (G = !0);
        }), G || this._createDragElement(y);
      });
    }
    _dragChange() {
      if (this.attrs.draggable)
        this._listenDrag();
      else {
        if (this._dragCleanup(), !this.getStage())
          return;
        const F = u.DD._dragElements.get(this._id), R = F && F.dragStatus === "dragging", G = F && F.dragStatus === "ready";
        R ? this.stopDrag() : G && u.DD._dragElements.delete(this._id);
      }
    }
    _dragCleanup() {
      this.off("mousedown.konva"), this.off("touchstart.konva");
    }
    isClientRectOnScreen(y = { x: 0, y: 0 }) {
      const F = this.getStage();
      if (!F)
        return !1;
      const R = {
        x: -y.x,
        y: -y.y,
        width: F.width() + 2 * y.x,
        height: F.height() + 2 * y.y
      };
      return r.Util.haveIntersection(R, this.getClientRect());
    }
    static create(y, F) {
      return r.Util._isString(y) && (y = JSON.parse(y)), this._createNode(y, F);
    }
    static _createNode(y, F) {
      let R = Yh.prototype.getClassName.call(y), G = y.children, U, K, $;
      F && (y.attrs.container = F), o.Konva[R] || (r.Util.warn('Can not find a node with class name "' + R + '". Fallback to "Shape".'), R = "Shape");
      const X = o.Konva[R];
      if (U = new X(y.attrs), G)
        for (K = G.length, $ = 0; $ < K; $++)
          U.add(Yh._createNode(G[$]));
      return U;
    }
  };
  Ri.Node = O, O.prototype.nodeType = "Node", O.prototype._attrsAffectingSize = [], O.prototype.eventListeners = {}, O.prototype.on.call(O.prototype, I, function() {
    if (this._batchingTransformChange) {
      this._needClearTransformCache = !0;
      return;
    }
    this._clearCache(E), this._clearSelfAndDescendantCache(g);
  }), O.prototype.on.call(O.prototype, "visibleChange.konva", function() {
    this._clearSelfAndDescendantCache(D);
  }), O.prototype.on.call(O.prototype, "listeningChange.konva", function() {
    this._clearSelfAndDescendantCache(_);
  }), O.prototype.on.call(O.prototype, "opacityChange.konva", function() {
    this._clearSelfAndDescendantCache(h);
  });
  const N = a.Factory.addGetterSetter;
  return N(O, "zIndex"), N(O, "absolutePosition"), N(O, "position"), N(O, "x", 0, (0, s.getNumberValidator)()), N(O, "y", 0, (0, s.getNumberValidator)()), N(O, "globalCompositeOperation", "source-over", (0, s.getStringValidator)()), N(O, "opacity", 1, (0, s.getNumberValidator)()), N(O, "name", "", (0, s.getStringValidator)()), N(O, "id", "", (0, s.getStringValidator)()), N(O, "rotation", 0, (0, s.getNumberValidator)()), a.Factory.addComponentsGetterSetter(O, "scale", ["x", "y"]), N(O, "scaleX", 1, (0, s.getNumberValidator)()), N(O, "scaleY", 1, (0, s.getNumberValidator)()), a.Factory.addComponentsGetterSetter(O, "skew", ["x", "y"]), N(O, "skewX", 0, (0, s.getNumberValidator)()), N(O, "skewY", 0, (0, s.getNumberValidator)()), a.Factory.addComponentsGetterSetter(O, "offset", ["x", "y"]), N(O, "offsetX", 0, (0, s.getNumberValidator)()), N(O, "offsetY", 0, (0, s.getNumberValidator)()), N(O, "dragDistance", null, (0, s.getNumberValidator)()), N(O, "width", 0, (0, s.getNumberValidator)()), N(O, "height", 0, (0, s.getNumberValidator)()), N(O, "listening", !0, (0, s.getBooleanValidator)()), N(O, "preventDefault", !0, (0, s.getBooleanValidator)()), N(O, "filters", null, function(H) {
    return this._filterUpToDate = !1, H;
  }), N(O, "visible", !0, (0, s.getBooleanValidator)()), N(O, "transformsEnabled", "all", (0, s.getStringValidator)()), N(O, "size"), N(O, "dragBoundFunc"), N(O, "draggable", !1, (0, s.getBooleanValidator)()), a.Factory.backCompat(O, {
    rotateDeg: "rotate",
    setRotationDeg: "setRotation",
    getRotationDeg: "getRotation"
  }), Ri;
}
var Ai = {}, qc;
function Sa() {
  if (qc) return Ai;
  qc = 1, Object.defineProperty(Ai, "__esModule", { value: !0 }), Ai.Container = void 0;
  const r = Tt(), a = $t(), n = Ot();
  let o = class extends a.Node {
    constructor() {
      super(...arguments), this.children = [];
    }
    getChildren(s) {
      if (!s)
        return this.children || [];
      const h = this.children || [], l = [];
      return h.forEach(function(g) {
        s(g) && l.push(g);
      }), l;
    }
    hasChildren() {
      return this.getChildren().length > 0;
    }
    removeChildren() {
      return this.getChildren().forEach((s) => {
        s.parent = null, s.index = 0, s.remove();
      }), this.children = [], this._requestDraw(), this;
    }
    destroyChildren() {
      return this.getChildren().forEach((s) => {
        s.parent = null, s.index = 0, s.destroy();
      }), this.children = [], this._requestDraw(), this;
    }
    add(...s) {
      if (s.length === 0)
        return this;
      if (s.length > 1) {
        for (let l = 0; l < s.length; l++)
          this.add(s[l]);
        return this;
      }
      const h = s[0];
      return h.getParent() ? (h.moveTo(this), this) : (this._validateAdd(h), h.index = this.getChildren().length, h.parent = this, h._clearCaches(), this.getChildren().push(h), this._fire("add", {
        child: h
      }), this._requestDraw(), this);
    }
    destroy() {
      return this.hasChildren() && this.destroyChildren(), super.destroy(), this;
    }
    find(s) {
      return this._generalFind(s, !1);
    }
    findOne(s) {
      const h = this._generalFind(s, !0);
      return h.length > 0 ? h[0] : void 0;
    }
    _generalFind(s, h) {
      const l = [];
      return this._descendants((g) => {
        const p = g._isMatch(s);
        return p && l.push(g), !!(p && h);
      }), l;
    }
    _descendants(s) {
      let h = !1;
      const l = this.getChildren();
      for (const g of l) {
        if (h = s(g), h)
          return !0;
        if (g.hasChildren() && (h = g._descendants(s), h))
          return !0;
      }
      return !1;
    }
    toObject() {
      const s = a.Node.prototype.toObject.call(this);
      return s.children = [], this.getChildren().forEach((h) => {
        s.children.push(h.toObject());
      }), s;
    }
    isAncestorOf(s) {
      let h = s.getParent();
      for (; h; ) {
        if (h._id === this._id)
          return !0;
        h = h.getParent();
      }
      return !1;
    }
    clone(s) {
      const h = a.Node.prototype.clone.call(this, s);
      return this.getChildren().forEach(function(l) {
        h.add(l.clone());
      }), h;
    }
    getAllIntersections(s) {
      const h = [];
      return this.find("Shape").forEach((l) => {
        l.isVisible() && l.intersects(s) && h.push(l);
      }), h;
    }
    _clearSelfAndDescendantCache(s) {
      var h;
      super._clearSelfAndDescendantCache(s), !this.isCached() && ((h = this.children) === null || h === void 0 || h.forEach(function(l) {
        l._clearSelfAndDescendantCache(s);
      }));
    }
    _setChildrenIndices() {
      var s;
      (s = this.children) === null || s === void 0 || s.forEach(function(h, l) {
        h.index = l;
      }), this._requestDraw();
    }
    drawScene(s, h, l) {
      const g = this.getLayer(), p = s || g && g.getCanvas(), b = p && p.getContext(), m = this._getCanvasCache(), C = m && m.scene, v = p && p.isCache;
      if (!this.isVisible() && !v)
        return this;
      if (C) {
        b.save();
        const _ = this.getAbsoluteTransform(h).getMatrix();
        b.transform(_[0], _[1], _[2], _[3], _[4], _[5]), this._drawCachedSceneCanvas(b), b.restore();
      } else
        this._drawChildren("drawScene", p, h, l);
      return this;
    }
    drawHit(s, h) {
      if (!this.shouldDrawHit(h))
        return this;
      const l = this.getLayer(), g = s || l && l.hitCanvas, p = g && g.getContext(), b = this._getCanvasCache();
      if (b && b.hit) {
        p.save();
        const C = this.getAbsoluteTransform(h).getMatrix();
        p.transform(C[0], C[1], C[2], C[3], C[4], C[5]), this._drawCachedHitCanvas(p), p.restore();
      } else
        this._drawChildren("drawHit", g, h);
      return this;
    }
    _drawChildren(s, h, l, g) {
      var p;
      const b = h && h.getContext(), m = this.clipWidth(), C = this.clipHeight(), v = this.clipFunc(), _ = typeof m == "number" && typeof C == "number" || v, w = l === this;
      if (_) {
        b.save();
        const P = this.getAbsoluteTransform(l);
        let c = P.getMatrix();
        b.transform(c[0], c[1], c[2], c[3], c[4], c[5]), b.beginPath();
        let f;
        if (v)
          f = v.call(this, b, this);
        else {
          const S = this.clipX(), E = this.clipY();
          b.rect(S || 0, E || 0, m, C);
        }
        b.clip.apply(b, f), c = P.copy().invert().getMatrix(), b.transform(c[0], c[1], c[2], c[3], c[4], c[5]);
      }
      const x = !w && this.globalCompositeOperation() !== "source-over" && s === "drawScene";
      x && (b.save(), b._applyGlobalCompositeOperation(this)), (p = this.children) === null || p === void 0 || p.forEach(function(P) {
        P[s](h, l, g);
      }), x && b.restore(), _ && b.restore();
    }
    getClientRect(s = {}) {
      var h;
      const l = s.skipTransform, g = s.relativeTo;
      let p, b, m, C, v = {
        x: 1 / 0,
        y: 1 / 0,
        width: 0,
        height: 0
      };
      const _ = this;
      (h = this.children) === null || h === void 0 || h.forEach(function(P) {
        if (!P.visible())
          return;
        const c = P.getClientRect({
          relativeTo: _,
          skipShadow: s.skipShadow,
          skipStroke: s.skipStroke
        });
        c.width === 0 && c.height === 0 || (p === void 0 ? (p = c.x, b = c.y, m = c.x + c.width, C = c.y + c.height) : (p = Math.min(p, c.x), b = Math.min(b, c.y), m = Math.max(m, c.x + c.width), C = Math.max(C, c.y + c.height)));
      });
      const w = this.find("Shape");
      let x = !1;
      for (let P = 0; P < w.length; P++)
        if (w[P]._isVisible(this)) {
          x = !0;
          break;
        }
      return x && p !== void 0 ? v = {
        x: p,
        y: b,
        width: m - p,
        height: C - b
      } : v = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, l ? v : this._transformedRect(v, g);
    }
  };
  return Ai.Container = o, r.Factory.addComponentsGetterSetter(o, "clip", [
    "x",
    "y",
    "width",
    "height"
  ]), r.Factory.addGetterSetter(o, "clipX", void 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(o, "clipY", void 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(o, "clipWidth", void 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(o, "clipHeight", void 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(o, "clipFunc"), Ai;
}
var Ks = {}, xr = {}, Hc;
function $0() {
  if (Hc) return xr;
  Hc = 1, Object.defineProperty(xr, "__esModule", { value: !0 }), xr.getCapturedShape = o, xr.createEvent = u, xr.hasPointerCapture = s, xr.setPointerCapture = h, xr.releaseCapture = l;
  const r = At(), a = /* @__PURE__ */ new Map(), n = r.Konva._global.PointerEvent !== void 0;
  function o(g) {
    return a.get(g);
  }
  function u(g) {
    return {
      evt: g,
      pointerId: g.pointerId
    };
  }
  function s(g, p) {
    return a.get(g) === p;
  }
  function h(g, p) {
    l(g), p.getStage() && (a.set(g, p), n && p._fire("gotpointercapture", u(new PointerEvent("gotpointercapture"))));
  }
  function l(g, p) {
    const b = a.get(g);
    if (!b)
      return;
    const m = b.getStage();
    m && m.content, a.delete(g), n && b._fire("lostpointercapture", u(new PointerEvent("lostpointercapture")));
  }
  return xr;
}
var zc;
function i6() {
  return zc || (zc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Stage = r.stages = void 0;
    const a = Kt(), n = Tt(), o = Sa(), u = At(), s = ba(), h = $h(), l = At(), g = $0(), p = "Stage", b = "string", m = "px", C = "mouseout", v = "mouseleave", _ = "mouseover", w = "mouseenter", x = "mousemove", P = "mousedown", c = "mouseup", f = "pointermove", S = "pointerdown", E = "pointerup", T = "pointercancel", D = "lostpointercapture", I = "pointerout", M = "pointerleave", O = "pointerover", N = "pointerenter", H = "contextmenu", y = "touchstart", F = "touchend", R = "touchmove", G = "touchcancel", U = "wheel", K = 5, $ = [
      [w, "_pointerenter"],
      [P, "_pointerdown"],
      [x, "_pointermove"],
      [c, "_pointerup"],
      [v, "_pointerleave"],
      [y, "_pointerdown"],
      [R, "_pointermove"],
      [F, "_pointerup"],
      [G, "_pointercancel"],
      [_, "_pointerover"],
      [U, "_wheel"],
      [H, "_contextmenu"],
      [S, "_pointerdown"],
      [f, "_pointermove"],
      [E, "_pointerup"],
      [T, "_pointercancel"],
      [D, "_lostpointercapture"]
    ], X = {
      mouse: {
        [I]: C,
        [M]: v,
        [O]: _,
        [N]: w,
        [f]: x,
        [S]: P,
        [E]: c,
        [T]: "mousecancel",
        pointerclick: "click",
        pointerdblclick: "dblclick"
      },
      touch: {
        [I]: "touchout",
        [M]: "touchleave",
        [O]: "touchover",
        [N]: "touchenter",
        [f]: R,
        [S]: y,
        [E]: F,
        [T]: G,
        pointerclick: "tap",
        pointerdblclick: "dbltap"
      },
      pointer: {
        [I]: I,
        [M]: M,
        [O]: O,
        [N]: N,
        [f]: f,
        [S]: S,
        [E]: E,
        [T]: T,
        pointerclick: "pointerclick",
        pointerdblclick: "pointerdblclick"
      }
    }, Q = (ct) => ct.indexOf("pointer") >= 0 ? "pointer" : ct.indexOf("touch") >= 0 ? "touch" : "mouse", st = (ct) => {
      const z = Q(ct);
      if (z === "pointer")
        return u.Konva.pointerEventsEnabled && X.pointer;
      if (z === "touch")
        return X.touch;
      if (z === "mouse")
        return X.mouse;
    };
    function Z(ct = {}) {
      return (ct.clipFunc || ct.clipWidth || ct.clipHeight) && a.Util.warn("Stage does not support clipping. Please use clip for Layers or Groups."), ct;
    }
    const at = "Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);";
    r.stages = [];
    class ht extends o.Container {
      constructor(z) {
        super(Z(z)), this._pointerPositions = [], this._changedPointerPositions = [], this._buildDOM(), this._bindContentEvents(), r.stages.push(this), this.on("widthChange.konva heightChange.konva", this._resizeDOM), this.on("visibleChange.konva", this._checkVisibility), this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", () => {
          Z(this.attrs);
        }), this._checkVisibility();
      }
      _validateAdd(z) {
        const j = z.getType() === "Layer", et = z.getType() === "FastLayer";
        j || et || a.Util.throw("You may only add layers to the stage.");
      }
      _checkVisibility() {
        if (!this.content)
          return;
        const z = this.visible() ? "" : "none";
        this.content.style.display = z;
      }
      setContainer(z) {
        if (typeof z === b) {
          if (z.charAt(0) === ".") {
            const et = z.slice(1);
            z = document.getElementsByClassName(et)[0];
          } else {
            var j;
            z.charAt(0) !== "#" ? j = z : j = z.slice(1), z = document.getElementById(j);
          }
          if (!z)
            throw "Can not find container in document with id " + j;
        }
        return this._setAttr("container", z), this.content && (this.content.parentElement && this.content.parentElement.removeChild(this.content), z.appendChild(this.content)), this;
      }
      shouldDrawHit() {
        return !0;
      }
      clear() {
        let z = this.children, j = z.length, et;
        for (et = 0; et < j; et++)
          z[et].clear();
        return this;
      }
      clone(z) {
        return z || (z = {}), z.container = typeof document != "undefined" && document.createElement("div"), o.Container.prototype.clone.call(this, z);
      }
      destroy() {
        super.destroy();
        const z = this.content;
        z && a.Util._isInDocument(z) && this.container().removeChild(z);
        const j = r.stages.indexOf(this);
        return j > -1 && r.stages.splice(j, 1), a.Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas), this;
      }
      getPointerPosition() {
        const z = this._pointerPositions[0] || this._changedPointerPositions[0];
        return z ? {
          x: z.x,
          y: z.y
        } : (a.Util.warn(at), null);
      }
      _getPointerById(z) {
        return this._pointerPositions.find((j) => j.id === z);
      }
      getPointersPositions() {
        return this._pointerPositions;
      }
      getStage() {
        return this;
      }
      getContent() {
        return this.content;
      }
      _toKonvaCanvas(z) {
        z = z || {}, z.x = z.x || 0, z.y = z.y || 0, z.width = z.width || this.width(), z.height = z.height || this.height();
        const j = new s.SceneCanvas({
          width: z.width,
          height: z.height,
          pixelRatio: z.pixelRatio || 1
        }), et = j.getContext()._context, ut = this.children;
        return (z.x || z.y) && et.translate(-1 * z.x, -1 * z.y), ut.forEach(function(ft) {
          if (!ft.isVisible())
            return;
          const gt = ft._toKonvaCanvas(z);
          et.drawImage(gt._canvas, z.x, z.y, gt.getWidth() / gt.getPixelRatio(), gt.getHeight() / gt.getPixelRatio());
        }), j;
      }
      getIntersection(z) {
        if (!z)
          return null;
        let j = this.children, et = j.length, ut = et - 1, ft;
        for (ft = ut; ft >= 0; ft--) {
          const gt = j[ft].getIntersection(z);
          if (gt)
            return gt;
        }
        return null;
      }
      _resizeDOM() {
        const z = this.width(), j = this.height();
        this.content && (this.content.style.width = z + m, this.content.style.height = j + m), this.bufferCanvas.setSize(z, j), this.bufferHitCanvas.setSize(z, j), this.children.forEach((et) => {
          et.setSize({ width: z, height: j }), et.draw();
        });
      }
      add(z, ...j) {
        if (arguments.length > 1) {
          for (let ut = 0; ut < arguments.length; ut++)
            this.add(arguments[ut]);
          return this;
        }
        super.add(z);
        const et = this.children.length;
        return et > K && a.Util.warn("The stage has " + et + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group."), z.setSize({ width: this.width(), height: this.height() }), z.draw(), u.Konva.isBrowser && this.content.appendChild(z.canvas._canvas), this;
      }
      getParent() {
        return null;
      }
      getLayer() {
        return null;
      }
      hasPointerCapture(z) {
        return g.hasPointerCapture(z, this);
      }
      setPointerCapture(z) {
        g.setPointerCapture(z, this);
      }
      releaseCapture(z) {
        g.releaseCapture(z, this);
      }
      getLayers() {
        return this.children;
      }
      _bindContentEvents() {
        u.Konva.isBrowser && $.forEach(([z, j]) => {
          this.content.addEventListener(z, (et) => {
            this[j](et);
          }, { passive: !1 });
        });
      }
      _pointerenter(z) {
        this.setPointersPositions(z);
        const j = st(z.type);
        j && this._fire(j.pointerenter, {
          evt: z,
          target: this,
          currentTarget: this
        });
      }
      _pointerover(z) {
        this.setPointersPositions(z);
        const j = st(z.type);
        j && this._fire(j.pointerover, {
          evt: z,
          target: this,
          currentTarget: this
        });
      }
      _getTargetShape(z) {
        let j = this[z + "targetShape"];
        return j && !j.getStage() && (j = null), j;
      }
      _pointerleave(z) {
        const j = st(z.type), et = Q(z.type);
        if (!j)
          return;
        this.setPointersPositions(z);
        const ut = this._getTargetShape(et), ft = !(u.Konva.isDragging() || u.Konva.isTransforming()) || u.Konva.hitOnDragEnabled;
        ut && ft ? (ut._fireAndBubble(j.pointerout, { evt: z }), ut._fireAndBubble(j.pointerleave, { evt: z }), this._fire(j.pointerleave, {
          evt: z,
          target: this,
          currentTarget: this
        }), this[et + "targetShape"] = null) : ft && (this._fire(j.pointerleave, {
          evt: z,
          target: this,
          currentTarget: this
        }), this._fire(j.pointerout, {
          evt: z,
          target: this,
          currentTarget: this
        })), this.pointerPos = null, this._pointerPositions = [];
      }
      _pointerdown(z) {
        const j = st(z.type), et = Q(z.type);
        if (!j)
          return;
        this.setPointersPositions(z);
        let ut = !1;
        this._changedPointerPositions.forEach((ft) => {
          const gt = this.getIntersection(ft);
          if (h.DD.justDragged = !1, u.Konva["_" + et + "ListenClick"] = !0, !gt || !gt.isListening()) {
            this[et + "ClickStartShape"] = void 0;
            return;
          }
          u.Konva.capturePointerEventsEnabled && gt.setPointerCapture(ft.id), this[et + "ClickStartShape"] = gt, gt._fireAndBubble(j.pointerdown, {
            evt: z,
            pointerId: ft.id
          }), ut = !0;
          const Mt = z.type.indexOf("touch") >= 0;
          gt.preventDefault() && z.cancelable && Mt && z.preventDefault();
        }), ut || this._fire(j.pointerdown, {
          evt: z,
          target: this,
          currentTarget: this,
          pointerId: this._pointerPositions[0].id
        });
      }
      _pointermove(z) {
        const j = st(z.type), et = Q(z.type);
        if (!j || (u.Konva.isDragging() && h.DD.node.preventDefault() && z.cancelable && z.preventDefault(), this.setPointersPositions(z), !(!(u.Konva.isDragging() || u.Konva.isTransforming()) || u.Konva.hitOnDragEnabled)))
          return;
        const ft = {};
        let gt = !1;
        const Mt = this._getTargetShape(et);
        this._changedPointerPositions.forEach((xt) => {
          const mt = g.getCapturedShape(xt.id) || this.getIntersection(xt), ee = xt.id, Pt = { evt: z, pointerId: ee }, zt = Mt !== mt;
          if (zt && Mt && (Mt._fireAndBubble(j.pointerout, { ...Pt }, mt), Mt._fireAndBubble(j.pointerleave, { ...Pt }, mt)), mt) {
            if (ft[mt._id])
              return;
            ft[mt._id] = !0;
          }
          mt && mt.isListening() ? (gt = !0, zt && (mt._fireAndBubble(j.pointerover, { ...Pt }, Mt), mt._fireAndBubble(j.pointerenter, { ...Pt }, Mt), this[et + "targetShape"] = mt), mt._fireAndBubble(j.pointermove, { ...Pt })) : Mt && (this._fire(j.pointerover, {
            evt: z,
            target: this,
            currentTarget: this,
            pointerId: ee
          }), this[et + "targetShape"] = null);
        }), gt || this._fire(j.pointermove, {
          evt: z,
          target: this,
          currentTarget: this,
          pointerId: this._changedPointerPositions[0].id
        });
      }
      _pointerup(z) {
        const j = st(z.type), et = Q(z.type);
        if (!j)
          return;
        this.setPointersPositions(z);
        const ut = this[et + "ClickStartShape"], ft = this[et + "ClickEndShape"], gt = {};
        let Mt = !1;
        this._changedPointerPositions.forEach((xt) => {
          const mt = g.getCapturedShape(xt.id) || this.getIntersection(xt);
          if (mt) {
            if (mt.releaseCapture(xt.id), gt[mt._id])
              return;
            gt[mt._id] = !0;
          }
          const ee = xt.id, Pt = { evt: z, pointerId: ee };
          let zt = !1;
          u.Konva["_" + et + "InDblClickWindow"] ? (zt = !0, clearTimeout(this[et + "DblTimeout"])) : h.DD.justDragged || (u.Konva["_" + et + "InDblClickWindow"] = !0, clearTimeout(this[et + "DblTimeout"])), this[et + "DblTimeout"] = setTimeout(function() {
            u.Konva["_" + et + "InDblClickWindow"] = !1;
          }, u.Konva.dblClickWindow), mt && mt.isListening() ? (Mt = !0, this[et + "ClickEndShape"] = mt, mt._fireAndBubble(j.pointerup, { ...Pt }), u.Konva["_" + et + "ListenClick"] && ut && ut === mt && (mt._fireAndBubble(j.pointerclick, { ...Pt }), zt && ft && ft === mt && mt._fireAndBubble(j.pointerdblclick, { ...Pt }))) : (this[et + "ClickEndShape"] = null, u.Konva["_" + et + "ListenClick"] && this._fire(j.pointerclick, {
            evt: z,
            target: this,
            currentTarget: this,
            pointerId: ee
          }), zt && this._fire(j.pointerdblclick, {
            evt: z,
            target: this,
            currentTarget: this,
            pointerId: ee
          }));
        }), Mt || this._fire(j.pointerup, {
          evt: z,
          target: this,
          currentTarget: this,
          pointerId: this._changedPointerPositions[0].id
        }), u.Konva["_" + et + "ListenClick"] = !1, z.cancelable && et !== "touch" && z.preventDefault();
      }
      _contextmenu(z) {
        this.setPointersPositions(z);
        const j = this.getIntersection(this.getPointerPosition());
        j && j.isListening() ? j._fireAndBubble(H, { evt: z }) : this._fire(H, {
          evt: z,
          target: this,
          currentTarget: this
        });
      }
      _wheel(z) {
        this.setPointersPositions(z);
        const j = this.getIntersection(this.getPointerPosition());
        j && j.isListening() ? j._fireAndBubble(U, { evt: z }) : this._fire(U, {
          evt: z,
          target: this,
          currentTarget: this
        });
      }
      _pointercancel(z) {
        this.setPointersPositions(z);
        const j = g.getCapturedShape(z.pointerId) || this.getIntersection(this.getPointerPosition());
        j && j._fireAndBubble(E, g.createEvent(z)), g.releaseCapture(z.pointerId);
      }
      _lostpointercapture(z) {
        g.releaseCapture(z.pointerId);
      }
      setPointersPositions(z) {
        let j = this._getContentPosition(), et = null, ut = null;
        z = z || window.event, z.touches !== void 0 ? (this._pointerPositions = [], this._changedPointerPositions = [], Array.prototype.forEach.call(z.touches, (ft) => {
          this._pointerPositions.push({
            id: ft.identifier,
            x: (ft.clientX - j.left) / j.scaleX,
            y: (ft.clientY - j.top) / j.scaleY
          });
        }), Array.prototype.forEach.call(z.changedTouches || z.touches, (ft) => {
          this._changedPointerPositions.push({
            id: ft.identifier,
            x: (ft.clientX - j.left) / j.scaleX,
            y: (ft.clientY - j.top) / j.scaleY
          });
        })) : (et = (z.clientX - j.left) / j.scaleX, ut = (z.clientY - j.top) / j.scaleY, this.pointerPos = {
          x: et,
          y: ut
        }, this._pointerPositions = [{ x: et, y: ut, id: a.Util._getFirstPointerId(z) }], this._changedPointerPositions = [
          { x: et, y: ut, id: a.Util._getFirstPointerId(z) }
        ]);
      }
      _setPointerPosition(z) {
        a.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.'), this.setPointersPositions(z);
      }
      _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect)
          return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
          };
        const z = this.content.getBoundingClientRect();
        return {
          top: z.top,
          left: z.left,
          scaleX: z.width / this.content.clientWidth || 1,
          scaleY: z.height / this.content.clientHeight || 1
        };
      }
      _buildDOM() {
        if (this.bufferCanvas = new s.SceneCanvas({
          width: this.width(),
          height: this.height()
        }), this.bufferHitCanvas = new s.HitCanvas({
          pixelRatio: 1,
          width: this.width(),
          height: this.height()
        }), !u.Konva.isBrowser)
          return;
        const z = this.container();
        if (!z)
          throw "Stage has no container. A container is required.";
        z.innerHTML = "", this.content = document.createElement("div"), this.content.style.position = "relative", this.content.style.userSelect = "none", this.content.className = "konvajs-content", this.content.setAttribute("role", "presentation"), z.appendChild(this.content), this._resizeDOM();
      }
      cache() {
        return a.Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes."), this;
      }
      clearCache() {
        return this;
      }
      batchDraw() {
        return this.getChildren().forEach(function(z) {
          z.batchDraw();
        }), this;
      }
    }
    r.Stage = ht, ht.prototype.nodeType = p, (0, l._registerNode)(ht), n.Factory.addGetterSetter(ht, "container"), u.Konva.isBrowser && document.addEventListener("visibilitychange", () => {
      r.stages.forEach((ct) => {
        ct.batchDraw();
      });
    });
  }(Ks)), Ks;
}
var Ti = {}, Ys = {}, Vc;
function se() {
  return Vc || (Vc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Shape = r.shapes = void 0;
    const a = At(), n = Kt(), o = Tt(), u = $t(), s = Ot(), h = At(), l = $0(), g = "hasShadow", p = "shadowRGBA", b = "patternImage", m = "linearGradient", C = "radialGradient";
    let v;
    function _() {
      return v || (v = n.Util.createCanvasElement().getContext("2d"), v);
    }
    r.shapes = {};
    function w(M) {
      const O = this.attrs.fillRule;
      O ? M.fill(O) : M.fill();
    }
    function x(M) {
      M.stroke();
    }
    function P(M) {
      const O = this.attrs.fillRule;
      O ? M.fill(O) : M.fill();
    }
    function c(M) {
      M.stroke();
    }
    function f() {
      this._clearCache(g);
    }
    function S() {
      this._clearCache(p);
    }
    function E() {
      this._clearCache(b);
    }
    function T() {
      this._clearCache(m);
    }
    function D() {
      this._clearCache(C);
    }
    class I extends u.Node {
      constructor(O) {
        super(O);
        let N;
        for (; N = n.Util.getRandomColor(), !(N && !(N in r.shapes)); )
          ;
        this.colorKey = N, r.shapes[N] = this;
      }
      getContext() {
        return n.Util.warn("shape.getContext() method is deprecated. Please do not use it."), this.getLayer().getContext();
      }
      getCanvas() {
        return n.Util.warn("shape.getCanvas() method is deprecated. Please do not use it."), this.getLayer().getCanvas();
      }
      getSceneFunc() {
        return this.attrs.sceneFunc || this._sceneFunc;
      }
      getHitFunc() {
        return this.attrs.hitFunc || this._hitFunc;
      }
      hasShadow() {
        return this._getCache(g, this._hasShadow);
      }
      _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
      }
      _getFillPattern() {
        return this._getCache(b, this.__getFillPattern);
      }
      __getFillPattern() {
        if (this.fillPatternImage()) {
          const N = _().createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
          if (N && N.setTransform) {
            const H = new n.Transform();
            H.translate(this.fillPatternX(), this.fillPatternY()), H.rotate(a.Konva.getAngle(this.fillPatternRotation())), H.scale(this.fillPatternScaleX(), this.fillPatternScaleY()), H.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
            const y = H.getMatrix(), F = typeof DOMMatrix == "undefined" ? {
              a: y[0],
              b: y[1],
              c: y[2],
              d: y[3],
              e: y[4],
              f: y[5]
            } : new DOMMatrix(y);
            N.setTransform(F);
          }
          return N;
        }
      }
      _getLinearGradient() {
        return this._getCache(m, this.__getLinearGradient);
      }
      __getLinearGradient() {
        const O = this.fillLinearGradientColorStops();
        if (O) {
          const N = _(), H = this.fillLinearGradientStartPoint(), y = this.fillLinearGradientEndPoint(), F = N.createLinearGradient(H.x, H.y, y.x, y.y);
          for (let R = 0; R < O.length; R += 2)
            F.addColorStop(O[R], O[R + 1]);
          return F;
        }
      }
      _getRadialGradient() {
        return this._getCache(C, this.__getRadialGradient);
      }
      __getRadialGradient() {
        const O = this.fillRadialGradientColorStops();
        if (O) {
          const N = _(), H = this.fillRadialGradientStartPoint(), y = this.fillRadialGradientEndPoint(), F = N.createRadialGradient(H.x, H.y, this.fillRadialGradientStartRadius(), y.x, y.y, this.fillRadialGradientEndRadius());
          for (let R = 0; R < O.length; R += 2)
            F.addColorStop(O[R], O[R + 1]);
          return F;
        }
      }
      getShadowRGBA() {
        return this._getCache(p, this._getShadowRGBA);
      }
      _getShadowRGBA() {
        if (!this.hasShadow())
          return;
        const O = n.Util.colorToRGBA(this.shadowColor());
        if (O)
          return "rgba(" + O.r + "," + O.g + "," + O.b + "," + O.a * (this.shadowOpacity() || 1) + ")";
      }
      hasFill() {
        return this._calculate("hasFill", [
          "fillEnabled",
          "fill",
          "fillPatternImage",
          "fillLinearGradientColorStops",
          "fillRadialGradientColorStops"
        ], () => this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops()));
      }
      hasStroke() {
        return this._calculate("hasStroke", [
          "strokeEnabled",
          "strokeWidth",
          "stroke",
          "strokeLinearGradientColorStops"
        ], () => this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops()));
      }
      hasHitStroke() {
        const O = this.hitStrokeWidth();
        return O === "auto" ? this.hasStroke() : this.strokeEnabled() && !!O;
      }
      intersects(O) {
        const N = this.getStage();
        if (!N)
          return !1;
        const H = N.bufferHitCanvas;
        return H.getContext().clear(), this.drawHit(H, void 0, !0), H.context.getImageData(Math.round(O.x), Math.round(O.y), 1, 1).data[3] > 0;
      }
      destroy() {
        return u.Node.prototype.destroy.call(this), delete r.shapes[this.colorKey], delete this.colorKey, this;
      }
      _useBufferCanvas(O) {
        var N;
        if (!((N = this.attrs.perfectDrawEnabled) !== null && N !== void 0 ? N : !0))
          return !1;
        const y = O || this.hasFill(), F = this.hasStroke(), R = this.getAbsoluteOpacity() !== 1;
        if (y && F && R)
          return !0;
        const G = this.hasShadow(), U = this.shadowForStrokeEnabled();
        return !!(y && F && G && U);
      }
      setStrokeHitEnabled(O) {
        n.Util.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead."), O ? this.hitStrokeWidth("auto") : this.hitStrokeWidth(0);
      }
      getStrokeHitEnabled() {
        return this.hitStrokeWidth() !== 0;
      }
      getSelfRect() {
        const O = this.size();
        return {
          x: this._centroid ? -O.width / 2 : 0,
          y: this._centroid ? -O.height / 2 : 0,
          width: O.width,
          height: O.height
        };
      }
      getClientRect(O = {}) {
        let N = !1, H = this.getParent();
        for (; H; ) {
          if (H.isCached()) {
            N = !0;
            break;
          }
          H = H.getParent();
        }
        const y = O.skipTransform, F = O.relativeTo || N && this.getStage() || void 0, R = this.getSelfRect(), U = !O.skipStroke && this.hasStroke() && this.strokeWidth() || 0, K = R.width + U, $ = R.height + U, X = !O.skipShadow && this.hasShadow(), Q = X ? this.shadowOffsetX() : 0, st = X ? this.shadowOffsetY() : 0, Z = K + Math.abs(Q), at = $ + Math.abs(st), ht = X && this.shadowBlur() || 0, ct = Z + ht * 2, z = at + ht * 2, j = {
          width: ct,
          height: z,
          x: -(U / 2 + ht) + Math.min(Q, 0) + R.x,
          y: -(U / 2 + ht) + Math.min(st, 0) + R.y
        };
        return y ? j : this._transformedRect(j, F);
      }
      drawScene(O, N, H) {
        const y = this.getLayer();
        let F = O || y.getCanvas(), R = F.getContext(), G = this._getCanvasCache(), U = this.getSceneFunc(), K = this.hasShadow(), $, X;
        const Q = F.isCache, st = N === this;
        if (!this.isVisible() && !st)
          return this;
        if (G) {
          R.save();
          const at = this.getAbsoluteTransform(N).getMatrix();
          return R.transform(at[0], at[1], at[2], at[3], at[4], at[5]), this._drawCachedSceneCanvas(R), R.restore(), this;
        }
        if (!U)
          return this;
        if (R.save(), this._useBufferCanvas() && !Q) {
          $ = this.getStage();
          const at = H || $.bufferCanvas;
          X = at.getContext(), X.clear(), X.save(), X._applyLineJoin(this);
          var Z = this.getAbsoluteTransform(N).getMatrix();
          X.transform(Z[0], Z[1], Z[2], Z[3], Z[4], Z[5]), U.call(this, X, this), X.restore();
          const ht = at.pixelRatio;
          K && R._applyShadow(this), R._applyOpacity(this), R._applyGlobalCompositeOperation(this), R.drawImage(at._canvas, 0, 0, at.width / ht, at.height / ht);
        } else {
          if (R._applyLineJoin(this), !st) {
            var Z = this.getAbsoluteTransform(N).getMatrix();
            R.transform(Z[0], Z[1], Z[2], Z[3], Z[4], Z[5]), R._applyOpacity(this), R._applyGlobalCompositeOperation(this);
          }
          K && R._applyShadow(this), U.call(this, R, this);
        }
        return R.restore(), this;
      }
      drawHit(O, N, H = !1) {
        if (!this.shouldDrawHit(N, H))
          return this;
        const y = this.getLayer(), F = O || y.hitCanvas, R = F && F.getContext(), G = this.hitFunc() || this.sceneFunc(), U = this._getCanvasCache(), K = U && U.hit;
        if (this.colorKey || n.Util.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()"), K) {
          R.save();
          const X = this.getAbsoluteTransform(N).getMatrix();
          return R.transform(X[0], X[1], X[2], X[3], X[4], X[5]), this._drawCachedHitCanvas(R), R.restore(), this;
        }
        if (!G)
          return this;
        if (R.save(), R._applyLineJoin(this), !(this === N)) {
          const X = this.getAbsoluteTransform(N).getMatrix();
          R.transform(X[0], X[1], X[2], X[3], X[4], X[5]);
        }
        return G.call(this, R, this), R.restore(), this;
      }
      drawHitFromCache(O = 0) {
        let N = this._getCanvasCache(), H = this._getCachedSceneCanvas(), y = N.hit, F = y.getContext(), R = y.getWidth(), G = y.getHeight(), U, K, $, X, Q, st;
        F.clear(), F.drawImage(H._canvas, 0, 0, R, G);
        try {
          for (U = F.getImageData(0, 0, R, G), K = U.data, $ = K.length, X = n.Util._hexToRgb(this.colorKey), Q = 0; Q < $; Q += 4)
            st = K[Q + 3], st > O ? (K[Q] = X.r, K[Q + 1] = X.g, K[Q + 2] = X.b, K[Q + 3] = 255) : K[Q + 3] = 0;
          F.putImageData(U, 0, 0);
        } catch (Z) {
          n.Util.error("Unable to draw hit graph from cached scene canvas. " + Z.message);
        }
        return this;
      }
      hasPointerCapture(O) {
        return l.hasPointerCapture(O, this);
      }
      setPointerCapture(O) {
        l.setPointerCapture(O, this);
      }
      releaseCapture(O) {
        l.releaseCapture(O, this);
      }
    }
    r.Shape = I, I.prototype._fillFunc = w, I.prototype._strokeFunc = x, I.prototype._fillFuncHit = P, I.prototype._strokeFuncHit = c, I.prototype._centroid = !1, I.prototype.nodeType = "Shape", (0, h._registerNode)(I), I.prototype.eventListeners = {}, I.prototype.on.call(I.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", f), I.prototype.on.call(I.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", S), I.prototype.on.call(I.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", E), I.prototype.on.call(I.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", T), I.prototype.on.call(I.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", D), o.Factory.addGetterSetter(I, "stroke", void 0, (0, s.getStringOrGradientValidator)()), o.Factory.addGetterSetter(I, "strokeWidth", 2, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillAfterStrokeEnabled", !1), o.Factory.addGetterSetter(I, "hitStrokeWidth", "auto", (0, s.getNumberOrAutoValidator)()), o.Factory.addGetterSetter(I, "strokeHitEnabled", !0, (0, s.getBooleanValidator)()), o.Factory.addGetterSetter(I, "perfectDrawEnabled", !0, (0, s.getBooleanValidator)()), o.Factory.addGetterSetter(I, "shadowForStrokeEnabled", !0, (0, s.getBooleanValidator)()), o.Factory.addGetterSetter(I, "lineJoin"), o.Factory.addGetterSetter(I, "lineCap"), o.Factory.addGetterSetter(I, "sceneFunc"), o.Factory.addGetterSetter(I, "hitFunc"), o.Factory.addGetterSetter(I, "dash"), o.Factory.addGetterSetter(I, "dashOffset", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "shadowColor", void 0, (0, s.getStringValidator)()), o.Factory.addGetterSetter(I, "shadowBlur", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "shadowOpacity", 1, (0, s.getNumberValidator)()), o.Factory.addComponentsGetterSetter(I, "shadowOffset", ["x", "y"]), o.Factory.addGetterSetter(I, "shadowOffsetX", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "shadowOffsetY", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternImage"), o.Factory.addGetterSetter(I, "fill", void 0, (0, s.getStringOrGradientValidator)()), o.Factory.addGetterSetter(I, "fillPatternX", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternY", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillLinearGradientColorStops"), o.Factory.addGetterSetter(I, "strokeLinearGradientColorStops"), o.Factory.addGetterSetter(I, "fillRadialGradientStartRadius", 0), o.Factory.addGetterSetter(I, "fillRadialGradientEndRadius", 0), o.Factory.addGetterSetter(I, "fillRadialGradientColorStops"), o.Factory.addGetterSetter(I, "fillPatternRepeat", "repeat"), o.Factory.addGetterSetter(I, "fillEnabled", !0), o.Factory.addGetterSetter(I, "strokeEnabled", !0), o.Factory.addGetterSetter(I, "shadowEnabled", !0), o.Factory.addGetterSetter(I, "dashEnabled", !0), o.Factory.addGetterSetter(I, "strokeScaleEnabled", !0), o.Factory.addGetterSetter(I, "fillPriority", "color"), o.Factory.addComponentsGetterSetter(I, "fillPatternOffset", ["x", "y"]), o.Factory.addGetterSetter(I, "fillPatternOffsetX", 0, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternOffsetY", 0, (0, s.getNumberValidator)()), o.Factory.addComponentsGetterSetter(I, "fillPatternScale", ["x", "y"]), o.Factory.addGetterSetter(I, "fillPatternScaleX", 1, (0, s.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternScaleY", 1, (0, s.getNumberValidator)()), o.Factory.addComponentsGetterSetter(I, "fillLinearGradientStartPoint", [
      "x",
      "y"
    ]), o.Factory.addComponentsGetterSetter(I, "strokeLinearGradientStartPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillLinearGradientStartPointX", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientStartPointX", 0), o.Factory.addGetterSetter(I, "fillLinearGradientStartPointY", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientStartPointY", 0), o.Factory.addComponentsGetterSetter(I, "fillLinearGradientEndPoint", [
      "x",
      "y"
    ]), o.Factory.addComponentsGetterSetter(I, "strokeLinearGradientEndPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillLinearGradientEndPointX", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientEndPointX", 0), o.Factory.addGetterSetter(I, "fillLinearGradientEndPointY", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientEndPointY", 0), o.Factory.addComponentsGetterSetter(I, "fillRadialGradientStartPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillRadialGradientStartPointX", 0), o.Factory.addGetterSetter(I, "fillRadialGradientStartPointY", 0), o.Factory.addComponentsGetterSetter(I, "fillRadialGradientEndPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillRadialGradientEndPointX", 0), o.Factory.addGetterSetter(I, "fillRadialGradientEndPointY", 0), o.Factory.addGetterSetter(I, "fillPatternRotation", 0), o.Factory.addGetterSetter(I, "fillRule", void 0, (0, s.getStringValidator)()), o.Factory.backCompat(I, {
      dashArray: "dash",
      getDashArray: "getDash",
      setDashArray: "getDash",
      drawFunc: "sceneFunc",
      getDrawFunc: "getSceneFunc",
      setDrawFunc: "setSceneFunc",
      drawHitFunc: "hitFunc",
      getDrawHitFunc: "getHitFunc",
      setDrawHitFunc: "setHitFunc"
    });
  }(Ys)), Ys;
}
var Wc;
function Z0() {
  if (Wc) return Ti;
  Wc = 1, Object.defineProperty(Ti, "__esModule", { value: !0 }), Ti.Layer = void 0;
  const r = Kt(), a = Sa(), n = $t(), o = Tt(), u = ba(), s = Ot(), h = se(), l = At(), g = "#", p = "beforeDraw", b = "draw", m = [
    { x: 0, y: 0 },
    { x: -1, y: -1 },
    { x: 1, y: -1 },
    { x: 1, y: 1 },
    { x: -1, y: 1 }
  ], C = m.length;
  let v = class extends a.Container {
    constructor(w) {
      super(w), this.canvas = new u.SceneCanvas(), this.hitCanvas = new u.HitCanvas({
        pixelRatio: 1
      }), this._waitingForDraw = !1, this.on("visibleChange.konva", this._checkVisibility), this._checkVisibility(), this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled), this._setSmoothEnabled();
    }
    createPNGStream() {
      return this.canvas._canvas.createPNGStream();
    }
    getCanvas() {
      return this.canvas;
    }
    getNativeCanvasElement() {
      return this.canvas._canvas;
    }
    getHitCanvas() {
      return this.hitCanvas;
    }
    getContext() {
      return this.getCanvas().getContext();
    }
    clear(w) {
      return this.getContext().clear(w), this.getHitCanvas().getContext().clear(w), this;
    }
    setZIndex(w) {
      super.setZIndex(w);
      const x = this.getStage();
      return x && x.content && (x.content.removeChild(this.getNativeCanvasElement()), w < x.children.length - 1 ? x.content.insertBefore(this.getNativeCanvasElement(), x.children[w + 1].getCanvas()._canvas) : x.content.appendChild(this.getNativeCanvasElement())), this;
    }
    moveToTop() {
      n.Node.prototype.moveToTop.call(this);
      const w = this.getStage();
      return w && w.content && (w.content.removeChild(this.getNativeCanvasElement()), w.content.appendChild(this.getNativeCanvasElement())), !0;
    }
    moveUp() {
      if (!n.Node.prototype.moveUp.call(this))
        return !1;
      const x = this.getStage();
      return !x || !x.content ? !1 : (x.content.removeChild(this.getNativeCanvasElement()), this.index < x.children.length - 1 ? x.content.insertBefore(this.getNativeCanvasElement(), x.children[this.index + 1].getCanvas()._canvas) : x.content.appendChild(this.getNativeCanvasElement()), !0);
    }
    moveDown() {
      if (n.Node.prototype.moveDown.call(this)) {
        const w = this.getStage();
        if (w) {
          const x = w.children;
          w.content && (w.content.removeChild(this.getNativeCanvasElement()), w.content.insertBefore(this.getNativeCanvasElement(), x[this.index + 1].getCanvas()._canvas));
        }
        return !0;
      }
      return !1;
    }
    moveToBottom() {
      if (n.Node.prototype.moveToBottom.call(this)) {
        const w = this.getStage();
        if (w) {
          const x = w.children;
          w.content && (w.content.removeChild(this.getNativeCanvasElement()), w.content.insertBefore(this.getNativeCanvasElement(), x[1].getCanvas()._canvas));
        }
        return !0;
      }
      return !1;
    }
    getLayer() {
      return this;
    }
    remove() {
      const w = this.getNativeCanvasElement();
      return n.Node.prototype.remove.call(this), w && w.parentNode && r.Util._isInDocument(w) && w.parentNode.removeChild(w), this;
    }
    getStage() {
      return this.parent;
    }
    setSize({ width: w, height: x }) {
      return this.canvas.setSize(w, x), this.hitCanvas.setSize(w, x), this._setSmoothEnabled(), this;
    }
    _validateAdd(w) {
      const x = w.getType();
      x !== "Group" && x !== "Shape" && r.Util.throw("You may only add groups and shapes to a layer.");
    }
    _toKonvaCanvas(w) {
      return w = w || {}, w.width = w.width || this.getWidth(), w.height = w.height || this.getHeight(), w.x = w.x !== void 0 ? w.x : this.x(), w.y = w.y !== void 0 ? w.y : this.y(), n.Node.prototype._toKonvaCanvas.call(this, w);
    }
    _checkVisibility() {
      this.visible() ? this.canvas._canvas.style.display = "block" : this.canvas._canvas.style.display = "none";
    }
    _setSmoothEnabled() {
      this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
      if (this.parent)
        return this.parent.width();
    }
    setWidth() {
      r.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
      if (this.parent)
        return this.parent.height();
    }
    setHeight() {
      r.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
      return this._waitingForDraw || (this._waitingForDraw = !0, r.Util.requestAnimFrame(() => {
        this.draw(), this._waitingForDraw = !1;
      })), this;
    }
    getIntersection(w) {
      if (!this.isListening() || !this.isVisible())
        return null;
      let x = 1, P = !1;
      for (; ; ) {
        for (let c = 0; c < C; c++) {
          const f = m[c], S = this._getIntersection({
            x: w.x + f.x * x,
            y: w.y + f.y * x
          }), E = S.shape;
          if (E)
            return E;
          if (P = !!S.antialiased, !S.antialiased)
            break;
        }
        if (P)
          x += 1;
        else
          return null;
      }
    }
    _getIntersection(w) {
      const x = this.hitCanvas.pixelRatio, P = this.hitCanvas.context.getImageData(Math.round(w.x * x), Math.round(w.y * x), 1, 1).data, c = P[3];
      if (c === 255) {
        const f = r.Util._rgbToHex(P[0], P[1], P[2]), S = h.shapes[g + f];
        return S ? {
          shape: S
        } : {
          antialiased: !0
        };
      } else if (c > 0)
        return {
          antialiased: !0
        };
      return {};
    }
    drawScene(w, x) {
      const P = this.getLayer(), c = w || P && P.getCanvas();
      return this._fire(p, {
        node: this
      }), this.clearBeforeDraw() && c.getContext().clear(), a.Container.prototype.drawScene.call(this, c, x), this._fire(b, {
        node: this
      }), this;
    }
    drawHit(w, x) {
      const P = this.getLayer(), c = w || P && P.hitCanvas;
      return P && P.clearBeforeDraw() && P.getHitCanvas().getContext().clear(), a.Container.prototype.drawHit.call(this, c, x), this;
    }
    enableHitGraph() {
      return this.hitGraphEnabled(!0), this;
    }
    disableHitGraph() {
      return this.hitGraphEnabled(!1), this;
    }
    setHitGraphEnabled(w) {
      r.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening(w);
    }
    getHitGraphEnabled(w) {
      return r.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening();
    }
    toggleHitCanvas() {
      if (!this.parent || !this.parent.content)
        return;
      const w = this.parent;
      !!this.hitCanvas._canvas.parentNode ? w.content.removeChild(this.hitCanvas._canvas) : w.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
      return r.Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas), super.destroy();
    }
  };
  return Ti.Layer = v, v.prototype.nodeType = "Layer", (0, l._registerNode)(v), o.Factory.addGetterSetter(v, "imageSmoothingEnabled", !0), o.Factory.addGetterSetter(v, "clearBeforeDraw", !0), o.Factory.addGetterSetter(v, "hitGraphEnabled", !0, (0, s.getBooleanValidator)()), Ti;
}
var Pi = {}, jc;
function n6() {
  if (jc) return Pi;
  jc = 1, Object.defineProperty(Pi, "__esModule", { value: !0 }), Pi.FastLayer = void 0;
  const r = Kt(), a = Z0(), n = At();
  let o = class extends a.Layer {
    constructor(s) {
      super(s), this.listening(!1), r.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
  };
  return Pi.FastLayer = o, o.prototype.nodeType = "FastLayer", (0, n._registerNode)(o), Pi;
}
var Fi = {}, Kc;
function Zh() {
  if (Kc) return Fi;
  Kc = 1, Object.defineProperty(Fi, "__esModule", { value: !0 }), Fi.Group = void 0;
  const r = Kt(), a = Sa(), n = At();
  let o = class extends a.Container {
    _validateAdd(s) {
      const h = s.getType();
      h !== "Group" && h !== "Shape" && r.Util.throw("You may only add groups and shapes to groups.");
    }
  };
  return Fi.Group = o, o.prototype.nodeType = "Group", (0, n._registerNode)(o), Fi;
}
var Oi = {}, Yc;
function Jh() {
  if (Yc) return Oi;
  Yc = 1, Object.defineProperty(Oi, "__esModule", { value: !0 }), Oi.Animation = void 0;
  const r = At(), a = Kt(), n = function() {
    return r.glob.performance && r.glob.performance.now ? function() {
      return r.glob.performance.now();
    } : function() {
      return (/* @__PURE__ */ new Date()).getTime();
    };
  }();
  let o = class ei {
    constructor(s, h) {
      this.id = ei.animIdCounter++, this.frame = {
        time: 0,
        timeDiff: 0,
        lastTime: n(),
        frameRate: 0
      }, this.func = s, this.setLayers(h);
    }
    setLayers(s) {
      let h = [];
      return s && (h = Array.isArray(s) ? s : [s]), this.layers = h, this;
    }
    getLayers() {
      return this.layers;
    }
    addLayer(s) {
      const h = this.layers, l = h.length;
      for (let g = 0; g < l; g++)
        if (h[g]._id === s._id)
          return !1;
      return this.layers.push(s), !0;
    }
    isRunning() {
      const h = ei.animations, l = h.length;
      for (let g = 0; g < l; g++)
        if (h[g].id === this.id)
          return !0;
      return !1;
    }
    start() {
      return this.stop(), this.frame.timeDiff = 0, this.frame.lastTime = n(), ei._addAnimation(this), this;
    }
    stop() {
      return ei._removeAnimation(this), this;
    }
    _updateFrameObject(s) {
      this.frame.timeDiff = s - this.frame.lastTime, this.frame.lastTime = s, this.frame.time += this.frame.timeDiff, this.frame.frameRate = 1e3 / this.frame.timeDiff;
    }
    static _addAnimation(s) {
      this.animations.push(s), this._handleAnimation();
    }
    static _removeAnimation(s) {
      const h = s.id, l = this.animations, g = l.length;
      for (let p = 0; p < g; p++)
        if (l[p].id === h) {
          this.animations.splice(p, 1);
          break;
        }
    }
    static _runFrames() {
      const s = {}, h = this.animations;
      for (let l = 0; l < h.length; l++) {
        const g = h[l], p = g.layers, b = g.func;
        g._updateFrameObject(n());
        const m = p.length;
        let C;
        if (b ? C = b.call(g, g.frame) !== !1 : C = !0, !!C)
          for (let v = 0; v < m; v++) {
            const _ = p[v];
            _._id !== void 0 && (s[_._id] = _);
          }
      }
      for (const l in s)
        s.hasOwnProperty(l) && s[l].batchDraw();
    }
    static _animationLoop() {
      const s = ei;
      s.animations.length ? (s._runFrames(), a.Util.requestAnimFrame(s._animationLoop)) : s.animRunning = !1;
    }
    static _handleAnimation() {
      this.animRunning || (this.animRunning = !0, a.Util.requestAnimFrame(this._animationLoop));
    }
  };
  return Oi.Animation = o, o.animations = [], o.animIdCounter = 0, o.animRunning = !1, Oi;
}
var Xs = {}, Xc;
function a6() {
  return Xc || (Xc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Easings = r.Tween = void 0;
    const a = Kt(), n = Jh(), o = $t(), u = At();
    let s = {
      node: 1,
      duration: 1,
      easing: 1,
      onFinish: 1,
      yoyo: 1
    }, h = 1, l = 2, g = 3, p = 0, b = ["fill", "stroke", "shadowColor"];
    class m {
      constructor(_, w, x, P, c, f, S) {
        this.prop = _, this.propFunc = w, this.begin = P, this._pos = P, this.duration = f, this._change = 0, this.prevPos = 0, this.yoyo = S, this._time = 0, this._position = 0, this._startTime = 0, this._finish = 0, this.func = x, this._change = c - this.begin, this.pause();
      }
      fire(_) {
        const w = this[_];
        w && w();
      }
      setTime(_) {
        _ > this.duration ? this.yoyo ? (this._time = this.duration, this.reverse()) : this.finish() : _ < 0 ? this.yoyo ? (this._time = 0, this.play()) : this.reset() : (this._time = _, this.update());
      }
      getTime() {
        return this._time;
      }
      setPosition(_) {
        this.prevPos = this._pos, this.propFunc(_), this._pos = _;
      }
      getPosition(_) {
        return _ === void 0 && (_ = this._time), this.func(_, this.begin, this._change, this.duration);
      }
      play() {
        this.state = l, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onPlay");
      }
      reverse() {
        this.state = g, this._time = this.duration - this._time, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onReverse");
      }
      seek(_) {
        this.pause(), this._time = _, this.update(), this.fire("onSeek");
      }
      reset() {
        this.pause(), this._time = 0, this.update(), this.fire("onReset");
      }
      finish() {
        this.pause(), this._time = this.duration, this.update(), this.fire("onFinish");
      }
      update() {
        this.setPosition(this.getPosition(this._time)), this.fire("onUpdate");
      }
      onEnterFrame() {
        const _ = this.getTimer() - this._startTime;
        this.state === l ? this.setTime(_) : this.state === g && this.setTime(this.duration - _);
      }
      pause() {
        this.state = h, this.fire("onPause");
      }
      getTimer() {
        return (/* @__PURE__ */ new Date()).getTime();
      }
    }
    class C {
      constructor(_) {
        let w = this, x = _.node, P = x._id, c, f = _.easing || r.Easings.Linear, S = !!_.yoyo, E;
        typeof _.duration == "undefined" ? c = 0.3 : _.duration === 0 ? c = 1e-3 : c = _.duration, this.node = x, this._id = p++;
        const T = x.getLayer() || (x instanceof u.Konva.Stage ? x.getLayers() : null);
        T || a.Util.error("Tween constructor have `node` that is not in a layer. Please add node into layer first."), this.anim = new n.Animation(function() {
          w.tween.onEnterFrame();
        }, T), this.tween = new m(E, function(D) {
          w._tweenFunc(D);
        }, f, 0, 1, c * 1e3, S), this._addListeners(), C.attrs[P] || (C.attrs[P] = {}), C.attrs[P][this._id] || (C.attrs[P][this._id] = {}), C.tweens[P] || (C.tweens[P] = {});
        for (E in _)
          s[E] === void 0 && this._addAttr(E, _[E]);
        this.reset(), this.onFinish = _.onFinish, this.onReset = _.onReset, this.onUpdate = _.onUpdate;
      }
      _addAttr(_, w) {
        let x = this.node, P = x._id, c, f, S, E, T, D, I, M;
        if (S = C.tweens[P][_], S && delete C.attrs[P][S][_], c = x.getAttr(_), a.Util._isArray(w))
          if (f = [], T = Math.max(w.length, c.length), _ === "points" && w.length !== c.length && (w.length > c.length ? (I = c, c = a.Util._prepareArrayForTween(c, w, x.closed())) : (D = w, w = a.Util._prepareArrayForTween(w, c, x.closed()))), _.indexOf("fill") === 0)
            for (E = 0; E < T; E++)
              if (E % 2 === 0)
                f.push(w[E] - c[E]);
              else {
                const O = a.Util.colorToRGBA(c[E]);
                M = a.Util.colorToRGBA(w[E]), c[E] = O, f.push({
                  r: M.r - O.r,
                  g: M.g - O.g,
                  b: M.b - O.b,
                  a: M.a - O.a
                });
              }
          else
            for (E = 0; E < T; E++)
              f.push(w[E] - c[E]);
        else b.indexOf(_) !== -1 ? (c = a.Util.colorToRGBA(c), M = a.Util.colorToRGBA(w), f = {
          r: M.r - c.r,
          g: M.g - c.g,
          b: M.b - c.b,
          a: M.a - c.a
        }) : f = w - c;
        C.attrs[P][this._id][_] = {
          start: c,
          diff: f,
          end: w,
          trueEnd: D,
          trueStart: I
        }, C.tweens[P][_] = this._id;
      }
      _tweenFunc(_) {
        let w = this.node, x = C.attrs[w._id][this._id], P, c, f, S, E, T, D, I;
        for (P in x) {
          if (c = x[P], f = c.start, S = c.diff, I = c.end, a.Util._isArray(f))
            if (E = [], D = Math.max(f.length, I.length), P.indexOf("fill") === 0)
              for (T = 0; T < D; T++)
                T % 2 === 0 ? E.push((f[T] || 0) + S[T] * _) : E.push("rgba(" + Math.round(f[T].r + S[T].r * _) + "," + Math.round(f[T].g + S[T].g * _) + "," + Math.round(f[T].b + S[T].b * _) + "," + (f[T].a + S[T].a * _) + ")");
            else
              for (T = 0; T < D; T++)
                E.push((f[T] || 0) + S[T] * _);
          else b.indexOf(P) !== -1 ? E = "rgba(" + Math.round(f.r + S.r * _) + "," + Math.round(f.g + S.g * _) + "," + Math.round(f.b + S.b * _) + "," + (f.a + S.a * _) + ")" : E = f + S * _;
          w.setAttr(P, E);
        }
      }
      _addListeners() {
        this.tween.onPlay = () => {
          this.anim.start();
        }, this.tween.onReverse = () => {
          this.anim.start();
        }, this.tween.onPause = () => {
          this.anim.stop();
        }, this.tween.onFinish = () => {
          const _ = this.node, w = C.attrs[_._id][this._id];
          w.points && w.points.trueEnd && _.setAttr("points", w.points.trueEnd), this.onFinish && this.onFinish.call(this);
        }, this.tween.onReset = () => {
          const _ = this.node, w = C.attrs[_._id][this._id];
          w.points && w.points.trueStart && _.points(w.points.trueStart), this.onReset && this.onReset();
        }, this.tween.onUpdate = () => {
          this.onUpdate && this.onUpdate.call(this);
        };
      }
      play() {
        return this.tween.play(), this;
      }
      reverse() {
        return this.tween.reverse(), this;
      }
      reset() {
        return this.tween.reset(), this;
      }
      seek(_) {
        return this.tween.seek(_ * 1e3), this;
      }
      pause() {
        return this.tween.pause(), this;
      }
      finish() {
        return this.tween.finish(), this;
      }
      destroy() {
        let _ = this.node._id, w = this._id, x = C.tweens[_], P;
        this.pause();
        for (P in x)
          delete C.tweens[_][P];
        delete C.attrs[_][w];
      }
    }
    r.Tween = C, C.attrs = {}, C.tweens = {}, o.Node.prototype.to = function(v) {
      const _ = v.onFinish;
      v.node = this, v.onFinish = function() {
        this.destroy(), _ && _();
      }, new C(v).play();
    }, r.Easings = {
      BackEaseIn(v, _, w, x) {
        return w * (v /= x) * v * ((1.70158 + 1) * v - 1.70158) + _;
      },
      BackEaseOut(v, _, w, x) {
        return w * ((v = v / x - 1) * v * ((1.70158 + 1) * v + 1.70158) + 1) + _;
      },
      BackEaseInOut(v, _, w, x) {
        let P = 1.70158;
        return (v /= x / 2) < 1 ? w / 2 * (v * v * (((P *= 1.525) + 1) * v - P)) + _ : w / 2 * ((v -= 2) * v * (((P *= 1.525) + 1) * v + P) + 2) + _;
      },
      ElasticEaseIn(v, _, w, x, P, c) {
        let f = 0;
        return v === 0 ? _ : (v /= x) === 1 ? _ + w : (c || (c = x * 0.3), !P || P < Math.abs(w) ? (P = w, f = c / 4) : f = c / (2 * Math.PI) * Math.asin(w / P), -(P * Math.pow(2, 10 * (v -= 1)) * Math.sin((v * x - f) * (2 * Math.PI) / c)) + _);
      },
      ElasticEaseOut(v, _, w, x, P, c) {
        let f = 0;
        return v === 0 ? _ : (v /= x) === 1 ? _ + w : (c || (c = x * 0.3), !P || P < Math.abs(w) ? (P = w, f = c / 4) : f = c / (2 * Math.PI) * Math.asin(w / P), P * Math.pow(2, -10 * v) * Math.sin((v * x - f) * (2 * Math.PI) / c) + w + _);
      },
      ElasticEaseInOut(v, _, w, x, P, c) {
        let f = 0;
        return v === 0 ? _ : (v /= x / 2) === 2 ? _ + w : (c || (c = x * (0.3 * 1.5)), !P || P < Math.abs(w) ? (P = w, f = c / 4) : f = c / (2 * Math.PI) * Math.asin(w / P), v < 1 ? -0.5 * (P * Math.pow(2, 10 * (v -= 1)) * Math.sin((v * x - f) * (2 * Math.PI) / c)) + _ : P * Math.pow(2, -10 * (v -= 1)) * Math.sin((v * x - f) * (2 * Math.PI) / c) * 0.5 + w + _);
      },
      BounceEaseOut(v, _, w, x) {
        return (v /= x) < 1 / 2.75 ? w * (7.5625 * v * v) + _ : v < 2 / 2.75 ? w * (7.5625 * (v -= 1.5 / 2.75) * v + 0.75) + _ : v < 2.5 / 2.75 ? w * (7.5625 * (v -= 2.25 / 2.75) * v + 0.9375) + _ : w * (7.5625 * (v -= 2.625 / 2.75) * v + 0.984375) + _;
      },
      BounceEaseIn(v, _, w, x) {
        return w - r.Easings.BounceEaseOut(x - v, 0, w, x) + _;
      },
      BounceEaseInOut(v, _, w, x) {
        return v < x / 2 ? r.Easings.BounceEaseIn(v * 2, 0, w, x) * 0.5 + _ : r.Easings.BounceEaseOut(v * 2 - x, 0, w, x) * 0.5 + w * 0.5 + _;
      },
      EaseIn(v, _, w, x) {
        return w * (v /= x) * v + _;
      },
      EaseOut(v, _, w, x) {
        return -w * (v /= x) * (v - 2) + _;
      },
      EaseInOut(v, _, w, x) {
        return (v /= x / 2) < 1 ? w / 2 * v * v + _ : -w / 2 * (--v * (v - 2) - 1) + _;
      },
      StrongEaseIn(v, _, w, x) {
        return w * (v /= x) * v * v * v * v + _;
      },
      StrongEaseOut(v, _, w, x) {
        return w * ((v = v / x - 1) * v * v * v * v + 1) + _;
      },
      StrongEaseInOut(v, _, w, x) {
        return (v /= x / 2) < 1 ? w / 2 * v * v * v * v * v + _ : w / 2 * ((v -= 2) * v * v * v * v + 2) + _;
      },
      Linear(v, _, w, x) {
        return w * v / x + _;
      }
    };
  }(Xs)), Xs;
}
var $c;
function s6() {
  return $c || ($c = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Konva = void 0;
    const a = At(), n = Kt(), o = $t(), u = Sa(), s = i6(), h = Z0(), l = n6(), g = Zh(), p = $h(), b = se(), m = Jh(), C = a6(), v = X0(), _ = ba();
    r.Konva = n.Util._assign(a.Konva, {
      Util: n.Util,
      Transform: n.Transform,
      Node: o.Node,
      Container: u.Container,
      Stage: s.Stage,
      stages: s.stages,
      Layer: h.Layer,
      FastLayer: l.FastLayer,
      Group: g.Group,
      DD: p.DD,
      Shape: b.Shape,
      shapes: b.shapes,
      Animation: m.Animation,
      Tween: C.Tween,
      Easings: C.Easings,
      Context: v.Context,
      Canvas: _.Canvas
    }), r.default = r.Konva;
  }(Hs)), Hs;
}
var ki = {}, Zc;
function o6() {
  if (Zc) return ki;
  Zc = 1, Object.defineProperty(ki, "__esModule", { value: !0 }), ki.Arc = void 0;
  const r = Tt(), a = se(), n = At(), o = Ot(), u = At();
  let s = class extends a.Shape {
    _sceneFunc(l) {
      const g = n.Konva.getAngle(this.angle()), p = this.clockwise();
      l.beginPath(), l.arc(0, 0, this.outerRadius(), 0, g, p), l.arc(0, 0, this.innerRadius(), g, 0, !p), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(l) {
      this.outerRadius(l / 2);
    }
    setHeight(l) {
      this.outerRadius(l / 2);
    }
    getSelfRect() {
      const l = this.innerRadius(), g = this.outerRadius(), p = this.clockwise(), b = n.Konva.getAngle(p ? 360 - this.angle() : this.angle()), m = Math.cos(Math.min(b, Math.PI)), C = 1, v = Math.sin(Math.min(Math.max(Math.PI, b), 3 * Math.PI / 2)), _ = Math.sin(Math.min(b, Math.PI / 2)), w = m * (m > 0 ? l : g), x = C * g, P = v * (v > 0 ? l : g), c = _ * (_ > 0 ? g : l);
      return {
        x: w,
        y: p ? -1 * c : P,
        width: x - w,
        height: c - P
      };
    }
  };
  return ki.Arc = s, s.prototype._centroid = !0, s.prototype.className = "Arc", s.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, u._registerNode)(s), r.Factory.addGetterSetter(s, "innerRadius", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "outerRadius", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "angle", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "clockwise", !1, (0, o.getBooleanValidator)()), ki;
}
var Ii = {}, Mi = {}, Jc;
function J0() {
  if (Jc) return Mi;
  Jc = 1, Object.defineProperty(Mi, "__esModule", { value: !0 }), Mi.Line = void 0;
  const r = Tt(), a = At(), n = se(), o = Ot();
  function u(l, g, p, b, m, C, v) {
    const _ = Math.sqrt(Math.pow(p - l, 2) + Math.pow(b - g, 2)), w = Math.sqrt(Math.pow(m - p, 2) + Math.pow(C - b, 2)), x = v * _ / (_ + w), P = v * w / (_ + w), c = p - x * (m - l), f = b - x * (C - g), S = p + P * (m - l), E = b + P * (C - g);
    return [c, f, S, E];
  }
  function s(l, g) {
    const p = l.length, b = [];
    for (let m = 2; m < p - 2; m += 2) {
      const C = u(l[m - 2], l[m - 1], l[m], l[m + 1], l[m + 2], l[m + 3], g);
      isNaN(C[0]) || (b.push(C[0]), b.push(C[1]), b.push(l[m]), b.push(l[m + 1]), b.push(C[2]), b.push(C[3]));
    }
    return b;
  }
  let h = class extends n.Shape {
    constructor(g) {
      super(g), this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
        this._clearCache("tensionPoints");
      });
    }
    _sceneFunc(g) {
      let p = this.points(), b = p.length, m = this.tension(), C = this.closed(), v = this.bezier(), _, w, x;
      if (b) {
        if (g.beginPath(), g.moveTo(p[0], p[1]), m !== 0 && b > 4) {
          for (_ = this.getTensionPoints(), w = _.length, x = C ? 0 : 4, C || g.quadraticCurveTo(_[0], _[1], _[2], _[3]); x < w - 2; )
            g.bezierCurveTo(_[x++], _[x++], _[x++], _[x++], _[x++], _[x++]);
          C || g.quadraticCurveTo(_[w - 2], _[w - 1], p[b - 2], p[b - 1]);
        } else if (v)
          for (x = 2; x < b; )
            g.bezierCurveTo(p[x++], p[x++], p[x++], p[x++], p[x++], p[x++]);
        else
          for (x = 2; x < b; x += 2)
            g.lineTo(p[x], p[x + 1]);
        C ? (g.closePath(), g.fillStrokeShape(this)) : g.strokeShape(this);
      }
    }
    getTensionPoints() {
      return this._getCache("tensionPoints", this._getTensionPoints);
    }
    _getTensionPoints() {
      return this.closed() ? this._getTensionPointsClosed() : s(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
      const g = this.points(), p = g.length, b = this.tension(), m = u(g[p - 2], g[p - 1], g[0], g[1], g[2], g[3], b), C = u(g[p - 4], g[p - 3], g[p - 2], g[p - 1], g[0], g[1], b), v = s(g, b);
      return [m[2], m[3]].concat(v).concat([
        C[0],
        C[1],
        g[p - 2],
        g[p - 1],
        C[2],
        C[3],
        m[0],
        m[1],
        g[0],
        g[1]
      ]);
    }
    getWidth() {
      return this.getSelfRect().width;
    }
    getHeight() {
      return this.getSelfRect().height;
    }
    getSelfRect() {
      let g = this.points();
      if (g.length < 4)
        return {
          x: g[0] || 0,
          y: g[1] || 0,
          width: 0,
          height: 0
        };
      this.tension() !== 0 ? g = [
        g[0],
        g[1],
        ...this._getTensionPoints(),
        g[g.length - 2],
        g[g.length - 1]
      ] : g = this.points();
      let p = g[0], b = g[0], m = g[1], C = g[1], v, _;
      for (let w = 0; w < g.length / 2; w++)
        v = g[w * 2], _ = g[w * 2 + 1], p = Math.min(p, v), b = Math.max(b, v), m = Math.min(m, _), C = Math.max(C, _);
      return {
        x: p,
        y: m,
        width: b - p,
        height: C - m
      };
    }
  };
  return Mi.Line = h, h.prototype.className = "Line", h.prototype._attrsAffectingSize = ["points", "bezier", "tension"], (0, a._registerNode)(h), r.Factory.addGetterSetter(h, "closed", !1), r.Factory.addGetterSetter(h, "bezier", !1), r.Factory.addGetterSetter(h, "tension", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(h, "points", [], (0, o.getNumberArrayValidator)()), Mi;
}
var Li = {}, $s = {}, Qc;
function h6() {
  return Qc || (Qc = 1, function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.t2length = r.getQuadraticArcLength = r.getCubicArcLength = r.binomialCoefficients = r.cValues = r.tValues = void 0, r.tValues = [
      [],
      [],
      [
        -0.5773502691896257,
        0.5773502691896257
      ],
      [
        0,
        -0.7745966692414834,
        0.7745966692414834
      ],
      [
        -0.33998104358485626,
        0.33998104358485626,
        -0.8611363115940526,
        0.8611363115940526
      ],
      [
        0,
        -0.5384693101056831,
        0.5384693101056831,
        -0.906179845938664,
        0.906179845938664
      ],
      [
        0.6612093864662645,
        -0.6612093864662645,
        -0.2386191860831969,
        0.2386191860831969,
        -0.932469514203152,
        0.932469514203152
      ],
      [
        0,
        0.4058451513773972,
        -0.4058451513773972,
        -0.7415311855993945,
        0.7415311855993945,
        -0.9491079123427585,
        0.9491079123427585
      ],
      [
        -0.1834346424956498,
        0.1834346424956498,
        -0.525532409916329,
        0.525532409916329,
        -0.7966664774136267,
        0.7966664774136267,
        -0.9602898564975363,
        0.9602898564975363
      ],
      [
        0,
        -0.8360311073266358,
        0.8360311073266358,
        -0.9681602395076261,
        0.9681602395076261,
        -0.3242534234038089,
        0.3242534234038089,
        -0.6133714327005904,
        0.6133714327005904
      ],
      [
        -0.14887433898163122,
        0.14887433898163122,
        -0.4333953941292472,
        0.4333953941292472,
        -0.6794095682990244,
        0.6794095682990244,
        -0.8650633666889845,
        0.8650633666889845,
        -0.9739065285171717,
        0.9739065285171717
      ],
      [
        0,
        -0.26954315595234496,
        0.26954315595234496,
        -0.5190961292068118,
        0.5190961292068118,
        -0.7301520055740494,
        0.7301520055740494,
        -0.8870625997680953,
        0.8870625997680953,
        -0.978228658146057,
        0.978228658146057
      ],
      [
        -0.1252334085114689,
        0.1252334085114689,
        -0.3678314989981802,
        0.3678314989981802,
        -0.5873179542866175,
        0.5873179542866175,
        -0.7699026741943047,
        0.7699026741943047,
        -0.9041172563704749,
        0.9041172563704749,
        -0.9815606342467192,
        0.9815606342467192
      ],
      [
        0,
        -0.2304583159551348,
        0.2304583159551348,
        -0.44849275103644687,
        0.44849275103644687,
        -0.6423493394403402,
        0.6423493394403402,
        -0.8015780907333099,
        0.8015780907333099,
        -0.9175983992229779,
        0.9175983992229779,
        -0.9841830547185881,
        0.9841830547185881
      ],
      [
        -0.10805494870734367,
        0.10805494870734367,
        -0.31911236892788974,
        0.31911236892788974,
        -0.5152486363581541,
        0.5152486363581541,
        -0.6872929048116855,
        0.6872929048116855,
        -0.827201315069765,
        0.827201315069765,
        -0.9284348836635735,
        0.9284348836635735,
        -0.9862838086968123,
        0.9862838086968123
      ],
      [
        0,
        -0.20119409399743451,
        0.20119409399743451,
        -0.3941513470775634,
        0.3941513470775634,
        -0.5709721726085388,
        0.5709721726085388,
        -0.7244177313601701,
        0.7244177313601701,
        -0.8482065834104272,
        0.8482065834104272,
        -0.937273392400706,
        0.937273392400706,
        -0.9879925180204854,
        0.9879925180204854
      ],
      [
        -0.09501250983763744,
        0.09501250983763744,
        -0.2816035507792589,
        0.2816035507792589,
        -0.45801677765722737,
        0.45801677765722737,
        -0.6178762444026438,
        0.6178762444026438,
        -0.755404408355003,
        0.755404408355003,
        -0.8656312023878318,
        0.8656312023878318,
        -0.9445750230732326,
        0.9445750230732326,
        -0.9894009349916499,
        0.9894009349916499
      ],
      [
        0,
        -0.17848418149584785,
        0.17848418149584785,
        -0.3512317634538763,
        0.3512317634538763,
        -0.5126905370864769,
        0.5126905370864769,
        -0.6576711592166907,
        0.6576711592166907,
        -0.7815140038968014,
        0.7815140038968014,
        -0.8802391537269859,
        0.8802391537269859,
        -0.9506755217687678,
        0.9506755217687678,
        -0.9905754753144174,
        0.9905754753144174
      ],
      [
        -0.0847750130417353,
        0.0847750130417353,
        -0.2518862256915055,
        0.2518862256915055,
        -0.41175116146284263,
        0.41175116146284263,
        -0.5597708310739475,
        0.5597708310739475,
        -0.6916870430603532,
        0.6916870430603532,
        -0.8037049589725231,
        0.8037049589725231,
        -0.8926024664975557,
        0.8926024664975557,
        -0.9558239495713977,
        0.9558239495713977,
        -0.9915651684209309,
        0.9915651684209309
      ],
      [
        0,
        -0.16035864564022537,
        0.16035864564022537,
        -0.31656409996362983,
        0.31656409996362983,
        -0.46457074137596094,
        0.46457074137596094,
        -0.600545304661681,
        0.600545304661681,
        -0.7209661773352294,
        0.7209661773352294,
        -0.8227146565371428,
        0.8227146565371428,
        -0.9031559036148179,
        0.9031559036148179,
        -0.96020815213483,
        0.96020815213483,
        -0.9924068438435844,
        0.9924068438435844
      ],
      [
        -0.07652652113349734,
        0.07652652113349734,
        -0.22778585114164507,
        0.22778585114164507,
        -0.37370608871541955,
        0.37370608871541955,
        -0.5108670019508271,
        0.5108670019508271,
        -0.636053680726515,
        0.636053680726515,
        -0.7463319064601508,
        0.7463319064601508,
        -0.8391169718222188,
        0.8391169718222188,
        -0.912234428251326,
        0.912234428251326,
        -0.9639719272779138,
        0.9639719272779138,
        -0.9931285991850949,
        0.9931285991850949
      ],
      [
        0,
        -0.1455618541608951,
        0.1455618541608951,
        -0.2880213168024011,
        0.2880213168024011,
        -0.4243421202074388,
        0.4243421202074388,
        -0.5516188358872198,
        0.5516188358872198,
        -0.6671388041974123,
        0.6671388041974123,
        -0.7684399634756779,
        0.7684399634756779,
        -0.8533633645833173,
        0.8533633645833173,
        -0.9200993341504008,
        0.9200993341504008,
        -0.9672268385663063,
        0.9672268385663063,
        -0.9937521706203895,
        0.9937521706203895
      ],
      [
        -0.06973927331972223,
        0.06973927331972223,
        -0.20786042668822127,
        0.20786042668822127,
        -0.34193582089208424,
        0.34193582089208424,
        -0.469355837986757,
        0.469355837986757,
        -0.5876404035069116,
        0.5876404035069116,
        -0.6944872631866827,
        0.6944872631866827,
        -0.7878168059792081,
        0.7878168059792081,
        -0.8658125777203002,
        0.8658125777203002,
        -0.926956772187174,
        0.926956772187174,
        -0.9700604978354287,
        0.9700604978354287,
        -0.9942945854823992,
        0.9942945854823992
      ],
      [
        0,
        -0.1332568242984661,
        0.1332568242984661,
        -0.26413568097034495,
        0.26413568097034495,
        -0.3903010380302908,
        0.3903010380302908,
        -0.5095014778460075,
        0.5095014778460075,
        -0.6196098757636461,
        0.6196098757636461,
        -0.7186613631319502,
        0.7186613631319502,
        -0.8048884016188399,
        0.8048884016188399,
        -0.8767523582704416,
        0.8767523582704416,
        -0.9329710868260161,
        0.9329710868260161,
        -0.9725424712181152,
        0.9725424712181152,
        -0.9947693349975522,
        0.9947693349975522
      ],
      [
        -0.06405689286260563,
        0.06405689286260563,
        -0.1911188674736163,
        0.1911188674736163,
        -0.3150426796961634,
        0.3150426796961634,
        -0.4337935076260451,
        0.4337935076260451,
        -0.5454214713888396,
        0.5454214713888396,
        -0.6480936519369755,
        0.6480936519369755,
        -0.7401241915785544,
        0.7401241915785544,
        -0.820001985973903,
        0.820001985973903,
        -0.8864155270044011,
        0.8864155270044011,
        -0.9382745520027328,
        0.9382745520027328,
        -0.9747285559713095,
        0.9747285559713095,
        -0.9951872199970213,
        0.9951872199970213
      ]
    ], r.cValues = [
      [],
      [],
      [1, 1],
      [
        0.8888888888888888,
        0.5555555555555556,
        0.5555555555555556
      ],
      [
        0.6521451548625461,
        0.6521451548625461,
        0.34785484513745385,
        0.34785484513745385
      ],
      [
        0.5688888888888889,
        0.47862867049936647,
        0.47862867049936647,
        0.23692688505618908,
        0.23692688505618908
      ],
      [
        0.3607615730481386,
        0.3607615730481386,
        0.46791393457269104,
        0.46791393457269104,
        0.17132449237917036,
        0.17132449237917036
      ],
      [
        0.4179591836734694,
        0.3818300505051189,
        0.3818300505051189,
        0.27970539148927664,
        0.27970539148927664,
        0.1294849661688697,
        0.1294849661688697
      ],
      [
        0.362683783378362,
        0.362683783378362,
        0.31370664587788727,
        0.31370664587788727,
        0.22238103445337448,
        0.22238103445337448,
        0.10122853629037626,
        0.10122853629037626
      ],
      [
        0.3302393550012598,
        0.1806481606948574,
        0.1806481606948574,
        0.08127438836157441,
        0.08127438836157441,
        0.31234707704000286,
        0.31234707704000286,
        0.26061069640293544,
        0.26061069640293544
      ],
      [
        0.29552422471475287,
        0.29552422471475287,
        0.26926671930999635,
        0.26926671930999635,
        0.21908636251598204,
        0.21908636251598204,
        0.1494513491505806,
        0.1494513491505806,
        0.06667134430868814,
        0.06667134430868814
      ],
      [
        0.2729250867779006,
        0.26280454451024665,
        0.26280454451024665,
        0.23319376459199048,
        0.23319376459199048,
        0.18629021092773426,
        0.18629021092773426,
        0.1255803694649046,
        0.1255803694649046,
        0.05566856711617366,
        0.05566856711617366
      ],
      [
        0.24914704581340277,
        0.24914704581340277,
        0.2334925365383548,
        0.2334925365383548,
        0.20316742672306592,
        0.20316742672306592,
        0.16007832854334622,
        0.16007832854334622,
        0.10693932599531843,
        0.10693932599531843,
        0.04717533638651183,
        0.04717533638651183
      ],
      [
        0.2325515532308739,
        0.22628318026289723,
        0.22628318026289723,
        0.2078160475368885,
        0.2078160475368885,
        0.17814598076194574,
        0.17814598076194574,
        0.13887351021978725,
        0.13887351021978725,
        0.09212149983772845,
        0.09212149983772845,
        0.04048400476531588,
        0.04048400476531588
      ],
      [
        0.2152638534631578,
        0.2152638534631578,
        0.2051984637212956,
        0.2051984637212956,
        0.18553839747793782,
        0.18553839747793782,
        0.15720316715819355,
        0.15720316715819355,
        0.12151857068790319,
        0.12151857068790319,
        0.08015808715976021,
        0.08015808715976021,
        0.03511946033175186,
        0.03511946033175186
      ],
      [
        0.2025782419255613,
        0.19843148532711158,
        0.19843148532711158,
        0.1861610000155622,
        0.1861610000155622,
        0.16626920581699392,
        0.16626920581699392,
        0.13957067792615432,
        0.13957067792615432,
        0.10715922046717194,
        0.10715922046717194,
        0.07036604748810812,
        0.07036604748810812,
        0.03075324199611727,
        0.03075324199611727
      ],
      [
        0.1894506104550685,
        0.1894506104550685,
        0.18260341504492358,
        0.18260341504492358,
        0.16915651939500254,
        0.16915651939500254,
        0.14959598881657674,
        0.14959598881657674,
        0.12462897125553388,
        0.12462897125553388,
        0.09515851168249279,
        0.09515851168249279,
        0.062253523938647894,
        0.062253523938647894,
        0.027152459411754096,
        0.027152459411754096
      ],
      [
        0.17944647035620653,
        0.17656270536699264,
        0.17656270536699264,
        0.16800410215645004,
        0.16800410215645004,
        0.15404576107681028,
        0.15404576107681028,
        0.13513636846852548,
        0.13513636846852548,
        0.11188384719340397,
        0.11188384719340397,
        0.08503614831717918,
        0.08503614831717918,
        0.0554595293739872,
        0.0554595293739872,
        0.02414830286854793,
        0.02414830286854793
      ],
      [
        0.1691423829631436,
        0.1691423829631436,
        0.16427648374583273,
        0.16427648374583273,
        0.15468467512626524,
        0.15468467512626524,
        0.14064291467065065,
        0.14064291467065065,
        0.12255520671147846,
        0.12255520671147846,
        0.10094204410628717,
        0.10094204410628717,
        0.07642573025488905,
        0.07642573025488905,
        0.0497145488949698,
        0.0497145488949698,
        0.02161601352648331,
        0.02161601352648331
      ],
      [
        0.1610544498487837,
        0.15896884339395434,
        0.15896884339395434,
        0.15276604206585967,
        0.15276604206585967,
        0.1426067021736066,
        0.1426067021736066,
        0.12875396253933621,
        0.12875396253933621,
        0.11156664554733399,
        0.11156664554733399,
        0.09149002162245,
        0.09149002162245,
        0.06904454273764123,
        0.06904454273764123,
        0.0448142267656996,
        0.0448142267656996,
        0.019461788229726478,
        0.019461788229726478
      ],
      [
        0.15275338713072584,
        0.15275338713072584,
        0.14917298647260374,
        0.14917298647260374,
        0.14209610931838204,
        0.14209610931838204,
        0.13168863844917664,
        0.13168863844917664,
        0.11819453196151841,
        0.11819453196151841,
        0.10193011981724044,
        0.10193011981724044,
        0.08327674157670475,
        0.08327674157670475,
        0.06267204833410907,
        0.06267204833410907,
        0.04060142980038694,
        0.04060142980038694,
        0.017614007139152118,
        0.017614007139152118
      ],
      [
        0.14608113364969041,
        0.14452440398997005,
        0.14452440398997005,
        0.13988739479107315,
        0.13988739479107315,
        0.13226893863333747,
        0.13226893863333747,
        0.12183141605372853,
        0.12183141605372853,
        0.10879729916714838,
        0.10879729916714838,
        0.09344442345603386,
        0.09344442345603386,
        0.0761001136283793,
        0.0761001136283793,
        0.057134425426857205,
        0.057134425426857205,
        0.036953789770852494,
        0.036953789770852494,
        0.016017228257774335,
        0.016017228257774335
      ],
      [
        0.13925187285563198,
        0.13925187285563198,
        0.13654149834601517,
        0.13654149834601517,
        0.13117350478706238,
        0.13117350478706238,
        0.12325237681051242,
        0.12325237681051242,
        0.11293229608053922,
        0.11293229608053922,
        0.10041414444288096,
        0.10041414444288096,
        0.08594160621706773,
        0.08594160621706773,
        0.06979646842452049,
        0.06979646842452049,
        0.052293335152683286,
        0.052293335152683286,
        0.03377490158481415,
        0.03377490158481415,
        0.0146279952982722,
        0.0146279952982722
      ],
      [
        0.13365457218610619,
        0.1324620394046966,
        0.1324620394046966,
        0.12890572218808216,
        0.12890572218808216,
        0.12304908430672953,
        0.12304908430672953,
        0.11499664022241136,
        0.11499664022241136,
        0.10489209146454141,
        0.10489209146454141,
        0.09291576606003515,
        0.09291576606003515,
        0.07928141177671895,
        0.07928141177671895,
        0.06423242140852585,
        0.06423242140852585,
        0.04803767173108467,
        0.04803767173108467,
        0.030988005856979445,
        0.030988005856979445,
        0.013411859487141771,
        0.013411859487141771
      ],
      [
        0.12793819534675216,
        0.12793819534675216,
        0.1258374563468283,
        0.1258374563468283,
        0.12167047292780339,
        0.12167047292780339,
        0.1155056680537256,
        0.1155056680537256,
        0.10744427011596563,
        0.10744427011596563,
        0.09761865210411388,
        0.09761865210411388,
        0.08619016153195327,
        0.08619016153195327,
        0.0733464814110803,
        0.0733464814110803,
        0.05929858491543678,
        0.05929858491543678,
        0.04427743881741981,
        0.04427743881741981,
        0.028531388628933663,
        0.028531388628933663,
        0.0123412297999872,
        0.0123412297999872
      ]
    ], r.binomialCoefficients = [[1], [1, 1], [1, 2, 1], [1, 3, 3, 1]];
    const a = (h, l, g) => {
      let p, b;
      const C = g / 2;
      p = 0;
      for (let v = 0; v < 20; v++)
        b = C * r.tValues[20][v] + C, p += r.cValues[20][v] * o(h, l, b);
      return C * p;
    };
    r.getCubicArcLength = a;
    const n = (h, l, g) => {
      g === void 0 && (g = 1);
      const p = h[0] - 2 * h[1] + h[2], b = l[0] - 2 * l[1] + l[2], m = 2 * h[1] - 2 * h[0], C = 2 * l[1] - 2 * l[0], v = 4 * (p * p + b * b), _ = 4 * (p * m + b * C), w = m * m + C * C;
      if (v === 0)
        return g * Math.sqrt(Math.pow(h[2] - h[0], 2) + Math.pow(l[2] - l[0], 2));
      const x = _ / (2 * v), P = w / v, c = g + x, f = P - x * x, S = c * c + f > 0 ? Math.sqrt(c * c + f) : 0, E = x * x + f > 0 ? Math.sqrt(x * x + f) : 0, T = x + Math.sqrt(x * x + f) !== 0 ? f * Math.log(Math.abs((c + S) / (x + E))) : 0;
      return Math.sqrt(v) / 2 * (c * S - x * E + T);
    };
    r.getQuadraticArcLength = n;
    function o(h, l, g) {
      const p = u(1, g, h), b = u(1, g, l), m = p * p + b * b;
      return Math.sqrt(m);
    }
    const u = (h, l, g) => {
      const p = g.length - 1;
      let b, m;
      if (p === 0)
        return 0;
      if (h === 0) {
        m = 0;
        for (let C = 0; C <= p; C++)
          m += r.binomialCoefficients[p][C] * Math.pow(1 - l, p - C) * Math.pow(l, C) * g[C];
        return m;
      } else {
        b = new Array(p);
        for (let C = 0; C < p; C++)
          b[C] = p * (g[C + 1] - g[C]);
        return u(h - 1, l, b);
      }
    }, s = (h, l, g) => {
      let p = 1, b = h / l, m = (h - g(b)) / l, C = 0;
      for (; p > 1e-3; ) {
        const v = g(b + m), _ = Math.abs(h - v) / l;
        if (_ < p)
          p = _, b += m;
        else {
          const w = g(b - m), x = Math.abs(h - w) / l;
          x < p ? (p = x, b -= m) : m /= 2;
        }
        if (C++, C > 500)
          break;
      }
      return b;
    };
    r.t2length = s;
  }($s)), $s;
}
var td;
function Qh() {
  if (td) return Li;
  td = 1, Object.defineProperty(Li, "__esModule", { value: !0 }), Li.Path = void 0;
  const r = Tt(), a = se(), n = At(), o = h6();
  let u = class Se extends a.Shape {
    constructor(h) {
      super(h), this.dataArray = [], this.pathLength = 0, this._readDataAttribute(), this.on("dataChange.konva", function() {
        this._readDataAttribute();
      });
    }
    _readDataAttribute() {
      this.dataArray = Se.parsePathData(this.data()), this.pathLength = Se.getPathLength(this.dataArray);
    }
    _sceneFunc(h) {
      const l = this.dataArray;
      h.beginPath();
      let g = !1;
      for (let S = 0; S < l.length; S++) {
        const E = l[S].command, T = l[S].points;
        switch (E) {
          case "L":
            h.lineTo(T[0], T[1]);
            break;
          case "M":
            h.moveTo(T[0], T[1]);
            break;
          case "C":
            h.bezierCurveTo(T[0], T[1], T[2], T[3], T[4], T[5]);
            break;
          case "Q":
            h.quadraticCurveTo(T[0], T[1], T[2], T[3]);
            break;
          case "A":
            var p = T[0], b = T[1], m = T[2], C = T[3], v = T[4], _ = T[5], w = T[6], x = T[7], P = m > C ? m : C, c = m > C ? 1 : m / C, f = m > C ? C / m : 1;
            h.translate(p, b), h.rotate(w), h.scale(c, f), h.arc(0, 0, P, v, v + _, 1 - x), h.scale(1 / c, 1 / f), h.rotate(-w), h.translate(-p, -b);
            break;
          case "z":
            g = !0, h.closePath();
            break;
        }
      }
      !g && !this.hasFill() ? h.strokeShape(this) : h.fillStrokeShape(this);
    }
    getSelfRect() {
      let h = [];
      this.dataArray.forEach(function(v) {
        if (v.command === "A") {
          const _ = v.points[4], w = v.points[5], x = v.points[4] + w;
          let P = Math.PI / 180;
          if (Math.abs(_ - x) < P && (P = Math.abs(_ - x)), w < 0)
            for (let c = _ - P; c > x; c -= P) {
              const f = Se.getPointOnEllipticalArc(v.points[0], v.points[1], v.points[2], v.points[3], c, 0);
              h.push(f.x, f.y);
            }
          else
            for (let c = _ + P; c < x; c += P) {
              const f = Se.getPointOnEllipticalArc(v.points[0], v.points[1], v.points[2], v.points[3], c, 0);
              h.push(f.x, f.y);
            }
        } else if (v.command === "C")
          for (let _ = 0; _ <= 1; _ += 0.01) {
            const w = Se.getPointOnCubicBezier(_, v.start.x, v.start.y, v.points[0], v.points[1], v.points[2], v.points[3], v.points[4], v.points[5]);
            h.push(w.x, w.y);
          }
        else
          h = h.concat(v.points);
      });
      let l = h[0], g = h[0], p = h[1], b = h[1], m, C;
      for (let v = 0; v < h.length / 2; v++)
        m = h[v * 2], C = h[v * 2 + 1], isNaN(m) || (l = Math.min(l, m), g = Math.max(g, m)), isNaN(C) || (p = Math.min(p, C), b = Math.max(b, C));
      return {
        x: l,
        y: p,
        width: g - l,
        height: b - p
      };
    }
    getLength() {
      return this.pathLength;
    }
    getPointAtLength(h) {
      return Se.getPointAtLengthOfDataArray(h, this.dataArray);
    }
    static getLineLength(h, l, g, p) {
      return Math.sqrt((g - h) * (g - h) + (p - l) * (p - l));
    }
    static getPathLength(h) {
      let l = 0;
      for (let g = 0; g < h.length; ++g)
        l += h[g].pathLength;
      return l;
    }
    static getPointAtLengthOfDataArray(h, l) {
      let g, p = 0, b = l.length;
      if (!b)
        return null;
      for (; p < b && h > l[p].pathLength; )
        h -= l[p].pathLength, ++p;
      if (p === b)
        return g = l[p - 1].points.slice(-2), {
          x: g[0],
          y: g[1]
        };
      if (h < 0.01)
        return g = l[p].points.slice(0, 2), {
          x: g[0],
          y: g[1]
        };
      const m = l[p], C = m.points;
      switch (m.command) {
        case "L":
          return Se.getPointOnLine(h, m.start.x, m.start.y, C[0], C[1]);
        case "C":
          return Se.getPointOnCubicBezier((0, o.t2length)(h, Se.getPathLength(l), (S) => (0, o.getCubicArcLength)([m.start.x, C[0], C[2], C[4]], [m.start.y, C[1], C[3], C[5]], S)), m.start.x, m.start.y, C[0], C[1], C[2], C[3], C[4], C[5]);
        case "Q":
          return Se.getPointOnQuadraticBezier((0, o.t2length)(h, Se.getPathLength(l), (S) => (0, o.getQuadraticArcLength)([m.start.x, C[0], C[2]], [m.start.y, C[1], C[3]], S)), m.start.x, m.start.y, C[0], C[1], C[2], C[3]);
        case "A":
          var v = C[0], _ = C[1], w = C[2], x = C[3], P = C[4], c = C[5], f = C[6];
          return P += c * h / m.pathLength, Se.getPointOnEllipticalArc(v, _, w, x, P, f);
      }
      return null;
    }
    static getPointOnLine(h, l, g, p, b, m, C) {
      m = m != null ? m : l, C = C != null ? C : g;
      const v = this.getLineLength(l, g, p, b);
      if (v < 1e-10)
        return { x: l, y: g };
      if (p === l)
        return { x: m, y: C + (b > g ? h : -h) };
      const _ = (b - g) / (p - l), w = Math.sqrt(h * h / (1 + _ * _)) * (p < l ? -1 : 1), x = _ * w;
      if (Math.abs(C - g - _ * (m - l)) < 1e-10)
        return { x: m + w, y: C + x };
      const P = ((m - l) * (p - l) + (C - g) * (b - g)) / (v * v), c = l + P * (p - l), f = g + P * (b - g), S = this.getLineLength(m, C, c, f), E = Math.sqrt(h * h - S * S), T = Math.sqrt(E * E / (1 + _ * _)) * (p < l ? -1 : 1), D = _ * T;
      return { x: c + T, y: f + D };
    }
    static getPointOnCubicBezier(h, l, g, p, b, m, C, v, _) {
      function w(E) {
        return E * E * E;
      }
      function x(E) {
        return 3 * E * E * (1 - E);
      }
      function P(E) {
        return 3 * E * (1 - E) * (1 - E);
      }
      function c(E) {
        return (1 - E) * (1 - E) * (1 - E);
      }
      const f = v * w(h) + m * x(h) + p * P(h) + l * c(h), S = _ * w(h) + C * x(h) + b * P(h) + g * c(h);
      return {
        x: f,
        y: S
      };
    }
    static getPointOnQuadraticBezier(h, l, g, p, b, m, C) {
      function v(c) {
        return c * c;
      }
      function _(c) {
        return 2 * c * (1 - c);
      }
      function w(c) {
        return (1 - c) * (1 - c);
      }
      const x = m * v(h) + p * _(h) + l * w(h), P = C * v(h) + b * _(h) + g * w(h);
      return {
        x,
        y: P
      };
    }
    static getPointOnEllipticalArc(h, l, g, p, b, m) {
      const C = Math.cos(m), v = Math.sin(m), _ = {
        x: g * Math.cos(b),
        y: p * Math.sin(b)
      };
      return {
        x: h + (_.x * C - _.y * v),
        y: l + (_.x * v + _.y * C)
      };
    }
    static parsePathData(h) {
      if (!h)
        return [];
      let l = h;
      const g = [
        "m",
        "M",
        "l",
        "L",
        "v",
        "V",
        "h",
        "H",
        "z",
        "Z",
        "c",
        "C",
        "q",
        "Q",
        "t",
        "T",
        "s",
        "S",
        "a",
        "A"
      ];
      l = l.replace(new RegExp(" ", "g"), ",");
      for (var p = 0; p < g.length; p++)
        l = l.replace(new RegExp(g[p], "g"), "|" + g[p]);
      const b = l.split("|"), m = [], C = [];
      let v = 0, _ = 0;
      const w = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
      let x;
      for (p = 1; p < b.length; p++) {
        let y = b[p], F = y.charAt(0);
        for (y = y.slice(1), C.length = 0; x = w.exec(y); )
          C.push(x[0]);
        const R = [];
        for (let G = 0, U = C.length; G < U; G++) {
          if (C[G] === "00") {
            R.push(0, 0);
            continue;
          }
          const K = parseFloat(C[G]);
          isNaN(K) ? R.push(0) : R.push(K);
        }
        for (; R.length > 0 && !isNaN(R[0]); ) {
          let G = "", U = [];
          const K = v, $ = _;
          var P, c, f, S, E, T, D, I, M, O;
          switch (F) {
            case "l":
              v += R.shift(), _ += R.shift(), G = "L", U.push(v, _);
              break;
            case "L":
              v = R.shift(), _ = R.shift(), U.push(v, _);
              break;
            case "m":
              var N = R.shift(), H = R.shift();
              if (v += N, _ += H, G = "M", m.length > 2 && m[m.length - 1].command === "z") {
                for (let X = m.length - 2; X >= 0; X--)
                  if (m[X].command === "M") {
                    v = m[X].points[0] + N, _ = m[X].points[1] + H;
                    break;
                  }
              }
              U.push(v, _), F = "l";
              break;
            case "M":
              v = R.shift(), _ = R.shift(), G = "M", U.push(v, _), F = "L";
              break;
            case "h":
              v += R.shift(), G = "L", U.push(v, _);
              break;
            case "H":
              v = R.shift(), G = "L", U.push(v, _);
              break;
            case "v":
              _ += R.shift(), G = "L", U.push(v, _);
              break;
            case "V":
              _ = R.shift(), G = "L", U.push(v, _);
              break;
            case "C":
              U.push(R.shift(), R.shift(), R.shift(), R.shift()), v = R.shift(), _ = R.shift(), U.push(v, _);
              break;
            case "c":
              U.push(v + R.shift(), _ + R.shift(), v + R.shift(), _ + R.shift()), v += R.shift(), _ += R.shift(), G = "C", U.push(v, _);
              break;
            case "S":
              c = v, f = _, P = m[m.length - 1], P.command === "C" && (c = v + (v - P.points[2]), f = _ + (_ - P.points[3])), U.push(c, f, R.shift(), R.shift()), v = R.shift(), _ = R.shift(), G = "C", U.push(v, _);
              break;
            case "s":
              c = v, f = _, P = m[m.length - 1], P.command === "C" && (c = v + (v - P.points[2]), f = _ + (_ - P.points[3])), U.push(c, f, v + R.shift(), _ + R.shift()), v += R.shift(), _ += R.shift(), G = "C", U.push(v, _);
              break;
            case "Q":
              U.push(R.shift(), R.shift()), v = R.shift(), _ = R.shift(), U.push(v, _);
              break;
            case "q":
              U.push(v + R.shift(), _ + R.shift()), v += R.shift(), _ += R.shift(), G = "Q", U.push(v, _);
              break;
            case "T":
              c = v, f = _, P = m[m.length - 1], P.command === "Q" && (c = v + (v - P.points[0]), f = _ + (_ - P.points[1])), v = R.shift(), _ = R.shift(), G = "Q", U.push(c, f, v, _);
              break;
            case "t":
              c = v, f = _, P = m[m.length - 1], P.command === "Q" && (c = v + (v - P.points[0]), f = _ + (_ - P.points[1])), v += R.shift(), _ += R.shift(), G = "Q", U.push(c, f, v, _);
              break;
            case "A":
              S = R.shift(), E = R.shift(), T = R.shift(), D = R.shift(), I = R.shift(), M = v, O = _, v = R.shift(), _ = R.shift(), G = "A", U = this.convertEndpointToCenterParameterization(M, O, v, _, D, I, S, E, T);
              break;
            case "a":
              S = R.shift(), E = R.shift(), T = R.shift(), D = R.shift(), I = R.shift(), M = v, O = _, v += R.shift(), _ += R.shift(), G = "A", U = this.convertEndpointToCenterParameterization(M, O, v, _, D, I, S, E, T);
              break;
          }
          m.push({
            command: G || F,
            points: U,
            start: {
              x: K,
              y: $
            },
            pathLength: this.calcLength(K, $, G || F, U)
          });
        }
        (F === "z" || F === "Z") && m.push({
          command: "z",
          points: [],
          start: void 0,
          pathLength: 0
        });
      }
      return m;
    }
    static calcLength(h, l, g, p) {
      let b, m, C, v;
      const _ = Se;
      switch (g) {
        case "L":
          return _.getLineLength(h, l, p[0], p[1]);
        case "C":
          return (0, o.getCubicArcLength)([h, p[0], p[2], p[4]], [l, p[1], p[3], p[5]], 1);
        case "Q":
          return (0, o.getQuadraticArcLength)([h, p[0], p[2]], [l, p[1], p[3]], 1);
        case "A":
          b = 0;
          var w = p[4], x = p[5], P = p[4] + x, c = Math.PI / 180;
          if (Math.abs(w - P) < c && (c = Math.abs(w - P)), m = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], w, 0), x < 0)
            for (v = w - c; v > P; v -= c)
              C = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], v, 0), b += _.getLineLength(m.x, m.y, C.x, C.y), m = C;
          else
            for (v = w + c; v < P; v += c)
              C = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], v, 0), b += _.getLineLength(m.x, m.y, C.x, C.y), m = C;
          return C = _.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], P, 0), b += _.getLineLength(m.x, m.y, C.x, C.y), b;
      }
      return 0;
    }
    static convertEndpointToCenterParameterization(h, l, g, p, b, m, C, v, _) {
      const w = _ * (Math.PI / 180), x = Math.cos(w) * (h - g) / 2 + Math.sin(w) * (l - p) / 2, P = -1 * Math.sin(w) * (h - g) / 2 + Math.cos(w) * (l - p) / 2, c = x * x / (C * C) + P * P / (v * v);
      c > 1 && (C *= Math.sqrt(c), v *= Math.sqrt(c));
      let f = Math.sqrt((C * C * (v * v) - C * C * (P * P) - v * v * (x * x)) / (C * C * (P * P) + v * v * (x * x)));
      b === m && (f *= -1), isNaN(f) && (f = 0);
      const S = f * C * P / v, E = f * -v * x / C, T = (h + g) / 2 + Math.cos(w) * S - Math.sin(w) * E, D = (l + p) / 2 + Math.sin(w) * S + Math.cos(w) * E, I = function(R) {
        return Math.sqrt(R[0] * R[0] + R[1] * R[1]);
      }, M = function(R, G) {
        return (R[0] * G[0] + R[1] * G[1]) / (I(R) * I(G));
      }, O = function(R, G) {
        return (R[0] * G[1] < R[1] * G[0] ? -1 : 1) * Math.acos(M(R, G));
      }, N = O([1, 0], [(x - S) / C, (P - E) / v]), H = [(x - S) / C, (P - E) / v], y = [(-1 * x - S) / C, (-1 * P - E) / v];
      let F = O(H, y);
      return M(H, y) <= -1 && (F = Math.PI), M(H, y) >= 1 && (F = 0), m === 0 && F > 0 && (F = F - 2 * Math.PI), m === 1 && F < 0 && (F = F + 2 * Math.PI), [T, D, C, v, N, F, w, m];
    }
  };
  return Li.Path = u, u.prototype.className = "Path", u.prototype._attrsAffectingSize = ["data"], (0, n._registerNode)(u), r.Factory.addGetterSetter(u, "data"), Li;
}
var ed;
function l6() {
  if (ed) return Ii;
  ed = 1, Object.defineProperty(Ii, "__esModule", { value: !0 }), Ii.Arrow = void 0;
  const r = Tt(), a = J0(), n = Ot(), o = At(), u = Qh();
  let s = class extends a.Line {
    _sceneFunc(l) {
      super._sceneFunc(l);
      const g = Math.PI * 2, p = this.points();
      let b = p;
      const m = this.tension() !== 0 && p.length > 4;
      m && (b = this.getTensionPoints());
      const C = this.pointerLength(), v = p.length;
      let _, w;
      if (m) {
        const c = [
          b[b.length - 4],
          b[b.length - 3],
          b[b.length - 2],
          b[b.length - 1],
          p[v - 2],
          p[v - 1]
        ], f = u.Path.calcLength(b[b.length - 4], b[b.length - 3], "C", c), S = u.Path.getPointOnQuadraticBezier(Math.min(1, 1 - C / f), c[0], c[1], c[2], c[3], c[4], c[5]);
        _ = p[v - 2] - S.x, w = p[v - 1] - S.y;
      } else
        _ = p[v - 2] - p[v - 4], w = p[v - 1] - p[v - 3];
      const x = (Math.atan2(w, _) + g) % g, P = this.pointerWidth();
      this.pointerAtEnding() && (l.save(), l.beginPath(), l.translate(p[v - 2], p[v - 1]), l.rotate(x), l.moveTo(0, 0), l.lineTo(-C, P / 2), l.lineTo(-C, -P / 2), l.closePath(), l.restore(), this.__fillStroke(l)), this.pointerAtBeginning() && (l.save(), l.beginPath(), l.translate(p[0], p[1]), m ? (_ = (b[0] + b[2]) / 2 - p[0], w = (b[1] + b[3]) / 2 - p[1]) : (_ = p[2] - p[0], w = p[3] - p[1]), l.rotate((Math.atan2(-w, -_) + g) % g), l.moveTo(0, 0), l.lineTo(-C, P / 2), l.lineTo(-C, -P / 2), l.closePath(), l.restore(), this.__fillStroke(l));
    }
    __fillStroke(l) {
      const g = this.dashEnabled();
      g && (this.attrs.dashEnabled = !1, l.setLineDash([])), l.fillStrokeShape(this), g && (this.attrs.dashEnabled = !0);
    }
    getSelfRect() {
      const l = super.getSelfRect(), g = this.pointerWidth() / 2;
      return {
        x: l.x - g,
        y: l.y - g,
        width: l.width + g * 2,
        height: l.height + g * 2
      };
    }
  };
  return Ii.Arrow = s, s.prototype.className = "Arrow", (0, o._registerNode)(s), r.Factory.addGetterSetter(s, "pointerLength", 10, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(s, "pointerWidth", 10, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(s, "pointerAtBeginning", !1), r.Factory.addGetterSetter(s, "pointerAtEnding", !0), Ii;
}
var Ni = {}, rd;
function u6() {
  if (rd) return Ni;
  rd = 1, Object.defineProperty(Ni, "__esModule", { value: !0 }), Ni.Circle = void 0;
  const r = Tt(), a = se(), n = Ot(), o = At();
  let u = class extends a.Shape {
    _sceneFunc(h) {
      h.beginPath(), h.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, !1), h.closePath(), h.fillStrokeShape(this);
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(h) {
      this.radius() !== h / 2 && this.radius(h / 2);
    }
    setHeight(h) {
      this.radius() !== h / 2 && this.radius(h / 2);
    }
  };
  return Ni.Circle = u, u.prototype._centroid = !0, u.prototype.className = "Circle", u.prototype._attrsAffectingSize = ["radius"], (0, o._registerNode)(u), r.Factory.addGetterSetter(u, "radius", 0, (0, n.getNumberValidator)()), Ni;
}
var Gi = {}, id;
function c6() {
  if (id) return Gi;
  id = 1, Object.defineProperty(Gi, "__esModule", { value: !0 }), Gi.Ellipse = void 0;
  const r = Tt(), a = se(), n = Ot(), o = At();
  let u = class extends a.Shape {
    _sceneFunc(h) {
      const l = this.radiusX(), g = this.radiusY();
      h.beginPath(), h.save(), l !== g && h.scale(1, g / l), h.arc(0, 0, l, 0, Math.PI * 2, !1), h.restore(), h.closePath(), h.fillStrokeShape(this);
    }
    getWidth() {
      return this.radiusX() * 2;
    }
    getHeight() {
      return this.radiusY() * 2;
    }
    setWidth(h) {
      this.radiusX(h / 2);
    }
    setHeight(h) {
      this.radiusY(h / 2);
    }
  };
  return Gi.Ellipse = u, u.prototype.className = "Ellipse", u.prototype._centroid = !0, u.prototype._attrsAffectingSize = ["radiusX", "radiusY"], (0, o._registerNode)(u), r.Factory.addComponentsGetterSetter(u, "radius", ["x", "y"]), r.Factory.addGetterSetter(u, "radiusX", 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(u, "radiusY", 0, (0, n.getNumberValidator)()), Gi;
}
var Di = {}, nd;
function d6() {
  if (nd) return Di;
  nd = 1, Object.defineProperty(Di, "__esModule", { value: !0 }), Di.Image = void 0;
  const r = Kt(), a = Tt(), n = se(), o = At(), u = Ot();
  let s = class Q0 extends n.Shape {
    constructor(l) {
      super(l), this.on("imageChange.konva", () => {
        this._setImageLoad();
      }), this._setImageLoad();
    }
    _setImageLoad() {
      const l = this.image();
      l && l.complete || l && l.readyState === 4 || l && l.addEventListener && l.addEventListener("load", () => {
        this._requestDraw();
      });
    }
    _useBufferCanvas() {
      const l = !!this.cornerRadius(), g = this.hasShadow();
      return l && g ? !0 : super._useBufferCanvas(!0);
    }
    _sceneFunc(l) {
      const g = this.getWidth(), p = this.getHeight(), b = this.cornerRadius(), m = this.attrs.image;
      let C;
      if (m) {
        const v = this.attrs.cropWidth, _ = this.attrs.cropHeight;
        v && _ ? C = [
          m,
          this.cropX(),
          this.cropY(),
          v,
          _,
          0,
          0,
          g,
          p
        ] : C = [m, 0, 0, g, p];
      }
      (this.hasFill() || this.hasStroke() || b) && (l.beginPath(), b ? r.Util.drawRoundedRectPath(l, g, p, b) : l.rect(0, 0, g, p), l.closePath(), l.fillStrokeShape(this)), m && (b && l.clip(), l.drawImage.apply(l, C));
    }
    _hitFunc(l) {
      const g = this.width(), p = this.height(), b = this.cornerRadius();
      l.beginPath(), b ? r.Util.drawRoundedRectPath(l, g, p, b) : l.rect(0, 0, g, p), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      var l, g;
      return (l = this.attrs.width) !== null && l !== void 0 ? l : (g = this.image()) === null || g === void 0 ? void 0 : g.width;
    }
    getHeight() {
      var l, g;
      return (l = this.attrs.height) !== null && l !== void 0 ? l : (g = this.image()) === null || g === void 0 ? void 0 : g.height;
    }
    static fromURL(l, g, p = null) {
      const b = r.Util.createImageElement();
      b.onload = function() {
        const m = new Q0({
          image: b
        });
        g(m);
      }, b.onerror = p, b.crossOrigin = "Anonymous", b.src = l;
    }
  };
  return Di.Image = s, s.prototype.className = "Image", (0, o._registerNode)(s), a.Factory.addGetterSetter(s, "cornerRadius", 0, (0, u.getNumberOrArrayOfNumbersValidator)(4)), a.Factory.addGetterSetter(s, "image"), a.Factory.addComponentsGetterSetter(s, "crop", ["x", "y", "width", "height"]), a.Factory.addGetterSetter(s, "cropX", 0, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(s, "cropY", 0, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(s, "cropWidth", 0, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(s, "cropHeight", 0, (0, u.getNumberValidator)()), Di;
}
var Nr = {}, ad;
function f6() {
  if (ad) return Nr;
  ad = 1, Object.defineProperty(Nr, "__esModule", { value: !0 }), Nr.Tag = Nr.Label = void 0;
  const r = Tt(), a = se(), n = Zh(), o = Ot(), u = At(), s = [
    "fontFamily",
    "fontSize",
    "fontStyle",
    "padding",
    "lineHeight",
    "text",
    "width",
    "height",
    "pointerDirection",
    "pointerWidth",
    "pointerHeight"
  ], h = "Change.konva", l = "none", g = "up", p = "right", b = "down", m = "left", C = s.length;
  let v = class extends n.Group {
    constructor(x) {
      super(x), this.on("add.konva", function(P) {
        this._addListeners(P.child), this._sync();
      });
    }
    getText() {
      return this.find("Text")[0];
    }
    getTag() {
      return this.find("Tag")[0];
    }
    _addListeners(x) {
      let P = this, c;
      const f = function() {
        P._sync();
      };
      for (c = 0; c < C; c++)
        x.on(s[c] + h, f);
    }
    getWidth() {
      return this.getText().width();
    }
    getHeight() {
      return this.getText().height();
    }
    _sync() {
      let x = this.getText(), P = this.getTag(), c, f, S, E, T, D, I;
      if (x && P) {
        switch (c = x.width(), f = x.height(), S = P.pointerDirection(), E = P.pointerWidth(), I = P.pointerHeight(), T = 0, D = 0, S) {
          case g:
            T = c / 2, D = -1 * I;
            break;
          case p:
            T = c + E, D = f / 2;
            break;
          case b:
            T = c / 2, D = f + I;
            break;
          case m:
            T = -1 * E, D = f / 2;
            break;
        }
        P.setAttrs({
          x: -1 * T,
          y: -1 * D,
          width: c,
          height: f
        }), x.setAttrs({
          x: -1 * T,
          y: -1 * D
        });
      }
    }
  };
  Nr.Label = v, v.prototype.className = "Label", (0, u._registerNode)(v);
  class _ extends a.Shape {
    _sceneFunc(x) {
      const P = this.width(), c = this.height(), f = this.pointerDirection(), S = this.pointerWidth(), E = this.pointerHeight(), T = this.cornerRadius();
      let D = 0, I = 0, M = 0, O = 0;
      typeof T == "number" ? D = I = M = O = Math.min(T, P / 2, c / 2) : (D = Math.min(T[0] || 0, P / 2, c / 2), I = Math.min(T[1] || 0, P / 2, c / 2), O = Math.min(T[2] || 0, P / 2, c / 2), M = Math.min(T[3] || 0, P / 2, c / 2)), x.beginPath(), x.moveTo(D, 0), f === g && (x.lineTo((P - S) / 2, 0), x.lineTo(P / 2, -1 * E), x.lineTo((P + S) / 2, 0)), x.lineTo(P - I, 0), x.arc(P - I, I, I, Math.PI * 3 / 2, 0, !1), f === p && (x.lineTo(P, (c - E) / 2), x.lineTo(P + S, c / 2), x.lineTo(P, (c + E) / 2)), x.lineTo(P, c - O), x.arc(P - O, c - O, O, 0, Math.PI / 2, !1), f === b && (x.lineTo((P + S) / 2, c), x.lineTo(P / 2, c + E), x.lineTo((P - S) / 2, c)), x.lineTo(M, c), x.arc(M, c - M, M, Math.PI / 2, Math.PI, !1), f === m && (x.lineTo(0, (c + E) / 2), x.lineTo(-1 * S, c / 2), x.lineTo(0, (c - E) / 2)), x.lineTo(0, D), x.arc(D, D, D, Math.PI, Math.PI * 3 / 2, !1), x.closePath(), x.fillStrokeShape(this);
    }
    getSelfRect() {
      let x = 0, P = 0, c = this.pointerWidth(), f = this.pointerHeight(), S = this.pointerDirection(), E = this.width(), T = this.height();
      return S === g ? (P -= f, T += f) : S === b ? T += f : S === m ? (x -= c * 1.5, E += c) : S === p && (E += c * 1.5), {
        x,
        y: P,
        width: E,
        height: T
      };
    }
  }
  return Nr.Tag = _, _.prototype.className = "Tag", (0, u._registerNode)(_), r.Factory.addGetterSetter(_, "pointerDirection", l), r.Factory.addGetterSetter(_, "pointerWidth", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(_, "pointerHeight", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(_, "cornerRadius", 0, (0, o.getNumberOrArrayOfNumbersValidator)(4)), Nr;
}
var Bi = {}, sd;
function t1() {
  if (sd) return Bi;
  sd = 1, Object.defineProperty(Bi, "__esModule", { value: !0 }), Bi.Rect = void 0;
  const r = Tt(), a = se(), n = At(), o = Kt(), u = Ot();
  let s = class extends a.Shape {
    _sceneFunc(l) {
      const g = this.cornerRadius(), p = this.width(), b = this.height();
      l.beginPath(), g ? o.Util.drawRoundedRectPath(l, p, b, g) : l.rect(0, 0, p, b), l.closePath(), l.fillStrokeShape(this);
    }
  };
  return Bi.Rect = s, s.prototype.className = "Rect", (0, n._registerNode)(s), r.Factory.addGetterSetter(s, "cornerRadius", 0, (0, u.getNumberOrArrayOfNumbersValidator)(4)), Bi;
}
var Ui = {}, od;
function g6() {
  if (od) return Ui;
  od = 1, Object.defineProperty(Ui, "__esModule", { value: !0 }), Ui.RegularPolygon = void 0;
  const r = Tt(), a = se(), n = Ot(), o = At();
  let u = class extends a.Shape {
    _sceneFunc(h) {
      const l = this._getPoints();
      h.beginPath(), h.moveTo(l[0].x, l[0].y);
      for (let g = 1; g < l.length; g++)
        h.lineTo(l[g].x, l[g].y);
      h.closePath(), h.fillStrokeShape(this);
    }
    _getPoints() {
      const h = this.attrs.sides, l = this.attrs.radius || 0, g = [];
      for (let p = 0; p < h; p++)
        g.push({
          x: l * Math.sin(p * 2 * Math.PI / h),
          y: -1 * l * Math.cos(p * 2 * Math.PI / h)
        });
      return g;
    }
    getSelfRect() {
      const h = this._getPoints();
      let l = h[0].x, g = h[0].y, p = h[0].x, b = h[0].y;
      return h.forEach((m) => {
        l = Math.min(l, m.x), g = Math.max(g, m.x), p = Math.min(p, m.y), b = Math.max(b, m.y);
      }), {
        x: l,
        y: p,
        width: g - l,
        height: b - p
      };
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(h) {
      this.radius(h / 2);
    }
    setHeight(h) {
      this.radius(h / 2);
    }
  };
  return Ui.RegularPolygon = u, u.prototype.className = "RegularPolygon", u.prototype._centroid = !0, u.prototype._attrsAffectingSize = ["radius"], (0, o._registerNode)(u), r.Factory.addGetterSetter(u, "radius", 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(u, "sides", 0, (0, n.getNumberValidator)()), Ui;
}
var qi = {}, hd;
function p6() {
  if (hd) return qi;
  hd = 1, Object.defineProperty(qi, "__esModule", { value: !0 }), qi.Ring = void 0;
  const r = Tt(), a = se(), n = Ot(), o = At(), u = Math.PI * 2;
  let s = class extends a.Shape {
    _sceneFunc(l) {
      l.beginPath(), l.arc(0, 0, this.innerRadius(), 0, u, !1), l.moveTo(this.outerRadius(), 0), l.arc(0, 0, this.outerRadius(), u, 0, !0), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(l) {
      this.outerRadius(l / 2);
    }
    setHeight(l) {
      this.outerRadius(l / 2);
    }
  };
  return qi.Ring = s, s.prototype.className = "Ring", s.prototype._centroid = !0, s.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, o._registerNode)(s), r.Factory.addGetterSetter(s, "innerRadius", 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(s, "outerRadius", 0, (0, n.getNumberValidator)()), qi;
}
var Hi = {}, ld;
function _6() {
  if (ld) return Hi;
  ld = 1, Object.defineProperty(Hi, "__esModule", { value: !0 }), Hi.Sprite = void 0;
  const r = Tt(), a = se(), n = Jh(), o = Ot(), u = At();
  let s = class extends a.Shape {
    constructor(l) {
      super(l), this._updated = !0, this.anim = new n.Animation(() => {
        const g = this._updated;
        return this._updated = !1, g;
      }), this.on("animationChange.konva", function() {
        this.frameIndex(0);
      }), this.on("frameIndexChange.konva", function() {
        this._updated = !0;
      }), this.on("frameRateChange.konva", function() {
        this.anim.isRunning() && (clearInterval(this.interval), this._setInterval());
      });
    }
    _sceneFunc(l) {
      const g = this.animation(), p = this.frameIndex(), b = p * 4, m = this.animations()[g], C = this.frameOffsets(), v = m[b + 0], _ = m[b + 1], w = m[b + 2], x = m[b + 3], P = this.image();
      if ((this.hasFill() || this.hasStroke()) && (l.beginPath(), l.rect(0, 0, w, x), l.closePath(), l.fillStrokeShape(this)), P)
        if (C) {
          const c = C[g], f = p * 2;
          l.drawImage(P, v, _, w, x, c[f + 0], c[f + 1], w, x);
        } else
          l.drawImage(P, v, _, w, x, 0, 0, w, x);
    }
    _hitFunc(l) {
      const g = this.animation(), p = this.frameIndex(), b = p * 4, m = this.animations()[g], C = this.frameOffsets(), v = m[b + 2], _ = m[b + 3];
      if (l.beginPath(), C) {
        const w = C[g], x = p * 2;
        l.rect(w[x + 0], w[x + 1], v, _);
      } else
        l.rect(0, 0, v, _);
      l.closePath(), l.fillShape(this);
    }
    _useBufferCanvas() {
      return super._useBufferCanvas(!0);
    }
    _setInterval() {
      const l = this;
      this.interval = setInterval(function() {
        l._updateIndex();
      }, 1e3 / this.frameRate());
    }
    start() {
      if (this.isRunning())
        return;
      const l = this.getLayer();
      this.anim.setLayers(l), this._setInterval(), this.anim.start();
    }
    stop() {
      this.anim.stop(), clearInterval(this.interval);
    }
    isRunning() {
      return this.anim.isRunning();
    }
    _updateIndex() {
      const l = this.frameIndex(), g = this.animation(), p = this.animations(), b = p[g], m = b.length / 4;
      l < m - 1 ? this.frameIndex(l + 1) : this.frameIndex(0);
    }
  };
  return Hi.Sprite = s, s.prototype.className = "Sprite", (0, u._registerNode)(s), r.Factory.addGetterSetter(s, "animation"), r.Factory.addGetterSetter(s, "animations"), r.Factory.addGetterSetter(s, "frameOffsets"), r.Factory.addGetterSetter(s, "image"), r.Factory.addGetterSetter(s, "frameIndex", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "frameRate", 17, (0, o.getNumberValidator)()), r.Factory.backCompat(s, {
    index: "frameIndex",
    getIndex: "getFrameIndex",
    setIndex: "setFrameIndex"
  }), Hi;
}
var zi = {}, ud;
function v6() {
  if (ud) return zi;
  ud = 1, Object.defineProperty(zi, "__esModule", { value: !0 }), zi.Star = void 0;
  const r = Tt(), a = se(), n = Ot(), o = At();
  let u = class extends a.Shape {
    _sceneFunc(h) {
      const l = this.innerRadius(), g = this.outerRadius(), p = this.numPoints();
      h.beginPath(), h.moveTo(0, 0 - g);
      for (let b = 1; b < p * 2; b++) {
        const m = b % 2 === 0 ? g : l, C = m * Math.sin(b * Math.PI / p), v = -1 * m * Math.cos(b * Math.PI / p);
        h.lineTo(C, v);
      }
      h.closePath(), h.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(h) {
      this.outerRadius(h / 2);
    }
    setHeight(h) {
      this.outerRadius(h / 2);
    }
  };
  return zi.Star = u, u.prototype.className = "Star", u.prototype._centroid = !0, u.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, o._registerNode)(u), r.Factory.addGetterSetter(u, "numPoints", 5, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(u, "innerRadius", 0, (0, n.getNumberValidator)()), r.Factory.addGetterSetter(u, "outerRadius", 0, (0, n.getNumberValidator)()), zi;
}
var Qr = {}, cd;
function e1() {
  if (cd) return Qr;
  cd = 1, Object.defineProperty(Qr, "__esModule", { value: !0 }), Qr.Text = void 0, Qr.stringToArray = h;
  const r = Kt(), a = Tt(), n = se(), o = At(), u = Ot(), s = At();
  function h(st) {
    return [...st].reduce((Z, at, ht, ct) => (/\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?(?:\u200D\p{Emoji_Presentation})+/u.test(at) ? Z.push(at) : /\p{Regional_Indicator}{2}/u.test(at + (ct[ht + 1] || "")) ? Z.push(at + ct[ht + 1]) : ht > 0 && /\p{Mn}|\p{Me}|\p{Mc}/u.test(at) ? Z[Z.length - 1] += at : Z.push(at), Z), []);
  }
  const l = "auto", g = "center", p = "inherit", b = "justify", m = "Change.konva", C = "2d", v = "-", _ = "left", w = "text", x = "Text", P = "top", c = "bottom", f = "middle", S = "normal", E = "px ", T = " ", D = "right", I = "rtl", M = "word", O = "char", N = "none", H = "…", y = [
    "direction",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontVariant",
    "padding",
    "align",
    "verticalAlign",
    "lineHeight",
    "text",
    "width",
    "height",
    "wrap",
    "ellipsis",
    "letterSpacing"
  ], F = y.length;
  function R(st) {
    return st.split(",").map((Z) => {
      Z = Z.trim();
      const at = Z.indexOf(" ") >= 0, ht = Z.indexOf('"') >= 0 || Z.indexOf("'") >= 0;
      return at && !ht && (Z = `"${Z}"`), Z;
    }).join(", ");
  }
  let G;
  function U() {
    return G || (G = r.Util.createCanvasElement().getContext(C), G);
  }
  function K(st) {
    st.fillText(this._partialText, this._partialTextX, this._partialTextY);
  }
  function $(st) {
    st.setAttr("miterLimit", 2), st.strokeText(this._partialText, this._partialTextX, this._partialTextY);
  }
  function X(st) {
    return st = st || {}, !st.fillLinearGradientColorStops && !st.fillRadialGradientColorStops && !st.fillPatternImage && (st.fill = st.fill || "black"), st;
  }
  let Q = class extends n.Shape {
    constructor(Z) {
      super(X(Z)), this._partialTextX = 0, this._partialTextY = 0;
      for (let at = 0; at < F; at++)
        this.on(y[at] + m, this._setTextData);
      this._setTextData();
    }
    _sceneFunc(Z) {
      const at = this.textArr, ht = at.length;
      if (!this.text())
        return;
      let ct = this.padding(), z = this.fontSize(), j = this.lineHeight() * z, et = this.verticalAlign(), ut = this.direction(), ft = 0, gt = this.align(), Mt = this.getWidth(), xt = this.letterSpacing(), mt = this.fill(), ee = this.textDecoration(), Pt = ee.indexOf("underline") !== -1, zt = ee.indexOf("line-through") !== -1, gr;
      ut = ut === p ? Z.direction : ut;
      let re = j / 2, Zt = f;
      if (o.Konva._fixTextRendering) {
        const $e = this.measureSize("M");
        Zt = "alphabetic", re = ($e.fontBoundingBoxAscent - $e.fontBoundingBoxDescent) / 2 + j / 2;
      }
      var Jt = 0, Ut = 0;
      for (ut === I && Z.setAttr("direction", ut), Z.setAttr("font", this._getContextFont()), Z.setAttr("textBaseline", Zt), Z.setAttr("textAlign", _), et === f ? ft = (this.getHeight() - ht * j - ct * 2) / 2 : et === c && (ft = this.getHeight() - ht * j - ct * 2), Z.translate(ct, ft + ct), gr = 0; gr < ht; gr++) {
        var Jt = 0, Ut = 0, He = at[gr], ie = He.text, ze = He.width, Wt = He.lastInParagraph, ne, Fe, pe;
        if (Z.save(), gt === D ? Jt += Mt - ze - ct * 2 : gt === g && (Jt += (Mt - ze - ct * 2) / 2), Pt) {
          Z.save(), Z.beginPath();
          const Ve = o.Konva._fixTextRendering ? Math.round(z / 4) : Math.round(z / 2), Oe = Jt, Ze = re + Ut + Ve;
          Z.moveTo(Oe, Ze), ne = ie.split(" ").length - 1, Fe = ne === 0, pe = gt === b && !Wt ? Mt - ct * 2 : ze, Z.lineTo(Oe + Math.round(pe), Ze), Z.lineWidth = z / 15;
          const hi = this._getLinearGradient();
          Z.strokeStyle = hi || mt, Z.stroke(), Z.restore();
        }
        if (zt) {
          Z.save(), Z.beginPath();
          const Ve = o.Konva._fixTextRendering ? -Math.round(z / 4) : 0;
          Z.moveTo(Jt, re + Ut + Ve), ne = ie.split(" ").length - 1, Fe = ne === 0, pe = gt === b && Wt && !Fe ? Mt - ct * 2 : ze, Z.lineTo(Jt + Math.round(pe), re + Ut + Ve), Z.lineWidth = z / 15;
          const Oe = this._getLinearGradient();
          Z.strokeStyle = Oe || mt, Z.stroke(), Z.restore();
        }
        if (ut !== I && (xt !== 0 || gt === b)) {
          ne = ie.split(" ").length - 1;
          const Ve = h(ie);
          for (let Oe = 0; Oe < Ve.length; Oe++) {
            const Ze = Ve[Oe];
            Ze === " " && !Wt && gt === b && (Jt += (Mt - ct * 2 - ze) / ne), this._partialTextX = Jt, this._partialTextY = re + Ut, this._partialText = Ze, Z.fillStrokeShape(this), Jt += this.measureSize(Ze).width + xt;
          }
        } else
          xt !== 0 && Z.setAttr("letterSpacing", `${xt}px`), this._partialTextX = Jt, this._partialTextY = re + Ut, this._partialText = ie, Z.fillStrokeShape(this);
        Z.restore(), ht > 1 && (re += j);
      }
    }
    _hitFunc(Z) {
      const at = this.getWidth(), ht = this.getHeight();
      Z.beginPath(), Z.rect(0, 0, at, ht), Z.closePath(), Z.fillStrokeShape(this);
    }
    setText(Z) {
      const at = r.Util._isString(Z) ? Z : Z == null ? "" : Z + "";
      return this._setAttr(w, at), this;
    }
    getWidth() {
      return this.attrs.width === l || this.attrs.width === void 0 ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
      return this.attrs.height === l || this.attrs.height === void 0 ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
      return this.textWidth;
    }
    getTextHeight() {
      return r.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
    }
    measureSize(Z) {
      var at, ht, ct, z, j, et, ut, ft, gt, Mt, xt;
      let mt = U(), ee = this.fontSize(), Pt;
      mt.save(), mt.font = this._getContextFont(), Pt = mt.measureText(Z), mt.restore();
      const zt = ee / 100;
      return {
        actualBoundingBoxAscent: (at = Pt.actualBoundingBoxAscent) !== null && at !== void 0 ? at : 71.58203125 * zt,
        actualBoundingBoxDescent: (ht = Pt.actualBoundingBoxDescent) !== null && ht !== void 0 ? ht : 0,
        actualBoundingBoxLeft: (ct = Pt.actualBoundingBoxLeft) !== null && ct !== void 0 ? ct : -7.421875 * zt,
        actualBoundingBoxRight: (z = Pt.actualBoundingBoxRight) !== null && z !== void 0 ? z : 75.732421875 * zt,
        alphabeticBaseline: (j = Pt.alphabeticBaseline) !== null && j !== void 0 ? j : 0,
        emHeightAscent: (et = Pt.emHeightAscent) !== null && et !== void 0 ? et : 100 * zt,
        emHeightDescent: (ut = Pt.emHeightDescent) !== null && ut !== void 0 ? ut : -20 * zt,
        fontBoundingBoxAscent: (ft = Pt.fontBoundingBoxAscent) !== null && ft !== void 0 ? ft : 91 * zt,
        fontBoundingBoxDescent: (gt = Pt.fontBoundingBoxDescent) !== null && gt !== void 0 ? gt : 21 * zt,
        hangingBaseline: (Mt = Pt.hangingBaseline) !== null && Mt !== void 0 ? Mt : 72.80000305175781 * zt,
        ideographicBaseline: (xt = Pt.ideographicBaseline) !== null && xt !== void 0 ? xt : -21 * zt,
        width: Pt.width,
        height: ee
      };
    }
    _getContextFont() {
      return this.fontStyle() + T + this.fontVariant() + T + (this.fontSize() + E) + R(this.fontFamily());
    }
    _addTextLine(Z) {
      this.align() === b && (Z = Z.trim());
      const ht = this._getTextWidth(Z);
      return this.textArr.push({
        text: Z,
        width: ht,
        lastInParagraph: !1
      });
    }
    _getTextWidth(Z) {
      const at = this.letterSpacing(), ht = Z.length;
      return U().measureText(Z).width + (ht ? at * (ht - 1) : 0);
    }
    _setTextData() {
      let Z = this.text().split(`
`), at = +this.fontSize(), ht = 0, ct = this.lineHeight() * at, z = this.attrs.width, j = this.attrs.height, et = z !== l && z !== void 0, ut = j !== l && j !== void 0, ft = this.padding(), gt = z - ft * 2, Mt = j - ft * 2, xt = 0, mt = this.wrap(), ee = mt !== N, Pt = mt !== O && ee, zt = this.ellipsis();
      this.textArr = [], U().font = this._getContextFont();
      const gr = zt ? this._getTextWidth(H) : 0;
      for (let Zt = 0, Jt = Z.length; Zt < Jt; ++Zt) {
        let Ut = Z[Zt], He = this._getTextWidth(Ut);
        if (et && He > gt)
          for (; Ut.length > 0; ) {
            let ie = 0, ze = Ut.length, Wt = "", ne = 0;
            for (; ie < ze; ) {
              const Fe = ie + ze >>> 1, pe = Ut.slice(0, Fe + 1), $e = this._getTextWidth(pe) + gr;
              $e <= gt ? (ie = Fe + 1, Wt = pe, ne = $e) : ze = Fe;
            }
            if (Wt) {
              if (Pt) {
                var re;
                const pe = Ut[Wt.length];
                (pe === T || pe === v) && ne <= gt ? re = Wt.length : re = Math.max(Wt.lastIndexOf(T), Wt.lastIndexOf(v)) + 1, re > 0 && (ie = re, Wt = Wt.slice(0, ie), ne = this._getTextWidth(Wt));
              }
              if (Wt = Wt.trimRight(), this._addTextLine(Wt), ht = Math.max(ht, ne), xt += ct, this._shouldHandleEllipsis(xt)) {
                this._tryToAddEllipsisToLastLine();
                break;
              }
              if (Ut = Ut.slice(ie), Ut = Ut.trimLeft(), Ut.length > 0 && (He = this._getTextWidth(Ut), He <= gt)) {
                this._addTextLine(Ut), xt += ct, ht = Math.max(ht, He);
                break;
              }
            } else
              break;
          }
        else
          this._addTextLine(Ut), xt += ct, ht = Math.max(ht, He), this._shouldHandleEllipsis(xt) && Zt < Jt - 1 && this._tryToAddEllipsisToLastLine();
        if (this.textArr[this.textArr.length - 1] && (this.textArr[this.textArr.length - 1].lastInParagraph = !0), ut && xt + ct > Mt)
          break;
      }
      this.textHeight = at, this.textWidth = ht;
    }
    _shouldHandleEllipsis(Z) {
      const at = +this.fontSize(), ht = this.lineHeight() * at, ct = this.attrs.height, z = ct !== l && ct !== void 0, j = this.padding(), et = ct - j * 2;
      return !(this.wrap() !== N) || z && Z + ht > et;
    }
    _tryToAddEllipsisToLastLine() {
      const Z = this.attrs.width, at = Z !== l && Z !== void 0, ht = this.padding(), ct = Z - ht * 2, z = this.ellipsis(), j = this.textArr[this.textArr.length - 1];
      !j || !z || (at && (this._getTextWidth(j.text + H) < ct || (j.text = j.text.slice(0, j.text.length - 3))), this.textArr.splice(this.textArr.length - 1, 1), this._addTextLine(j.text + H));
    }
    getStrokeScaleEnabled() {
      return !0;
    }
    _useBufferCanvas() {
      const Z = this.textDecoration().indexOf("underline") !== -1 || this.textDecoration().indexOf("line-through") !== -1, at = this.hasShadow();
      return Z && at ? !0 : super._useBufferCanvas();
    }
  };
  return Qr.Text = Q, Q.prototype._fillFunc = K, Q.prototype._strokeFunc = $, Q.prototype.className = x, Q.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "padding",
    "wrap",
    "lineHeight",
    "letterSpacing"
  ], (0, s._registerNode)(Q), a.Factory.overWriteSetter(Q, "width", (0, u.getNumberOrAutoValidator)()), a.Factory.overWriteSetter(Q, "height", (0, u.getNumberOrAutoValidator)()), a.Factory.addGetterSetter(Q, "direction", p), a.Factory.addGetterSetter(Q, "fontFamily", "Arial"), a.Factory.addGetterSetter(Q, "fontSize", 12, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(Q, "fontStyle", S), a.Factory.addGetterSetter(Q, "fontVariant", S), a.Factory.addGetterSetter(Q, "padding", 0, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(Q, "align", _), a.Factory.addGetterSetter(Q, "verticalAlign", P), a.Factory.addGetterSetter(Q, "lineHeight", 1, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(Q, "wrap", M), a.Factory.addGetterSetter(Q, "ellipsis", !1, (0, u.getBooleanValidator)()), a.Factory.addGetterSetter(Q, "letterSpacing", 0, (0, u.getNumberValidator)()), a.Factory.addGetterSetter(Q, "text", "", (0, u.getStringValidator)()), a.Factory.addGetterSetter(Q, "textDecoration", ""), Qr;
}
var Vi = {}, dd;
function y6() {
  if (dd) return Vi;
  dd = 1, Object.defineProperty(Vi, "__esModule", { value: !0 }), Vi.TextPath = void 0;
  const r = Kt(), a = Tt(), n = se(), o = Qh(), u = e1(), s = Ot(), h = At(), l = "", g = "normal";
  function p(C) {
    C.fillText(this.partialText, 0, 0);
  }
  function b(C) {
    C.strokeText(this.partialText, 0, 0);
  }
  let m = class extends n.Shape {
    constructor(v) {
      super(v), this.dummyCanvas = r.Util.createCanvasElement(), this.dataArray = [], this._readDataAttribute(), this.on("dataChange.konva", function() {
        this._readDataAttribute(), this._setTextData();
      }), this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData), this._setTextData();
    }
    _getTextPathLength() {
      return o.Path.getPathLength(this.dataArray);
    }
    _getPointAtLength(v) {
      if (!this.attrs.data)
        return null;
      const _ = this.pathLength;
      return v - 1 > _ ? null : o.Path.getPointAtLengthOfDataArray(v, this.dataArray);
    }
    _readDataAttribute() {
      this.dataArray = o.Path.parsePathData(this.attrs.data), this.pathLength = this._getTextPathLength();
    }
    _sceneFunc(v) {
      v.setAttr("font", this._getContextFont()), v.setAttr("textBaseline", this.textBaseline()), v.setAttr("textAlign", "left"), v.save();
      const _ = this.textDecoration(), w = this.fill(), x = this.fontSize(), P = this.glyphInfo;
      _ === "underline" && v.beginPath();
      for (let c = 0; c < P.length; c++) {
        v.save();
        const f = P[c].p0;
        v.translate(f.x, f.y), v.rotate(P[c].rotation), this.partialText = P[c].text, v.fillStrokeShape(this), _ === "underline" && (c === 0 && v.moveTo(0, x / 2 + 1), v.lineTo(x, x / 2 + 1)), v.restore();
      }
      _ === "underline" && (v.strokeStyle = w, v.lineWidth = x / 20, v.stroke()), v.restore();
    }
    _hitFunc(v) {
      v.beginPath();
      const _ = this.glyphInfo;
      if (_.length >= 1) {
        const w = _[0].p0;
        v.moveTo(w.x, w.y);
      }
      for (let w = 0; w < _.length; w++) {
        const x = _[w].p1;
        v.lineTo(x.x, x.y);
      }
      v.setAttr("lineWidth", this.fontSize()), v.setAttr("strokeStyle", this.colorKey), v.stroke();
    }
    getTextWidth() {
      return this.textWidth;
    }
    getTextHeight() {
      return r.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
    }
    setText(v) {
      return u.Text.prototype.setText.call(this, v);
    }
    _getContextFont() {
      return u.Text.prototype._getContextFont.call(this);
    }
    _getTextSize(v) {
      const w = this.dummyCanvas.getContext("2d");
      w.save(), w.font = this._getContextFont();
      const x = w.measureText(v);
      return w.restore(), {
        width: x.width,
        height: parseInt(`${this.fontSize()}`, 10)
      };
    }
    _setTextData() {
      const { width: v, height: _ } = this._getTextSize(this.attrs.text);
      if (this.textWidth = v, this.textHeight = _, this.glyphInfo = [], !this.attrs.data)
        return null;
      const w = this.letterSpacing(), x = this.align(), P = this.kerningFunc(), c = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * w, 0);
      let f = 0;
      x === "center" && (f = Math.max(0, this.pathLength / 2 - c / 2)), x === "right" && (f = Math.max(0, this.pathLength - c));
      const S = (0, u.stringToArray)(this.text());
      let E = f;
      for (let T = 0; T < S.length; T++) {
        const D = this._getPointAtLength(E);
        if (!D)
          return;
        let I = this._getTextSize(S[T]).width + w;
        if (S[T] === " " && x === "justify") {
          const F = this.text().split(" ").length - 1;
          I += (this.pathLength - c) / F;
        }
        const M = this._getPointAtLength(E + I);
        if (!M)
          return;
        const O = o.Path.getLineLength(D.x, D.y, M.x, M.y);
        let N = 0;
        if (P)
          try {
            N = P(S[T - 1], S[T]) * this.fontSize();
          } catch {
            N = 0;
          }
        D.x += N, M.x += N, this.textWidth += N;
        const H = o.Path.getPointOnLine(N + O / 2, D.x, D.y, M.x, M.y), y = Math.atan2(M.y - D.y, M.x - D.x);
        this.glyphInfo.push({
          transposeX: H.x,
          transposeY: H.y,
          text: S[T],
          rotation: y,
          p0: D,
          p1: M
        }), E += I;
      }
    }
    getSelfRect() {
      if (!this.glyphInfo.length)
        return {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      const v = [];
      this.glyphInfo.forEach(function(E) {
        v.push(E.p0.x), v.push(E.p0.y), v.push(E.p1.x), v.push(E.p1.y);
      });
      let _ = v[0] || 0, w = v[0] || 0, x = v[1] || 0, P = v[1] || 0, c, f;
      for (let E = 0; E < v.length / 2; E++)
        c = v[E * 2], f = v[E * 2 + 1], _ = Math.min(_, c), w = Math.max(w, c), x = Math.min(x, f), P = Math.max(P, f);
      const S = this.fontSize();
      return {
        x: _ - S / 2,
        y: x - S / 2,
        width: w - _ + S,
        height: P - x + S
      };
    }
    destroy() {
      return r.Util.releaseCanvas(this.dummyCanvas), super.destroy();
    }
  };
  return Vi.TextPath = m, m.prototype._fillFunc = p, m.prototype._strokeFunc = b, m.prototype._fillFuncHit = p, m.prototype._strokeFuncHit = b, m.prototype.className = "TextPath", m.prototype._attrsAffectingSize = ["text", "fontSize", "data"], (0, h._registerNode)(m), a.Factory.addGetterSetter(m, "data"), a.Factory.addGetterSetter(m, "fontFamily", "Arial"), a.Factory.addGetterSetter(m, "fontSize", 12, (0, s.getNumberValidator)()), a.Factory.addGetterSetter(m, "fontStyle", g), a.Factory.addGetterSetter(m, "align", "left"), a.Factory.addGetterSetter(m, "letterSpacing", 0, (0, s.getNumberValidator)()), a.Factory.addGetterSetter(m, "textBaseline", "middle"), a.Factory.addGetterSetter(m, "fontVariant", g), a.Factory.addGetterSetter(m, "text", l), a.Factory.addGetterSetter(m, "textDecoration", null), a.Factory.addGetterSetter(m, "kerningFunc", null), Vi;
}
var Wi = {}, fd;
function m6() {
  if (fd) return Wi;
  fd = 1, Object.defineProperty(Wi, "__esModule", { value: !0 }), Wi.Transformer = void 0;
  const r = Kt(), a = Tt(), n = $t(), o = se(), u = t1(), s = Zh(), h = At(), l = Ot(), g = At(), p = "tr-konva", b = [
    "resizeEnabledChange",
    "rotateAnchorOffsetChange",
    "rotateEnabledChange",
    "enabledAnchorsChange",
    "anchorSizeChange",
    "borderEnabledChange",
    "borderStrokeChange",
    "borderStrokeWidthChange",
    "borderDashChange",
    "anchorStrokeChange",
    "anchorStrokeWidthChange",
    "anchorFillChange",
    "anchorCornerRadiusChange",
    "ignoreStrokeChange",
    "anchorStyleFuncChange"
  ].map((I) => I + `.${p}`).join(" "), m = "nodesRect", C = [
    "widthChange",
    "heightChange",
    "scaleXChange",
    "scaleYChange",
    "skewXChange",
    "skewYChange",
    "rotationChange",
    "offsetXChange",
    "offsetYChange",
    "transformsEnabledChange",
    "strokeWidthChange"
  ], v = {
    "top-left": -45,
    "top-center": 0,
    "top-right": 45,
    "middle-right": -90,
    "middle-left": 90,
    "bottom-left": -135,
    "bottom-center": 180,
    "bottom-right": 135
  }, _ = "ontouchstart" in h.Konva._global;
  function w(I, M, O) {
    if (I === "rotater")
      return O;
    M += r.Util.degToRad(v[I] || 0);
    const N = (r.Util.radToDeg(M) % 360 + 360) % 360;
    return r.Util._inRange(N, 315 + 22.5, 360) || r.Util._inRange(N, 0, 22.5) ? "ns-resize" : r.Util._inRange(N, 45 - 22.5, 45 + 22.5) ? "nesw-resize" : r.Util._inRange(N, 90 - 22.5, 90 + 22.5) ? "ew-resize" : r.Util._inRange(N, 135 - 22.5, 135 + 22.5) ? "nwse-resize" : r.Util._inRange(N, 180 - 22.5, 180 + 22.5) ? "ns-resize" : r.Util._inRange(N, 225 - 22.5, 225 + 22.5) ? "nesw-resize" : r.Util._inRange(N, 270 - 22.5, 270 + 22.5) ? "ew-resize" : r.Util._inRange(N, 315 - 22.5, 315 + 22.5) ? "nwse-resize" : (r.Util.error("Transformer has unknown angle for cursor detection: " + N), "pointer");
  }
  const x = [
    "top-left",
    "top-center",
    "top-right",
    "middle-right",
    "middle-left",
    "bottom-left",
    "bottom-center",
    "bottom-right"
  ];
  function P(I) {
    return {
      x: I.x + I.width / 2 * Math.cos(I.rotation) + I.height / 2 * Math.sin(-I.rotation),
      y: I.y + I.height / 2 * Math.cos(I.rotation) + I.width / 2 * Math.sin(I.rotation)
    };
  }
  function c(I, M, O) {
    const N = O.x + (I.x - O.x) * Math.cos(M) - (I.y - O.y) * Math.sin(M), H = O.y + (I.x - O.x) * Math.sin(M) + (I.y - O.y) * Math.cos(M);
    return {
      ...I,
      rotation: I.rotation + M,
      x: N,
      y: H
    };
  }
  function f(I, M) {
    const O = P(I);
    return c(I, M, O);
  }
  function S(I, M, O) {
    let N = M;
    for (let H = 0; H < I.length; H++) {
      const y = h.Konva.getAngle(I[H]), F = Math.abs(y - M) % (Math.PI * 2);
      Math.min(F, Math.PI * 2 - F) < O && (N = y);
    }
    return N;
  }
  let E = 0, T = class extends s.Group {
    constructor(M) {
      super(M), this._movingAnchorName = null, this._transforming = !1, this._createElements(), this._handleMouseMove = this._handleMouseMove.bind(this), this._handleMouseUp = this._handleMouseUp.bind(this), this.update = this.update.bind(this), this.on(b, this.update), this.getNode() && this.update();
    }
    attachTo(M) {
      return this.setNode(M), this;
    }
    setNode(M) {
      return r.Util.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead."), this.setNodes([M]);
    }
    getNode() {
      return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
      return p + this._id;
    }
    setNodes(M = []) {
      this._nodes && this._nodes.length && this.detach();
      const O = M.filter((H) => H.isAncestorOf(this) ? (r.Util.error("Konva.Transformer cannot be an a child of the node you are trying to attach"), !1) : !0);
      return this._nodes = M = O, M.length === 1 && this.useSingleNodeRotation() ? this.rotation(M[0].getAbsoluteRotation()) : this.rotation(0), this._nodes.forEach((H) => {
        const y = () => {
          this.nodes().length === 1 && this.useSingleNodeRotation() && this.rotation(this.nodes()[0].getAbsoluteRotation()), this._resetTransformCache(), !this._transforming && !this.isDragging() && this.update();
        }, F = H._attrsAffectingSize.map((R) => R + "Change." + this._getEventNamespace()).join(" ");
        H.on(F, y), H.on(C.map((R) => R + `.${this._getEventNamespace()}`).join(" "), y), H.on(`absoluteTransformChange.${this._getEventNamespace()}`, y), this._proxyDrag(H);
      }), this._resetTransformCache(), !!this.findOne(".top-left") && this.update(), this;
    }
    _proxyDrag(M) {
      let O;
      M.on(`dragstart.${this._getEventNamespace()}`, (N) => {
        O = M.getAbsolutePosition(), !this.isDragging() && M !== this.findOne(".back") && this.startDrag(N, !1);
      }), M.on(`dragmove.${this._getEventNamespace()}`, (N) => {
        if (!O)
          return;
        const H = M.getAbsolutePosition(), y = H.x - O.x, F = H.y - O.y;
        this.nodes().forEach((R) => {
          if (R === M || R.isDragging())
            return;
          const G = R.getAbsolutePosition();
          R.setAbsolutePosition({
            x: G.x + y,
            y: G.y + F
          }), R.startDrag(N);
        }), O = null;
      });
    }
    getNodes() {
      return this._nodes || [];
    }
    getActiveAnchor() {
      return this._movingAnchorName;
    }
    detach() {
      this._nodes && this._nodes.forEach((M) => {
        M.off("." + this._getEventNamespace());
      }), this._nodes = [], this._resetTransformCache();
    }
    _resetTransformCache() {
      this._clearCache(m), this._clearCache("transform"), this._clearSelfAndDescendantCache("absoluteTransform");
    }
    _getNodeRect() {
      return this._getCache(m, this.__getNodeRect);
    }
    __getNodeShape(M, O = this.rotation(), N) {
      const H = M.getClientRect({
        skipTransform: !0,
        skipShadow: !0,
        skipStroke: this.ignoreStroke()
      }), y = M.getAbsoluteScale(N), F = M.getAbsolutePosition(N), R = H.x * y.x - M.offsetX() * y.x, G = H.y * y.y - M.offsetY() * y.y, U = (h.Konva.getAngle(M.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2), K = {
        x: F.x + R * Math.cos(U) + G * Math.sin(-U),
        y: F.y + G * Math.cos(U) + R * Math.sin(U),
        width: H.width * y.x,
        height: H.height * y.y,
        rotation: U
      };
      return c(K, -h.Konva.getAngle(O), {
        x: 0,
        y: 0
      });
    }
    __getNodeRect() {
      if (!this.getNode())
        return {
          x: -1e8,
          y: -1e8,
          width: 0,
          height: 0,
          rotation: 0
        };
      const O = [];
      this.nodes().map((U) => {
        const K = U.getClientRect({
          skipTransform: !0,
          skipShadow: !0,
          skipStroke: this.ignoreStroke()
        }), $ = [
          { x: K.x, y: K.y },
          { x: K.x + K.width, y: K.y },
          { x: K.x + K.width, y: K.y + K.height },
          { x: K.x, y: K.y + K.height }
        ], X = U.getAbsoluteTransform();
        $.forEach(function(Q) {
          const st = X.point(Q);
          O.push(st);
        });
      });
      const N = new r.Transform();
      N.rotate(-h.Konva.getAngle(this.rotation()));
      let H = 1 / 0, y = 1 / 0, F = -1 / 0, R = -1 / 0;
      O.forEach(function(U) {
        const K = N.point(U);
        H === void 0 && (H = F = K.x, y = R = K.y), H = Math.min(H, K.x), y = Math.min(y, K.y), F = Math.max(F, K.x), R = Math.max(R, K.y);
      }), N.invert();
      const G = N.point({ x: H, y });
      return {
        x: G.x,
        y: G.y,
        width: F - H,
        height: R - y,
        rotation: h.Konva.getAngle(this.rotation())
      };
    }
    getX() {
      return this._getNodeRect().x;
    }
    getY() {
      return this._getNodeRect().y;
    }
    getWidth() {
      return this._getNodeRect().width;
    }
    getHeight() {
      return this._getNodeRect().height;
    }
    _createElements() {
      this._createBack(), x.forEach((M) => {
        this._createAnchor(M);
      }), this._createAnchor("rotater");
    }
    _createAnchor(M) {
      const O = new u.Rect({
        stroke: "rgb(0, 161, 255)",
        fill: "white",
        strokeWidth: 1,
        name: M + " _anchor",
        dragDistance: 0,
        draggable: !0,
        hitStrokeWidth: _ ? 10 : "auto"
      }), N = this;
      O.on("mousedown touchstart", function(H) {
        N._handleMouseDown(H);
      }), O.on("dragstart", (H) => {
        O.stopDrag(), H.cancelBubble = !0;
      }), O.on("dragend", (H) => {
        H.cancelBubble = !0;
      }), O.on("mouseenter", () => {
        const H = h.Konva.getAngle(this.rotation()), y = this.rotateAnchorCursor(), F = w(M, H, y);
        O.getStage().content && (O.getStage().content.style.cursor = F), this._cursorChange = !0;
      }), O.on("mouseout", () => {
        O.getStage().content && (O.getStage().content.style.cursor = ""), this._cursorChange = !1;
      }), this.add(O);
    }
    _createBack() {
      const M = new o.Shape({
        name: "back",
        width: 0,
        height: 0,
        draggable: !0,
        sceneFunc(O, N) {
          const H = N.getParent(), y = H.padding();
          O.beginPath(), O.rect(-y, -y, N.width() + y * 2, N.height() + y * 2), O.moveTo(N.width() / 2, -y), H.rotateEnabled() && H.rotateLineVisible() && O.lineTo(N.width() / 2, -H.rotateAnchorOffset() * r.Util._sign(N.height()) - y), O.fillStrokeShape(N);
        },
        hitFunc: (O, N) => {
          if (!this.shouldOverdrawWholeArea())
            return;
          const H = this.padding();
          O.beginPath(), O.rect(-H, -H, N.width() + H * 2, N.height() + H * 2), O.fillStrokeShape(N);
        }
      });
      this.add(M), this._proxyDrag(M), M.on("dragstart", (O) => {
        O.cancelBubble = !0;
      }), M.on("dragmove", (O) => {
        O.cancelBubble = !0;
      }), M.on("dragend", (O) => {
        O.cancelBubble = !0;
      }), this.on("dragmove", (O) => {
        this.update();
      });
    }
    _handleMouseDown(M) {
      if (this._transforming)
        return;
      this._movingAnchorName = M.target.name().split(" ")[0];
      const O = this._getNodeRect(), N = O.width, H = O.height, y = Math.sqrt(Math.pow(N, 2) + Math.pow(H, 2));
      this.sin = Math.abs(H / y), this.cos = Math.abs(N / y), typeof window != "undefined" && (window.addEventListener("mousemove", this._handleMouseMove), window.addEventListener("touchmove", this._handleMouseMove), window.addEventListener("mouseup", this._handleMouseUp, !0), window.addEventListener("touchend", this._handleMouseUp, !0)), this._transforming = !0;
      const F = M.target.getAbsolutePosition(), R = M.target.getStage().getPointerPosition();
      this._anchorDragOffset = {
        x: R.x - F.x,
        y: R.y - F.y
      }, E++, this._fire("transformstart", { evt: M.evt, target: this.getNode() }), this._nodes.forEach((G) => {
        G._fire("transformstart", { evt: M.evt, target: G });
      });
    }
    _handleMouseMove(M) {
      let O, N, H;
      const y = this.findOne("." + this._movingAnchorName), F = y.getStage();
      F.setPointersPositions(M);
      const R = F.getPointerPosition();
      let G = {
        x: R.x - this._anchorDragOffset.x,
        y: R.y - this._anchorDragOffset.y
      };
      const U = y.getAbsolutePosition();
      this.anchorDragBoundFunc() && (G = this.anchorDragBoundFunc()(U, G, M)), y.setAbsolutePosition(G);
      const K = y.getAbsolutePosition();
      if (U.x === K.x && U.y === K.y)
        return;
      if (this._movingAnchorName === "rotater") {
        const et = this._getNodeRect();
        O = y.x() - et.width / 2, N = -y.y() + et.height / 2;
        let ut = Math.atan2(-N, O) + Math.PI / 2;
        et.height < 0 && (ut -= Math.PI);
        const gt = h.Konva.getAngle(this.rotation()) + ut, Mt = h.Konva.getAngle(this.rotationSnapTolerance()), mt = S(this.rotationSnaps(), gt, Mt) - et.rotation, ee = f(et, mt);
        this._fitNodesInto(ee, M);
        return;
      }
      const $ = this.shiftBehavior();
      let X;
      $ === "inverted" ? X = this.keepRatio() && !M.shiftKey : $ === "none" ? X = this.keepRatio() : X = this.keepRatio() || M.shiftKey;
      var ht = this.centeredScaling() || M.altKey;
      if (this._movingAnchorName === "top-left") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-right").x(),
            y: this.findOne(".bottom-right").y()
          };
          H = Math.sqrt(Math.pow(Q.x - y.x(), 2) + Math.pow(Q.y - y.y(), 2));
          var st = this.findOne(".top-left").x() > Q.x ? -1 : 1, Z = this.findOne(".top-left").y() > Q.y ? -1 : 1;
          O = H * this.cos * st, N = H * this.sin * Z, this.findOne(".top-left").x(Q.x - O), this.findOne(".top-left").y(Q.y - N);
        }
      } else if (this._movingAnchorName === "top-center")
        this.findOne(".top-left").y(y.y());
      else if (this._movingAnchorName === "top-right") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-left").x(),
            y: this.findOne(".bottom-left").y()
          };
          H = Math.sqrt(Math.pow(y.x() - Q.x, 2) + Math.pow(Q.y - y.y(), 2));
          var st = this.findOne(".top-right").x() < Q.x ? -1 : 1, Z = this.findOne(".top-right").y() > Q.y ? -1 : 1;
          O = H * this.cos * st, N = H * this.sin * Z, this.findOne(".top-right").x(Q.x + O), this.findOne(".top-right").y(Q.y - N);
        }
        var at = y.position();
        this.findOne(".top-left").y(at.y), this.findOne(".bottom-right").x(at.x);
      } else if (this._movingAnchorName === "middle-left")
        this.findOne(".top-left").x(y.x());
      else if (this._movingAnchorName === "middle-right")
        this.findOne(".bottom-right").x(y.x());
      else if (this._movingAnchorName === "bottom-left") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-right").x(),
            y: this.findOne(".top-right").y()
          };
          H = Math.sqrt(Math.pow(Q.x - y.x(), 2) + Math.pow(y.y() - Q.y, 2));
          var st = Q.x < y.x() ? -1 : 1, Z = y.y() < Q.y ? -1 : 1;
          O = H * this.cos * st, N = H * this.sin * Z, y.x(Q.x - O), y.y(Q.y + N);
        }
        at = y.position(), this.findOne(".top-left").x(at.x), this.findOne(".bottom-right").y(at.y);
      } else if (this._movingAnchorName === "bottom-center")
        this.findOne(".bottom-right").y(y.y());
      else if (this._movingAnchorName === "bottom-right") {
        if (X) {
          var Q = ht ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-left").x(),
            y: this.findOne(".top-left").y()
          };
          H = Math.sqrt(Math.pow(y.x() - Q.x, 2) + Math.pow(y.y() - Q.y, 2));
          var st = this.findOne(".bottom-right").x() < Q.x ? -1 : 1, Z = this.findOne(".bottom-right").y() < Q.y ? -1 : 1;
          O = H * this.cos * st, N = H * this.sin * Z, this.findOne(".bottom-right").x(Q.x + O), this.findOne(".bottom-right").y(Q.y + N);
        }
      } else
        console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
      var ht = this.centeredScaling() || M.altKey;
      if (ht) {
        const et = this.findOne(".top-left"), ut = this.findOne(".bottom-right"), ft = et.x(), gt = et.y(), Mt = this.getWidth() - ut.x(), xt = this.getHeight() - ut.y();
        ut.move({
          x: -ft,
          y: -gt
        }), et.move({
          x: Mt,
          y: xt
        });
      }
      const ct = this.findOne(".top-left").getAbsolutePosition();
      O = ct.x, N = ct.y;
      const z = this.findOne(".bottom-right").x() - this.findOne(".top-left").x(), j = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
      this._fitNodesInto({
        x: O,
        y: N,
        width: z,
        height: j,
        rotation: h.Konva.getAngle(this.rotation())
      }, M);
    }
    _handleMouseUp(M) {
      this._removeEvents(M);
    }
    getAbsoluteTransform() {
      return this.getTransform();
    }
    _removeEvents(M) {
      var O;
      if (this._transforming) {
        this._transforming = !1, typeof window != "undefined" && (window.removeEventListener("mousemove", this._handleMouseMove), window.removeEventListener("touchmove", this._handleMouseMove), window.removeEventListener("mouseup", this._handleMouseUp, !0), window.removeEventListener("touchend", this._handleMouseUp, !0));
        const N = this.getNode();
        E--, this._fire("transformend", { evt: M, target: N }), (O = this.getLayer()) === null || O === void 0 || O.batchDraw(), N && this._nodes.forEach((H) => {
          var y;
          H._fire("transformend", { evt: M, target: H }), (y = H.getLayer()) === null || y === void 0 || y.batchDraw();
        }), this._movingAnchorName = null;
      }
    }
    _fitNodesInto(M, O) {
      const N = this._getNodeRect(), H = 1;
      if (r.Util._inRange(M.width, -this.padding() * 2 - H, H)) {
        this.update();
        return;
      }
      if (r.Util._inRange(M.height, -this.padding() * 2 - H, H)) {
        this.update();
        return;
      }
      const y = new r.Transform();
      if (y.rotate(h.Konva.getAngle(this.rotation())), this._movingAnchorName && M.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
        const X = y.point({
          x: -this.padding() * 2,
          y: 0
        });
        M.x += X.x, M.y += X.y, M.width += this.padding() * 2, this._movingAnchorName = this._movingAnchorName.replace("left", "right"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y;
      } else if (this._movingAnchorName && M.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
        const X = y.point({
          x: this.padding() * 2,
          y: 0
        });
        this._movingAnchorName = this._movingAnchorName.replace("right", "left"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y, M.width += this.padding() * 2;
      }
      if (this._movingAnchorName && M.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
        const X = y.point({
          x: 0,
          y: -this.padding() * 2
        });
        M.x += X.x, M.y += X.y, this._movingAnchorName = this._movingAnchorName.replace("top", "bottom"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y, M.height += this.padding() * 2;
      } else if (this._movingAnchorName && M.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
        const X = y.point({
          x: 0,
          y: this.padding() * 2
        });
        this._movingAnchorName = this._movingAnchorName.replace("bottom", "top"), this._anchorDragOffset.x -= X.x, this._anchorDragOffset.y -= X.y, M.height += this.padding() * 2;
      }
      if (this.boundBoxFunc()) {
        const X = this.boundBoxFunc()(N, M);
        X ? M = X : r.Util.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
      }
      const F = 1e7, R = new r.Transform();
      R.translate(N.x, N.y), R.rotate(N.rotation), R.scale(N.width / F, N.height / F);
      const G = new r.Transform(), U = M.width / F, K = M.height / F;
      this.flipEnabled() === !1 ? (G.translate(M.x, M.y), G.rotate(M.rotation), G.translate(M.width < 0 ? M.width : 0, M.height < 0 ? M.height : 0), G.scale(Math.abs(U), Math.abs(K))) : (G.translate(M.x, M.y), G.rotate(M.rotation), G.scale(U, K));
      const $ = G.multiply(R.invert());
      this._nodes.forEach((X) => {
        var Q;
        const st = X.getParent().getAbsoluteTransform(), Z = X.getTransform().copy();
        Z.translate(X.offsetX(), X.offsetY());
        const at = new r.Transform();
        at.multiply(st.copy().invert()).multiply($).multiply(st).multiply(Z);
        const ht = at.decompose();
        X.setAttrs(ht), (Q = X.getLayer()) === null || Q === void 0 || Q.batchDraw();
      }), this.rotation(r.Util._getRotation(M.rotation)), this._nodes.forEach((X) => {
        this._fire("transform", { evt: O, target: X }), X._fire("transform", { evt: O, target: X });
      }), this._resetTransformCache(), this.update(), this.getLayer().batchDraw();
    }
    forceUpdate() {
      this._resetTransformCache(), this.update();
    }
    _batchChangeChild(M, O) {
      this.findOne(M).setAttrs(O);
    }
    update() {
      var M;
      const O = this._getNodeRect();
      this.rotation(r.Util._getRotation(O.rotation));
      const N = O.width, H = O.height, y = this.enabledAnchors(), F = this.resizeEnabled(), R = this.padding(), G = this.anchorSize(), U = this.find("._anchor");
      U.forEach(($) => {
        $.setAttrs({
          width: G,
          height: G,
          offsetX: G / 2,
          offsetY: G / 2,
          stroke: this.anchorStroke(),
          strokeWidth: this.anchorStrokeWidth(),
          fill: this.anchorFill(),
          cornerRadius: this.anchorCornerRadius()
        });
      }), this._batchChangeChild(".top-left", {
        x: 0,
        y: 0,
        offsetX: G / 2 + R,
        offsetY: G / 2 + R,
        visible: F && y.indexOf("top-left") >= 0
      }), this._batchChangeChild(".top-center", {
        x: N / 2,
        y: 0,
        offsetY: G / 2 + R,
        visible: F && y.indexOf("top-center") >= 0
      }), this._batchChangeChild(".top-right", {
        x: N,
        y: 0,
        offsetX: G / 2 - R,
        offsetY: G / 2 + R,
        visible: F && y.indexOf("top-right") >= 0
      }), this._batchChangeChild(".middle-left", {
        x: 0,
        y: H / 2,
        offsetX: G / 2 + R,
        visible: F && y.indexOf("middle-left") >= 0
      }), this._batchChangeChild(".middle-right", {
        x: N,
        y: H / 2,
        offsetX: G / 2 - R,
        visible: F && y.indexOf("middle-right") >= 0
      }), this._batchChangeChild(".bottom-left", {
        x: 0,
        y: H,
        offsetX: G / 2 + R,
        offsetY: G / 2 - R,
        visible: F && y.indexOf("bottom-left") >= 0
      }), this._batchChangeChild(".bottom-center", {
        x: N / 2,
        y: H,
        offsetY: G / 2 - R,
        visible: F && y.indexOf("bottom-center") >= 0
      }), this._batchChangeChild(".bottom-right", {
        x: N,
        y: H,
        offsetX: G / 2 - R,
        offsetY: G / 2 - R,
        visible: F && y.indexOf("bottom-right") >= 0
      }), this._batchChangeChild(".rotater", {
        x: N / 2,
        y: -this.rotateAnchorOffset() * r.Util._sign(H) - R,
        visible: this.rotateEnabled()
      }), this._batchChangeChild(".back", {
        width: N,
        height: H,
        visible: this.borderEnabled(),
        stroke: this.borderStroke(),
        strokeWidth: this.borderStrokeWidth(),
        dash: this.borderDash(),
        x: 0,
        y: 0
      });
      const K = this.anchorStyleFunc();
      K && U.forEach(($) => {
        K($);
      }), (M = this.getLayer()) === null || M === void 0 || M.batchDraw();
    }
    isTransforming() {
      return this._transforming;
    }
    stopTransform() {
      if (this._transforming) {
        this._removeEvents();
        const M = this.findOne("." + this._movingAnchorName);
        M && M.stopDrag();
      }
    }
    destroy() {
      return this.getStage() && this._cursorChange && this.getStage().content && (this.getStage().content.style.cursor = ""), s.Group.prototype.destroy.call(this), this.detach(), this._removeEvents(), this;
    }
    toObject() {
      return n.Node.prototype.toObject.call(this);
    }
    clone(M) {
      return n.Node.prototype.clone.call(this, M);
    }
    getClientRect() {
      return this.nodes().length > 0 ? super.getClientRect() : { x: 0, y: 0, width: 0, height: 0 };
    }
  };
  Wi.Transformer = T, T.isTransforming = () => E > 0;
  function D(I) {
    return I instanceof Array || r.Util.warn("enabledAnchors value should be an array"), I instanceof Array && I.forEach(function(M) {
      x.indexOf(M) === -1 && r.Util.warn("Unknown anchor name: " + M + ". Available names are: " + x.join(", "));
    }), I || [];
  }
  return T.prototype.className = "Transformer", (0, g._registerNode)(T), a.Factory.addGetterSetter(T, "enabledAnchors", x, D), a.Factory.addGetterSetter(T, "flipEnabled", !0, (0, l.getBooleanValidator)()), a.Factory.addGetterSetter(T, "resizeEnabled", !0), a.Factory.addGetterSetter(T, "anchorSize", 10, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "rotateEnabled", !0), a.Factory.addGetterSetter(T, "rotateLineVisible", !0), a.Factory.addGetterSetter(T, "rotationSnaps", []), a.Factory.addGetterSetter(T, "rotateAnchorOffset", 50, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "rotateAnchorCursor", "crosshair"), a.Factory.addGetterSetter(T, "rotationSnapTolerance", 5, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "borderEnabled", !0), a.Factory.addGetterSetter(T, "anchorStroke", "rgb(0, 161, 255)"), a.Factory.addGetterSetter(T, "anchorStrokeWidth", 1, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "anchorFill", "white"), a.Factory.addGetterSetter(T, "anchorCornerRadius", 0, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "borderStroke", "rgb(0, 161, 255)"), a.Factory.addGetterSetter(T, "borderStrokeWidth", 1, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "borderDash"), a.Factory.addGetterSetter(T, "keepRatio", !0), a.Factory.addGetterSetter(T, "shiftBehavior", "default"), a.Factory.addGetterSetter(T, "centeredScaling", !1), a.Factory.addGetterSetter(T, "ignoreStroke", !1), a.Factory.addGetterSetter(T, "padding", 0, (0, l.getNumberValidator)()), a.Factory.addGetterSetter(T, "node"), a.Factory.addGetterSetter(T, "nodes"), a.Factory.addGetterSetter(T, "boundBoxFunc"), a.Factory.addGetterSetter(T, "anchorDragBoundFunc"), a.Factory.addGetterSetter(T, "anchorStyleFunc"), a.Factory.addGetterSetter(T, "shouldOverdrawWholeArea", !1), a.Factory.addGetterSetter(T, "useSingleNodeRotation", !0), a.Factory.backCompat(T, {
    lineEnabled: "borderEnabled",
    rotateHandlerOffset: "rotateAnchorOffset",
    enabledHandlers: "enabledAnchors"
  }), Wi;
}
var ji = {}, gd;
function b6() {
  if (gd) return ji;
  gd = 1, Object.defineProperty(ji, "__esModule", { value: !0 }), ji.Wedge = void 0;
  const r = Tt(), a = se(), n = At(), o = Ot(), u = At();
  let s = class extends a.Shape {
    _sceneFunc(l) {
      l.beginPath(), l.arc(0, 0, this.radius(), 0, n.Konva.getAngle(this.angle()), this.clockwise()), l.lineTo(0, 0), l.closePath(), l.fillStrokeShape(this);
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(l) {
      this.radius(l / 2);
    }
    setHeight(l) {
      this.radius(l / 2);
    }
  };
  return ji.Wedge = s, s.prototype.className = "Wedge", s.prototype._centroid = !0, s.prototype._attrsAffectingSize = ["radius"], (0, u._registerNode)(s), r.Factory.addGetterSetter(s, "radius", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "angle", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(s, "clockwise", !1), r.Factory.backCompat(s, {
    angleDeg: "angle",
    getAngleDeg: "getAngle",
    setAngleDeg: "setAngle"
  }), ji;
}
var Ki = {}, pd;
function S6() {
  if (pd) return Ki;
  pd = 1, Object.defineProperty(Ki, "__esModule", { value: !0 }), Ki.Blur = void 0;
  const r = Tt(), a = $t(), n = Ot();
  function o() {
    this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
  const u = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
  ], s = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
  ];
  function h(g, p) {
    const b = g.data, m = g.width, C = g.height;
    let v, _, w, x, P, c, f, S, E, T, D, I, M, O, N, H, y, F, R, G, U, K, $, X, Q = p + p + 1, st = m - 1, Z = C - 1, at = p + 1, ht = at * (at + 1) / 2, ct = new o(), z = null, j = ct, et = null, ut = null, ft = u[p], gt = s[p];
    for (w = 1; w < Q; w++)
      j = j.next = new o(), w === at && (z = j);
    for (j.next = ct, f = c = 0, _ = 0; _ < C; _++) {
      for (H = y = F = R = S = E = T = D = 0, I = at * (G = b[c]), M = at * (U = b[c + 1]), O = at * (K = b[c + 2]), N = at * ($ = b[c + 3]), S += ht * G, E += ht * U, T += ht * K, D += ht * $, j = ct, w = 0; w < at; w++)
        j.r = G, j.g = U, j.b = K, j.a = $, j = j.next;
      for (w = 1; w < at; w++)
        x = c + ((st < w ? st : w) << 2), S += (j.r = G = b[x]) * (X = at - w), E += (j.g = U = b[x + 1]) * X, T += (j.b = K = b[x + 2]) * X, D += (j.a = $ = b[x + 3]) * X, H += G, y += U, F += K, R += $, j = j.next;
      for (et = ct, ut = z, v = 0; v < m; v++)
        b[c + 3] = $ = D * ft >> gt, $ !== 0 ? ($ = 255 / $, b[c] = (S * ft >> gt) * $, b[c + 1] = (E * ft >> gt) * $, b[c + 2] = (T * ft >> gt) * $) : b[c] = b[c + 1] = b[c + 2] = 0, S -= I, E -= M, T -= O, D -= N, I -= et.r, M -= et.g, O -= et.b, N -= et.a, x = f + ((x = v + p + 1) < st ? x : st) << 2, H += et.r = b[x], y += et.g = b[x + 1], F += et.b = b[x + 2], R += et.a = b[x + 3], S += H, E += y, T += F, D += R, et = et.next, I += G = ut.r, M += U = ut.g, O += K = ut.b, N += $ = ut.a, H -= G, y -= U, F -= K, R -= $, ut = ut.next, c += 4;
      f += m;
    }
    for (v = 0; v < m; v++) {
      for (y = F = R = H = E = T = D = S = 0, c = v << 2, I = at * (G = b[c]), M = at * (U = b[c + 1]), O = at * (K = b[c + 2]), N = at * ($ = b[c + 3]), S += ht * G, E += ht * U, T += ht * K, D += ht * $, j = ct, w = 0; w < at; w++)
        j.r = G, j.g = U, j.b = K, j.a = $, j = j.next;
      for (P = m, w = 1; w <= p; w++)
        c = P + v << 2, S += (j.r = G = b[c]) * (X = at - w), E += (j.g = U = b[c + 1]) * X, T += (j.b = K = b[c + 2]) * X, D += (j.a = $ = b[c + 3]) * X, H += G, y += U, F += K, R += $, j = j.next, w < Z && (P += m);
      for (c = v, et = ct, ut = z, _ = 0; _ < C; _++)
        x = c << 2, b[x + 3] = $ = D * ft >> gt, $ > 0 ? ($ = 255 / $, b[x] = (S * ft >> gt) * $, b[x + 1] = (E * ft >> gt) * $, b[x + 2] = (T * ft >> gt) * $) : b[x] = b[x + 1] = b[x + 2] = 0, S -= I, E -= M, T -= O, D -= N, I -= et.r, M -= et.g, O -= et.b, N -= et.a, x = v + ((x = _ + at) < Z ? x : Z) * m << 2, S += H += et.r = b[x], E += y += et.g = b[x + 1], T += F += et.b = b[x + 2], D += R += et.a = b[x + 3], et = et.next, I += G = ut.r, M += U = ut.g, O += K = ut.b, N += $ = ut.a, H -= G, y -= U, F -= K, R -= $, ut = ut.next, c += m;
    }
  }
  const l = function(p) {
    const b = Math.round(this.blurRadius());
    b > 0 && h(p, b);
  };
  return Ki.Blur = l, r.Factory.addGetterSetter(a.Node, "blurRadius", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), Ki;
}
var Yi = {}, _d;
function w6() {
  if (_d) return Yi;
  _d = 1, Object.defineProperty(Yi, "__esModule", { value: !0 }), Yi.Brighten = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(u) {
    let s = this.brightness() * 255, h = u.data, l = h.length, g;
    for (g = 0; g < l; g += 4)
      h[g] += s, h[g + 1] += s, h[g + 2] += s;
  };
  return Yi.Brighten = o, r.Factory.addGetterSetter(a.Node, "brightness", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), Yi;
}
var Xi = {}, vd;
function C6() {
  if (vd) return Xi;
  vd = 1, Object.defineProperty(Xi, "__esModule", { value: !0 }), Xi.Contrast = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(u) {
    const s = Math.pow((this.contrast() + 100) / 100, 2);
    let h = u.data, l = h.length, g = 150, p = 150, b = 150, m;
    for (m = 0; m < l; m += 4)
      g = h[m], p = h[m + 1], b = h[m + 2], g /= 255, g -= 0.5, g *= s, g += 0.5, g *= 255, p /= 255, p -= 0.5, p *= s, p += 0.5, p *= 255, b /= 255, b -= 0.5, b *= s, b += 0.5, b *= 255, g = g < 0 ? 0 : g > 255 ? 255 : g, p = p < 0 ? 0 : p > 255 ? 255 : p, b = b < 0 ? 0 : b > 255 ? 255 : b, h[m] = g, h[m + 1] = p, h[m + 2] = b;
  };
  return Xi.Contrast = o, r.Factory.addGetterSetter(a.Node, "contrast", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), Xi;
}
var $i = {}, yd;
function x6() {
  if (yd) return $i;
  yd = 1, Object.defineProperty($i, "__esModule", { value: !0 }), $i.Emboss = void 0;
  const r = Tt(), a = $t(), n = Kt(), o = Ot(), u = function(s) {
    let h = this.embossStrength() * 10, l = this.embossWhiteLevel() * 255, g = this.embossDirection(), p = this.embossBlend(), b = 0, m = 0, C = s.data, v = s.width, _ = s.height, w = v * 4, x = _;
    switch (g) {
      case "top-left":
        b = -1, m = -1;
        break;
      case "top":
        b = -1, m = 0;
        break;
      case "top-right":
        b = -1, m = 1;
        break;
      case "right":
        b = 0, m = 1;
        break;
      case "bottom-right":
        b = 1, m = 1;
        break;
      case "bottom":
        b = 1, m = 0;
        break;
      case "bottom-left":
        b = 1, m = -1;
        break;
      case "left":
        b = 0, m = -1;
        break;
      default:
        n.Util.error("Unknown emboss direction: " + g);
    }
    do {
      const P = (x - 1) * w;
      let c = b;
      x + c < 1 && (c = 0), x + c > _ && (c = 0);
      const f = (x - 1 + c) * v * 4;
      let S = v;
      do {
        const E = P + (S - 1) * 4;
        let T = m;
        S + T < 1 && (T = 0), S + T > v && (T = 0);
        const D = f + (S - 1 + T) * 4, I = C[E] - C[D], M = C[E + 1] - C[D + 1], O = C[E + 2] - C[D + 2];
        let N = I;
        const H = N > 0 ? N : -N, y = M > 0 ? M : -M, F = O > 0 ? O : -O;
        if (y > H && (N = M), F > H && (N = O), N *= h, p) {
          const R = C[E] + N, G = C[E + 1] + N, U = C[E + 2] + N;
          C[E] = R > 255 ? 255 : R < 0 ? 0 : R, C[E + 1] = G > 255 ? 255 : G < 0 ? 0 : G, C[E + 2] = U > 255 ? 255 : U < 0 ? 0 : U;
        } else {
          let R = l - N;
          R < 0 ? R = 0 : R > 255 && (R = 255), C[E] = C[E + 1] = C[E + 2] = R;
        }
      } while (--S);
    } while (--x);
  };
  return $i.Emboss = u, r.Factory.addGetterSetter(a.Node, "embossStrength", 0.5, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "embossWhiteLevel", 0.5, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "embossDirection", "top-left", null, r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "embossBlend", !1, null, r.Factory.afterSetFilter), $i;
}
var Zi = {}, md;
function E6() {
  if (md) return Zi;
  md = 1, Object.defineProperty(Zi, "__esModule", { value: !0 }), Zi.Enhance = void 0;
  const r = Tt(), a = $t(), n = Ot();
  function o(s, h, l, g, p) {
    let b = l - h, m = p - g, C;
    return b === 0 ? g + m / 2 : m === 0 ? g : (C = (s - h) / b, C = m * C + g, C);
  }
  const u = function(s) {
    let h = s.data, l = h.length, g = h[0], p = g, b, m = h[1], C = m, v, _ = h[2], w = _, x, P;
    const c = this.enhance();
    if (c === 0)
      return;
    for (P = 0; P < l; P += 4)
      b = h[P + 0], b < g ? g = b : b > p && (p = b), v = h[P + 1], v < m ? m = v : v > C && (C = v), x = h[P + 2], x < _ ? _ = x : x > w && (w = x);
    p === g && (p = 255, g = 0), C === m && (C = 255, m = 0), w === _ && (w = 255, _ = 0);
    let f, S, E, T, D, I, M, O, N;
    for (c > 0 ? (S = p + c * (255 - p), E = g - c * (g - 0), D = C + c * (255 - C), I = m - c * (m - 0), O = w + c * (255 - w), N = _ - c * (_ - 0)) : (f = (p + g) * 0.5, S = p + c * (p - f), E = g + c * (g - f), T = (C + m) * 0.5, D = C + c * (C - T), I = m + c * (m - T), M = (w + _) * 0.5, O = w + c * (w - M), N = _ + c * (_ - M)), P = 0; P < l; P += 4)
      h[P + 0] = o(h[P + 0], g, p, E, S), h[P + 1] = o(h[P + 1], m, C, I, D), h[P + 2] = o(h[P + 2], _, w, N, O);
  };
  return Zi.Enhance = u, r.Factory.addGetterSetter(a.Node, "enhance", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), Zi;
}
var Ji = {}, bd;
function R6() {
  if (bd) return Ji;
  bd = 1, Object.defineProperty(Ji, "__esModule", { value: !0 }), Ji.Grayscale = void 0;
  const r = function(a) {
    let n = a.data, o = n.length, u, s;
    for (u = 0; u < o; u += 4)
      s = 0.34 * n[u] + 0.5 * n[u + 1] + 0.16 * n[u + 2], n[u] = s, n[u + 1] = s, n[u + 2] = s;
  };
  return Ji.Grayscale = r, Ji;
}
var Qi = {}, Sd;
function A6() {
  if (Sd) return Qi;
  Sd = 1, Object.defineProperty(Qi, "__esModule", { value: !0 }), Qi.HSL = void 0;
  const r = Tt(), a = $t(), n = Ot();
  r.Factory.addGetterSetter(a.Node, "hue", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "saturation", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "luminance", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter);
  const o = function(u) {
    let s = u.data, h = s.length, l = 1, g = Math.pow(2, this.saturation()), p = Math.abs(this.hue() + 360) % 360, b = this.luminance() * 127, m;
    const C = l * g * Math.cos(p * Math.PI / 180), v = l * g * Math.sin(p * Math.PI / 180), _ = 0.299 * l + 0.701 * C + 0.167 * v, w = 0.587 * l - 0.587 * C + 0.33 * v, x = 0.114 * l - 0.114 * C - 0.497 * v, P = 0.299 * l - 0.299 * C - 0.328 * v, c = 0.587 * l + 0.413 * C + 0.035 * v, f = 0.114 * l - 0.114 * C + 0.293 * v, S = 0.299 * l - 0.3 * C + 1.25 * v, E = 0.587 * l - 0.586 * C - 1.05 * v, T = 0.114 * l + 0.886 * C - 0.2 * v;
    let D, I, M, O;
    for (m = 0; m < h; m += 4)
      D = s[m + 0], I = s[m + 1], M = s[m + 2], O = s[m + 3], s[m + 0] = _ * D + w * I + x * M + b, s[m + 1] = P * D + c * I + f * M + b, s[m + 2] = S * D + E * I + T * M + b, s[m + 3] = O;
  };
  return Qi.HSL = o, Qi;
}
var tn = {}, wd;
function T6() {
  if (wd) return tn;
  wd = 1, Object.defineProperty(tn, "__esModule", { value: !0 }), tn.HSV = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(u) {
    const s = u.data, h = s.length, l = Math.pow(2, this.value()), g = Math.pow(2, this.saturation()), p = Math.abs(this.hue() + 360) % 360, b = l * g * Math.cos(p * Math.PI / 180), m = l * g * Math.sin(p * Math.PI / 180), C = 0.299 * l + 0.701 * b + 0.167 * m, v = 0.587 * l - 0.587 * b + 0.33 * m, _ = 0.114 * l - 0.114 * b - 0.497 * m, w = 0.299 * l - 0.299 * b - 0.328 * m, x = 0.587 * l + 0.413 * b + 0.035 * m, P = 0.114 * l - 0.114 * b + 0.293 * m, c = 0.299 * l - 0.3 * b + 1.25 * m, f = 0.587 * l - 0.586 * b - 1.05 * m, S = 0.114 * l + 0.886 * b - 0.2 * m;
    let E, T, D, I;
    for (let M = 0; M < h; M += 4)
      E = s[M + 0], T = s[M + 1], D = s[M + 2], I = s[M + 3], s[M + 0] = C * E + v * T + _ * D, s[M + 1] = w * E + x * T + P * D, s[M + 2] = c * E + f * T + S * D, s[M + 3] = I;
  };
  return tn.HSV = o, r.Factory.addGetterSetter(a.Node, "hue", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "saturation", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "value", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), tn;
}
var en = {}, Cd;
function P6() {
  if (Cd) return en;
  Cd = 1, Object.defineProperty(en, "__esModule", { value: !0 }), en.Invert = void 0;
  const r = function(a) {
    let n = a.data, o = n.length, u;
    for (u = 0; u < o; u += 4)
      n[u] = 255 - n[u], n[u + 1] = 255 - n[u + 1], n[u + 2] = 255 - n[u + 2];
  };
  return en.Invert = r, en;
}
var rn = {}, xd;
function F6() {
  if (xd) return rn;
  xd = 1, Object.defineProperty(rn, "__esModule", { value: !0 }), rn.Kaleidoscope = void 0;
  const r = Tt(), a = $t(), n = Kt(), o = Ot(), u = function(l, g, p) {
    let b = l.data, m = g.data, C = l.width, v = l.height, _ = p.polarCenterX || C / 2, w = p.polarCenterY || v / 2, x, P, c, f = 0, S = 0, E = 0, T = 0, D, I = Math.sqrt(_ * _ + w * w);
    P = C - _, c = v - w, D = Math.sqrt(P * P + c * c), I = D > I ? D : I;
    let M = v, O = C, N, H, y = 360 / O * Math.PI / 180, F, R;
    for (H = 0; H < O; H += 1)
      for (F = Math.sin(H * y), R = Math.cos(H * y), N = 0; N < M; N += 1)
        P = Math.floor(_ + I * N / M * R), c = Math.floor(w + I * N / M * F), x = (c * C + P) * 4, f = b[x + 0], S = b[x + 1], E = b[x + 2], T = b[x + 3], x = (H + N * C) * 4, m[x + 0] = f, m[x + 1] = S, m[x + 2] = E, m[x + 3] = T;
  }, s = function(l, g, p) {
    let b = l.data, m = g.data, C = l.width, v = l.height, _ = p.polarCenterX || C / 2, w = p.polarCenterY || v / 2, x, P, c, f, S, E = 0, T = 0, D = 0, I = 0, M, O = Math.sqrt(_ * _ + w * w);
    P = C - _, c = v - w, M = Math.sqrt(P * P + c * c), O = M > O ? M : O;
    let N = v, H = C, y, F, R = 0, G, U;
    for (P = 0; P < C; P += 1)
      for (c = 0; c < v; c += 1)
        f = P - _, S = c - w, y = Math.sqrt(f * f + S * S) * N / O, F = (Math.atan2(S, f) * 180 / Math.PI + 360 + R) % 360, F = F * H / 360, G = Math.floor(F), U = Math.floor(y), x = (U * C + G) * 4, E = b[x + 0], T = b[x + 1], D = b[x + 2], I = b[x + 3], x = (c * C + P) * 4, m[x + 0] = E, m[x + 1] = T, m[x + 2] = D, m[x + 3] = I;
  }, h = function(l) {
    const g = l.width, p = l.height;
    let b, m, C, v, _, w, x, P, c, f, S = Math.round(this.kaleidoscopePower());
    const E = Math.round(this.kaleidoscopeAngle()), T = Math.floor(g * (E % 360) / 360);
    if (S < 1)
      return;
    const D = n.Util.createCanvasElement();
    D.width = g, D.height = p;
    const I = D.getContext("2d").getImageData(0, 0, g, p);
    n.Util.releaseCanvas(D), u(l, I, {
      polarCenterX: g / 2,
      polarCenterY: p / 2
    });
    let M = g / Math.pow(2, S);
    for (; M <= 8; )
      M = M * 2, S -= 1;
    M = Math.ceil(M);
    let O = M, N = 0, H = O, y = 1;
    for (T + M > g && (N = O, H = 0, y = -1), m = 0; m < p; m += 1)
      for (b = N; b !== H; b += y)
        C = Math.round(b + T) % g, c = (g * m + C) * 4, _ = I.data[c + 0], w = I.data[c + 1], x = I.data[c + 2], P = I.data[c + 3], f = (g * m + b) * 4, I.data[f + 0] = _, I.data[f + 1] = w, I.data[f + 2] = x, I.data[f + 3] = P;
    for (m = 0; m < p; m += 1)
      for (O = Math.floor(M), v = 0; v < S; v += 1) {
        for (b = 0; b < O + 1; b += 1)
          c = (g * m + b) * 4, _ = I.data[c + 0], w = I.data[c + 1], x = I.data[c + 2], P = I.data[c + 3], f = (g * m + O * 2 - b - 1) * 4, I.data[f + 0] = _, I.data[f + 1] = w, I.data[f + 2] = x, I.data[f + 3] = P;
        O *= 2;
      }
    s(I, l, {});
  };
  return rn.Kaleidoscope = h, r.Factory.addGetterSetter(a.Node, "kaleidoscopePower", 2, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "kaleidoscopeAngle", 0, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), rn;
}
var nn = {}, Ed;
function O6() {
  if (Ed) return nn;
  Ed = 1, Object.defineProperty(nn, "__esModule", { value: !0 }), nn.Mask = void 0;
  const r = Tt(), a = $t(), n = Ot();
  function o(C, v, _) {
    let w = (_ * C.width + v) * 4;
    const x = [];
    return x.push(C.data[w++], C.data[w++], C.data[w++], C.data[w++]), x;
  }
  function u(C, v) {
    return Math.sqrt(Math.pow(C[0] - v[0], 2) + Math.pow(C[1] - v[1], 2) + Math.pow(C[2] - v[2], 2));
  }
  function s(C) {
    const v = [0, 0, 0];
    for (let _ = 0; _ < C.length; _++)
      v[0] += C[_][0], v[1] += C[_][1], v[2] += C[_][2];
    return v[0] /= C.length, v[1] /= C.length, v[2] /= C.length, v;
  }
  function h(C, v) {
    const _ = o(C, 0, 0), w = o(C, C.width - 1, 0), x = o(C, 0, C.height - 1), P = o(C, C.width - 1, C.height - 1), c = v || 10;
    if (u(_, w) < c && u(w, P) < c && u(P, x) < c && u(x, _) < c) {
      const f = s([w, _, P, x]), S = [];
      for (let E = 0; E < C.width * C.height; E++) {
        const T = u(f, [
          C.data[E * 4],
          C.data[E * 4 + 1],
          C.data[E * 4 + 2]
        ]);
        S[E] = T < c ? 0 : 255;
      }
      return S;
    }
  }
  function l(C, v) {
    for (let _ = 0; _ < C.width * C.height; _++)
      C.data[4 * _ + 3] = v[_];
  }
  function g(C, v, _) {
    const w = [1, 1, 1, 1, 0, 1, 1, 1, 1], x = Math.round(Math.sqrt(w.length)), P = Math.floor(x / 2), c = [];
    for (let f = 0; f < _; f++)
      for (let S = 0; S < v; S++) {
        const E = f * v + S;
        let T = 0;
        for (let D = 0; D < x; D++)
          for (let I = 0; I < x; I++) {
            const M = f + D - P, O = S + I - P;
            if (M >= 0 && M < _ && O >= 0 && O < v) {
              const N = M * v + O, H = w[D * x + I];
              T += C[N] * H;
            }
          }
        c[E] = T === 255 * 8 ? 255 : 0;
      }
    return c;
  }
  function p(C, v, _) {
    const w = [1, 1, 1, 1, 1, 1, 1, 1, 1], x = Math.round(Math.sqrt(w.length)), P = Math.floor(x / 2), c = [];
    for (let f = 0; f < _; f++)
      for (let S = 0; S < v; S++) {
        const E = f * v + S;
        let T = 0;
        for (let D = 0; D < x; D++)
          for (let I = 0; I < x; I++) {
            const M = f + D - P, O = S + I - P;
            if (M >= 0 && M < _ && O >= 0 && O < v) {
              const N = M * v + O, H = w[D * x + I];
              T += C[N] * H;
            }
          }
        c[E] = T >= 255 * 4 ? 255 : 0;
      }
    return c;
  }
  function b(C, v, _) {
    const w = [0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111], x = Math.round(Math.sqrt(w.length)), P = Math.floor(x / 2), c = [];
    for (let f = 0; f < _; f++)
      for (let S = 0; S < v; S++) {
        const E = f * v + S;
        let T = 0;
        for (let D = 0; D < x; D++)
          for (let I = 0; I < x; I++) {
            const M = f + D - P, O = S + I - P;
            if (M >= 0 && M < _ && O >= 0 && O < v) {
              const N = M * v + O, H = w[D * x + I];
              T += C[N] * H;
            }
          }
        c[E] = T;
      }
    return c;
  }
  const m = function(C) {
    let v = this.threshold(), _ = h(C, v);
    return _ && (_ = g(_, C.width, C.height), _ = p(_, C.width, C.height), _ = b(_, C.width, C.height), l(C, _)), C;
  };
  return nn.Mask = m, r.Factory.addGetterSetter(a.Node, "threshold", 0, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), nn;
}
var an = {}, Rd;
function k6() {
  if (Rd) return an;
  Rd = 1, Object.defineProperty(an, "__esModule", { value: !0 }), an.Noise = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(u) {
    const s = this.noise() * 255, h = u.data, l = h.length, g = s / 2;
    for (let p = 0; p < l; p += 4)
      h[p + 0] += g - 2 * g * Math.random(), h[p + 1] += g - 2 * g * Math.random(), h[p + 2] += g - 2 * g * Math.random();
  };
  return an.Noise = o, r.Factory.addGetterSetter(a.Node, "noise", 0.2, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), an;
}
var sn = {}, Ad;
function I6() {
  if (Ad) return sn;
  Ad = 1, Object.defineProperty(sn, "__esModule", { value: !0 }), sn.Pixelate = void 0;
  const r = Tt(), a = Kt(), n = $t(), o = Ot(), u = function(s) {
    let h = Math.ceil(this.pixelSize()), l = s.width, g = s.height, p, b, m, C, v, _, w, x = Math.ceil(l / h), P = Math.ceil(g / h), c, f, S, E, T, D, I, M = s.data;
    if (h <= 0) {
      a.Util.error("pixelSize value can not be <= 0");
      return;
    }
    for (T = 0; T < x; T += 1)
      for (D = 0; D < P; D += 1) {
        for (C = 0, v = 0, _ = 0, w = 0, c = T * h, f = c + h, S = D * h, E = S + h, I = 0, p = c; p < f; p += 1)
          if (!(p >= l))
            for (b = S; b < E; b += 1)
              b >= g || (m = (l * b + p) * 4, C += M[m + 0], v += M[m + 1], _ += M[m + 2], w += M[m + 3], I += 1);
        for (C = C / I, v = v / I, _ = _ / I, w = w / I, p = c; p < f; p += 1)
          if (!(p >= l))
            for (b = S; b < E; b += 1)
              b >= g || (m = (l * b + p) * 4, M[m + 0] = C, M[m + 1] = v, M[m + 2] = _, M[m + 3] = w);
      }
  };
  return sn.Pixelate = u, r.Factory.addGetterSetter(n.Node, "pixelSize", 8, (0, o.getNumberValidator)(), r.Factory.afterSetFilter), sn;
}
var on = {}, Td;
function M6() {
  if (Td) return on;
  Td = 1, Object.defineProperty(on, "__esModule", { value: !0 }), on.Posterize = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(u) {
    let s = Math.round(this.levels() * 254) + 1, h = u.data, l = h.length, g = 255 / s, p;
    for (p = 0; p < l; p += 1)
      h[p] = Math.floor(h[p] / g) * g;
  };
  return on.Posterize = o, r.Factory.addGetterSetter(a.Node, "levels", 0.5, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), on;
}
var hn = {}, Pd;
function L6() {
  if (Pd) return hn;
  Pd = 1, Object.defineProperty(hn, "__esModule", { value: !0 }), hn.RGB = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(u) {
    let s = u.data, h = s.length, l = this.red(), g = this.green(), p = this.blue(), b, m;
    for (b = 0; b < h; b += 4)
      m = (0.34 * s[b] + 0.5 * s[b + 1] + 0.16 * s[b + 2]) / 255, s[b] = m * l, s[b + 1] = m * g, s[b + 2] = m * p, s[b + 3] = s[b + 3];
  };
  return hn.RGB = o, r.Factory.addGetterSetter(a.Node, "red", 0, function(u) {
    return this._filterUpToDate = !1, u > 255 ? 255 : u < 0 ? 0 : Math.round(u);
  }), r.Factory.addGetterSetter(a.Node, "green", 0, function(u) {
    return this._filterUpToDate = !1, u > 255 ? 255 : u < 0 ? 0 : Math.round(u);
  }), r.Factory.addGetterSetter(a.Node, "blue", 0, n.RGBComponent, r.Factory.afterSetFilter), hn;
}
var ln = {}, Fd;
function N6() {
  if (Fd) return ln;
  Fd = 1, Object.defineProperty(ln, "__esModule", { value: !0 }), ln.RGBA = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(u) {
    const s = u.data, h = s.length, l = this.red(), g = this.green(), p = this.blue(), b = this.alpha();
    for (let m = 0; m < h; m += 4) {
      const C = 1 - b;
      s[m] = l * b + s[m] * C, s[m + 1] = g * b + s[m + 1] * C, s[m + 2] = p * b + s[m + 2] * C;
    }
  };
  return ln.RGBA = o, r.Factory.addGetterSetter(a.Node, "red", 0, function(u) {
    return this._filterUpToDate = !1, u > 255 ? 255 : u < 0 ? 0 : Math.round(u);
  }), r.Factory.addGetterSetter(a.Node, "green", 0, function(u) {
    return this._filterUpToDate = !1, u > 255 ? 255 : u < 0 ? 0 : Math.round(u);
  }), r.Factory.addGetterSetter(a.Node, "blue", 0, n.RGBComponent, r.Factory.afterSetFilter), r.Factory.addGetterSetter(a.Node, "alpha", 1, function(u) {
    return this._filterUpToDate = !1, u > 1 ? 1 : u < 0 ? 0 : u;
  }), ln;
}
var un = {}, Od;
function G6() {
  if (Od) return un;
  Od = 1, Object.defineProperty(un, "__esModule", { value: !0 }), un.Sepia = void 0;
  const r = function(a) {
    let n = a.data, o = n.length, u, s, h, l;
    for (u = 0; u < o; u += 4)
      s = n[u + 0], h = n[u + 1], l = n[u + 2], n[u + 0] = Math.min(255, s * 0.393 + h * 0.769 + l * 0.189), n[u + 1] = Math.min(255, s * 0.349 + h * 0.686 + l * 0.168), n[u + 2] = Math.min(255, s * 0.272 + h * 0.534 + l * 0.131);
  };
  return un.Sepia = r, un;
}
var cn = {}, kd;
function D6() {
  if (kd) return cn;
  kd = 1, Object.defineProperty(cn, "__esModule", { value: !0 }), cn.Solarize = void 0;
  const r = function(a) {
    const n = a.data, o = a.width, u = a.height, s = o * 4;
    let h = u;
    do {
      const l = (h - 1) * s;
      let g = o;
      do {
        const p = l + (g - 1) * 4;
        let b = n[p], m = n[p + 1], C = n[p + 2];
        b > 127 && (b = 255 - b), m > 127 && (m = 255 - m), C > 127 && (C = 255 - C), n[p] = b, n[p + 1] = m, n[p + 2] = C;
      } while (--g);
    } while (--h);
  };
  return cn.Solarize = r, cn;
}
var dn = {}, Id;
function B6() {
  if (Id) return dn;
  Id = 1, Object.defineProperty(dn, "__esModule", { value: !0 }), dn.Threshold = void 0;
  const r = Tt(), a = $t(), n = Ot(), o = function(u) {
    const s = this.threshold() * 255, h = u.data, l = h.length;
    for (let g = 0; g < l; g += 1)
      h[g] = h[g] < s ? 0 : 255;
  };
  return dn.Threshold = o, r.Factory.addGetterSetter(a.Node, "threshold", 0.5, (0, n.getNumberValidator)(), r.Factory.afterSetFilter), dn;
}
var Md;
function U6() {
  if (Md) return Ei;
  Md = 1, Object.defineProperty(Ei, "__esModule", { value: !0 }), Ei.Konva = void 0;
  const r = s6(), a = o6(), n = l6(), o = u6(), u = c6(), s = d6(), h = f6(), l = J0(), g = Qh(), p = t1(), b = g6(), m = p6(), C = _6(), v = v6(), _ = e1(), w = y6(), x = m6(), P = b6(), c = S6(), f = w6(), S = C6(), E = x6(), T = E6(), D = R6(), I = A6(), M = T6(), O = P6(), N = F6(), H = O6(), y = k6(), F = I6(), R = M6(), G = L6(), U = N6(), K = G6(), $ = D6(), X = B6();
  return Ei.Konva = r.Konva.Util._assign(r.Konva, {
    Arc: a.Arc,
    Arrow: n.Arrow,
    Circle: o.Circle,
    Ellipse: u.Ellipse,
    Image: s.Image,
    Label: h.Label,
    Tag: h.Tag,
    Line: l.Line,
    Path: g.Path,
    Rect: p.Rect,
    RegularPolygon: b.RegularPolygon,
    Ring: m.Ring,
    Sprite: C.Sprite,
    Star: v.Star,
    Text: _.Text,
    TextPath: w.TextPath,
    Transformer: x.Transformer,
    Wedge: P.Wedge,
    Filters: {
      Blur: c.Blur,
      Brighten: f.Brighten,
      Contrast: S.Contrast,
      Emboss: E.Emboss,
      Enhance: T.Enhance,
      Grayscale: D.Grayscale,
      HSL: I.HSL,
      HSV: M.HSV,
      Invert: O.Invert,
      Kaleidoscope: N.Kaleidoscope,
      Mask: H.Mask,
      Noise: y.Noise,
      Pixelate: F.Pixelate,
      Posterize: R.Posterize,
      RGB: G.RGB,
      RGBA: U.RGBA,
      Sepia: K.Sepia,
      Solarize: $.Solarize,
      Threshold: X.Threshold
    }
  }), Ei;
}
var q6 = ga.exports, Ld;
function H6() {
  if (Ld) return ga.exports;
  Ld = 1, Object.defineProperty(q6, "__esModule", { value: !0 });
  const r = U6();
  return ga.exports = r.Konva, ga.exports;
}
var z6 = H6();
const yt = /* @__PURE__ */ ai(z6);
var Zs, Nd;
function bn() {
  if (Nd) return Zs;
  Nd = 1;
  function r(a) {
    var n = typeof a;
    return a != null && (n == "object" || n == "function");
  }
  return Zs = r, Zs;
}
var Js, Gd;
function r1() {
  if (Gd) return Js;
  Gd = 1;
  var r = typeof ri == "object" && ri && ri.Object === Object && ri;
  return Js = r, Js;
}
var Qs, Dd;
function Xe() {
  if (Dd) return Qs;
  Dd = 1;
  var r = r1(), a = typeof self == "object" && self && self.Object === Object && self, n = r || a || Function("return this")();
  return Qs = n, Qs;
}
var to, Bd;
function V6() {
  if (Bd) return to;
  Bd = 1;
  var r = Xe(), a = function() {
    return r.Date.now();
  };
  return to = a, to;
}
var eo, Ud;
function W6() {
  if (Ud) return eo;
  Ud = 1;
  var r = /\s/;
  function a(n) {
    for (var o = n.length; o-- && r.test(n.charAt(o)); )
      ;
    return o;
  }
  return eo = a, eo;
}
var ro, qd;
function j6() {
  if (qd) return ro;
  qd = 1;
  var r = W6(), a = /^\s+/;
  function n(o) {
    return o && o.slice(0, r(o) + 1).replace(a, "");
  }
  return ro = n, ro;
}
var io, Hd;
function wa() {
  if (Hd) return io;
  Hd = 1;
  var r = Xe(), a = r.Symbol;
  return io = a, io;
}
var no, zd;
function K6() {
  if (zd) return no;
  zd = 1;
  var r = wa(), a = Object.prototype, n = a.hasOwnProperty, o = a.toString, u = r ? r.toStringTag : void 0;
  function s(h) {
    var l = n.call(h, u), g = h[u];
    try {
      h[u] = void 0;
      var p = !0;
    } catch {
    }
    var b = o.call(h);
    return p && (l ? h[u] = g : delete h[u]), b;
  }
  return no = s, no;
}
var ao, Vd;
function Y6() {
  if (Vd) return ao;
  Vd = 1;
  var r = Object.prototype, a = r.toString;
  function n(o) {
    return a.call(o);
  }
  return ao = n, ao;
}
var so, Wd;
function Sn() {
  if (Wd) return so;
  Wd = 1;
  var r = wa(), a = K6(), n = Y6(), o = "[object Null]", u = "[object Undefined]", s = r ? r.toStringTag : void 0;
  function h(l) {
    return l == null ? l === void 0 ? u : o : s && s in Object(l) ? a(l) : n(l);
  }
  return so = h, so;
}
var oo, jd;
function wn() {
  if (jd) return oo;
  jd = 1;
  function r(a) {
    return a != null && typeof a == "object";
  }
  return oo = r, oo;
}
var ho, Kd;
function i1() {
  if (Kd) return ho;
  Kd = 1;
  var r = Sn(), a = wn(), n = "[object Symbol]";
  function o(u) {
    return typeof u == "symbol" || a(u) && r(u) == n;
  }
  return ho = o, ho;
}
var lo, Yd;
function tl() {
  if (Yd) return lo;
  Yd = 1;
  var r = j6(), a = bn(), n = i1(), o = NaN, u = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, h = /^0o[0-7]+$/i, l = parseInt;
  function g(p) {
    if (typeof p == "number")
      return p;
    if (n(p))
      return o;
    if (a(p)) {
      var b = typeof p.valueOf == "function" ? p.valueOf() : p;
      p = a(b) ? b + "" : b;
    }
    if (typeof p != "string")
      return p === 0 ? p : +p;
    p = r(p);
    var m = s.test(p);
    return m || h.test(p) ? l(p.slice(2), m ? 2 : 8) : u.test(p) ? o : +p;
  }
  return lo = g, lo;
}
var uo, Xd;
function n1() {
  if (Xd) return uo;
  Xd = 1;
  var r = bn(), a = V6(), n = tl(), o = "Expected a function", u = Math.max, s = Math.min;
  function h(l, g, p) {
    var b, m, C, v, _, w, x = 0, P = !1, c = !1, f = !0;
    if (typeof l != "function")
      throw new TypeError(o);
    g = n(g) || 0, r(p) && (P = !!p.leading, c = "maxWait" in p, C = c ? u(n(p.maxWait) || 0, g) : C, f = "trailing" in p ? !!p.trailing : f);
    function S(y) {
      var F = b, R = m;
      return b = m = void 0, x = y, v = l.apply(R, F), v;
    }
    function E(y) {
      return x = y, _ = setTimeout(I, g), P ? S(y) : v;
    }
    function T(y) {
      var F = y - w, R = y - x, G = g - F;
      return c ? s(G, C - R) : G;
    }
    function D(y) {
      var F = y - w, R = y - x;
      return w === void 0 || F >= g || F < 0 || c && R >= C;
    }
    function I() {
      var y = a();
      if (D(y))
        return M(y);
      _ = setTimeout(I, T(y));
    }
    function M(y) {
      return _ = void 0, f && b ? S(y) : (b = m = void 0, v);
    }
    function O() {
      _ !== void 0 && clearTimeout(_), x = 0, b = w = m = _ = void 0;
    }
    function N() {
      return _ === void 0 ? v : M(a());
    }
    function H() {
      var y = a(), F = D(y);
      if (b = arguments, m = this, w = y, F) {
        if (_ === void 0)
          return E(w);
        if (c)
          return clearTimeout(_), _ = setTimeout(I, g), S(w);
      }
      return _ === void 0 && (_ = setTimeout(I, g)), v;
    }
    return H.cancel = O, H.flush = N, H;
  }
  return uo = h, uo;
}
var X6 = n1();
const $6 = /* @__PURE__ */ ai(X6);
var co, $d;
function Z6() {
  if ($d) return co;
  $d = 1;
  function r() {
    this.__data__ = [], this.size = 0;
  }
  return co = r, co;
}
var fo, Zd;
function a1() {
  if (Zd) return fo;
  Zd = 1;
  function r(a, n) {
    return a === n || a !== a && n !== n;
  }
  return fo = r, fo;
}
var go, Jd;
function Ca() {
  if (Jd) return go;
  Jd = 1;
  var r = a1();
  function a(n, o) {
    for (var u = n.length; u--; )
      if (r(n[u][0], o))
        return u;
    return -1;
  }
  return go = a, go;
}
var po, Qd;
function J6() {
  if (Qd) return po;
  Qd = 1;
  var r = Ca(), a = Array.prototype, n = a.splice;
  function o(u) {
    var s = this.__data__, h = r(s, u);
    if (h < 0)
      return !1;
    var l = s.length - 1;
    return h == l ? s.pop() : n.call(s, h, 1), --this.size, !0;
  }
  return po = o, po;
}
var _o, tf;
function Q6() {
  if (tf) return _o;
  tf = 1;
  var r = Ca();
  function a(n) {
    var o = this.__data__, u = r(o, n);
    return u < 0 ? void 0 : o[u][1];
  }
  return _o = a, _o;
}
var vo, ef;
function tv() {
  if (ef) return vo;
  ef = 1;
  var r = Ca();
  function a(n) {
    return r(this.__data__, n) > -1;
  }
  return vo = a, vo;
}
var yo, rf;
function ev() {
  if (rf) return yo;
  rf = 1;
  var r = Ca();
  function a(n, o) {
    var u = this.__data__, s = r(u, n);
    return s < 0 ? (++this.size, u.push([n, o])) : u[s][1] = o, this;
  }
  return yo = a, yo;
}
var mo, nf;
function xa() {
  if (nf) return mo;
  nf = 1;
  var r = Z6(), a = J6(), n = Q6(), o = tv(), u = ev();
  function s(h) {
    var l = -1, g = h == null ? 0 : h.length;
    for (this.clear(); ++l < g; ) {
      var p = h[l];
      this.set(p[0], p[1]);
    }
  }
  return s.prototype.clear = r, s.prototype.delete = a, s.prototype.get = n, s.prototype.has = o, s.prototype.set = u, mo = s, mo;
}
var bo, af;
function rv() {
  if (af) return bo;
  af = 1;
  var r = xa();
  function a() {
    this.__data__ = new r(), this.size = 0;
  }
  return bo = a, bo;
}
var So, sf;
function iv() {
  if (sf) return So;
  sf = 1;
  function r(a) {
    var n = this.__data__, o = n.delete(a);
    return this.size = n.size, o;
  }
  return So = r, So;
}
var wo, of;
function nv() {
  if (of) return wo;
  of = 1;
  function r(a) {
    return this.__data__.get(a);
  }
  return wo = r, wo;
}
var Co, hf;
function av() {
  if (hf) return Co;
  hf = 1;
  function r(a) {
    return this.__data__.has(a);
  }
  return Co = r, Co;
}
var xo, lf;
function s1() {
  if (lf) return xo;
  lf = 1;
  var r = Sn(), a = bn(), n = "[object AsyncFunction]", o = "[object Function]", u = "[object GeneratorFunction]", s = "[object Proxy]";
  function h(l) {
    if (!a(l))
      return !1;
    var g = r(l);
    return g == o || g == u || g == n || g == s;
  }
  return xo = h, xo;
}
var Eo, uf;
function sv() {
  if (uf) return Eo;
  uf = 1;
  var r = Xe(), a = r["__core-js_shared__"];
  return Eo = a, Eo;
}
var Ro, cf;
function ov() {
  if (cf) return Ro;
  cf = 1;
  var r = sv(), a = function() {
    var o = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
    return o ? "Symbol(src)_1." + o : "";
  }();
  function n(o) {
    return !!a && a in o;
  }
  return Ro = n, Ro;
}
var Ao, df;
function o1() {
  if (df) return Ao;
  df = 1;
  var r = Function.prototype, a = r.toString;
  function n(o) {
    if (o != null) {
      try {
        return a.call(o);
      } catch {
      }
      try {
        return o + "";
      } catch {
      }
    }
    return "";
  }
  return Ao = n, Ao;
}
var To, ff;
function hv() {
  if (ff) return To;
  ff = 1;
  var r = s1(), a = ov(), n = bn(), o = o1(), u = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, h = Function.prototype, l = Object.prototype, g = h.toString, p = l.hasOwnProperty, b = RegExp(
    "^" + g.call(p).replace(u, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function m(C) {
    if (!n(C) || a(C))
      return !1;
    var v = r(C) ? b : s;
    return v.test(o(C));
  }
  return To = m, To;
}
var Po, gf;
function lv() {
  if (gf) return Po;
  gf = 1;
  function r(a, n) {
    return a == null ? void 0 : a[n];
  }
  return Po = r, Po;
}
var Fo, pf;
function si() {
  if (pf) return Fo;
  pf = 1;
  var r = hv(), a = lv();
  function n(o, u) {
    var s = a(o, u);
    return r(s) ? s : void 0;
  }
  return Fo = n, Fo;
}
var Oo, _f;
function el() {
  if (_f) return Oo;
  _f = 1;
  var r = si(), a = Xe(), n = r(a, "Map");
  return Oo = n, Oo;
}
var ko, vf;
function Ea() {
  if (vf) return ko;
  vf = 1;
  var r = si(), a = r(Object, "create");
  return ko = a, ko;
}
var Io, yf;
function uv() {
  if (yf) return Io;
  yf = 1;
  var r = Ea();
  function a() {
    this.__data__ = r ? r(null) : {}, this.size = 0;
  }
  return Io = a, Io;
}
var Mo, mf;
function cv() {
  if (mf) return Mo;
  mf = 1;
  function r(a) {
    var n = this.has(a) && delete this.__data__[a];
    return this.size -= n ? 1 : 0, n;
  }
  return Mo = r, Mo;
}
var Lo, bf;
function dv() {
  if (bf) return Lo;
  bf = 1;
  var r = Ea(), a = "__lodash_hash_undefined__", n = Object.prototype, o = n.hasOwnProperty;
  function u(s) {
    var h = this.__data__;
    if (r) {
      var l = h[s];
      return l === a ? void 0 : l;
    }
    return o.call(h, s) ? h[s] : void 0;
  }
  return Lo = u, Lo;
}
var No, Sf;
function fv() {
  if (Sf) return No;
  Sf = 1;
  var r = Ea(), a = Object.prototype, n = a.hasOwnProperty;
  function o(u) {
    var s = this.__data__;
    return r ? s[u] !== void 0 : n.call(s, u);
  }
  return No = o, No;
}
var Go, wf;
function gv() {
  if (wf) return Go;
  wf = 1;
  var r = Ea(), a = "__lodash_hash_undefined__";
  function n(o, u) {
    var s = this.__data__;
    return this.size += this.has(o) ? 0 : 1, s[o] = r && u === void 0 ? a : u, this;
  }
  return Go = n, Go;
}
var Do, Cf;
function pv() {
  if (Cf) return Do;
  Cf = 1;
  var r = uv(), a = cv(), n = dv(), o = fv(), u = gv();
  function s(h) {
    var l = -1, g = h == null ? 0 : h.length;
    for (this.clear(); ++l < g; ) {
      var p = h[l];
      this.set(p[0], p[1]);
    }
  }
  return s.prototype.clear = r, s.prototype.delete = a, s.prototype.get = n, s.prototype.has = o, s.prototype.set = u, Do = s, Do;
}
var Bo, xf;
function _v() {
  if (xf) return Bo;
  xf = 1;
  var r = pv(), a = xa(), n = el();
  function o() {
    this.size = 0, this.__data__ = {
      hash: new r(),
      map: new (n || a)(),
      string: new r()
    };
  }
  return Bo = o, Bo;
}
var Uo, Ef;
function vv() {
  if (Ef) return Uo;
  Ef = 1;
  function r(a) {
    var n = typeof a;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? a !== "__proto__" : a === null;
  }
  return Uo = r, Uo;
}
var qo, Rf;
function Ra() {
  if (Rf) return qo;
  Rf = 1;
  var r = vv();
  function a(n, o) {
    var u = n.__data__;
    return r(o) ? u[typeof o == "string" ? "string" : "hash"] : u.map;
  }
  return qo = a, qo;
}
var Ho, Af;
function yv() {
  if (Af) return Ho;
  Af = 1;
  var r = Ra();
  function a(n) {
    var o = r(this, n).delete(n);
    return this.size -= o ? 1 : 0, o;
  }
  return Ho = a, Ho;
}
var zo, Tf;
function mv() {
  if (Tf) return zo;
  Tf = 1;
  var r = Ra();
  function a(n) {
    return r(this, n).get(n);
  }
  return zo = a, zo;
}
var Vo, Pf;
function bv() {
  if (Pf) return Vo;
  Pf = 1;
  var r = Ra();
  function a(n) {
    return r(this, n).has(n);
  }
  return Vo = a, Vo;
}
var Wo, Ff;
function Sv() {
  if (Ff) return Wo;
  Ff = 1;
  var r = Ra();
  function a(n, o) {
    var u = r(this, n), s = u.size;
    return u.set(n, o), this.size += u.size == s ? 0 : 1, this;
  }
  return Wo = a, Wo;
}
var jo, Of;
function h1() {
  if (Of) return jo;
  Of = 1;
  var r = _v(), a = yv(), n = mv(), o = bv(), u = Sv();
  function s(h) {
    var l = -1, g = h == null ? 0 : h.length;
    for (this.clear(); ++l < g; ) {
      var p = h[l];
      this.set(p[0], p[1]);
    }
  }
  return s.prototype.clear = r, s.prototype.delete = a, s.prototype.get = n, s.prototype.has = o, s.prototype.set = u, jo = s, jo;
}
var Ko, kf;
function wv() {
  if (kf) return Ko;
  kf = 1;
  var r = xa(), a = el(), n = h1(), o = 200;
  function u(s, h) {
    var l = this.__data__;
    if (l instanceof r) {
      var g = l.__data__;
      if (!a || g.length < o - 1)
        return g.push([s, h]), this.size = ++l.size, this;
      l = this.__data__ = new n(g);
    }
    return l.set(s, h), this.size = l.size, this;
  }
  return Ko = u, Ko;
}
var Yo, If;
function Cv() {
  if (If) return Yo;
  If = 1;
  var r = xa(), a = rv(), n = iv(), o = nv(), u = av(), s = wv();
  function h(l) {
    var g = this.__data__ = new r(l);
    this.size = g.size;
  }
  return h.prototype.clear = a, h.prototype.delete = n, h.prototype.get = o, h.prototype.has = u, h.prototype.set = s, Yo = h, Yo;
}
var Xo, Mf;
function xv() {
  if (Mf) return Xo;
  Mf = 1;
  var r = "__lodash_hash_undefined__";
  function a(n) {
    return this.__data__.set(n, r), this;
  }
  return Xo = a, Xo;
}
var $o, Lf;
function Ev() {
  if (Lf) return $o;
  Lf = 1;
  function r(a) {
    return this.__data__.has(a);
  }
  return $o = r, $o;
}
var Zo, Nf;
function Rv() {
  if (Nf) return Zo;
  Nf = 1;
  var r = h1(), a = xv(), n = Ev();
  function o(u) {
    var s = -1, h = u == null ? 0 : u.length;
    for (this.__data__ = new r(); ++s < h; )
      this.add(u[s]);
  }
  return o.prototype.add = o.prototype.push = a, o.prototype.has = n, Zo = o, Zo;
}
var Jo, Gf;
function Av() {
  if (Gf) return Jo;
  Gf = 1;
  function r(a, n) {
    for (var o = -1, u = a == null ? 0 : a.length; ++o < u; )
      if (n(a[o], o, a))
        return !0;
    return !1;
  }
  return Jo = r, Jo;
}
var Qo, Df;
function Tv() {
  if (Df) return Qo;
  Df = 1;
  function r(a, n) {
    return a.has(n);
  }
  return Qo = r, Qo;
}
var th, Bf;
function l1() {
  if (Bf) return th;
  Bf = 1;
  var r = Rv(), a = Av(), n = Tv(), o = 1, u = 2;
  function s(h, l, g, p, b, m) {
    var C = g & o, v = h.length, _ = l.length;
    if (v != _ && !(C && _ > v))
      return !1;
    var w = m.get(h), x = m.get(l);
    if (w && x)
      return w == l && x == h;
    var P = -1, c = !0, f = g & u ? new r() : void 0;
    for (m.set(h, l), m.set(l, h); ++P < v; ) {
      var S = h[P], E = l[P];
      if (p)
        var T = C ? p(E, S, P, l, h, m) : p(S, E, P, h, l, m);
      if (T !== void 0) {
        if (T)
          continue;
        c = !1;
        break;
      }
      if (f) {
        if (!a(l, function(D, I) {
          if (!n(f, I) && (S === D || b(S, D, g, p, m)))
            return f.push(I);
        })) {
          c = !1;
          break;
        }
      } else if (!(S === E || b(S, E, g, p, m))) {
        c = !1;
        break;
      }
    }
    return m.delete(h), m.delete(l), c;
  }
  return th = s, th;
}
var eh, Uf;
function Pv() {
  if (Uf) return eh;
  Uf = 1;
  var r = Xe(), a = r.Uint8Array;
  return eh = a, eh;
}
var rh, qf;
function Fv() {
  if (qf) return rh;
  qf = 1;
  function r(a) {
    var n = -1, o = Array(a.size);
    return a.forEach(function(u, s) {
      o[++n] = [s, u];
    }), o;
  }
  return rh = r, rh;
}
var ih, Hf;
function Ov() {
  if (Hf) return ih;
  Hf = 1;
  function r(a) {
    var n = -1, o = Array(a.size);
    return a.forEach(function(u) {
      o[++n] = u;
    }), o;
  }
  return ih = r, ih;
}
var nh, zf;
function kv() {
  if (zf) return nh;
  zf = 1;
  var r = wa(), a = Pv(), n = a1(), o = l1(), u = Fv(), s = Ov(), h = 1, l = 2, g = "[object Boolean]", p = "[object Date]", b = "[object Error]", m = "[object Map]", C = "[object Number]", v = "[object RegExp]", _ = "[object Set]", w = "[object String]", x = "[object Symbol]", P = "[object ArrayBuffer]", c = "[object DataView]", f = r ? r.prototype : void 0, S = f ? f.valueOf : void 0;
  function E(T, D, I, M, O, N, H) {
    switch (I) {
      case c:
        if (T.byteLength != D.byteLength || T.byteOffset != D.byteOffset)
          return !1;
        T = T.buffer, D = D.buffer;
      case P:
        return !(T.byteLength != D.byteLength || !N(new a(T), new a(D)));
      case g:
      case p:
      case C:
        return n(+T, +D);
      case b:
        return T.name == D.name && T.message == D.message;
      case v:
      case w:
        return T == D + "";
      case m:
        var y = u;
      case _:
        var F = M & h;
        if (y || (y = s), T.size != D.size && !F)
          return !1;
        var R = H.get(T);
        if (R)
          return R == D;
        M |= l, H.set(T, D);
        var G = o(y(T), y(D), M, O, N, H);
        return H.delete(T), G;
      case x:
        if (S)
          return S.call(T) == S.call(D);
    }
    return !1;
  }
  return nh = E, nh;
}
var ah, Vf;
function Iv() {
  if (Vf) return ah;
  Vf = 1;
  function r(a, n) {
    for (var o = -1, u = n.length, s = a.length; ++o < u; )
      a[s + o] = n[o];
    return a;
  }
  return ah = r, ah;
}
var sh, Wf;
function Aa() {
  if (Wf) return sh;
  Wf = 1;
  var r = Array.isArray;
  return sh = r, sh;
}
var oh, jf;
function Mv() {
  if (jf) return oh;
  jf = 1;
  var r = Iv(), a = Aa();
  function n(o, u, s) {
    var h = u(o);
    return a(o) ? h : r(h, s(o));
  }
  return oh = n, oh;
}
var hh, Kf;
function Lv() {
  if (Kf) return hh;
  Kf = 1;
  function r(a, n) {
    for (var o = -1, u = a == null ? 0 : a.length, s = 0, h = []; ++o < u; ) {
      var l = a[o];
      n(l, o, a) && (h[s++] = l);
    }
    return h;
  }
  return hh = r, hh;
}
var lh, Yf;
function Nv() {
  if (Yf) return lh;
  Yf = 1;
  function r() {
    return [];
  }
  return lh = r, lh;
}
var uh, Xf;
function Gv() {
  if (Xf) return uh;
  Xf = 1;
  var r = Lv(), a = Nv(), n = Object.prototype, o = n.propertyIsEnumerable, u = Object.getOwnPropertySymbols, s = u ? function(h) {
    return h == null ? [] : (h = Object(h), r(u(h), function(l) {
      return o.call(h, l);
    }));
  } : a;
  return uh = s, uh;
}
var ch, $f;
function Dv() {
  if ($f) return ch;
  $f = 1;
  function r(a, n) {
    for (var o = -1, u = Array(a); ++o < a; )
      u[o] = n(o);
    return u;
  }
  return ch = r, ch;
}
var dh, Zf;
function Bv() {
  if (Zf) return dh;
  Zf = 1;
  var r = Sn(), a = wn(), n = "[object Arguments]";
  function o(u) {
    return a(u) && r(u) == n;
  }
  return dh = o, dh;
}
var fh, Jf;
function Uv() {
  if (Jf) return fh;
  Jf = 1;
  var r = Bv(), a = wn(), n = Object.prototype, o = n.hasOwnProperty, u = n.propertyIsEnumerable, s = r(/* @__PURE__ */ function() {
    return arguments;
  }()) ? r : function(h) {
    return a(h) && o.call(h, "callee") && !u.call(h, "callee");
  };
  return fh = s, fh;
}
var fn = { exports: {} }, gh, Qf;
function qv() {
  if (Qf) return gh;
  Qf = 1;
  function r() {
    return !1;
  }
  return gh = r, gh;
}
fn.exports;
var t0;
function u1() {
  return t0 || (t0 = 1, function(r, a) {
    var n = Xe(), o = qv(), u = a && !a.nodeType && a, s = u && !0 && r && !r.nodeType && r, h = s && s.exports === u, l = h ? n.Buffer : void 0, g = l ? l.isBuffer : void 0, p = g || o;
    r.exports = p;
  }(fn, fn.exports)), fn.exports;
}
var ph, e0;
function c1() {
  if (e0) return ph;
  e0 = 1;
  var r = 9007199254740991, a = /^(?:0|[1-9]\d*)$/;
  function n(o, u) {
    var s = typeof o;
    return u = u == null ? r : u, !!u && (s == "number" || s != "symbol" && a.test(o)) && o > -1 && o % 1 == 0 && o < u;
  }
  return ph = n, ph;
}
var _h, r0;
function d1() {
  if (r0) return _h;
  r0 = 1;
  var r = 9007199254740991;
  function a(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= r;
  }
  return _h = a, _h;
}
var vh, i0;
function Hv() {
  if (i0) return vh;
  i0 = 1;
  var r = Sn(), a = d1(), n = wn(), o = "[object Arguments]", u = "[object Array]", s = "[object Boolean]", h = "[object Date]", l = "[object Error]", g = "[object Function]", p = "[object Map]", b = "[object Number]", m = "[object Object]", C = "[object RegExp]", v = "[object Set]", _ = "[object String]", w = "[object WeakMap]", x = "[object ArrayBuffer]", P = "[object DataView]", c = "[object Float32Array]", f = "[object Float64Array]", S = "[object Int8Array]", E = "[object Int16Array]", T = "[object Int32Array]", D = "[object Uint8Array]", I = "[object Uint8ClampedArray]", M = "[object Uint16Array]", O = "[object Uint32Array]", N = {};
  N[c] = N[f] = N[S] = N[E] = N[T] = N[D] = N[I] = N[M] = N[O] = !0, N[o] = N[u] = N[x] = N[s] = N[P] = N[h] = N[l] = N[g] = N[p] = N[b] = N[m] = N[C] = N[v] = N[_] = N[w] = !1;
  function H(y) {
    return n(y) && a(y.length) && !!N[r(y)];
  }
  return vh = H, vh;
}
var yh, n0;
function zv() {
  if (n0) return yh;
  n0 = 1;
  function r(a) {
    return function(n) {
      return a(n);
    };
  }
  return yh = r, yh;
}
var gn = { exports: {} };
gn.exports;
var a0;
function Vv() {
  return a0 || (a0 = 1, function(r, a) {
    var n = r1(), o = a && !a.nodeType && a, u = o && !0 && r && !r.nodeType && r, s = u && u.exports === o, h = s && n.process, l = function() {
      try {
        var g = u && u.require && u.require("util").types;
        return g || h && h.binding && h.binding("util");
      } catch {
      }
    }();
    r.exports = l;
  }(gn, gn.exports)), gn.exports;
}
var mh, s0;
function f1() {
  if (s0) return mh;
  s0 = 1;
  var r = Hv(), a = zv(), n = Vv(), o = n && n.isTypedArray, u = o ? a(o) : r;
  return mh = u, mh;
}
var bh, o0;
function Wv() {
  if (o0) return bh;
  o0 = 1;
  var r = Dv(), a = Uv(), n = Aa(), o = u1(), u = c1(), s = f1(), h = Object.prototype, l = h.hasOwnProperty;
  function g(p, b) {
    var m = n(p), C = !m && a(p), v = !m && !C && o(p), _ = !m && !C && !v && s(p), w = m || C || v || _, x = w ? r(p.length, String) : [], P = x.length;
    for (var c in p)
      (b || l.call(p, c)) && !(w && // Safari 9 has enumerable `arguments.length` in strict mode.
      (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      _ && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
      u(c, P))) && x.push(c);
    return x;
  }
  return bh = g, bh;
}
var Sh, h0;
function jv() {
  if (h0) return Sh;
  h0 = 1;
  var r = Object.prototype;
  function a(n) {
    var o = n && n.constructor, u = typeof o == "function" && o.prototype || r;
    return n === u;
  }
  return Sh = a, Sh;
}
var wh, l0;
function Kv() {
  if (l0) return wh;
  l0 = 1;
  function r(a, n) {
    return function(o) {
      return a(n(o));
    };
  }
  return wh = r, wh;
}
var Ch, u0;
function Yv() {
  if (u0) return Ch;
  u0 = 1;
  var r = Kv(), a = r(Object.keys, Object);
  return Ch = a, Ch;
}
var xh, c0;
function Xv() {
  if (c0) return xh;
  c0 = 1;
  var r = jv(), a = Yv(), n = Object.prototype, o = n.hasOwnProperty;
  function u(s) {
    if (!r(s))
      return a(s);
    var h = [];
    for (var l in Object(s))
      o.call(s, l) && l != "constructor" && h.push(l);
    return h;
  }
  return xh = u, xh;
}
var Eh, d0;
function $v() {
  if (d0) return Eh;
  d0 = 1;
  var r = s1(), a = d1();
  function n(o) {
    return o != null && a(o.length) && !r(o);
  }
  return Eh = n, Eh;
}
var Rh, f0;
function Zv() {
  if (f0) return Rh;
  f0 = 1;
  var r = Wv(), a = Xv(), n = $v();
  function o(u) {
    return n(u) ? r(u) : a(u);
  }
  return Rh = o, Rh;
}
var Ah, g0;
function Jv() {
  if (g0) return Ah;
  g0 = 1;
  var r = Mv(), a = Gv(), n = Zv();
  function o(u) {
    return r(u, n, a);
  }
  return Ah = o, Ah;
}
var Th, p0;
function Qv() {
  if (p0) return Th;
  p0 = 1;
  var r = Jv(), a = 1, n = Object.prototype, o = n.hasOwnProperty;
  function u(s, h, l, g, p, b) {
    var m = l & a, C = r(s), v = C.length, _ = r(h), w = _.length;
    if (v != w && !m)
      return !1;
    for (var x = v; x--; ) {
      var P = C[x];
      if (!(m ? P in h : o.call(h, P)))
        return !1;
    }
    var c = b.get(s), f = b.get(h);
    if (c && f)
      return c == h && f == s;
    var S = !0;
    b.set(s, h), b.set(h, s);
    for (var E = m; ++x < v; ) {
      P = C[x];
      var T = s[P], D = h[P];
      if (g)
        var I = m ? g(D, T, P, h, s, b) : g(T, D, P, s, h, b);
      if (!(I === void 0 ? T === D || p(T, D, l, g, b) : I)) {
        S = !1;
        break;
      }
      E || (E = P == "constructor");
    }
    if (S && !E) {
      var M = s.constructor, O = h.constructor;
      M != O && "constructor" in s && "constructor" in h && !(typeof M == "function" && M instanceof M && typeof O == "function" && O instanceof O) && (S = !1);
    }
    return b.delete(s), b.delete(h), S;
  }
  return Th = u, Th;
}
var Ph, _0;
function t8() {
  if (_0) return Ph;
  _0 = 1;
  var r = si(), a = Xe(), n = r(a, "DataView");
  return Ph = n, Ph;
}
var Fh, v0;
function e8() {
  if (v0) return Fh;
  v0 = 1;
  var r = si(), a = Xe(), n = r(a, "Promise");
  return Fh = n, Fh;
}
var Oh, y0;
function r8() {
  if (y0) return Oh;
  y0 = 1;
  var r = si(), a = Xe(), n = r(a, "Set");
  return Oh = n, Oh;
}
var kh, m0;
function i8() {
  if (m0) return kh;
  m0 = 1;
  var r = si(), a = Xe(), n = r(a, "WeakMap");
  return kh = n, kh;
}
var Ih, b0;
function n8() {
  if (b0) return Ih;
  b0 = 1;
  var r = t8(), a = el(), n = e8(), o = r8(), u = i8(), s = Sn(), h = o1(), l = "[object Map]", g = "[object Object]", p = "[object Promise]", b = "[object Set]", m = "[object WeakMap]", C = "[object DataView]", v = h(r), _ = h(a), w = h(n), x = h(o), P = h(u), c = s;
  return (r && c(new r(new ArrayBuffer(1))) != C || a && c(new a()) != l || n && c(n.resolve()) != p || o && c(new o()) != b || u && c(new u()) != m) && (c = function(f) {
    var S = s(f), E = S == g ? f.constructor : void 0, T = E ? h(E) : "";
    if (T)
      switch (T) {
        case v:
          return C;
        case _:
          return l;
        case w:
          return p;
        case x:
          return b;
        case P:
          return m;
      }
    return S;
  }), Ih = c, Ih;
}
var Mh, S0;
function a8() {
  if (S0) return Mh;
  S0 = 1;
  var r = Cv(), a = l1(), n = kv(), o = Qv(), u = n8(), s = Aa(), h = u1(), l = f1(), g = 1, p = "[object Arguments]", b = "[object Array]", m = "[object Object]", C = Object.prototype, v = C.hasOwnProperty;
  function _(w, x, P, c, f, S) {
    var E = s(w), T = s(x), D = E ? b : u(w), I = T ? b : u(x);
    D = D == p ? m : D, I = I == p ? m : I;
    var M = D == m, O = I == m, N = D == I;
    if (N && h(w)) {
      if (!h(x))
        return !1;
      E = !0, M = !1;
    }
    if (N && !M)
      return S || (S = new r()), E || l(w) ? a(w, x, P, c, f, S) : n(w, x, D, P, c, f, S);
    if (!(P & g)) {
      var H = M && v.call(w, "__wrapped__"), y = O && v.call(x, "__wrapped__");
      if (H || y) {
        var F = H ? w.value() : w, R = y ? x.value() : x;
        return S || (S = new r()), f(F, R, P, c, S);
      }
    }
    return N ? (S || (S = new r()), o(w, x, P, c, f, S)) : !1;
  }
  return Mh = _, Mh;
}
var Lh, w0;
function s8() {
  if (w0) return Lh;
  w0 = 1;
  var r = a8(), a = wn();
  function n(o, u, s, h, l) {
    return o === u ? !0 : o == null || u == null || !a(o) && !a(u) ? o !== o && u !== u : r(o, u, s, h, n, l);
  }
  return Lh = n, Lh;
}
var Nh, C0;
function o8() {
  if (C0) return Nh;
  C0 = 1;
  var r = s8();
  function a(n, o) {
    return r(n, o);
  }
  return Nh = a, Nh;
}
var h8 = o8();
const x0 = /* @__PURE__ */ ai(h8);
var Gh, E0;
function l8() {
  if (E0) return Gh;
  E0 = 1;
  var r = tl(), a = 1 / 0, n = 17976931348623157e292;
  function o(u) {
    if (!u)
      return u === 0 ? u : 0;
    if (u = r(u), u === a || u === -1 / 0) {
      var s = u < 0 ? -1 : 1;
      return s * n;
    }
    return u === u ? u : 0;
  }
  return Gh = o, Gh;
}
var Dh, R0;
function g1() {
  if (R0) return Dh;
  R0 = 1;
  var r = l8();
  function a(n) {
    var o = r(n), u = o % 1;
    return o === o ? u ? o - u : o : 0;
  }
  return Dh = a, Dh;
}
var Bh, A0;
function u8() {
  if (A0) return Bh;
  A0 = 1;
  function r(a, n) {
    for (var o = -1, u = a == null ? 0 : a.length, s = Array(u); ++o < u; )
      s[o] = n(a[o], o, a);
    return s;
  }
  return Bh = r, Bh;
}
var Uh, T0;
function c8() {
  if (T0) return Uh;
  T0 = 1;
  var r = wa(), a = u8(), n = Aa(), o = i1(), u = r ? r.prototype : void 0, s = u ? u.toString : void 0;
  function h(l) {
    if (typeof l == "string")
      return l;
    if (n(l))
      return a(l, h) + "";
    if (o(l))
      return s ? s.call(l) : "";
    var g = l + "";
    return g == "0" && 1 / l == -1 / 0 ? "-0" : g;
  }
  return Uh = h, Uh;
}
var qh, P0;
function d8() {
  if (P0) return qh;
  P0 = 1;
  var r = c8();
  function a(n) {
    return n == null ? "" : r(n);
  }
  return qh = a, qh;
}
var Hh, F0;
function f8() {
  if (F0) return Hh;
  F0 = 1;
  var r = Xe(), a = g1(), n = tl(), o = d8(), u = r.isFinite, s = Math.min;
  function h(l) {
    var g = Math[l];
    return function(p, b) {
      if (p = n(p), b = b == null ? 0 : s(a(b), 292), b && u(p)) {
        var m = (o(p) + "e").split("e"), C = g(m[0] + "e" + (+m[1] + b));
        return m = (o(C) + "e").split("e"), +(m[0] + "e" + (+m[1] - b));
      }
      return g(p);
    };
  }
  return Hh = h, Hh;
}
var zh, O0;
function g8() {
  if (O0) return zh;
  O0 = 1;
  var r = f8(), a = r("round");
  return zh = a, zh;
}
var p8 = g8();
const pn = /* @__PURE__ */ ai(p8);
var Vh, k0;
function _8() {
  if (k0) return Vh;
  k0 = 1;
  var r = n1(), a = bn(), n = "Expected a function";
  function o(u, s, h) {
    var l = !0, g = !0;
    if (typeof u != "function")
      throw new TypeError(n);
    return a(h) && (l = "leading" in h ? !!h.leading : l, g = "trailing" in h ? !!h.trailing : g), r(u, s, {
      leading: l,
      maxWait: s,
      trailing: g
    });
  }
  return Vh = o, Vh;
}
var v8 = _8();
const p1 = /* @__PURE__ */ ai(v8), I0 = (r) => {
  let a;
  const n = /* @__PURE__ */ new Set(), o = (p, b) => {
    const m = typeof p == "function" ? p(a) : p;
    if (!Object.is(m, a)) {
      const C = a;
      a = (b != null ? b : typeof m != "object" || m === null) ? m : Object.assign({}, a, m), n.forEach((v) => v(a, C));
    }
  }, u = () => a, l = { setState: o, getState: u, getInitialState: () => g, subscribe: (p) => (n.add(p), () => n.delete(p)) }, g = a = r(o, u, l);
  return l;
}, _1 = (r) => r ? I0(r) : I0, Rt = _1(() => ({
  assetsBaseUrl: "",
  background: {
    url: null,
    height: 0,
    width: 0,
    offset: {
      x: 0,
      y: 0
    }
  },
  debug: !1,
  draggable: !0,
  elementsLayerOffsetX: 0,
  elementsMetaData: null,
  fit: mn.COVER,
  isPrintEnabled: !1,
  mapSize: {
    width: 0,
    height: 0
  },
  minScale: 0
})), _a = {
  getBackgroundColor(r) {
    switch (r) {
      case tt.GREY:
        return "rgb(103, 103, 103, 0.4)";
      case tt.BLUE:
        return "rgba(0, 176, 255, 0.4)";
      default:
        Rr(r);
    }
  },
  getBorderColor(r) {
    switch (r) {
      case tt.GREY:
        return "rgb(103, 103, 103)";
      case tt.BLUE:
        return "rgb(0, 176, 255)";
      default:
        Rr(r);
    }
  }
}, qe = {
  loadImageFromUrl(r, a) {
    const { isPrintEnabled: n } = Rt.getState();
    return new Promise((o, u) => {
      const s = document.createElement("img");
      n && (s.crossOrigin = "anonymous"), s.onload = function() {
        const h = new yt.Image({
          image: s,
          listening: !1,
          ...a
        });
        o(h);
      }, s.onerror = u, s.src = r;
    });
  }
};
function M0(r) {
  return typeof r == "string";
}
class er extends yt.Group {
  constructor(n, o) {
    var u;
    super(n);
    Ue(this, "HIGHLIGHT_GROUP_NAME", "highlight");
    Ue(this, "IMAGE_NAME", "image");
    Ue(this, "SPOT_NAME", "spot");
    Ue(this, "GAP", 2);
    Ue(this, "ATTRIBUTE_ICON_WIDTH", 8);
    Ue(this, "highligthColor", null);
    this.spot = o, this.highligthColor = (u = o.highlightColor) != null ? u : null;
  }
  get backgroundBorderColor() {
    var n, o, u;
    return (u = (o = (n = this.spot.style) == null ? void 0 : n.css) == null ? void 0 : o.borderColor) != null ? u : "rgb(135, 135, 135)";
  }
  get hasAttributeIcon() {
    var n;
    return M0((n = this.spot.style) == null ? void 0 : n.attributeIcon);
  }
  get isPlayfield() {
    return this.spot.subType === Er.PLAYFIELD;
  }
  get strokeWidth() {
    var n, o, u;
    return (u = (o = (n = this.spot.style) == null ? void 0 : n.css) == null ? void 0 : o.borderWidth) != null ? u : 1;
  }
  get bgWidth() {
    return this.spot.width - this.strokeWidth;
  }
  addBackground() {
    var o, u, s, h, l;
    const n = new yt.Rect({
      width: this.bgWidth,
      height: this.spot.height - this.strokeWidth,
      fill: (s = (u = (o = this.spot.style) == null ? void 0 : o.css) == null ? void 0 : u.backgroundColor) != null ? s : "#FFF",
      cornerRadius: 4,
      stroke: this.backgroundBorderColor,
      strokeWidth: this.strokeWidth,
      ...((l = (h = this.spot.style) == null ? void 0 : h.css) == null ? void 0 : l.borderStyle) === "dashed" ? { dash: [5, 5] } : {}
    });
    this.add(n);
  }
  async clearHighlight() {
    this.highligthColor = null, this.find(`.${this.HIGHLIGHT_GROUP_NAME}`).forEach((n) => n.destroy());
  }
  async highlight(n, o = !1) {
    try {
      if (this.highligthColor !== null && !o)
        return;
      this.highligthColor = n;
      const u = _a.getBackgroundColor(n), s = _a.getBorderColor(n), h = new yt.Rect({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: this.width(),
        height: this.height(),
        fill: u,
        stroke: s,
        cornerRadius: 4,
        listening: !1
      });
      this.add(h), h.zIndex(1);
      const l = await qe.loadImageFromUrl(
        `${Rt.getState().assetsBaseUrl}/iconset/check.svg`
      ), g = new yt.Circle({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: 16,
        height: 16,
        fill: s,
        x: this.width() / 2,
        y: this.height() / 2,
        listening: !1
      }), p = 10;
      l.name(this.HIGHLIGHT_GROUP_NAME), l.width(p), l.height(p), l.x(this.width() / 2 - p / 2), l.y(this.height() / 2 - p / 2), this.add(g, l);
    } catch (u) {
      console.error(u);
    }
  }
  getYFromImageSize() {
    const n = this.GAP, o = this.findOne(`.${this.IMAGE_NAME}`);
    return o ? o.y() + 1 + o.height() : n;
  }
  async addAttributeIcon() {
    var n;
    try {
      const o = (n = this.spot.style) == null ? void 0 : n.attributeIcon;
      if (!M0(o))
        return;
      const { assetsBaseUrl: u } = Rt.getState(), s = await qe.loadImageFromUrl(
        `${u}/iconset/${o}`
      ), h = this.ATTRIBUTE_ICON_WIDTH, l = new yt.Rect({
        width: h + this.GAP * 2,
        height: h + this.GAP * 2,
        fill: this.backgroundBorderColor,
        listening: !1
      });
      l.x(this.bgWidth - l.width()), s.width(h), s.height(h), s.x(this.bgWidth - h - this.GAP), s.y(this.GAP), s.listening(!1), this.add(l, s);
    } catch (o) {
      console.error(o);
    }
  }
}
const y8 = "background-sea", m8 = "background-sand", b8 = 100;
class S8 extends yt.Layer {
  constructor(n) {
    super({
      draggable: !1,
      listening: !1
    });
    Ue(this, "bgImage", null);
    Ue(this, "seaImage", null);
    Ue(this, "sandRect", null);
    typeof (n == null ? void 0 : n.visible) == "boolean" && this.visible(n.visible), this.init();
  }
  setVisibility(n) {
    this.visible(n);
  }
  toggleVisibility() {
    this.visible(!this.visible());
  }
  updateBgSize() {
    const { background: n, mapSize: o } = Rt.getState();
    this.sandRect !== null && (this.sandRect.width(o.width), this.sandRect.height(o.height)), this.seaImage !== null && this.seaImage.width(o.width), this.bgImage !== null && (this.bgImage.width(n.width), this.bgImage.height(n.height));
  }
  init() {
    this.renderSand(), this.renderSea(() => this.renderCustomBackground());
  }
  renderSand() {
    const { mapSize: n } = Rt.getState();
    this.sandRect = new yt.Rect({
      x: 0,
      y: 0,
      width: n.width,
      height: n.height,
      fill: "wheat",
      id: m8,
      listening: !1,
      draggable: !1
    }), this.add(this.sandRect);
  }
  renderSea(n) {
    const { assetsBaseUrl: o } = Rt.getState();
    qe.loadImageFromUrl(`${o}/images/sea.svg`).then((u) => {
      this.seaImage = u;
      const { mapSize: s } = Rt.getState();
      u.setAttrs({
        x: 0,
        y: 0,
        fillPatternRepeat: "repeat-x",
        width: s.width,
        height: b8,
        id: y8
      }), u.listening(!1), u.draggable(!1), this.add(u), n();
    }).catch((u) => {
      console.error(u);
    });
  }
  renderCustomBackground() {
    const { background: n } = Rt.getState(), o = n.url;
    o && qe.loadImageFromUrl(o).then((u) => {
      this.bgImage = u, u.width(n.width), u.height(n.height), u.x(n.offset.x), u.y(n.offset.y), this.add(u);
    }).catch((u) => {
      console.error(u);
    });
  }
}
var Wh, L0;
function w8() {
  if (L0) return Wh;
  L0 = 1;
  var r = c1();
  function a(n, o) {
    var u = n.length;
    if (u)
      return o += o < 0 ? u : 0, r(o, u) ? n[o] : void 0;
  }
  return Wh = a, Wh;
}
var jh, N0;
function C8() {
  if (N0) return jh;
  N0 = 1;
  var r = w8(), a = g1();
  function n(o, u) {
    return o && o.length ? r(o, a(u)) : void 0;
  }
  return jh = n, jh;
}
var x8 = C8();
const E8 = /* @__PURE__ */ ai(x8);
class oi extends yt.Group {
  constructor(a, n, o) {
    super({
      x: n.x,
      y: n.y,
      ...o
    }), this.decoration = n, this.add(a), this.init(a);
  }
  getSubType() {
    return this.decoration.subType;
  }
  get isSquareCell() {
    return this.decoration.width === this.decoration.cellSize.width;
  }
  get isDebugEnabled() {
    return Rt.getState().debug;
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = new yt.Rect({
      dash: [5, 5],
      height: this.height(),
      listening: !1,
      stroke: "rebeccapurple",
      strokeWidth: 1,
      width: this.width(),
      x: 0,
      y: 0
    });
    this.add(a);
  }
}
const _n = (r) => r * (Math.PI / 180), R8 = (r) => r * (180 / Math.PI);
function G0(r, a) {
  const n = Math.cos(a), o = Math.sin(a);
  return {
    x: r.x * n - r.y * o,
    y: r.y * n + r.x * o
  };
}
function Gr(r, a) {
  const n = { x: -r.width() / 2, y: -r.height() / 2 }, o = G0(n, 0), u = G0(n, _n(a)), s = u.x - o.x, h = u.y - o.y;
  r.rotation(a), r.x(r.x() + s), r.y(r.y() + h);
}
class v1 extends oi {
  constructor(a, n) {
    const o = n.cellSize.width / n.width;
    super(a, n, {
      height: a.height(),
      width: a.width() * o
    }), this.add(a);
  }
  init(a) {
    this.addDebugInfo(), a.x(this.width() / 2 - a.width() / 2), this.decoration.rotation > 0 && Gr(a, this.decoration.rotation);
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = new yt.Rect({
      dash: [5, 5],
      height: this.height(),
      listening: !1,
      stroke: "yellow",
      strokeWidth: 1,
      width: this.width(),
      x: 0,
      y: 0
    });
    this.add(a);
  }
}
class A8 extends oi {
  constructor(a, n) {
    super(a, n, {
      height: n.cellSize.height,
      width: n.cellSize.width
    }), this.add(a);
  }
  init(a) {
    this.adjustImageSize(a), this.adjustImagePosition(a), this.addDebugInfo();
  }
  getCustomDecorationImageSize(a, n, o) {
    const u = a.width / n, s = a.height / o;
    return u < s ? {
      width: a.width,
      height: Math.floor(o * u)
    } : {
      width: Math.floor(n * s),
      height: a.height
    };
  }
  adjustImageSize(a) {
    a.setAttrs({
      ...this.getCustomDecorationImageSize(
        this.decoration,
        a.width(),
        a.height()
      )
    });
  }
  adjustImagePosition(a) {
    a.x(this.width() / 2 - a.width() / 2), a.y(this.height() / 2 - a.height() / 2), this.decoration.rotation > 0 && Gr(a, this.decoration.rotation);
  }
}
class T8 extends oi {
  constructor(a, n) {
    super(a, n, {
      height: n.cellSize.height,
      width: n.cellSize.width
    }), this.add(a);
  }
  init() {
  }
}
class P8 extends oi {
  constructor(a, n) {
    super(a, n, {
      height: n.height,
      width: n.width
    }), this.add(a);
  }
  init(a) {
    this.adjustLineWidth(a), this.adjustRotation(a), this.addDebugInfo();
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = _n(this.decoration.rotation), n = Math.cos(a), o = Math.sin(a);
    if (Math.abs(n) === 1 || Math.abs(o) === 1)
      return;
    const u = n < 0, s = o < 0, h = Math.abs(this.decoration.width * n), l = Math.abs(this.decoration.width * o), g = new yt.Rect({
      x: u ? -h : 0,
      y: s ? -l : 0,
      width: h,
      height: l,
      stroke: "goldenrod",
      strokeWidth: 1,
      dash: [5, 5],
      listening: !1
    }), p = this.decoration.cellSize.width / this.decoration.width;
    if (p !== 1) {
      const b = h * p, m = new yt.Rect({
        x: u ? -b : 0,
        y: s ? -l : 0,
        width: b,
        height: l,
        stroke: "deepskyblue",
        strokeWidth: 1,
        dash: [5, 5],
        listening: !1
      });
      this.add(m);
    }
    this.add(g);
  }
  adjustLineWidth(a) {
    if (this.isSquareCell || !(a instanceof yt.Group) || a.children.length < 1)
      return;
    const n = a.children[0], o = _n(this.decoration.rotation), u = Math.cos(o), s = Math.sin(o);
    if (Math.abs(s) === 1)
      return;
    if (Math.abs(u) === 1) {
      n.width(this.decoration.cellSize.width);
      return;
    }
    const h = this.decoration.width * u, l = this.decoration.width * s, g = this.decoration.cellSize.width / this.decoration.width, p = h * g, b = Math.sqrt(Math.pow(p, 2) + Math.pow(l, 2));
    n.width(b);
  }
  adjustRotation(a) {
    if (this.decoration.rotation <= 0)
      return;
    const n = _n(this.decoration.rotation), o = Math.cos(n), u = Math.sin(n);
    if (this.isSquareCell || Math.abs(o) === 1 || Math.abs(u) === 1) {
      Gr(a, this.decoration.rotation);
      return;
    }
    const s = o < 0, h = u < 0, l = Math.abs(this.decoration.width * o), g = Math.abs(this.decoration.width * u), p = this.decoration.cellSize.width / this.decoration.width, b = l * p, m = Math.atan(g / b), C = R8(m);
    s && h ? Gr(a, C + 180) : s ? Gr(a, 180 - C) : Gr(a, C);
  }
}
function F8(r) {
  const a = _n(r), n = Math.cos(a), o = Math.sin(a);
  switch (!0) {
    case n === 1:
      return "horizontal";
    case n === -1:
      return "horizontal-flip";
    case o === 1:
      return "vertical";
    case o === -1:
      return "vertical-flip";
    default:
      return "diagonal";
  }
}
class O8 extends v1 {
  constructor(a, n) {
    super(a, n);
  }
  init(a) {
    const n = F8(this.decoration.rotation);
    if (this.isSquareCell || n === "diagonal") {
      super.init(a);
      return;
    }
    this.decoration.rotation > 0 && Gr(a, this.decoration.rotation), this.handleStretch(a, n), this.addDebugInfo();
  }
  addDebugInfo() {
    if (!this.isDebugEnabled)
      return;
    const a = this.children[0];
    if (!a)
      return;
    const n = new yt.Rect({
      dash: [5, 5],
      height: a.height(),
      listening: !1,
      stroke: "hotpink",
      strokeWidth: 1,
      width: a.width(),
      x: 0,
      y: 0
    });
    this.add(n);
  }
  handleStretch(a, n) {
    const o = this.decoration.cellSize.width / this.decoration.width;
    switch (n) {
      case "vertical": {
        const u = a.height() * o, s = u - a.height();
        a.height(u), a.offsetY(s);
        break;
      }
      case "vertical-flip": {
        a.height(a.height() * o);
        break;
      }
      case "horizontal": {
        a.width(a.width() * o), a.x(0);
        break;
      }
      case "horizontal-flip": {
        a.width(a.width() * o), a.x(this.width());
        break;
      }
      default:
        Rr(n);
    }
  }
}
const we = '"Roboto", system-ui, -apple-system, "Segoe UI", "Helvetica Neue", Arial, sans-serif', k8 = "black";
class I8 {
  async createDecoration(a) {
    switch (a.subType) {
      case ge.CUSTOM:
        return M8(a);
      case ge.LABEL:
        return L8(a);
      case ge.LINE:
        return G8(a);
      case ge.BASKET_FIELD:
      case ge.BEACH_VOLLEY:
      case ge.FOOTBOARD:
      case ge.POOL:
      case ge.POOL_ROUNDED:
      case ge.SOCCER_FIELD:
      case ge.TENT:
      case ge.TENT_BIG:
        return D0(a, !0);
      default:
        return D0(a);
    }
  }
}
async function M8(r) {
  if (!r.url)
    throw new Error("Decoration URL is required");
  try {
    const a = await qe.loadImageFromUrl(r.url);
    return a.setAttrs({
      x: 0,
      y: 0
    }), new A8(a, r);
  } catch (a) {
    console.error(a);
  }
  return null;
}
async function D0(r, a = !1) {
  const n = `${Rt.getState().assetsBaseUrl}/decorations/${r.subType}.svg`;
  try {
    const o = await qe.loadImageFromUrl(n), u = D8(r), s = o.width(), h = o.height();
    if (s > h) {
      const l = u.width, g = h / s * u.height;
      o.setAttrs({
        height: g,
        width: l
      });
    } else if (s < h) {
      const l = u.height, g = s / h * u.width;
      o.setAttrs({
        height: l,
        width: g
      });
    } else {
      const l = u.height, g = u.width;
      o.setAttrs({
        height: l,
        width: g
      });
    }
    return a ? new O8(o, r) : new v1(o, r);
  } catch (o) {
    console.error(o);
  }
  return null;
}
function L8(r) {
  const a = new yt.Text({
    fill: "black",
    fontFamily: we,
    fontSize: 14,
    listening: !1,
    padding: 4,
    text: r.name,
    x: 0,
    y: 0
  });
  return new T8(a, r);
}
const N8 = (r) => r.trim().length === 0 ? k8 : r;
function G8(r) {
  const a = new yt.Group({
    listening: !1,
    x: 0,
    y: 0
  }), n = new yt.Rect({
    fill: N8(r.name),
    height: r.height,
    listening: !1,
    strokeEnabled: !1,
    width: r.width,
    x: 0,
    y: 0
  });
  return a.add(n), new P8(a, r);
}
function D8(r) {
  return r.width > r.height ? {
    width: r.height,
    height: r.height
  } : r.width < r.height ? {
    width: r.width,
    height: r.width
  } : {
    width: r.width,
    height: r.height
  };
}
function B8(r) {
  const a = r.split(" ");
  return {
    timeSlot: a[a.length - 1],
    name: a.slice(0, a.length - 1).join(" ")
  };
}
function rl(r) {
  return r.subType === Er.PLAYFIELD ? B8(r.name).name : r.name;
}
const ti = 1, B0 = "image";
class y1 extends er {
  constructor(a, n) {
    super(a, n);
  }
  get isAvailable() {
    var a;
    return ((a = this.spot.style) == null ? void 0 : a.iconColor) === tt.GREEN;
  }
  async init() {
    this.addBackground(), await this.addImage(), this.addSpotName();
  }
  async clearHighlight() {
    if (this.highligthColor !== null)
      return this.highligthColor = null, this.redrawImage();
  }
  async highlight() {
    this.highligthColor === null && (this.highligthColor = tt.BLUE, await this.redrawImage());
  }
  async redrawImage() {
    var n;
    (n = this.findOne(`.${B0}`)) == null || n.destroy();
    const a = await this.addImage();
    a !== null && a.zIndex(1);
  }
  addBackground() {
    const a = new yt.Rect({
      width: this.spot.width,
      height: this.spot.height,
      fill: "#FFF",
      cornerRadius: 4
    });
    this.add(a);
  }
  getImageName() {
    return this.highligthColor ? "checked" : this.isAvailable ? "available" : "not-available";
  }
  getImageWidth() {
    return this.spot.subType === Er.CABIN ? 24 : this.spot.subType === Er.UMBRELLA && this.highligthColor ? 35 : 30;
  }
  async addImage() {
    try {
      const a = `${this.spot.subType}-${this.getImageName()}`, n = `${Rt.getState().assetsBaseUrl}/spots/${a}.svg`, o = await qe.loadImageFromUrl(n), u = this.getImageWidth(), s = u * o.height() / o.width();
      return o.width(u), o.height(s), o.x(this.width() / 2 - o.width() / 2), o.y(this.height() / 2 - o.height() / 2), o.name(B0), this.add(o), o;
    } catch (a) {
      console.error(a);
    }
    return null;
  }
  addSpotName() {
    if (!this.isAvailable)
      return;
    if (this.spot.subType === Er.PLAYFIELD)
      return this.addPlayfieldName();
    const a = new yt.Text({
      text: rl(this.spot),
      fontSize: 12,
      fontFamily: we,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    a.width() > this.width() ? (a.width(this.width() - ti * 2), a.x(this.width() - a.width() - ti)) : a.x(this.width() - a.width() - ti * 2), a.y(this.height() - a.height());
    const n = new yt.Rect({
      cornerRadius: 4,
      fill: "white",
      height: a.height(),
      listening: !1,
      width: a.width(),
      x: a.x(),
      y: a.y()
    });
    this.add(n, a);
  }
  addPlayfieldName() {
    const [a, n] = this.spot.name.split(" "), o = new yt.Text({
      text: a,
      fontFamily: we,
      fontSize: 10,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    o.x(this.width() - o.width() - ti * 2), o.y(this.height() - o.height());
    const u = new yt.Rect({
      cornerRadius: 4,
      fill: "white",
      height: o.height() * 2,
      listening: !1,
      width: this.width(),
      x: 0,
      y: o.y()
    }), s = n.indexOf("-"), h = n.substring(0, s + 1), l = n.substring(s + 1), g = new yt.Text({
      text: h,
      fontFamily: we,
      fontSize: 10,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    g.x(this.width() - g.width() - ti * 2), g.y(u.y() + 10);
    const p = new yt.Text({
      text: l,
      fontFamily: we,
      fontSize: 10,
      fontStyle: "bold",
      fill: "black",
      wrap: "none",
      listening: !1,
      x: 0,
      y: 0
    });
    p.x(this.width() - p.width() - ti * 2), p.y(g.y() + 10), this.add(u, o, g, p);
  }
}
const il = {
  getSpotIconByColor(r, a) {
    const n = `spots/${r}`;
    switch (a) {
      case tt.RED:
      case tt.BLUE:
      case tt.GREEN:
      case tt.YELLOW:
      case tt.ORANGE:
      case tt.WHITE:
      case tt.BLACK:
      case tt.PURPLE:
      case tt.BLACK_WHITE:
      case tt.BLACK_BLUE:
      case tt.BLACK_YELLOW:
      case tt.BLACK_GREY:
      case tt.BLACK_RED:
      case tt.BLACK_GREEN:
      case tt.BLACK_PURPLE:
      case tt.GREY:
      case tt.CYAN:
      case tt.BROWN:
      case tt.LIME:
      case tt.PINK:
        return `${n}/${a.toLowerCase()}.svg`;
      case tt.PINK_FLUO:
        return `${n}/pinkfluo.svg`;
      case tt.RED_FLUO:
        return `${n}/redfluo.svg`;
      case tt.BLUE_FLUO:
        return `${n}/bluefluo.svg`;
      case tt.GREEN_FLUO:
        return `${n}/greenfluo.svg`;
      case tt.YELLOW_FLUO:
        return `${n}/yellowfluo.svg`;
      case tt.WHITE_FLUO:
        return `${n}/whitefluo.svg`;
      case tt.PURPLE_FLUO:
        return `${n}/purplefluo.svg`;
    }
  }
};
class U8 extends er {
  constructor(a, n) {
    super(a, n);
  }
  async init() {
    this.addBackground(), await this.addImage(), this.addSpotName(), this.addCustomLabel();
  }
  async clearHighlight() {
  }
  async highlight() {
  }
  addBackground() {
    var n, o, u, s, h, l, g, p;
    const a = new yt.Circle({
      radius: this.width() / 2,
      fill: (u = (o = (n = this.spot.style) == null ? void 0 : n.css) == null ? void 0 : o.backgroundColor) != null ? u : "#FFF",
      stroke: "rgb(135, 135, 135)",
      strokeWidth: (l = (h = (s = this.spot.style) == null ? void 0 : s.css) == null ? void 0 : h.borderWidth) != null ? l : 1,
      x: this.width() / 2,
      y: this.height() / 2,
      ...((p = (g = this.spot.style) == null ? void 0 : g.css) == null ? void 0 : p.borderStyle) === "dashed" ? { dash: [5, 5] } : {}
    });
    this.add(a);
  }
  async addImage() {
    var a, n;
    try {
      const o = `${Rt.getState().assetsBaseUrl}/${il.getSpotIconByColor(this.spot.subType, (n = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? n : tt.GREEN)}`, u = await qe.loadImageFromUrl(o), s = 32, h = s * u.height() / u.width();
      u.width(s), u.height(h), u.x(this.width() / 2 - u.width() / 2), u.y(this.height() / 2 - u.height() / 2), this.add(u);
    } catch (o) {
      console.error(o);
    }
  }
  addSpotName() {
    const a = new yt.Text({
      text: this.spot.name,
      fontFamily: we,
      fontSize: 10,
      fontStyle: "bold",
      fill: "#242424",
      align: "center",
      wrap: "none",
      width: this.width(),
      y: 38,
      listening: !1
    });
    this.add(a);
  }
  addCustomLabel() {
    if (typeof this.spot.customLabel != "string")
      return;
    const a = new yt.Text({
      text: this.spot.customLabel,
      fontFamily: we,
      fontSize: 8,
      fill: "#242424",
      align: "center",
      width: this.width(),
      y: 8,
      listening: !1
    });
    this.add(a);
  }
}
const U0 = "SPOT_DATE", ca = 10, q8 = 6.6, q0 = 13;
class H8 extends er {
  constructor(a, n) {
    super(a, n);
  }
  async init() {
    this.addBackground(), this.addCustomerName(), this.addServiceIcons(), await this.addImage(), this.addDate(), this.addSpotName(), this.addStaging(), this.highligthColor && await this.highlight(this.highligthColor, !0), await this.addAttributeIcon();
  }
  async addImage() {
    var a, n;
    try {
      const o = `${Rt.getState().assetsBaseUrl}/${il.getSpotIconByColor(this.spot.subType, (n = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? n : tt.GREEN)}`, u = await qe.loadImageFromUrl(o, {
        name: this.IMAGE_NAME,
        y: 14
      }), s = 1 / (u.height() / q0);
      u.width(u.width() * s), u.height(q0), u.x(this.GAP), this.add(u);
    } catch (o) {
      console.error(o);
    }
  }
  getSpotNameWidth() {
    const a = this.findOne(`.${U0}`);
    return a ? this.bgWidth - a.width() + this.strokeWidth : this.bgWidth;
  }
  addSpotName() {
    const a = this.getSpotNameWidth(), n = new yt.Text({
      fill: "black",
      fontSize: ca,
      fontFamily: we,
      fontStyle: "bold",
      letterSpacing: -0.4,
      listening: !1,
      name: this.SPOT_NAME,
      text: rl(this.spot),
      width: a,
      wrap: "none",
      x: this.GAP / 2,
      y: 30 - this.strokeWidth
    });
    this.add(n);
  }
  addStaging() {
    if (this.spot.staging === null)
      return;
    const a = new yt.Text({
      text: this.spot.staging,
      fontFamily: we,
      fontSize: this.isPlayfield ? q8 : ca,
      fill: "black",
      y: 20 - this.strokeWidth,
      listening: !1
    });
    a.x(
      this.width() - a.width() * 2 / this.GAP - this.strokeWidth
    ), this.add(a);
  }
  addDate() {
    var o, u, s;
    const a = (s = (o = this.spot.reservation) == null ? void 0 : o.endDate) != null ? s : (u = this.spot.reservation) == null ? void 0 : u.startDate;
    if (a === null)
      return;
    const n = new yt.Text({
      text: a,
      name: U0,
      fontFamily: we,
      fontSize: ca,
      letterSpacing: -0.6,
      fill: "black",
      y: 30 - this.strokeWidth,
      listening: !1,
      wrap: "none"
    });
    n.x(this.width() - n.width() - this.strokeWidth), this.add(n);
  }
  addCustomerName() {
    var o;
    const a = (o = this.spot.reservation) == null ? void 0 : o.customerName;
    if (typeof a != "string")
      return;
    const n = new yt.Text({
      ellipsis: !0,
      fill: "black",
      fontFamily: we,
      fontSize: ca,
      listening: !1,
      text: a,
      width: this.width() - 2 * this.GAP - (this.hasAttributeIcon ? this.ATTRIBUTE_ICON_WIDTH : 0),
      wrap: "none",
      x: this.GAP,
      y: this.GAP
    });
    this.add(n);
  }
  async addServiceIcons() {
    if (!Array.isArray(this.spot.serviceIcons) || this.spot.serviceIcons.length === 0)
      return;
    const { assetsBaseUrl: a } = Rt.getState(), n = 7;
    let o = 0;
    for await (const u of this.spot.serviceIcons)
      try {
        const s = await qe.loadImageFromUrl(
          `${a}/services/${u}`
        ), h = s.width() * n / s.height();
        s.width(h), s.height(n), s.y(12), s.x(this.width() - s.width() - o - this.strokeWidth), s.listening(!1), o += s.width(), this.add(s);
      } catch (s) {
        console.error(s);
      }
  }
}
const z8 = "SPOT_DATE", Kh = 10, V8 = 6.6, H0 = 13;
class W8 extends er {
  constructor(a, n) {
    super(a, n);
  }
  async init() {
    this.addBackground(), await this.addImage(), this.addSpotName(), this.addDate(), this.addStaging(), this.highligthColor && await this.highlight(this.highligthColor, !0), await this.addAttributeIcon();
  }
  async clearHighlight() {
    this.highligthColor = null, this.find(`.${this.HIGHLIGHT_GROUP_NAME}`).forEach((a) => a.destroy());
  }
  async highlight(a, n = !1) {
    try {
      if (this.highligthColor !== null && !n)
        return;
      this.highligthColor = a;
      const o = _a.getBackgroundColor(a), u = _a.getBorderColor(a), s = new yt.Rect({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: this.width(),
        height: this.height(),
        fill: o,
        stroke: u,
        cornerRadius: 4,
        listening: !1
      });
      this.add(s), s.zIndex(1);
      const h = await qe.loadImageFromUrl(
        `${Rt.getState().assetsBaseUrl}/iconset/check.svg`
      ), l = new yt.Circle({
        name: this.HIGHLIGHT_GROUP_NAME,
        width: 16,
        height: 16,
        fill: u,
        x: this.width() / 2,
        y: this.height() / 2,
        listening: !1
      }), g = 10;
      h.name(this.HIGHLIGHT_GROUP_NAME), h.width(g), h.height(g), h.x(this.width() / 2 - g / 2), h.y(this.height() / 2 - g / 2), this.add(l, h);
    } catch (o) {
      console.error(o);
    }
  }
  getYFromSpotName() {
    const a = this.GAP, n = this.findOne(`.${this.SPOT_NAME}`);
    return n ? a + n.y() + n.height() : a;
  }
  async addImage() {
    var a, n;
    try {
      const o = `${Rt.getState().assetsBaseUrl}/${il.getSpotIconByColor(this.spot.subType, (n = (a = this.spot.style) == null ? void 0 : a.iconColor) != null ? n : tt.GREEN)}`, u = await qe.loadImageFromUrl(o, {
        name: this.IMAGE_NAME,
        y: this.GAP
      }), s = 1 / (u.height() / H0);
      u.width(u.width() * s), u.height(H0), u.x(this.spot.width / 2 - u.width() / 2), this.add(u);
    } catch (o) {
      console.error(o);
    }
  }
  getSpotNameWidth() {
    return this.spot.width;
  }
  addSpotName() {
    const a = this.getSpotNameWidth(), n = new yt.Text({
      align: "center",
      ellipsis: !0,
      fill: "black",
      fontFamily: we,
      fontSize: Kh,
      fontStyle: "bold",
      listening: !1,
      name: this.SPOT_NAME,
      text: rl(this.spot),
      width: a,
      wrap: "none",
      y: this.getYFromImageSize()
    });
    this.add(n);
  }
  addStaging() {
    if (this.spot.layout !== Pe.VIEWER_STAGING || this.spot.staging === null)
      return;
    const a = new yt.Text({
      align: "center",
      ellipsis: !0,
      fill: "black",
      fontFamily: we,
      fontSize: this.isPlayfield ? V8 : Kh,
      listening: !1,
      text: this.spot.staging,
      width: this.spot.width,
      wrap: "none",
      y: this.getYFromSpotName()
    });
    this.add(a);
  }
  addDate() {
    var o, u, s;
    const a = (s = (o = this.spot.reservation) == null ? void 0 : o.endDate) != null ? s : (u = this.spot.reservation) == null ? void 0 : u.startDate;
    if (this.spot.layout !== Pe.VIEWER_DATE || a === null)
      return;
    const n = new yt.Text({
      align: "center",
      ellipsis: !0,
      fill: "black",
      fontFamily: we,
      fontSize: Kh,
      listening: !1,
      name: z8,
      text: a,
      width: this.spot.width,
      wrap: "none",
      y: this.getYFromSpotName()
    });
    this.add(n);
  }
}
class j8 {
  async createSpot(a) {
    const n = {
      id: a.id,
      x: a.x,
      y: a.y,
      width: a.width,
      height: a.height
    };
    let o;
    switch (a.layout) {
      case Pe.BOOKING_NAME:
        o = new y1(n, a);
        break;
      case Pe.VIEWER_DATE:
      case Pe.VIEWER_FULL:
      case Pe.VIEWER_NAME:
      case Pe.VIEWER_STAGING:
        o = K8(n, a);
        break;
      default:
        Rr(a.layout);
    }
    return await o.init(), o;
  }
}
function K8(r, a) {
  if (a.subType === Er.BEDS)
    return new U8(
      {
        ...r,
        height: 52,
        width: 52
      },
      a
    );
  switch (a.layout) {
    case Pe.BOOKING_NAME:
      throw new Error(`Invalid layout: ${a.layout}`);
    case Pe.VIEWER_FULL:
      return new H8(r, a);
    case Pe.VIEWER_DATE:
    case Pe.VIEWER_NAME:
    case Pe.VIEWER_STAGING:
      return new W8(r, a);
    default:
      Rr(a.layout);
  }
}
const ii = _1(() => ({
  cachePixelRation: 2,
  clusterSize: 500,
  dragMoveThrottle: 500,
  lazyLoadEnabled: !1
})), z0 = "spot-group";
class Y8 extends yt.Layer {
  constructor() {
    super(...arguments);
    Ue(this, "spotClusterMap", /* @__PURE__ */ new Map());
  }
  async renderElements({
    elements: n,
    layerConfig: o
  }) {
    var _, w, x, P;
    this.destroyChildren();
    const u = new j8(), s = new I8(), h = (w = (_ = o == null ? void 0 : o.spots) == null ? void 0 : _.visible) != null ? w : !0, l = (P = (x = o == null ? void 0 : o.decorations) == null ? void 0 : x.visible) != null ? P : !0, g = n.map(
      async (c) => {
        if (r6(c)) {
          const S = await u.createSpot(c);
          return h || S.visible(!1), S;
        }
        const f = await s.createDecoration(c);
        if (f === null)
          throw new Error(
            `Cannot create decoration element from: ${JSON.stringify(c)}`
          );
        return l || f.visible(!1), f;
      }
    ), p = await Promise.allSettled(g), { decorations: b, spots: m } = p.reduce(
      (c, f) => {
        const { status: S } = f;
        switch (S) {
          case "rejected":
            console.error(f.reason);
            break;
          case "fulfilled": {
            f.value instanceof er ? c.spots.push(f.value) : c.decorations.push(f.value);
            break;
          }
          default:
            Rr(S);
        }
        return c;
      },
      { spots: [], decorations: [] }
    ), C = this.sortDecorations(b), v = this.getSpotClusters(m);
    this.add(...C, ...v), this.adjustLayerPosition(), v.forEach((c) => {
      c.cache({
        pixelRatio: Math.min(2, ii.getState().cachePixelRation)
      });
    });
  }
  setVisibility(n, o) {
    switch (n) {
      case fr.SPOT: {
        this.setSpotsVisibility(o);
        break;
      }
      case fr.DECORATION: {
        this.setDecorationsVisibility(o);
        break;
      }
      default:
        Rr(n);
    }
  }
  toggleVisibility(n) {
    switch (n) {
      case fr.SPOT: {
        this.setSpotsVisibility();
        break;
      }
      case fr.DECORATION: {
        this.setDecorationsVisibility();
        break;
      }
      default:
        Rr(n);
    }
  }
  onElementHighligh(n) {
    const o = this.spotClusterMap.get(n);
    o && (o.isCached() && o.clearCache(), o.cache({
      pixelRatio: Math.min(2, ii.getState().cachePixelRation)
    }));
  }
  updateClusterVisibility() {
    if (!ii.getState().lazyLoadEnabled)
      return;
    const n = this.getStage(), o = {
      x: -n.x() / n.scaleX(),
      y: -n.y() / n.scaleY(),
      width: n.width() / n.scaleX(),
      height: n.height() / n.scaleY()
    };
    this.find(`.${z0}`).forEach((u) => {
      if (!(u instanceof yt.Group))
        return;
      const s = u.getClientRect({ relativeTo: n }), h = yt.Util.haveIntersection(s, o);
      h !== u.visible() && u.visible(h);
    });
  }
  updateOffset(n) {
    this.x(n), Rt.setState({
      elementsLayerOffsetX: n
    });
  }
  adjustLayerPosition() {
    if (this.children.length === 0) {
      this.updateOffset(0);
      return;
    }
    const { mapSize: n, background: o, elementsMetaData: u } = Rt.getState();
    if (!o.url && u !== null && u.maxX < n.width) {
      const s = n.width / 2 - u.maxX / 2;
      this.updateOffset(s);
    } else
      this.updateOffset(0);
  }
  setSpotsVisibility(n) {
    this.children.forEach((o) => {
      o instanceof er && o.visible(n != null ? n : !o.visible());
    });
  }
  setDecorationsVisibility(n) {
    this.children.forEach((o) => {
      o instanceof oi && o.visible(n != null ? n : !o.visible());
    });
  }
  clusterize(n, o) {
    const u = Math.ceil(n.length / o.clusterSize), s = [];
    for (let h = 0; h < u; h++) {
      const l = new yt.Group({
        name: o.groupName
      }), g = [];
      for (let p = 0; p < o.clusterSize; p++) {
        const b = h * o.clusterSize + p;
        if (b >= n.length)
          break;
        const m = E8(n, b);
        m && (g.push(m), this.spotClusterMap.set(m.id(), l));
      }
      l.add(...g), s.push(l);
    }
    return s;
  }
  sortDecorations(n) {
    return n.sort((o, u) => {
      const s = o.getSubType() === ge.LABEL, h = u.getSubType() === ge.LABEL;
      return s && !h ? 1 : !s && h ? -1 : 0;
    });
  }
  getSpotClusters(n) {
    this.spotClusterMap.clear();
    const o = n.sort((u, s) => u.x() - s.x());
    return this.clusterize(o, {
      clusterSize: ii.getState().clusterSize,
      groupName: z0
    });
  }
}
const V0 = 1754, da = "black", fa = 0.5, vn = class vn extends yt.Layer {
  constructor(a) {
    super(), this.init(a);
  }
  init(a) {
    this.buildPrintPreview(a);
  }
  getPrintPreview() {
    return this.findOne(`#${vn.PRINT_PREVIEW_ID}`);
  }
  buildPrintPreview(a) {
    var v, _, w, x, P, c, f, S;
    const { mapSize: n } = Rt.getState(), o = new yt.Rect({
      id: vn.PRINT_PREVIEW_ID,
      x: (_ = (v = a.initialPreview) == null ? void 0 : v.x) != null ? _ : 0,
      y: (x = (w = a.initialPreview) == null ? void 0 : w.y) != null ? x : 0,
      width: (c = (P = a.initialPreview) == null ? void 0 : P.width) != null ? c : 100,
      height: (S = (f = a.initialPreview) == null ? void 0 : f.height) != null ? S : 100,
      draggable: !0
    }), u = o.x(), s = o.y(), h = o.x() + o.width(), l = o.y() + o.height(), g = new yt.Rect({
      x: 0,
      y: 0,
      width: u,
      height: n.height,
      fill: da,
      opacity: fa,
      listening: !1
    }), p = new yt.Rect({
      x: h - 0.5,
      y: 0,
      width: n.width - h,
      height: n.height,
      fill: da,
      opacity: fa,
      listening: !1
    }), b = new yt.Rect({
      x: u,
      y: 0,
      width: o.width(),
      height: s,
      fill: da,
      opacity: fa,
      listening: !1
    }), m = new yt.Rect({
      x: u,
      y: l,
      width: o.width(),
      height: n.height - l,
      fill: da,
      opacity: fa,
      listening: !1
    }), C = new yt.Transformer({
      enabledAnchors: [
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right",
        "top-center",
        "middle-right",
        "middle-left",
        "bottom-center"
      ],
      rotateEnabled: !1,
      keepRatio: !1,
      anchorFill: "white",
      anchorStroke: "black",
      borderStroke: "black",
      borderStrokeWidth: 1,
      flipEnabled: !1
    });
    this.add(
      g,
      p,
      b,
      m,
      o,
      C
    ), C.nodes([o]), o.on("transform dragmove", () => {
      const E = this.getPrintPreview();
      if (!E) {
        console.error("printPreview is not initialized");
        return;
      }
      const T = E.width() * E.scaleX(), D = E.height() * E.scaleY(), I = E.x(), M = E.y(), O = E.x() + T, N = E.y() + D;
      g.width(I), p.setAttrs({
        x: O - 0.5,
        width: n.width - O
      }), b.setAttrs({
        x: I,
        y: 0,
        width: T,
        height: M
      }), m.setAttrs({
        x: I,
        y: N,
        width: T,
        height: n.height - N
      });
    }), o.on("transformend dragend", () => {
      a.cb && this.print(this.parent).then(a.cb);
    });
  }
  print(a) {
    return new Promise((n, o) => {
      const u = this.getPrintPreview();
      if (!u) {
        o("printPreview is not initialized");
        return;
      }
      const s = a.scaleX(), h = u.width() * u.scaleX(), l = u.height() * u.scaleY(), g = u.x(), p = u.y(), b = l > h ? V0 / (l * s) : V0 / (h * s);
      this.hide();
      try {
        a.toDataURL({
          x: g * s,
          y: p * s,
          // keep at least a 5x on the image
          pixelRatio: Math.max(b, 5),
          width: h * s,
          height: l * s,
          callback: (m) => {
            this.show(), n({
              data: m,
              x: g,
              y: p,
              width: h,
              height: l,
              pixelRatio: b
            });
          }
        });
      } catch (m) {
        this.show(), o(m);
      }
    });
  }
};
Ue(vn, "PRINT_PREVIEW_ID", "print-preview");
let va = vn;
const W0 = {
  fit(r, a) {
    const n = r.width / r.height, o = a.width / a.height;
    return n > o ? {
      width: a.width,
      height: a.width / n
    } : {
      width: a.height * n,
      height: a.height
    };
  },
  cover(r, a) {
    const n = r.width / r.height, o = a.width / a.height;
    return n < o ? {
      width: a.width,
      height: a.width / n
    } : {
      width: a.height * n,
      height: a.height
    };
  }
};
function ya(r, a) {
  const { draggable: n, fit: o } = Rt.getState();
  return o === mn.CONTAIN ? W0.fit(a, {
    width: r.clientWidth,
    height: r.clientHeight
  }) : n ? {
    width: r.clientWidth,
    height: r.clientHeight
  } : W0.cover(a, {
    width: r.clientWidth,
    height: r.clientHeight
  });
}
function X8(r) {
  const a = ya(r.container, r.mapSize), n = new yt.Stage({
    container: r.container.id,
    width: a.width,
    height: a.height,
    draggable: r.draggable
  });
  n.on("click tap", function(u) {
    var h, l;
    const s = u.target.getParent();
    s instanceof er && ((l = (h = r.events) == null ? void 0 : h.onMapElementClick) == null || l.call(h, s.id()));
  });
  const o = p1(
    () => {
      var u, s;
      if ((u = r.events) != null && u.onMapPanZoom) {
        const { x: h, y: l } = n.position(), g = n.scaleX();
        (s = r.events) == null || s.onMapPanZoom({
          position: {
            x: h / g,
            y: l / g
          },
          zoom: g
        });
      }
    },
    ii.getState().dragMoveThrottle,
    {
      leading: !0,
      trailing: !0
    }
  );
  return n.on("dragmove", o), n.on("mouseover", () => {
    var l, g, p, b;
    const u = n.getPointerPosition(), { isPrintEnabled: s } = Rt.getState();
    if (u === null)
      return;
    let h = n.getIntersection(u);
    if (s) {
      if ((h == null ? void 0 : h.id()) === va.PRINT_PREVIEW_ID) {
        n.container().style.cursor = "move";
        return;
      }
    } else {
      for (; h !== null; ) {
        if (h instanceof y1) {
          n.container().style.cursor = h.isAvailable ? "pointer" : "not-allowed";
          return;
        }
        if (h instanceof er) {
          (g = (l = r.events) == null ? void 0 : l.onMapElementHover) == null || g.call(l, h.id()), n.container().style.cursor = "pointer";
          return;
        }
        if (h instanceof oi) {
          (b = (p = r.events) == null ? void 0 : p.onMapElementHover) == null || b.call(p, h.id());
          return;
        }
        h = h.parent;
      }
      n.container().style.cursor = "move";
    }
  }), n.on("mouseout", () => {
    n.container().style.cursor = "default";
  }), n;
}
const yn = 2;
function Dr(r) {
  const { mapSize: a } = Rt.getState(), n = a.width * r.scale, o = a.height * r.scale;
  return {
    x: Math.min(
      0,
      Math.max(r.stageSize.width - n, r.pos.x)
    ),
    y: Math.min(
      0,
      Math.max(r.stageSize.height - o, r.pos.y)
    )
  };
}
function Xh(r) {
  const { minScale: a } = Rt.getState();
  r.scale({ x: a, y: a }), r.position(
    Dr({
      scale: r.scaleX(),
      pos: r.position(),
      stageSize: { width: r.width(), height: r.height() }
    })
  );
}
function ma(r, a) {
  return Math.min(Math.max(r, a), yn);
}
function j0(r) {
  const { minScale: a } = Rt.getState();
  let n = r.scale;
  n < a && (n = a), n > yn && (n = yn);
  const o = {
    x: pn((r.point.x - r.stage.x()) / r.stage.scaleX(), 2),
    y: pn((r.point.y - r.stage.y()) / r.stage.scaleX(), 2)
  };
  r.stage.scale({
    x: n,
    y: n
  });
  const u = Dr({
    scale: n,
    pos: {
      x: pn(r.point.x - o.x * n, 2),
      y: pn(r.point.y - o.y * n, 2)
    },
    stageSize: { width: r.stage.width(), height: r.stage.height() }
  });
  return r.stage.position(u), {
    position: {
      x: o.x,
      y: o.y
    },
    scale: n
  };
}
function $8(r, a) {
  return Math.sqrt(Math.pow(a.x - r.x, 2) + Math.pow(a.y - r.y, 2));
}
function K0(r, a) {
  return {
    x: (r.x + a.x) / 2,
    y: (r.y + a.y) / 2
  };
}
const Y0 = 0.2;
yt.hitOnDragEnabled = !0;
const ni = (r, a) => {
  const { fit: n } = Rt.getState();
  return (n === mn.CONTAIN ? Math.min : Math.max)(a.width / r.width, a.height / r.height);
};
async function Sy(r) {
  var C, v, _, w, x, P, c, f, S;
  const a = document.getElementById(r.opts.containerId);
  if (!a)
    throw new Error("Canvas container not found");
  const n = {
    width: Math.max(a.clientWidth, r.opts.size.width),
    height: Math.max(a.clientHeight, r.opts.size.height)
  }, o = (v = (C = r.opts.print) == null ? void 0 : C.enabled) != null ? v : !1, u = (_ = r.opts.draggable) != null ? _ : !0;
  Rt.setState({
    assetsBaseUrl: r.opts.assetsBaseUrl,
    background: r.opts.background,
    debug: !!r.opts.debug,
    fit: (w = r.opts.fit) != null ? w : mn.COVER,
    draggable: u,
    mapSize: n,
    isPrintEnabled: o,
    ...r.opts.elementsMetaData ? { elementsMetaData: r.opts.elementsMetaData } : {}
  }), r.config && ii.setState(r.config);
  const s = X8({
    container: a,
    draggable: u,
    events: r.events,
    mapSize: n
  }), h = ni(n, {
    width: s.width(),
    height: s.height()
  });
  Rt.setState({
    minScale: h
  });
  const l = new S8(
    (x = r.opts.layersConfig) == null ? void 0 : x.background
  );
  s.add(l);
  const g = new Y8();
  await g.renderElements({
    elements: r.opts.elements,
    layerConfig: (P = r.opts.layersConfig) == null ? void 0 : P.elements
  }), s.add(g);
  let p;
  if (o && (p = new va({
    initialPreview: (c = r.opts.print) == null ? void 0 : c.initialPreview,
    cb: (f = r.events) == null ? void 0 : f.onPrintPreview
  }), s.add(p)), o)
    s.scale({ x: h, y: h });
  else {
    if (Z8(s, (S = r.events) == null ? void 0 : S.onMapPanZoom), r.opts.initialZoom) {
      const E = ma(h, r.opts.initialZoom);
      s.scale({ x: E, y: E });
    }
    r.opts.initialPosition && s.position(
      Dr({
        scale: s.scaleX(),
        pos: {
          x: r.opts.initialPosition.x * s.scaleX(),
          y: r.opts.initialPosition.y * s.scaleY()
        },
        stageSize: {
          height: s.height(),
          width: s.width()
        }
      })
    );
  }
  const b = $6(J8(s, a), 250);
  window.addEventListener("resize", b);
  function m() {
    const { fit: E } = Rt.getState(), T = s.scaleX();
    return {
      fit: E,
      rect: {
        height: s.height() / T,
        width: s.width() / T,
        x: Math.abs(s.x()) / T,
        y: Math.abs(s.y()) / T
      },
      zoom: T
    };
  }
  return {
    destroy() {
      s.destroy();
    },
    getStageInfo: m,
    renderElements(E, T) {
      return g.renderElements({
        elements: E,
        layerConfig: T
      });
    },
    setBackgroundVisibility(E) {
      l.setVisibility(E);
    },
    setDecorationsVisibility(E) {
      g.setVisibility(fr.DECORATION, E);
    },
    setSpotsVisibility(E) {
      g.setVisibility(fr.SPOT, E);
    },
    toggleBackgroundVisibility() {
      l.toggleVisibility();
    },
    toggleDecorationsVisibility() {
      g.toggleVisibility(fr.DECORATION);
    },
    toggleSpotsVisibility() {
      g.toggleVisibility(fr.SPOT);
    },
    updateFit(E) {
      const { mapSize: T } = Rt.getState();
      Rt.setState({ fit: E });
      const D = ya(a, T);
      Rt.setState({
        minScale: ni(T, D)
      }), s.size(D), Xh(s);
    },
    zoomIn() {
      var I, M;
      const E = s.scaleX(), T = pn(
        Math.min(E + Y0, yn),
        2
      ), D = j0({
        scale: T,
        point: {
          x: s.width() / 2,
          y: s.height() / 2
        },
        stage: s
      });
      (M = (I = r.events) == null ? void 0 : I.onMapPanZoom) == null || M.call(I, {
        position: D.position,
        zoom: D.scale
      });
    },
    zoomOut() {
      var M, O;
      const { minScale: E } = Rt.getState(), T = s.scaleX(), D = Math.max(E, T - Y0), I = j0({
        stage: s,
        scale: D,
        point: {
          x: s.width() / 2,
          y: s.height() / 2
        }
      });
      (O = (M = r.events) == null ? void 0 : M.onMapPanZoom) == null || O.call(M, {
        position: I.position,
        zoom: I.scale
      });
    },
    updateBgSize(E, T) {
      const D = {
        width: Math.max(a.clientWidth, E.width),
        height: Math.max(a.clientHeight, E.height)
      }, I = Rt.getState();
      if (x0(D, I.mapSize) && x0(T, {
        width: I.background.width,
        height: I.background.height
      }))
        return;
      const M = ya(a, D);
      s.width(M.width), s.height(M.height), Rt.setState((O) => ({
        ...O,
        mapSize: D,
        background: {
          ...O.background,
          width: T.width,
          height: T.height
        },
        minScale: ni(E, {
          width: M.width,
          height: M.height
        })
      })), l.updateBgSize(), Xh(s);
    },
    async highlightElement(E, T) {
      const D = s.findOne(`#${E}`);
      if (D instanceof er)
        return D.highlight(T).then(() => {
          g.onElementHighligh(E);
        });
    },
    async clearHighlight(E) {
      if (E.length === 0)
        return;
      const T = E.map(async (D) => {
        const I = s.findOne(`#${D}`);
        if (I instanceof er)
          return I.clearHighlight();
      });
      await Promise.allSettled(T), E.forEach((D) => {
        g.onElementHighligh(D);
      });
    },
    goToPosition(E, T) {
      if (T) {
        const { minScale: D } = Rt.getState(), I = ma(D, T);
        s.scale({ x: I, y: I });
      }
      s.position(
        Dr({
          scale: s.scaleX(),
          pos: {
            x: E.x * s.scaleX(),
            y: E.y * s.scaleY()
          },
          stageSize: {
            height: s.height(),
            width: s.width()
          }
        })
      );
    },
    print() {
      if (!p)
        throw new Error("Print mode is not enabled");
      return p.print(s);
    },
    updatePrintPreview(E) {
      var T;
      if (!p)
        throw new Error("Print mode is not enabled");
      p.destroyChildren(), p.buildPrintPreview({
        initialPreview: E,
        cb: (T = r.events) == null ? void 0 : T.onPrintPreview
      });
    },
    handleResize() {
      b();
    },
    updateClusterVisibility() {
      g.updateClusterVisibility();
    }
  };
}
function Z8(r, a) {
  const { mapSize: n, minScale: o } = Rt.getState(), u = 1.05;
  r.scale({ x: o, y: o });
  const s = a ? p1(a, 250, {
    trailing: !0
  }) : null;
  r.on("wheel", (p) => {
    p.evt.preventDefault();
    const b = r.scaleX(), m = r.getPointerPosition();
    if (!m) return;
    const C = {
      x: (m.x - r.x()) / b,
      y: (m.y - r.y()) / b
    }, v = p.evt.deltaY > 0 ? -1 : 1, { mapSize: _ } = Rt.getState(), w = v > 0 ? b * u : b / u, x = ni(_, {
      width: r.width(),
      height: r.height()
    }), P = ma(x, w);
    if (w > P || w < x) return;
    r.scale({
      x: P,
      y: P
    });
    const c = m.x - C.x * w, f = m.y - C.y * w, S = {
      x: Math.min(0, c),
      // bound to the left of the bg
      y: Math.min(0, f)
      // bound to the top of the bg
    };
    r.position(
      Dr({
        scale: P,
        pos: S,
        stageSize: {
          height: r.height(),
          width: r.width()
        }
      })
    ), s && s({
      position: {
        x: S.x / P,
        y: S.y / P
      },
      zoom: P
    });
  }), r.dragBoundFunc(
    (p) => Dr({
      stageSize: { width: r.width(), height: r.height() },
      pos: p,
      scale: r.scaleX()
    })
  );
  let h = null, l = 0, g = !1;
  r.on("touchmove", function(p) {
    p.evt.preventDefault();
    const b = p.evt.touches[0], m = p.evt.touches[1];
    if (b && !m && !r.isDragging() && g && (r.startDrag(), g = !1), b && m) {
      r.isDragging() && (g = !0, r.stopDrag());
      const C = {
        x: b.clientX,
        y: b.clientY
      }, v = {
        x: m.clientX,
        y: m.clientY
      };
      if (!h) {
        h = K0(C, v);
        return;
      }
      const _ = K0(C, v), w = $8(C, v);
      l || (l = w);
      const x = r.scaleX() * (w / l), P = {
        x: (_.x - r.x()) / r.scaleX(),
        y: (_.y - r.y()) / r.scaleX()
      }, c = ni(n, {
        width: r.width(),
        height: r.height()
      }), f = ma(c, x);
      if (r.scale({
        x: f,
        y: f
      }), x >= yn || x <= c)
        return;
      const S = _.x - h.x, E = _.y - h.y, T = {
        x: _.x - P.x * x + S,
        y: _.y - P.y * x + E
      };
      r.position(
        Dr({
          scale: r.scaleX(),
          pos: T,
          stageSize: {
            height: r.height(),
            width: r.width()
          }
        })
      ), l = w, h = _;
    }
  }), r.on("touchend", function() {
    l = 0, h = null;
  });
}
const J8 = (r, a) => () => {
  const n = a.clientWidth, o = a.clientHeight, u = ya(a, Rt.getState().mapSize);
  r.width(u.width), r.height(u.height), Rt.setState((s) => ({
    ...s,
    minScale: ni(s.mapSize, {
      width: n,
      height: o
    })
  })), Xh(r);
};
export {
  mn as Fit,
  Pe as SpotLayout,
  Sy as init
};
